/* eslint-disable */
/*************************************************
 * This File is autogenerated do not directly edit
 * Run yarn graphql:codegen to regenerate
 *************************************************/

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  ANY: any;
  DataObject: any;
  DateTime: any;
  EmailAddress: any;
  JSONObject: any;
  PhoneNumber: any;
  ReportColumnType: any;
  ReportDataFilterOperator: any;
  ReportDataFilterType: any;
  ReportViewColumnPinnedSide: any;
  ReportViewColumnSortDirection: any;
  ReportViewVisibility: any;
  ReportVisibility: any;
  SafeInt: number;
};

export type ActiveUserOnEntity = {
  __typename?: 'ActiveUserOnEntity';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type AddBuyerInput = {
  buyer?: InputMaybe<CreateBuyerInput>;
  orderId: Scalars['ID'];
};

export type AddCarrierAccountRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  carrierAccountNumber: Scalars['String'];
  carrierType: CarrierType;
  companyAccess: CompanyAccessInput;
  companyInfo: AddCarrierAccountRequestInput_CompanyInfo;
  description?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  shippingAddress: AddCarrierAccountRequestInput_ShippingAddress;
};

export type AddCarrierAccountRequestInput_CompanyInfo = {
  address: AddCarrierAccountRequestInput_CompanyInfo_Address;
  contact: AddCarrierAccountRequestInput_CompanyInfo_Contact;
  name: Scalars['String'];
};

export type AddCarrierAccountRequestInput_CompanyInfo_Address = {
  city: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type AddCarrierAccountRequestInput_CompanyInfo_Contact = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type AddCarrierAccountRequestInput_ShippingAddress = {
  city: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type AddConsolidatedPayeesInput = {
  directoryCompanyIds: Array<Scalars['String']>;
};

export type AddNoteInput = {
  appliesTo?: InputMaybe<AppliesTo>;
  appliesToId?: InputMaybe<Scalars['String']>;
  attributions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  body: Scalars['String'];
  entityId: Scalars['String'];
  entityType: NoteEntityType;
};

/** These are the fields that will be stored on the new OrderParty - deprecated (Use CreateOrderPartyInput instead) */
export type AddPartyToOrderPayload = {
  /** When directoryContactId has a value, this field must also have a value. Otherwise, this field is optional. */
  directoryCompanyId?: InputMaybe<Scalars['String']>;
  directoryContactId?: InputMaybe<Scalars['String']>;
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  refSectionId?: InputMaybe<Scalars['String']>;
  refSectionLabel?: InputMaybe<Scalars['String']>;
  roleId: Scalars['String'];
};

/** This is the result of adding the party to the order */
export type AddPartyToOrderResult = {
  __typename?: 'AddPartyToOrderResult';
  party?: Maybe<OrderParty>;
};

export type AddSellerInput = {
  orderId: Scalars['ID'];
  seller?: InputMaybe<CreateSellerInput>;
};

export type AddSequenceInput = {
  alphaSuffix?: InputMaybe<Scalars['String']>;
  currentSequenceNumber?: InputMaybe<Scalars['Int']>;
  numberOfDigitsInSequence: Scalars['Int'];
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sequenceName: Scalars['String'];
  template: Scalars['String'];
};

export type AddUserRecentOrderInput = {
  id: Scalars['ID'];
};

export type AddUserRecentOrderPayload = {
  __typename?: 'AddUserRecentOrderPayload';
  user: User;
};

export type AdditionalPropertyDetails = {
  __typename?: 'AdditionalPropertyDetails';
  address?: Maybe<PropertySearchAddress>;
  apn?: Maybe<Scalars['String']>;
  appraisedValue?: Maybe<Scalars['Float']>;
  assessedValue?: Maybe<Scalars['Float']>;
  propertyId?: Maybe<Scalars['String']>;
};

export type AdditionalPropertyDetailsInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  apn?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  lookupType: PropertyLookupType;
  state?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type AdditionalQuestion = {
  __typename?: 'AdditionalQuestion';
  answer?: Maybe<Scalars['String']>;
  answerType?: Maybe<Scalars['String']>;
  defaultAnswer?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inputType: Scalars['String'];
  options: Array<AdditionalQuestionAnswerOption>;
  question: Scalars['String'];
};

export type AdditionalQuestionAnswerOption = {
  __typename?: 'AdditionalQuestionAnswerOption';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type AdditionalQuestionInput = {
  answer: Scalars['String'];
  answerType: Scalars['String'];
  defaultAnswer?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  inputType: Scalars['String'];
  options?: InputMaybe<Array<AdditionalQuestionOptionInput>>;
  question: Scalars['String'];
};

export type AdditionalQuestionOptionInput = {
  description: Scalars['String'];
  id: Scalars['String'];
};

export type AdditionalQuestionsRateRequest = {
  answer: Scalars['String'];
  answerType: Scalars['String'];
  id: Scalars['String'];
};

export type AdditionalQuestionsRateValidationRequest = {
  answer?: InputMaybe<Scalars['String']>;
  answerType?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  address1?: Maybe<Scalars['String']>;
  address1AndAddress2?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressType?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  fullDomesticAddress?: Maybe<Scalars['String']>;
  fullDomesticMailingAddress?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  stateOrProvinceDetail?: Maybe<StateDetail>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
};

export type AddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
};

export type AdjustableInterestRateTable = {
  __typename?: 'AdjustableInterestRateTable';
  firstChange?: Maybe<Scalars['Float']>;
  firstChangeFrequency?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['String']>;
  initialInterestRate?: Maybe<Scalars['Float']>;
  margin?: Maybe<Scalars['Float']>;
  maximumInterestRate?: Maybe<Scalars['Float']>;
  minimumInterestRate?: Maybe<Scalars['Float']>;
  subsequentChange?: Maybe<Scalars['Float']>;
  subsequentChangeFrequency?: Maybe<Scalars['String']>;
};

export type AdjustableInterestRateTableInput = {
  firstChange?: InputMaybe<Scalars['Float']>;
  firstChangeFrequency?: InputMaybe<Scalars['String']>;
  index?: InputMaybe<Scalars['String']>;
  initialInterestRate?: InputMaybe<Scalars['Float']>;
  margin?: InputMaybe<Scalars['Float']>;
  maximumInterestRate?: InputMaybe<Scalars['Float']>;
  minimumInterestRate?: InputMaybe<Scalars['Float']>;
  subsequentChange?: InputMaybe<Scalars['Float']>;
  subsequentChangeFrequency?: InputMaybe<Scalars['String']>;
};

export type AdjustablePaymentsTable = {
  __typename?: 'AdjustablePaymentsTable';
  firstChange?: Maybe<Scalars['String']>;
  firstChangeAt?: Maybe<Scalars['String']>;
  interestOnlyPayments?: Maybe<Scalars['Boolean']>;
  maximumPayment?: Maybe<Scalars['Float']>;
  maximumPaymentStartsAt?: Maybe<Scalars['String']>;
  numInterestOnlyPayments?: Maybe<Scalars['Int']>;
  numOptionalPayments?: Maybe<Scalars['Int']>;
  numStepPayments?: Maybe<Scalars['Int']>;
  optionalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPaymentsFrom?: Maybe<Scalars['String']>;
  seasonalPaymentsTo?: Maybe<Scalars['String']>;
  stepPayments?: Maybe<Scalars['Boolean']>;
  subsequentChangesEvery?: Maybe<Scalars['String']>;
};

export type AdjustablePaymentsTableInput = {
  firstChange?: InputMaybe<Scalars['String']>;
  firstChangeAt?: InputMaybe<Scalars['String']>;
  interestOnlyPayments?: InputMaybe<Scalars['Boolean']>;
  maximumPayment?: InputMaybe<Scalars['Float']>;
  maximumPaymentStartsAt?: InputMaybe<Scalars['String']>;
  numInterestOnlyPayments?: InputMaybe<Scalars['Int']>;
  numOptionalPayments?: InputMaybe<Scalars['Int']>;
  numStepPayments?: InputMaybe<Scalars['Int']>;
  optionalPayments?: InputMaybe<Scalars['Boolean']>;
  seasonalPayments?: InputMaybe<Scalars['Boolean']>;
  seasonalPaymentsFrom?: InputMaybe<Scalars['String']>;
  seasonalPaymentsTo?: InputMaybe<Scalars['String']>;
  stepPayments?: InputMaybe<Scalars['Boolean']>;
  subsequentChangesEvery?: InputMaybe<Scalars['String']>;
};

export type Adjustment = {
  __typename?: 'Adjustment';
  amount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  dcLineMapping?: Maybe<AdjustmentLineMappings>;
  dcSectionMapping?: Maybe<AdjustmentSectionMapping>;
  defaultLineMapping: DefaultLineMapping;
  description: Scalars['String'];
  externalItemId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDebitCredit: Scalars['Boolean'];
  lineMapping: AdjustmentLineMappings;
  lineType: Scalars['String'];
  orderId: Scalars['String'];
  payeePayorId?: Maybe<Scalars['String']>;
  sectionMapping: AdjustmentSectionMapping;
  tenantId: Scalars['String'];
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type AdjustmentLineMapping = {
  __typename?: 'AdjustmentLineMapping';
  addendumLineNumber?: Maybe<Scalars['Int']>;
  lineNumber: Scalars['Int'];
};

export type AdjustmentLineMappings = {
  __typename?: 'AdjustmentLineMappings';
  alta?: Maybe<AdjustmentLineMapping>;
  cd?: Maybe<AdjustmentLineMapping>;
  hud1986?: Maybe<AdjustmentLineMapping>;
  hud2010?: Maybe<AdjustmentLineMapping>;
};

export type AdjustmentResponseWithMirror = {
  __typename?: 'AdjustmentResponseWithMirror';
  adjustment: Adjustment;
  mirrorAdjustment?: Maybe<Adjustment>;
};

export type AdjustmentSectionMapping = {
  __typename?: 'AdjustmentSectionMapping';
  alta?: Maybe<Scalars['String']>;
  cd?: Maybe<Scalars['String']>;
  hud1986?: Maybe<Scalars['String']>;
  hud2010?: Maybe<Scalars['String']>;
};

export type AdminCredentialAgentNetStatus = {
  __typename?: 'AdminCredentialAgentNetStatus';
  active: Scalars['Boolean'];
};

export type AdminDomain = {
  __typename?: 'AdminDomain';
  permissionsRuleSets?: Maybe<PermissionsRuleSets>;
  title?: Maybe<AdminTitleDomain>;
};

export type AdminMilestone = {
  __typename?: 'AdminMilestone';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  tasks?: Maybe<Array<Maybe<AdminTask>>>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  workflowId: Scalars['ID'];
};

export type AdminMilestoneInput = {
  name: Scalars['String'];
};

export type AdminSetAgentNetOffices = {
  mapping: Array<InputMaybe<AgentNetOfficeMapItem>>;
};

export type AdminSetCredentialAgentNet = {
  personalAccessToken: Scalars['String'];
};

export type AdminTask = {
  __typename?: 'AdminTask';
  active: Scalars['Boolean'];
  assignedTo?: Maybe<Scalars['String']>;
  assignment: TaskAssignment;
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  departmentDependency?: Maybe<Scalars['String']>;
  due: TaskDue;
  id: Scalars['ID'];
  milestoneId: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  start: TaskStart;
  type?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp: Scalars['DateTime'];
  workflowId: Scalars['ID'];
};

export type AdminTaskInput = {
  active: Scalars['Boolean'];
  assignment: TaskAssignmentInput;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due: TaskDueInput;
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  start: TaskStartInput;
  type: Scalars['String'];
};

export type AdminTitleDomain = {
  __typename?: 'AdminTitleDomain';
  _empty?: Maybe<Scalars['String']>;
  buyerSellerSplit?: Maybe<BuyerSellerSplit>;
  clauseAppliedToConfiguration?: Maybe<ClauseAppliedToConfiguration>;
  clausePackages?: Maybe<ClausePackageDomain>;
  clauseTemplates?: Maybe<ClauseTemplateDomain>;
};

export type AdminWorkflow = {
  __typename?: 'AdminWorkflow';
  active?: Maybe<Scalars['Boolean']>;
  companies?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  milestones?: Maybe<Array<Maybe<AdminMilestone>>>;
  name: Scalars['String'];
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionPurpose?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['ID']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type AdminWorkflowInput = {
  active: Scalars['Boolean'];
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name: Scalars['String'];
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionPurpose?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type AgentDisclosureFeeAdditionalData = {
  __typename?: 'AgentDisclosureFeeAdditionalData';
  externalLenderPremiumId?: Maybe<Scalars['String']>;
  externalOwnerPremiumId?: Maybe<Scalars['String']>;
  overallAgentRetainedAmount?: Maybe<Scalars['Float']>;
};

export type AgentNetAdminOfficesResponse = {
  __typename?: 'AgentNetAdminOfficesResponse';
  firms: Array<Maybe<AgentNetFirm>>;
  mapping: Array<Maybe<AgentNetOfficeMapping>>;
};

export type AgentNetAdminSetOfficesResponse = {
  __typename?: 'AgentNetAdminSetOfficesResponse';
  mapping: Array<Maybe<AgentNetOfficeMapping>>;
};

export type AgentNetFinance = {
  __typename?: 'AgentNetFinance';
  banking?: Maybe<Scalars['Boolean']>;
  reconciliation?: Maybe<Scalars['Boolean']>;
  ten99?: Maybe<Scalars['Boolean']>;
  wireValidation?: Maybe<Scalars['Boolean']>;
};

export type AgentNetFinanceInput = {
  banking?: InputMaybe<Scalars['Boolean']>;
  reconciliation?: InputMaybe<Scalars['Boolean']>;
  ten99?: InputMaybe<Scalars['Boolean']>;
  wireValidation?: InputMaybe<Scalars['Boolean']>;
};

export type AgentNetFinanceIntegrationResponse = {
  __typename?: 'AgentNetFinanceIntegrationResponse';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  credentialRequestOutcome?: Maybe<CredentialRequestOutcome>;
  features?: Maybe<AgentNetFinance>;
  isEnabled: Scalars['Boolean'];
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type AgentNetFirm = {
  __typename?: 'AgentNetFirm';
  id: Scalars['Int'];
  name: Scalars['String'];
  offices: Array<Maybe<AgentNetOffice>>;
};

export type AgentNetOffice = {
  __typename?: 'AgentNetOffice';
  id: Scalars['Int'];
  name: Scalars['String'];
};

export type AgentNetOfficeMapItem = {
  agentNetFirm: Scalars['Int'];
  agentNetOffice: Scalars['Int'];
  fluentBranch: Scalars['String'];
};

export type AgentNetOfficeMapping = {
  __typename?: 'AgentNetOfficeMapping';
  agentNetFirm: Scalars['Int'];
  agentNetOffice: Scalars['Int'];
  fluentBranch: Scalars['String'];
};

export type AlNrAf2SellerGainForm = {
  __typename?: 'AlNrAf2SellerGainForm';
  saleAmount?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<AlNrAf2SellerGainFormSeller>>>;
  sellingExpenses?: Maybe<Scalars['String']>;
};

export type AlNrAf2SellerGainFormAddress = {
  __typename?: 'AlNrAf2SellerGainFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AlNrAf2SellerGainFormSeller = {
  __typename?: 'AlNrAf2SellerGainFormSeller';
  address?: Maybe<AlNrAf2SellerGainFormAddress>;
  name?: Maybe<Scalars['String']>;
  spouseTaxId?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type AlWnrWithholdingSalesForm = {
  __typename?: 'AlWnrWithholdingSalesForm';
  buyer?: Maybe<AlWnrWithholdingSalesFormBuyer>;
  propertyAddress?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<AlWnrWithholdingSalesFormSeller>>>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type AlWnrWithholdingSalesFormAddress = {
  __typename?: 'AlWnrWithholdingSalesFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type AlWnrWithholdingSalesFormBuyer = {
  __typename?: 'AlWnrWithholdingSalesFormBuyer';
  address?: Maybe<AlWnrWithholdingSalesFormAddress>;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type AlWnrWithholdingSalesFormSeller = {
  __typename?: 'AlWnrWithholdingSalesFormSeller';
  address?: Maybe<AlWnrWithholdingSalesFormAddress>;
  name?: Maybe<Scalars['String']>;
  sellerType?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
  withheldAmount?: Maybe<Scalars['Float']>;
};

export type AllocationItem = {
  __typename?: 'AllocationItem';
  allocatedAmount?: Maybe<Scalars['Float']>;
  allocationMethod: AllocationMethod;
  description: Scalars['String'];
  id: Scalars['ID'];
  payee?: Maybe<OrderParty>;
  payeeId?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type AllocationItemInput = {
  allocatedAmount?: InputMaybe<Scalars['Float']>;
  allocationMethod: AllocationMethod;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  payeeId?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export enum AllocationMethod {
  FixedAmount = 'FIXED_AMOUNT',
  Percentage = 'PERCENTAGE'
}

export type AltaSectionSummaryTotals = {
  __typename?: 'AltaSectionSummaryTotals';
  creditBorrower: Scalars['Float'];
  creditSeller?: Maybe<Scalars['Float']>;
  debitBorrower: Scalars['Float'];
  debitSeller?: Maybe<Scalars['Float']>;
  toFromBorrower: Scalars['Float'];
  toFromSeller?: Maybe<Scalars['Float']>;
  totalBorrowerCredit: Scalars['Float'];
  totalBorrowerDebit: Scalars['Float'];
  totalSellerCredit?: Maybe<Scalars['Float']>;
  totalSellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatement = {
  __typename?: 'AltaStatement';
  costSections?: Maybe<Array<Maybe<AltaStatementCostSection>>>;
  header?: Maybe<AltaStatementHeader>;
  signatures?: Maybe<Array<Maybe<AltaStatementSignature>>>;
  totals?: Maybe<AltaStatementTotals>;
};

export type AltaStatementCostSection = {
  __typename?: 'AltaStatementCostSection';
  items?: Maybe<Array<Maybe<AltaStatementCostSectionItem>>>;
  title?: Maybe<Scalars['String']>;
};

export type AltaStatementCostSectionItem = {
  __typename?: 'AltaStatementCostSectionItem';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatementHeader = {
  __typename?: 'AltaStatementHeader';
  additionalDates?: Maybe<Array<Maybe<AltaStatementHeaderAdditionalDates>>>;
  altaId?: Maybe<Scalars['String']>;
  buyerAddress?: Maybe<Scalars['String']>;
  buyerAllNames?: Maybe<Scalars['String']>;
  companyLogo?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  escrowOfficer?: Maybe<Scalars['String']>;
  hasSeller?: Maybe<Scalars['Boolean']>;
  lenderAddress?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  sellerAddress?: Maybe<Scalars['String']>;
  sellerAllNames?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  settlementLocation?: Maybe<Scalars['String']>;
  timeSettlement?: Maybe<Scalars['String']>;
  titleCompanyAddress?: Maybe<Scalars['String']>;
  titleCompanyName?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type AltaStatementHeaderAdditionalDates = {
  __typename?: 'AltaStatementHeaderAdditionalDates';
  date?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
};

export type AltaStatementSignature = {
  __typename?: 'AltaStatementSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type AltaStatementTotals = {
  __typename?: 'AltaStatementTotals';
  borrowerDue?: Maybe<AltaStatementTotalsBorrowerDue>;
  sellerDue?: Maybe<AltaStatementTotalsSellerDue>;
  subtotal?: Maybe<AltaStatementTotalsSubtotal>;
  total?: Maybe<AltaStatementTotalsTotal>;
};

export type AltaStatementTotalsBorrowerDue = {
  __typename?: 'AltaStatementTotalsBorrowerDue';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type AltaStatementTotalsSellerDue = {
  __typename?: 'AltaStatementTotalsSellerDue';
  description?: Maybe<Scalars['String']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatementTotalsSubtotal = {
  __typename?: 'AltaStatementTotalsSubtotal';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AltaStatementTotalsTotal = {
  __typename?: 'AltaStatementTotalsTotal';
  buyerCredit?: Maybe<Scalars['Float']>;
  buyerDebit?: Maybe<Scalars['Float']>;
  sellerCredit?: Maybe<Scalars['Float']>;
  sellerDebit?: Maybe<Scalars['Float']>;
};

export type AmountIncreaseAfterClosingQuestion = {
  __typename?: 'AmountIncreaseAfterClosingQuestion';
  asHighAsAmount?: Maybe<Scalars['Float']>;
  canIncreaseUntilIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type AmountIncreaseAfterClosingQuestionInput = {
  asHighAsAmount?: InputMaybe<Scalars['Float']>;
  canIncreaseUntilIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
};

export type AnalyzeDocumentResponseV2 = {
  __typename?: 'AnalyzeDocumentResponseV2';
  insightId: Scalars['ID'];
  status: AnalyzeDocumentResponseV2Status;
};

export enum AnalyzeDocumentResponseV2Status {
  Pending = 'pending'
}

export type AnalyzeDocumentV2Input = {
  documentId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: AnalyzeDocumentV2InputEntityType;
  scopeId?: InputMaybe<Scalars['ID']>;
};

export enum AnalyzeDocumentV2InputEntityType {
  ConsolidatedPayment = 'CONSOLIDATED_PAYMENT',
  Escrow = 'ESCROW',
  Order = 'ORDER',
  PendingOrder = 'PENDING_ORDER'
}

export type AnalyzeOrderAssistDocumentsInput = {
  companyId: Scalars['String'];
  documents: Array<OrderAssistDocumentInput>;
  sessionId: Scalars['String'];
};

export type AnalyzeOrderAssistDocumentsPayload = {
  __typename?: 'AnalyzeOrderAssistDocumentsPayload';
  insightId: Scalars['String'];
  status: Scalars['String'];
};

export type AnalyzeSearchPackageDocumentInput = {
  documentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
};

export type AnalyzeSearchPackageInput = {
  documents: Array<AnalyzeSearchPackageDocumentInput>;
  orderId: Scalars['String'];
};

export type AnalyzeSearchPackageResponse = {
  __typename?: 'AnalyzeSearchPackageResponse';
  insightId: Scalars['String'];
  status: Scalars['String'];
};

export enum ApiFilterOperator {
  Begins = 'begins',
  Contains = 'contains',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  NotContains = 'notContains',
  Size = 'size'
}

export enum AppliesTo {
  Documents = 'documents',
  Funding = 'funding',
  Invoices = 'invoices',
  Order = 'order',
  Reconciliation = 'reconciliation',
  Settlement = 'settlement',
  Title = 'title',
  Workflow = 'workflow'
}

export type ApprovedAttorney = {
  __typename?: 'ApprovedAttorney';
  address: Scalars['String'];
  attorneyId: Scalars['String'];
  attorneyName: Scalars['String'];
  city: Scalars['String'];
  isDefault: Scalars['Boolean'];
  state: Scalars['String'];
  underwriterId: Scalars['String'];
  zip: Scalars['String'];
};

export type AssociatedDocument = {
  __typename?: 'AssociatedDocument';
  book?: Maybe<Scalars['String']>;
  bookType?: Maybe<Scalars['String']>;
  instrumentNumber?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
  recordedDate?: Maybe<Scalars['String']>;
};

export type AssociatedDocumentInput = {
  book?: InputMaybe<Scalars['String']>;
  bookType?: InputMaybe<Scalars['String']>;
  instrumentNumber?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['String']>;
  recordedDate?: InputMaybe<Scalars['String']>;
};

export type AsyncTaskResponse = {
  __typename?: 'AsyncTaskResponse';
  status: AsyncTaskResponseStatus;
  subscriptionId: Scalars['ID'];
};

export enum AsyncTaskResponseStatus {
  Queued = 'queued'
}

export type AttorneyTypeMap = {
  __typename?: 'AttorneyTypeMap';
  attorneyType: Scalars['String'];
  isApplied: Scalars['Boolean'];
};

/**
 * Input for authenticating (verify + persist) an FA Trust credential set for a specific escrow
 * account. The credential set is keyed per escrow account by svc-funding: escrowAccountId
 * is part of the storage key, and credentials must be supplied for every escrow account. tenantId is
 * auth-derived.
 */
export type AuthenticateFaTrustCredentialsInput = {
  /**
   * clientId/clientSecretCode/hmacKey are nullable to support re-authentication against the STORED
   * credential set: the admin UI sends only the fields the user changed, so an untouched
   * (masked) secret arrives omitted and the backend re-uses the persisted value. The first
   * authentication for an account must supply all three.
   */
  clientId?: InputMaybe<Scalars['String']>;
  clientSecretCode?: InputMaybe<Scalars['String']>;
  escrowAccountId: Scalars['String'];
  hmacKey?: InputMaybe<Scalars['String']>;
};

export type AuthorizeCarrierAccountRequestInput = {
  id: Scalars['ID'];
};

export type AuthorizedSignatoryUser = {
  __typename?: 'AuthorizedSignatoryUser';
  firstName: Scalars['String'];
  isActive: Scalars['Boolean'];
  isUnderwriterAuthorizedSignatory: Scalars['Boolean'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type AutoClearTotals = {
  __typename?: 'AutoClearTotals';
  disbursements: TransactionCategoryStatus;
  receipts: TransactionCategoryStatus;
};

export type AvailableJurisdiction = {
  __typename?: 'AvailableJurisdiction';
  fips?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  rjid?: Maybe<Scalars['String']>;
  stateCode?: Maybe<Scalars['String']>;
};

export type AvailableWorkflow = {
  __typename?: 'AvailableWorkflow';
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
};

export type Bai2TransactionSummary = {
  __typename?: 'BAI2TransactionSummary';
  additionalInformation: Scalars['String'];
  amount: Scalars['Float'];
  receiptOrDisbursement: Scalars['String'];
  referenceNumber: Scalars['String'];
  typeOfTransaction: Scalars['String'];
};

export type BalanceGridDisbursementSummaryDetails = {
  __typename?: 'BalanceGridDisbursementSummaryDetails';
  fundedBalance?: Maybe<Scalars['Float']>;
  fundedDisbursementBalance?: Maybe<Scalars['Float']>;
  fundedReceiptBalance?: Maybe<Scalars['Float']>;
  orderBalance?: Maybe<Scalars['Float']>;
  orderDisbursementBalance?: Maybe<Scalars['Float']>;
  orderReceiptBalance?: Maybe<Scalars['Float']>;
  remainingDisbursements?: Maybe<Scalars['Float']>;
  remainingReceipts?: Maybe<Scalars['Float']>;
};

export type BalanceGridDisbursementSummaryForm = {
  __typename?: 'BalanceGridDisbursementSummaryForm';
  fundedBalance?: Maybe<Scalars['Float']>;
  fundedDisbursementBalance?: Maybe<Scalars['Float']>;
  fundedReceiptBalance?: Maybe<Scalars['Float']>;
  orderBalance?: Maybe<Scalars['Float']>;
  orderDisbursementBalance?: Maybe<Scalars['Float']>;
  orderReceiptBalance?: Maybe<Scalars['Float']>;
  remainingDisbursements?: Maybe<Scalars['Float']>;
  remainingReceipts?: Maybe<Scalars['Float']>;
};

export type BaseOrder = {
  __typename?: 'BaseOrder';
  address?: Maybe<Address>;
  branch?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Array<Maybe<BuyerSellerName>>>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lenders?: Maybe<Array<Maybe<Scalars['String']>>>;
  order?: Maybe<Order>;
  orderNumber?: Maybe<Scalars['String']>;
  sellerNames?: Maybe<Array<Maybe<BuyerSellerName>>>;
  settlementDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionType?: Maybe<TransactionType>;
};

export type BaseOrderCommissionsLineItem = {
  agentType: Scalars['String'];
  id: Scalars['ID'];
  party?: Maybe<OrderParty>;
  partyId: Scalars['String'];
};

export type BeneficiaryBankInput = {
  address?: InputMaybe<AddressInput>;
  bankIdNumber?: InputMaybe<Scalars['String']>;
  bankIdType?: InputMaybe<Scalars['String']>;
  bbiLine1?: InputMaybe<Scalars['String']>;
  bbiLine2?: InputMaybe<Scalars['String']>;
  bbiLine3?: InputMaybe<Scalars['String']>;
  bbiLine4?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type BeneficiaryBankSchema = {
  __typename?: 'BeneficiaryBankSchema';
  address?: Maybe<Address>;
  bankIdNumber?: Maybe<Scalars['String']>;
  bankIdType?: Maybe<Scalars['String']>;
  bbiLine1?: Maybe<Scalars['String']>;
  bbiLine2?: Maybe<Scalars['String']>;
  bbiLine3?: Maybe<Scalars['String']>;
  bbiLine4?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type BookBalanceTransaction = {
  __typename?: 'BookBalanceTransaction';
  amount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeName?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  typeOfFunds?: Maybe<Scalars['String']>;
};

export type Buyer = OrderBuyerSeller & {
  __typename?: 'Buyer';
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']>;
  allFullNames?: Maybe<Scalars['String']>;
  buyerSellerId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayNameMetadata?: Maybe<OverrideMetadataString>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  entityDateOfAgreement?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entityStateOfAgreement?: Maybe<Scalars['String']>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  forwardingAddress?: Maybe<Address>;
  forwardingAddressSameAsCurrentAddress?: Maybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: Maybe<Scalars['Boolean']>;
  forwardingRegion?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isForeignAddress?: Maybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  ownershipPercentage?: Maybe<Scalars['Float']>;
  ownershipPercentageMetadata?: Maybe<OverrideMetadataNumber>;
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  recordName?: Maybe<BuyerSellerRecordName>;
  representatives?: Maybe<Array<OrderBuyerSellerSoRep>>;
  representativesAllNames?: Maybe<Scalars['String']>;
  representativesAllNamesWithCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  spouse?: Maybe<OrderBuyerSellerSoRep>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  typeOfBuyerSeller?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type BuyerSellerCollectionPatchInput = {
  buyerSellerId: Scalars['String'];
  ownershipPercentage?: InputMaybe<Scalars['Float']>;
  sequenceNumber?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type BuyerSellerEmailAddress = {
  __typename?: 'BuyerSellerEmailAddress';
  emailAddress?: Maybe<Scalars['EmailAddress']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type BuyerSellerEmailAddressInput = {
  emailAddress?: InputMaybe<Scalars['EmailAddress']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type BuyerSellerName = {
  __typename?: 'BuyerSellerName';
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleInitial?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};

export type BuyerSellerPhoneNumber = {
  __typename?: 'BuyerSellerPhoneNumber';
  ext?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  phoneNumber?: Maybe<Scalars['PhoneNumber']>;
  phoneNumberFull?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type BuyerSellerPhoneNumberInput = {
  ext?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber?: InputMaybe<Scalars['PhoneNumber']>;
  type?: InputMaybe<Scalars['String']>;
};

export enum BuyerSellerRecordName {
  Buyer = 'Buyer',
  Seller = 'Seller'
}

export type BuyerSellerSplit = {
  __typename?: 'BuyerSellerSplit';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  states: StateSplitConfiguration;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type BuyerSellerSplitConfiguration = {
  __typename?: 'BuyerSellerSplitConfiguration';
  buyer: Scalars['Int'];
  seller: Scalars['Int'];
};

export type BuyerSellerSplitInput = {
  states: StateSplitInput;
  updatedTimestamp: Scalars['String'];
};

export type BuyerSellerSplitValueInput = {
  buyer: Scalars['Int'];
  seller: Scalars['Int'];
};

export type CdStatement = {
  __typename?: 'CDStatement';
  addendum?: Maybe<CdStatementAddendum>;
  cashToClose?: Maybe<CdStatementCashToClose>;
  closingCosts?: Maybe<CdStatementClosingCosts>;
  closingInformation?: Maybe<StatementClosingInformation>;
  confirmReceipt?: Maybe<CdStatementConfirmReceipt>;
  contactInformation?: Maybe<CdStatementContactInformation>;
  estimatedTaxesInsuranceAndAssessments?: Maybe<CdStatementEstimatedTaxesInsuranceAssessments>;
  loanAndOtherCosts?: Maybe<CdStatementLoanCostsAndOther>;
  loanCalculationsDisclosures?: Maybe<CdStatementLoanCalculationsDisclosures>;
  loanDisclosures?: Maybe<CdStatementLoanDisclosures>;
  loanInformation?: Maybe<StatementLoanInformation>;
  loanTerms?: Maybe<StatementLoanTerms>;
  projectedPayments?: Maybe<CdStatementProjectedPayments>;
  transactionInformation?: Maybe<StatementTransactionInformation>;
  transactionSummary?: Maybe<CdStatementTransactionSummary>;
};

export type CdStatementAddendum = {
  __typename?: 'CDStatementAddendum';
  confirmReceipt?: Maybe<CdStatementAddendumConfirmReceipt>;
  contactInformation?: Maybe<CdStatementAddendumContactInformation>;
  transactionInformation?: Maybe<CdStatementAddendumTransactionInformation>;
  transactionSummary?: Maybe<CdStatementAddendumTransactionSummary>;
};

export type CdStatementAddendumConfirmReceipt = {
  __typename?: 'CDStatementAddendumConfirmReceipt';
  receiptConfirmed?: Maybe<Scalars['Boolean']>;
  showAddendum?: Maybe<Scalars['Boolean']>;
  signatures?: Maybe<CdStatementAddendumConfirmReceiptSignatures>;
};

export type CdStatementAddendumConfirmReceiptSignature = {
  __typename?: 'CDStatementAddendumConfirmReceiptSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumConfirmReceiptSignatures = {
  __typename?: 'CDStatementAddendumConfirmReceiptSignatures';
  buyers?: Maybe<Array<Maybe<CdStatementAddendumConfirmReceiptSignature>>>;
  sellers?: Maybe<Array<Maybe<CdStatementAddendumConfirmReceiptSignature>>>;
};

export type CdStatementAddendumContactInformation = {
  __typename?: 'CDStatementAddendumContactInformation';
  contacts?: Maybe<Array<Maybe<CdStatementAddendumContactInformationContact>>>;
  state?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumContactInformationContact = {
  __typename?: 'CDStatementAddendumContactInformationContact';
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contactLicenseId?: Maybe<Scalars['String']>;
  contactNmlsId?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumTransactionInformation = {
  __typename?: 'CDStatementAddendumTransactionInformation';
  borrowers?: Maybe<Array<Maybe<CdStatementAddendumTransactionInformationContact>>>;
  sellers?: Maybe<Array<Maybe<CdStatementAddendumTransactionInformationContact>>>;
};

export type CdStatementAddendumTransactionInformationContact = {
  __typename?: 'CDStatementAddendumTransactionInformationContact';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type CdStatementAddendumTransactionSummary = {
  __typename?: 'CDStatementAddendumTransactionSummary';
  sectionK?: Maybe<CdStatementAddendumTransactionSummarySection>;
  sectionL?: Maybe<CdStatementAddendumTransactionSummarySection>;
  sectionM?: Maybe<CdStatementAddendumTransactionSummarySection>;
  sectionN?: Maybe<CdStatementAddendumTransactionSummarySection>;
};

export type CdStatementAddendumTransactionSummarySection = {
  __typename?: 'CDStatementAddendumTransactionSummarySection';
  items?: Maybe<Array<Maybe<CdStatementAddendumTransactionSummarySectionItem>>>;
};

export type CdStatementAddendumTransactionSummarySectionItem = {
  __typename?: 'CDStatementAddendumTransactionSummarySectionItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
};

export type CdStatementCashToClose = {
  __typename?: 'CDStatementCashToClose';
  closingCostsFinanced?: Maybe<Scalars['Float']>;
  estimatedCashFromBorrower?: Maybe<Scalars['Boolean']>;
  finalCashFromBorrower?: Maybe<Scalars['Boolean']>;
  items?: Maybe<Array<Maybe<CdStatementCashToCloseItem>>>;
  totalEstimatedCashToClose?: Maybe<Scalars['Float']>;
  totalFinalCashToClose?: Maybe<Scalars['Float']>;
};

export type CdStatementCashToCloseItem = {
  __typename?: 'CDStatementCashToCloseItem';
  description?: Maybe<Scalars['String']>;
  didChange?: Maybe<Scalars['Boolean']>;
  estimatedAmount?: Maybe<Scalars['Float']>;
  finalAmount?: Maybe<Scalars['Float']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type CdStatementClosingCosts = {
  __typename?: 'CDStatementClosingCosts';
  cashFromBorrower?: Maybe<Scalars['Boolean']>;
  cashToClose?: Maybe<Scalars['Float']>;
  closingCosts?: Maybe<Scalars['Float']>;
  lenderCredits?: Maybe<Scalars['Float']>;
  loanCosts?: Maybe<Scalars['Float']>;
  otherCosts?: Maybe<Scalars['Float']>;
};

export type CdStatementConfirmReceipt = {
  __typename?: 'CDStatementConfirmReceipt';
  applicant?: Maybe<CdStatementConfirmReceiptApplicant>;
  coapplicant?: Maybe<CdStatementConfirmReceiptApplicant>;
  receiptConfirmed?: Maybe<Scalars['Boolean']>;
};

export type CdStatementConfirmReceiptApplicant = {
  __typename?: 'CDStatementConfirmReceiptApplicant';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type CdStatementContactInformation = {
  __typename?: 'CDStatementContactInformation';
  contacts?: Maybe<Array<Maybe<CdStatementContactInformationContact>>>;
  state?: Maybe<Scalars['String']>;
};

export type CdStatementContactInformationContact = {
  __typename?: 'CDStatementContactInformationContact';
  address?: Maybe<Scalars['String']>;
  contact?: Maybe<Scalars['String']>;
  contactLicenseId?: Maybe<Scalars['String']>;
  contactNmlsId?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  licenseId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
};

export type CdStatementEstimatedTaxesInsuranceAssessments = {
  __typename?: 'CDStatementEstimatedTaxesInsuranceAssessments';
  amount?: Maybe<Scalars['Float']>;
  includes?: Maybe<Array<Maybe<CdStatementEstimatedTaxesInsuranceAssessmentsItem>>>;
};

export type CdStatementEstimatedTaxesInsuranceAssessmentsItem = {
  __typename?: 'CDStatementEstimatedTaxesInsuranceAssessmentsItem';
  description?: Maybe<Scalars['String']>;
  inEscrow?: Maybe<Scalars['String']>;
  includedInEstimate?: Maybe<Scalars['Boolean']>;
};

export type CdStatementLoanCalculationsDisclosures = {
  __typename?: 'CDStatementLoanCalculationsDisclosures';
  amountFinanced?: Maybe<Scalars['Float']>;
  annualPercentageRate?: Maybe<Scalars['Float']>;
  financeCharge?: Maybe<Scalars['Float']>;
  liabilityAfterForeclosure?: Maybe<Scalars['String']>;
  totalInterestPercentage?: Maybe<Scalars['Float']>;
  totalOfPayments?: Maybe<Scalars['Float']>;
};

export type CdStatementLoanCostsAndOther = {
  __typename?: 'CDStatementLoanCostsAndOther';
  isTwoPages?: Maybe<Scalars['Boolean']>;
  sectionA?: Maybe<StatementLineItemSection>;
  sectionB?: Maybe<StatementLineItemSection>;
  sectionC?: Maybe<StatementLineItemSection>;
  sectionD?: Maybe<StatementLineItemSection>;
  sectionE?: Maybe<StatementLineItemSection>;
  sectionF?: Maybe<StatementLineItemSection>;
  sectionG?: Maybe<StatementLineItemSection>;
  sectionH?: Maybe<StatementLineItemSection>;
  sectionI?: Maybe<StatementLineItemSection>;
  sectionJ?: Maybe<StatementLineItemSection>;
};

export type CdStatementLoanDisclosures = {
  __typename?: 'CDStatementLoanDisclosures';
  adjustableInterestRateTable?: Maybe<CdStatementLoanDisclosuresAdjustableInterestRateTable>;
  adjustablePaymentsTable?: Maybe<CdStatementLoanDisclosuresAdjustmentPaymentsTable>;
  escrowAccount?: Maybe<Scalars['String']>;
  escrowWaiverFee?: Maybe<Scalars['Float']>;
  escrowWaiverFeeDescription?: Maybe<Scalars['String']>;
  escrowedCostsFirstYear?: Maybe<Scalars['Float']>;
  escrowedCostsListing?: Maybe<Scalars['String']>;
  estimatedCostsOverFirstYear?: Maybe<Scalars['Float']>;
  initialEscrowPayment?: Maybe<Scalars['Float']>;
  latePaymentDays?: Maybe<Scalars['Float']>;
  latePaymentFeeDescription?: Maybe<Scalars['String']>;
  loanAssumptionPermitted?: Maybe<Scalars['String']>;
  loanHasDemandFeature?: Maybe<Scalars['String']>;
  monthlyEscrowAmount?: Maybe<Scalars['Float']>;
  negativeAmortization?: Maybe<Scalars['String']>;
  nonEscrowedCostFirstYear?: Maybe<Scalars['Float']>;
  nonEscrowedCostsListing?: Maybe<Scalars['String']>;
  partialPayments?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  showAirTable?: Maybe<Scalars['Boolean']>;
  showApTable?: Maybe<Scalars['Boolean']>;
};

export type CdStatementLoanDisclosuresAdjustableInterestRateTable = {
  __typename?: 'CDStatementLoanDisclosuresAdjustableInterestRateTable';
  firstChange?: Maybe<Scalars['Float']>;
  firstChangeFrequency?: Maybe<Scalars['String']>;
  index?: Maybe<Scalars['String']>;
  initialInterestRate?: Maybe<Scalars['Float']>;
  margin?: Maybe<Scalars['Float']>;
  maximumInterestRate?: Maybe<Scalars['Float']>;
  minimumInterestRate?: Maybe<Scalars['Float']>;
  subsequentChange?: Maybe<Scalars['Float']>;
  subsequentChangeFrequency?: Maybe<Scalars['String']>;
};

export type CdStatementLoanDisclosuresAdjustmentPaymentsTable = {
  __typename?: 'CDStatementLoanDisclosuresAdjustmentPaymentsTable';
  firstChange?: Maybe<Scalars['String']>;
  firstChangeAt?: Maybe<Scalars['String']>;
  interestOnlyPayments?: Maybe<Scalars['Boolean']>;
  maximumPayment?: Maybe<Scalars['Float']>;
  maximumPaymentStartsAt?: Maybe<Scalars['String']>;
  numInterestOnlyPayments?: Maybe<Scalars['Float']>;
  numOptionalPayments?: Maybe<Scalars['Float']>;
  numStepPayments?: Maybe<Scalars['Float']>;
  optionalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPayments?: Maybe<Scalars['Boolean']>;
  seasonalPaymentsFrom?: Maybe<Scalars['String']>;
  seasonalPaymentsTo?: Maybe<Scalars['String']>;
  stepPayments?: Maybe<Scalars['Boolean']>;
  subsequentChangesEvery?: Maybe<Scalars['String']>;
};

export type CdStatementProjectedPayments = {
  __typename?: 'CDStatementProjectedPayments';
  paymentPeriod?: Maybe<Scalars['String']>;
  projections?: Maybe<Array<Maybe<CdStatementProjectedPaymentsProjection>>>;
};

export type CdStatementProjectedPaymentsProjection = {
  __typename?: 'CDStatementProjectedPaymentsProjection';
  estimatedEscrow?: Maybe<Scalars['Float']>;
  interestOnly?: Maybe<Scalars['Boolean']>;
  maxEstimatedPayment?: Maybe<Scalars['Float']>;
  maxPrincipalAndInterest?: Maybe<Scalars['Float']>;
  minEstimatedPayment?: Maybe<Scalars['Float']>;
  minPrincipalAndInterest?: Maybe<Scalars['Float']>;
  mortgageInsurance?: Maybe<Scalars['Float']>;
  period?: Maybe<Scalars['String']>;
};

export type CdStatementTransactionSummary = {
  __typename?: 'CDStatementTransactionSummary';
  borrowerCalcTotal?: Maybe<Scalars['Float']>;
  cashFromBorrower?: Maybe<Scalars['Boolean']>;
  cashFromSeller?: Maybe<Scalars['Boolean']>;
  sectionK?: Maybe<StatementLineItemAdjustmentSection>;
  sectionL?: Maybe<StatementLineItemAdjustmentSection>;
  sectionM?: Maybe<StatementLineItemAdjustmentSection>;
  sectionN?: Maybe<StatementLineItemAdjustmentSection>;
  sellerCalcTotal?: Maybe<Scalars['Float']>;
  totalDueFromBorrower?: Maybe<Scalars['Float']>;
  totalDueFromSeller?: Maybe<Scalars['Float']>;
  totalDueToSeller?: Maybe<Scalars['Float']>;
  totalPaidByBorrower?: Maybe<Scalars['Float']>;
};

export type CaRequirements = {
  __typename?: 'CaRequirements';
  requestedRecordingDate?: Maybe<Scalars['String']>;
  requestedRecordingTimeSlot?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type CaRequirementsInput = {
  requestedRecordingDate?: InputMaybe<Scalars['String']>;
  requestedRecordingTimeSlot?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type CalculateCplRateItem = {
  active: Scalars['Boolean'];
  coveredParty: Scalars['String'];
  effectiveDateOverride?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  letterType: Scalars['String'];
};

export type CalculateCplRatePricing = {
  __typename?: 'CalculateCplRatePricing';
  active: Scalars['Boolean'];
  coveredParty: Scalars['String'];
  effectiveDate?: Maybe<Scalars['String']>;
  effectiveDateOverride?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  letterType: Scalars['String'];
  price?: Maybe<Scalars['Float']>;
  priceStatus: Scalars['String'];
  productId?: Maybe<Scalars['String']>;
};

export type CalculateCplRateRequest = {
  cpls: Array<CalculateCplRateItem>;
};

export type CalculateCplRateResponse = {
  __typename?: 'CalculateCplRateResponse';
  cpls: Array<CalculateCplRatePricing>;
  statuses?: Maybe<Array<CplProductStatus>>;
};

export type CalculatePremiumRateRequest = {
  lenderPolicy?: InputMaybe<PolicyRateRequest>;
  lenderPremium?: InputMaybe<UpdateTitlePremiumInput>;
  ownerPolicy?: InputMaybe<PolicyRateRequest>;
  ownerPremium?: InputMaybe<UpdateTitlePremiumInput>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  simultaneousIssue?: InputMaybe<Scalars['Boolean']>;
};

export type CalculatingCashToClose = {
  __typename?: 'CalculatingCashToClose';
  id: Scalars['ID'];
  lineItems: Array<CalculatingCashToCloseLineItem>;
  totalEstimatedCashToClose?: Maybe<Scalars['Float']>;
  totalFinalCashToClose?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type CalculatingCashToCloseInput = {
  lineItems: Array<CalculatingCashToCloseLineItemInput>;
  orderId: Scalars['ID'];
  updatedTimestamp: Scalars['DateTime'];
};

export type CalculatingCashToCloseLineItem = {
  __typename?: 'CalculatingCashToCloseLineItem';
  details?: Maybe<Scalars['String']>;
  didChange?: Maybe<Scalars['Boolean']>;
  estimatedAmount?: Maybe<Scalars['Float']>;
  finalAmount?: Maybe<Scalars['Float']>;
  finalAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  id: Scalars['ID'];
  type: Scalars['String'];
};

export type CalculatingCashToCloseLineItemInput = {
  details?: InputMaybe<Scalars['String']>;
  estimatedAmount?: InputMaybe<Scalars['Float']>;
  finalAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
};

export type CanInterestRateIncreaseAfterClosingQuestion = {
  __typename?: 'CanInterestRateIncreaseAfterClosingQuestion';
  adjustsEveryAfterDate?: Maybe<Scalars['String']>;
  adjustsEveryIncrement?: Maybe<Scalars['Float']>;
  changePercentage?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  firstChangeIncrement?: Maybe<Scalars['Float']>;
  maximumInterestPercentage?: Maybe<Scalars['Float']>;
  maximumPercentageIncrement?: Maybe<Scalars['Float']>;
  minimumInterestPercentage?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
  seeAIRTable?: Maybe<Scalars['Boolean']>;
};

export type CanInterestRateIncreaseAfterClosingQuestionInput = {
  adjustsEveryAfterDate?: InputMaybe<Scalars['String']>;
  adjustsEveryIncrement?: InputMaybe<Scalars['Float']>;
  changePercentage?: InputMaybe<Scalars['Float']>;
  firstChangeDate?: InputMaybe<Scalars['String']>;
  firstChangeIncrement?: InputMaybe<Scalars['Float']>;
  maximumInterestPercentage?: InputMaybe<Scalars['Float']>;
  maximumPercentageIncrement?: InputMaybe<Scalars['Float']>;
  minimumInterestPercentage?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
  seeAIRTable?: InputMaybe<Scalars['Boolean']>;
};

export type CanMonthlyPrincipalAndInterestIncreaseQuestion = {
  __typename?: 'CanMonthlyPrincipalAndInterestIncreaseQuestion';
  adjustsEveryIncrement?: Maybe<Scalars['Float']>;
  adjustsStartIncrement?: Maybe<Scalars['Float']>;
  asHighAsAmount?: Maybe<Scalars['Float']>;
  asHighAsIncrement?: Maybe<Scalars['Float']>;
  firstChangeAsHighAsAmount?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  interestOnlyIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
  seeAPTable?: Maybe<Scalars['Boolean']>;
};

export type CanMonthlyPrincipalAndInterestIncreaseQuestionInput = {
  adjustsEveryIncrement?: InputMaybe<Scalars['Float']>;
  adjustsStartIncrement?: InputMaybe<Scalars['Float']>;
  asHighAsAmount?: InputMaybe<Scalars['Float']>;
  asHighAsIncrement?: InputMaybe<Scalars['Float']>;
  firstChangeAsHighAsAmount?: InputMaybe<Scalars['Float']>;
  firstChangeDate?: InputMaybe<Scalars['String']>;
  interestOnlyIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
  seeAPTable?: InputMaybe<Scalars['Boolean']>;
};

export type CancelTitleSearchOrderInput = {
  orderId: Scalars['String'];
  payload: CancelTitleSearchOrderPayloadInput;
};

export type CancelTitleSearchOrderPayloadInput = {
  externalFileId: Scalars['String'];
  id: Scalars['String'];
  notes: Scalars['String'];
  notificationEmailAddress: Scalars['String'];
  providerId: Scalars['String'];
  serviceOrderReferenceId: Scalars['String'];
};

export type CancelTitleSearchOrderUpdateInput = {
  id: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
};

export type CarrierAccountAuthorizationResult = {
  __typename?: 'CarrierAccountAuthorizationResult';
  success: Scalars['Boolean'];
};

export type CarrierAccountObject = {
  __typename?: 'CarrierAccountObject';
  active: Scalars['Boolean'];
  authLink?: Maybe<Scalars['String']>;
  authenticated: Scalars['Boolean'];
  carrierAccountNumber: Scalars['String'];
  carrierType: CarrierType;
  companyAccess: CompanyAccess;
  companyInfo: CarrierAccountObject_CompanyInfo;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  shippingAddress: CarrierAccountObject_ShippingAddress;
  tenantId: Scalars['ID'];
  updatedBy: UserDisplayName;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type CarrierAccountObject_CompanyInfo = {
  __typename?: 'CarrierAccountObject_CompanyInfo';
  address: CarrierAccountObject_CompanyInfo_Address;
  contact: CarrierAccountObject_CompanyInfo_Contact;
  name: Scalars['String'];
};

export type CarrierAccountObject_CompanyInfo_Address = {
  __typename?: 'CarrierAccountObject_CompanyInfo_Address';
  city: Scalars['String'];
  country: CountryCodes;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type CarrierAccountObject_CompanyInfo_Contact = {
  __typename?: 'CarrierAccountObject_CompanyInfo_Contact';
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type CarrierAccountObject_ShippingAddress = {
  __typename?: 'CarrierAccountObject_ShippingAddress';
  city: Scalars['String'];
  country: CountryCodes;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export enum CarrierType {
  Fedex = 'FEDEX',
  Ups = 'UPS'
}

export type ChainOfTitleV2 = {
  __typename?: 'ChainOfTitleV2';
  consistencyIssues?: Maybe<Array<Scalars['String']>>;
  conveyingParties?: Maybe<Array<Scalars['String']>>;
  currentVesting?: Maybe<Scalars['String']>;
  gapsIdentified?: Maybe<Array<Scalars['String']>>;
  isComplete?: Maybe<Scalars['Boolean']>;
  vestingHistory?: Maybe<Array<VestingEntryV2>>;
  vestingType?: Maybe<Scalars['String']>;
};

export type CheckAuthorizedSignatory = {
  __typename?: 'CheckAuthorizedSignatory';
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export type CheckPrinting = {
  __typename?: 'CheckPrinting';
  includeCompanyLogo?: Maybe<Scalars['Boolean']>;
  leftMarginAdjustment?: Maybe<Scalars['Float']>;
  micrLineStartPosition?: Maybe<Scalars['Int']>;
  numberLastUsed?: Maybe<Scalars['Int']>;
  numberStart?: Maybe<Scalars['Int']>;
  signatories?: Maybe<CheckPrintingSignatories>;
  signatureLineCount?: Maybe<Scalars['Int']>;
  signatures?: Maybe<CheckPrintingSignatures>;
  templateId?: Maybe<Scalars['String']>;
  topMarginAdjustment?: Maybe<Scalars['Float']>;
  voidAfterDays?: Maybe<Scalars['Int']>;
};

export type CheckPrintingData = {
  __typename?: 'CheckPrintingData';
  escrowAccount: EscrowAccount;
  fund: Fund;
  id: Scalars['ID'];
  micrLine: Array<Scalars['String']>;
  transaction: Transaction;
  transactionLineDetails: Array<LineDetail>;
};

export type CheckPrintingInput = {
  includeCompanyLogo?: InputMaybe<Scalars['Boolean']>;
  leftMarginAdjustment?: InputMaybe<Scalars['Float']>;
  micrLineStartPosition?: InputMaybe<Scalars['Int']>;
  numberLastUsed?: InputMaybe<Scalars['Int']>;
  numberStart?: InputMaybe<Scalars['Int']>;
  signatories?: InputMaybe<CheckPrintingSignatoriesInput>;
  signatureLineCount?: InputMaybe<Scalars['Int']>;
  templateId?: InputMaybe<Scalars['String']>;
  topMarginAdjustment?: InputMaybe<Scalars['Float']>;
  voidAfterDays?: InputMaybe<Scalars['Int']>;
};

export type CheckPrintingSignatories = {
  __typename?: 'CheckPrintingSignatories';
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
};

export type CheckPrintingSignatoriesInput = {
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
};

export type CheckPrintingSignatures = {
  __typename?: 'CheckPrintingSignatures';
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
};

export type CheckPrintingSignaturesInput = {
  line1?: InputMaybe<Scalars['String']>;
  line2?: InputMaybe<Scalars['String']>;
};

export type CheckPrintingTestInput = {
  escrowAccountId?: InputMaybe<Scalars['String']>;
  includeCompanyLogo?: InputMaybe<Scalars['Boolean']>;
  leftMarginAdjustment?: InputMaybe<Scalars['Float']>;
  micrLineStartPosition?: InputMaybe<Scalars['Int']>;
  numberLastUsed?: InputMaybe<Scalars['Int']>;
  numberStart?: InputMaybe<Scalars['Int']>;
  signatories?: InputMaybe<CheckPrintingSignatoriesInput>;
  signatureLineCount?: InputMaybe<Scalars['Int']>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
  templateId?: InputMaybe<Scalars['String']>;
  topMarginAdjustment?: InputMaybe<Scalars['Float']>;
  voidAfterDays?: InputMaybe<Scalars['Int']>;
};

export type ClassifiedDocumentV2 = {
  __typename?: 'ClassifiedDocumentV2';
  segments?: Maybe<Array<ClassifiedSegmentV2>>;
  sourceFilename?: Maybe<Scalars['String']>;
};

export type ClassifiedSegmentV2 = {
  __typename?: 'ClassifiedSegmentV2';
  documentCategory?: Maybe<Scalars['String']>;
  documentType: Scalars['String'];
  rationaleAndSummary?: Maybe<Scalars['String']>;
  relevantPageNumbers?: Maybe<Array<Scalars['Float']>>;
};

export type ClauseAppliedToConfiguration = {
  __typename?: 'ClauseAppliedToConfiguration';
  clauseAppliedToRules: Array<ClauseAppliedToUiRule>;
};

export type ClauseAppliedToUiRule = {
  __typename?: 'ClauseAppliedToUiRule';
  allowed: Array<Scalars['String']>;
  clauseType: Scalars['String'];
  default?: Maybe<Scalars['String']>;
  selectable: Scalars['Boolean'];
};

export type ClausePackage = Node & {
  __typename?: 'ClausePackage';
  active?: Maybe<Scalars['Boolean']>;
  adminNotes?: Maybe<Scalars['String']>;
  clauses?: Maybe<Array<Maybe<ClauseSummary>>>;
  companyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  title?: Maybe<Scalars['String']>;
  underwriterIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type ClausePackageConnection = Connection & {
  __typename?: 'ClausePackageConnection';
  edges: Array<ClausePackageEdge>;
  pageInfo: PageInfo;
};

export type ClausePackageDomain = {
  __typename?: 'ClausePackageDomain';
  connection?: Maybe<ClausePackageConnection>;
  list?: Maybe<Array<ClausePackage>>;
};


export type ClausePackageDomainConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClausePackageFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type ClausePackageDomainListArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type ClausePackageEdge = Edge & {
  __typename?: 'ClausePackageEdge';
  node: ClausePackage;
};

export enum ClausePackageField {
  Active = 'active',
  CompanyIds = 'companyIds',
  Name = 'name',
  States = 'states',
  Title = 'title',
  UnderwriterIds = 'underwriterIds',
  UpdatedBy = 'updatedBy',
  UpdatedByDisplayName = 'updatedByDisplayName',
  UpdatedTimestamp = 'updatedTimestamp'
}

export type ClausePackageFilter = {
  field: ClausePackageField;
  operator: ApiFilterOperator;
  value: Scalars['String'];
};

export type ClausePackageInput = {
  active: Scalars['Boolean'];
  adminNotes?: InputMaybe<Scalars['String']>;
  clauseIds: Array<InputMaybe<Scalars['String']>>;
  companyIds: Array<InputMaybe<Scalars['String']>>;
  name: Scalars['String'];
  states: Array<InputMaybe<Scalars['String']>>;
  title?: InputMaybe<Scalars['String']>;
  underwriterIds: Array<InputMaybe<Scalars['String']>>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type ClauseSummary = {
  __typename?: 'ClauseSummary';
  bodyTemplate?: Maybe<Scalars['String']>;
  clauseId: Scalars['ID'];
  mergeFields?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type ClauseTemplate = Node & {
  __typename?: 'ClauseTemplate';
  active?: Maybe<Scalars['Boolean']>;
  adminNotes?: Maybe<Scalars['String']>;
  appliedTo?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  companyIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy: Scalars['String'];
  createdByDisplayName?: Maybe<Scalars['String']>;
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  isGlobal: Scalars['Boolean'];
  mergeFields?: Maybe<Scalars['String']>;
  organizationId: Scalars['String'];
  packagesToDelete?: Maybe<Array<Scalars['String']>>;
  recitalType?: Maybe<SecurityInstrumentRecitalType>;
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  title: Scalars['String'];
  type: Scalars['String'];
  underwriters?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy: Scalars['String'];
  updatedByDisplayName?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type ClauseTemplateConnection = Connection & {
  __typename?: 'ClauseTemplateConnection';
  edges: Array<ClauseTemplateEdge>;
  pageInfo?: Maybe<PageInfo>;
};

export type ClauseTemplateDomain = {
  __typename?: 'ClauseTemplateDomain';
  connection?: Maybe<ClauseTemplateConnection>;
  fluentConnection?: Maybe<ClauseTemplateConnection>;
  list?: Maybe<WrappedClauseTemplateResponse>;
};


export type ClauseTemplateDomainConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type ClauseTemplateDomainFluentConnectionArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type ClauseTemplateDomainListArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type ClauseTemplateEdge = Edge & {
  __typename?: 'ClauseTemplateEdge';
  node: ClauseTemplate;
};

export enum ClauseTemplateField {
  Active = 'active',
  AdminNotes = 'adminNotes',
  AppliedTo = 'appliedTo',
  BodyTemplate = 'bodyTemplate',
  CompanyIds = 'companyIds',
  CreatedBy = 'createdBy',
  CreatedTimestamp = 'createdTimestamp',
  Id = 'id',
  IsGlobal = 'isGlobal',
  MergeFields = 'mergeFields',
  OrganizationId = 'organizationId',
  States = 'states',
  Title = 'title',
  Type = 'type',
  Underwriters = 'underwriters',
  UpdatedBy = 'updatedBy',
  UpdatedByDisplayName = 'updatedByDisplayName',
  UpdatedTimestamp = 'updatedTimestamp'
}

export type ClauseTemplateFilter = {
  field: ClauseTemplateField;
  operator: ApiFilterOperator;
  sizeOperator?: InputMaybe<Scalars['String']>;
  value: Scalars['String'];
};

export type ClauseTemplateInput = {
  active: Scalars['Boolean'];
  adminNotes: Scalars['String'];
  appliedTo: Scalars['String'];
  bodyTemplate: Scalars['String'];
  companyIds: Array<InputMaybe<Scalars['String']>>;
  recitalType?: InputMaybe<SecurityInstrumentRecitalType>;
  states: Array<InputMaybe<Scalars['String']>>;
  title: Scalars['String'];
  type: Scalars['String'];
  underwriters: Array<InputMaybe<Scalars['String']>>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type ClearAdjustmentInput = {
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type ClearDcAdjustmentInput = {
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type ClearFeeInput = {
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type ClearTransaction = {
  id: Scalars['String'];
  isCleared: Scalars['Boolean'];
  updatedTimestamp: Scalars['String'];
};

export type ClearTransactionsInput = {
  transactions: Array<ClearTransaction>;
};

export type ClearTransactionsResponse = {
  __typename?: 'ClearTransactionsResponse';
  clearedTransactions?: Maybe<Array<Maybe<Transaction>>>;
  ineligibleTransactions?: Maybe<Array<Maybe<IneligibleTransactions>>>;
};

export type ClosingAttorney = {
  __typename?: 'ClosingAttorney';
  attorneyId: Scalars['String'];
  attorneyName: Scalars['String'];
};

export type ClosingCosts = {
  __typename?: 'ClosingCosts';
  closingCosts?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lenderCredits?: Maybe<Scalars['Float']>;
  loanCosts?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['ID']>;
  otherCosts?: Maybe<Scalars['Float']>;
};

export type ClosingInformation = {
  __typename?: 'ClosingInformation';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  estimatedEscrowAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  interestRate?: Maybe<Scalars['Float']>;
  issueDate?: Maybe<Scalars['String']>;
  loanPurpose?: Maybe<Scalars['String']>;
  loanTerm?: Maybe<Scalars['Float']>;
  loanTermType?: Maybe<Scalars['String']>;
  loanType?: Maybe<Scalars['String']>;
  monthlyMIP?: Maybe<Scalars['Float']>;
  mortgageInsuranceCaseNumber?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  principalAndInterestAmount?: Maybe<Scalars['Float']>;
  product?: Maybe<Scalars['String']>;
  propertyValue?: Maybe<Scalars['Float']>;
  propertyValueType?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type ClosingInformationInput = {
  estimatedEscrowAmount?: InputMaybe<Scalars['Float']>;
  interestRate?: InputMaybe<Scalars['Float']>;
  issueDate?: InputMaybe<Scalars['String']>;
  loanPurpose?: InputMaybe<Scalars['String']>;
  loanTerm?: InputMaybe<Scalars['Float']>;
  loanTermType?: InputMaybe<Scalars['String']>;
  loanType?: InputMaybe<Scalars['String']>;
  monthlyMIP?: InputMaybe<Scalars['Float']>;
  mortgageInsuranceCaseNumber?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  principalAndInterestAmount?: InputMaybe<Scalars['Float']>;
  product?: InputMaybe<Scalars['String']>;
  propertyValue?: InputMaybe<Scalars['Float']>;
  propertyValueType?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type ClosingQuestions = {
  __typename?: 'ClosingQuestions';
  amountIncreaseAfterClosingQuestion?: Maybe<AmountIncreaseAfterClosingQuestion>;
  canInterestRateIncreaseAfterClosingQuestion?: Maybe<CanInterestRateIncreaseAfterClosingQuestion>;
  canMonthlyPrincipalAndInterestIncreaseQuestion?: Maybe<CanMonthlyPrincipalAndInterestIncreaseQuestion>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['ID']>;
  loanBalloonPaymentQuestion?: Maybe<LoanBalloonPaymentQuestion>;
  loanPrepaymentPenaltyQuestion?: Maybe<LoanPrepaymentPenaltyQuestion>;
  orderId?: Maybe<Scalars['ID']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type ClosingQuestionsInput = {
  amountIncreaseAfterClosingQuestion?: InputMaybe<AmountIncreaseAfterClosingQuestionInput>;
  canInterestRateIncreaseAfterClosingQuestion?: InputMaybe<CanInterestRateIncreaseAfterClosingQuestionInput>;
  canMonthlyPrincipalAndInterestIncreaseQuestion?: InputMaybe<CanMonthlyPrincipalAndInterestIncreaseQuestionInput>;
  loanBalloonPaymentQuestion?: InputMaybe<LoanBalloonPaymentQuestionInput>;
  loanPrepaymentPenaltyQuestion?: InputMaybe<LoanPrepaymentPenaltyQuestionInput>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type ColumnSets = {
  __typename?: 'ColumnSets';
  columnName: Scalars['String'];
  columnValues: Array<Scalars['String']>;
};

export type CombineDocumentsRequestV2Input = {
  /** @minItems 2 */
  documentIds: Array<Scalars['String']>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  subscriptionId?: InputMaybe<Scalars['ID']>;
  targetDocumentName: Scalars['String'];
};

export type CombineEntityDocumentsRequestV2Input = {
  /** @minItems 2 */
  documentIds: Array<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
  targetDocumentName: Scalars['String'];
};

export type CommissionBasisOverride = {
  __typename?: 'CommissionBasisOverride';
  value?: Maybe<Scalars['Float']>;
};

export type CommissionFeeAdditionalData = {
  __typename?: 'CommissionFeeAdditionalData';
  agentType?: Maybe<Scalars['String']>;
  externalCommissionLineId?: Maybe<Scalars['String']>;
};

export type CommissionLineItem = {
  __typename?: 'CommissionLineItem';
  commissionAmount?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['ID']>;
  realEstateAgentPartyReferenceId?: Maybe<Scalars['String']>;
  realEstateAgentType?: Maybe<Scalars['String']>;
};

export type Company = {
  __typename?: 'Company';
  active?: Maybe<Scalars['Boolean']>;
  addresses?: Maybe<Array<Maybe<Address>>>;
  altaId?: Maybe<Scalars['ID']>;
  alternateSearchName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdTimestamp?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  lenderLanguage?: Maybe<Scalars['String']>;
  lenderLanguageDefaultType?: Maybe<Scalars['String']>;
  lenderLanguageOptions?: Maybe<LenderLanguageOptions>;
  lenderLanguageOptionsOverrideMetadata?: Maybe<LenderLanguageOptionsOverrideMetadata>;
  licenses?: Maybe<Array<Maybe<License>>>;
  nmlsId?: Maybe<Scalars['ID']>;
  notaryCertification?: Maybe<Scalars['String']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentItemId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  taxId?: Maybe<Scalars['ID']>;
  taxIdType?: Maybe<Scalars['String']>;
  tenantOrgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  wireInstructions?: Maybe<WireSchema>;
};

export type CompanyAccess = {
  __typename?: 'CompanyAccess';
  companies?: Maybe<Array<CompanyAccessItem>>;
  enabledAll?: Maybe<Scalars['Boolean']>;
};

export type CompanyAccessInput = {
  companies?: InputMaybe<Array<CompanyAccessItemInput>>;
  enabledAll?: InputMaybe<Scalars['Boolean']>;
};

export type CompanyAccessItem = {
  __typename?: 'CompanyAccessItem';
  branches: Array<Scalars['String']>;
  id: Scalars['ID'];
};

export type CompanyAccessItemInput = {
  branches: Array<Scalars['String']>;
  id: Scalars['ID'];
};

export type CompanyContact = {
  __typename?: 'CompanyContact';
  company?: Maybe<Company>;
  contact?: Maybe<Contact>;
};

export type CompanyIdRequestInput = {
  companyId: Scalars['ID'];
};

export type CompanyPartialInput = {
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['ID']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  directoryCompanyId?: InputMaybe<Scalars['ID']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  lenderLanguage?: InputMaybe<Scalars['String']>;
  lenderLanguageDefaultType?: InputMaybe<Scalars['String']>;
  lenderLanguageOptions?: InputMaybe<LenderLanguageOptionsInput>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['ID']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['ID']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

export type CompanyRecipientAccountNumber = {
  __typename?: 'CompanyRecipientAccountNumber';
  recipientAccountNumber?: Maybe<Scalars['String']>;
};

export type CompanySummary = {
  __typename?: 'CompanySummary';
  active?: Maybe<Scalars['Boolean']>;
  alternateSearchName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  mailingAddress?: Maybe<Address>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentItemId?: Maybe<Scalars['String']>;
  primaryAddress?: Maybe<Address>;
  primaryEmail?: Maybe<Scalars['String']>;
  primaryPhone?: Maybe<PhoneNumberType>;
  tenantOrgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type CompanySummaryConnection = {
  __typename?: 'CompanySummaryConnection';
  edges?: Maybe<Array<Maybe<CompanySummaryEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type CompanySummaryEdge = {
  __typename?: 'CompanySummaryEdge';
  node?: Maybe<CompanySummary>;
};

export type CompanyTaxId = {
  __typename?: 'CompanyTaxId';
  taxId?: Maybe<Scalars['String']>;
};

export type CompanyTypeDefinition = {
  __typename?: 'CompanyTypeDefinition';
  additionalPartyRoleName?: Maybe<Scalars['String']>;
  additionalProperties?: Maybe<Array<Maybe<Scalars['String']>>>;
  id: Scalars['ID'];
  isSystemType?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
};

export type CompanyTypes = {
  __typename?: 'CompanyTypes';
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  types: Array<CompanyTypeDefinition>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type CompletenessCheckV2 = {
  __typename?: 'CompletenessCheckV2';
  category: Scalars['String'];
  documentCount?: Maybe<Scalars['Float']>;
  issues?: Maybe<Array<Scalars['String']>>;
  missingDocuments?: Maybe<Array<MissingDocumentItemV2>>;
  status: CompletenessCheckV2Status;
};

export enum CompletenessCheckV2Status {
  NotFound = 'NOT_FOUND',
  Ok = 'OK',
  Review = 'REVIEW'
}

export type ConfidenceFloat = {
  __typename?: 'ConfidenceFloat';
  confidenceLevel?: Maybe<ConfidenceLevel>;
  value?: Maybe<Scalars['Float']>;
};

export enum ConfidenceLevel {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

/**
 * A value extracted by Bonsai together with the confidence it was extracted with.
 * A null confidenceLevel means the leaf was not assessed, which is distinct from a low score.
 */
export type ConfidenceString = {
  __typename?: 'ConfidenceString';
  confidenceLevel?: Maybe<ConfidenceLevel>;
  value?: Maybe<Scalars['String']>;
};

export type Configuration = {
  __typename?: 'Configuration';
  contentful?: Maybe<ContentfulConfiguration>;
  google?: Maybe<GoogleConfiguration>;
  smartyStreet?: Maybe<SmartyStreetConfiguration>;
};

export type Connection = {
  edges: Array<Edge>;
  pageInfo?: Maybe<PageInfo>;
};

export type Consideration = {
  __typename?: 'Consideration';
  name?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type ConsiderationInput = {
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type ConsolidatedDisbursementRow = {
  __typename?: 'ConsolidatedDisbursementRow';
  amount?: Maybe<Scalars['Float']>;
  companyName?: Maybe<Scalars['String']>;
  consolidatedPaymentId?: Maybe<Scalars['String']>;
  directoryCompanyId?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  originTransactionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
};

export type ConsolidatedLineDetail = {
  __typename?: 'ConsolidatedLineDetail';
  amount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  refMetadata?: Maybe<Scalars['JSONObject']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ConsolidatedPayee = {
  __typename?: 'ConsolidatedPayee';
  active?: Maybe<Scalars['Boolean']>;
  alternateSearchName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  directoryCompanyId?: Maybe<Scalars['String']>;
  isActiveConsolidatedPayee?: Maybe<Scalars['Boolean']>;
  primaryAddress?: Maybe<Scalars['String']>;
  primaryPhoneNumber?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ConsolidatedPayeeEligibility = {
  __typename?: 'ConsolidatedPayeeEligibility';
  directoryCompanyId?: Maybe<Scalars['String']>;
  isEligible?: Maybe<Scalars['Boolean']>;
};

export type ConsolidatedPaymentLineItem = {
  __typename?: 'ConsolidatedPaymentLineItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  originalTransactionDate?: Maybe<Scalars['String']>;
};

export type ConsolidatedPaymentReport = {
  __typename?: 'ConsolidatedPaymentReport';
  consolidatedDate?: Maybe<Scalars['String']>;
  lineItems?: Maybe<Array<Maybe<ConsolidatedPaymentLineItem>>>;
  parentTransactionId?: Maybe<Scalars['String']>;
  payee?: Maybe<ConsolidatedPaymentReportPayee>;
  referenceNumber?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type ConsolidatedPaymentReportPayee = {
  __typename?: 'ConsolidatedPaymentReportPayee';
  directoryCompanyId?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
};

export type ConsolidatedPaymentWithLineDetails = {
  __typename?: 'ConsolidatedPaymentWithLineDetails';
  amount?: Maybe<Scalars['Float']>;
  consolidatedLineDetails?: Maybe<Array<Maybe<ConsolidatedLineDetail>>>;
  consolidatedPaymentId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  directoryCompanyId?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  originTransactionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ConsolidatedPendingTransaction = {
  __typename?: 'ConsolidatedPendingTransaction';
  amount?: Maybe<Scalars['Float']>;
  dateDisbursement?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  orderStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
};

export type Contact = {
  __typename?: 'Contact';
  active?: Maybe<Scalars['Boolean']>;
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<Maybe<License>>>;
  middleName?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  notaryCommissions?: Maybe<Array<Maybe<NotaryCommissions>>>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  useCompanyAddress?: Maybe<Scalars['Boolean']>;
};

export enum ContactMethod {
  TextMessage = 'TEXT_MESSAGE'
}

export type ContactPartialInput = {
  address?: InputMaybe<AddressInput>;
  contactId?: InputMaybe<Scalars['ID']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  middleName?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  title?: InputMaybe<Scalars['String']>;
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
};

export type ContactSummary = {
  __typename?: 'ContactSummary';
  active?: Maybe<Scalars['Boolean']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type ContactValidationRequestInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  orderId: Scalars['ID'];
  /** Party identifier - corresponds to buyerSellerId from orders service */
  partyId: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  /** Provider extracted from URL path parameter - not sent in request body by frontend */
  provider: ContactValidationRequestInputProvider;
  stateCode?: InputMaybe<Scalars['String']>;
  /** Underwriter name for validation rules */
  underwriter: Scalars['String'];
};

/** Provider extracted from URL path parameter - not sent in request body by frontend */
export enum ContactValidationRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type ContactValidationResponse = {
  __typename?: 'ContactValidationResponse';
  /** When validation was performed */
  createdAt: Scalars['String'];
  /** Our generated reference ID for internal tracking */
  referenceId?: Maybe<Scalars['ID']>;
  /** When validation was originally requested */
  requestedDate?: Maybe<Scalars['String']>;
  result?: Maybe<ContactValidationResponse_Result>;
  resultSummary?: Maybe<ContactValidationResponse_ResultSummary>;
  /** Transaction status (Completed, Failed, etc) */
  status: Scalars['String'];
  submittedData?: Maybe<ContactValidationResponse_SubmittedData>;
  /** Unique transaction identifier from SAFEIdentity */
  transactionId: Scalars['ID'];
};

/** Detailed contact validation results */
export type ContactValidationResponse_Result = {
  __typename?: 'ContactValidationResponse_Result';
  /** Address match status */
  addressMatch?: Maybe<Scalars['String']>;
  /** Address fraud match indicator */
  addressMatchWithFraud?: Maybe<Scalars['String']>;
  /** Date email was first seen */
  emailFirstSeenDate?: Maybe<Scalars['String']>;
  /** First name match status */
  firstNameMatch?: Maybe<Scalars['String']>;
  /** Last name match status */
  lastNameMatch?: Maybe<Scalars['String']>;
  /** Result message */
  message?: Maybe<Scalars['String']>;
  /** Phone carrier information */
  phoneCarrier?: Maybe<Scalars['String']>;
  /** Phone match status */
  phoneMatch?: Maybe<Scalars['String']>;
  /** Phone fraud match indicator */
  phoneMatchWithFraud?: Maybe<Scalars['String']>;
  /** Type of phone (mobile, landline, etc) */
  phoneType?: Maybe<Scalars['String']>;
  /** Whether phone is prepaid */
  phoneisPrePaid?: Maybe<Scalars['String']>;
  /** Numeric result code */
  result: Scalars['Float'];
  /** Category of the result */
  resultCategory?: Maybe<Scalars['String']>;
};

/** Summary of validation results */
export type ContactValidationResponse_ResultSummary = {
  __typename?: 'ContactValidationResponse_ResultSummary';
  addressMatchWithFraud?: Maybe<Scalars['String']>;
  emailRegisteredDate: Scalars['String'];
  firstNameMatch?: Maybe<Scalars['String']>;
  lastNameMatch?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  phoneCarrier: Scalars['String'];
  phoneMatchWithFraud?: Maybe<Scalars['String']>;
  phoneMatchesSubmittedData: Scalars['String'];
  phoneType: Scalars['String'];
  potentialRisks: Array<Scalars['String']>;
  prepaidPhone: Scalars['String'];
  resultCategory?: Maybe<Scalars['String']>;
  streetAddressMatch: Scalars['String'];
};

/** The input data that was validated */
export type ContactValidationResponse_SubmittedData = {
  __typename?: 'ContactValidationResponse_SubmittedData';
  /** Street address line 1 that was validated */
  address1?: Maybe<Scalars['String']>;
  /** Street address line 2 that was validated */
  address2?: Maybe<Scalars['String']>;
  /** City that was validated */
  city?: Maybe<Scalars['String']>;
  /** Email address that was validated */
  emailAddress?: Maybe<Scalars['String']>;
  /** Phone number that was validated */
  phoneNumber?: Maybe<Scalars['String']>;
  /** Postal code that was validated */
  postalCode?: Maybe<Scalars['String']>;
  /** State code that was validated */
  stateCode?: Maybe<Scalars['String']>;
};

export type ContactWithCompanySummary = {
  __typename?: 'ContactWithCompanySummary';
  active?: Maybe<Scalars['Boolean']>;
  directoryCompanyId: Scalars['String'];
  directoryCompanyName?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isManagedEntry?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ContactWithCompanySummaryConnection = {
  __typename?: 'ContactWithCompanySummaryConnection';
  edges?: Maybe<Array<Maybe<ContactWithCompanySummaryEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type ContactWithCompanySummaryEdge = {
  __typename?: 'ContactWithCompanySummaryEdge';
  node?: Maybe<ContactWithCompanySummary>;
};

export type ContentfulConfiguration = {
  __typename?: 'ContentfulConfiguration';
  contentDeliveryApiKey?: Maybe<Scalars['String']>;
  contentPreviewApiKey?: Maybe<Scalars['String']>;
  isPreview?: Maybe<Scalars['Boolean']>;
  spaceId?: Maybe<Scalars['String']>;
};

export type ConvertEntityDocumentScopeErrorV2 = {
  __typename?: 'ConvertEntityDocumentScopeErrorV2';
  documentId: Scalars['ID'];
  reason: Scalars['String'];
};

export type ConvertEntityDocumentScopeResponseV2 = {
  __typename?: 'ConvertEntityDocumentScopeResponseV2';
  convertedDocuments: Array<EntityDocumentV2>;
  failed: Array<ConvertEntityDocumentScopeErrorV2>;
};

export type ConvertEntityDocumentScopeV2Input = {
  /**
   * @minItems 1
   * @maxItems 100
   */
  documentIds: Array<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  newScopeId: Scalars['ID'];
  scopeId?: InputMaybe<Scalars['ID']>;
};

export type ConvertPendingOrderDocumentsV2Input = {
  entityId: Scalars['ID'];
  entityType: ConvertPendingOrderDocumentsV2InputEntityType;
  orderId: Scalars['ID'];
  scopeId?: InputMaybe<Scalars['ID']>;
};

export enum ConvertPendingOrderDocumentsV2InputEntityType {
  PendingOrder = 'PENDING_ORDER'
}

export enum CountryCodes {
  Us = 'US'
}

export type CoveredPartyStatisticalCode = {
  __typename?: 'CoveredPartyStatisticalCode';
  coveredParty: Scalars['String'];
  statisticalCodes?: Maybe<Array<Maybe<StatisticalCode>>>;
};

export type CplFeeAdditionalData = {
  __typename?: 'CplFeeAdditionalData';
  externalCplId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type CplProduct = {
  __typename?: 'CplProduct';
  createdTimestamp: Scalars['String'];
  documentId: Scalars['String'];
  id: Scalars['String'];
  lender?: Maybe<CplProductLender>;
  statuses: Array<CplProductStatus>;
};

export type CplProductLender = {
  __typename?: 'CplProductLender';
  address: Address;
  loanNumber?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type CplProductStatus = {
  __typename?: 'CplProductStatus';
  code: Scalars['String'];
  description: Scalars['String'];
};

export type CreateAdjustmentInput = {
  addendumLineNumber?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
};

export type CreateAdminMilestoneResponse = {
  __typename?: 'CreateAdminMilestoneResponse';
  existingMilestoneName?: Maybe<Scalars['String']>;
  milestone?: Maybe<AdminMilestone>;
};

export type CreateAdminWorkflowResponse = {
  __typename?: 'CreateAdminWorkflowResponse';
  existingWorkflowName?: Maybe<Scalars['String']>;
  workflow?: Maybe<AdminWorkflow>;
};

export type CreateAndPurchaseShipmentRequestInput = {
  buyerAddress?: InputMaybe<ShipmentAddressInput>;
  /** @minItems 1 */
  carrierAccounts: Array<Scalars['String']>;
  customLabelField?: InputMaybe<Scalars['String']>;
  deliveryConfirmation?: InputMaybe<Scalars['String']>;
  dropoffType?: InputMaybe<Scalars['String']>;
  fromAddress: ShipmentAddressInput;
  insurance?: InputMaybe<Scalars['String']>;
  labelDate?: InputMaybe<Scalars['String']>;
  labelSize?: InputMaybe<CreateAndPurchaseShipmentRequestInputLabelSize>;
  orderId: Scalars['ID'];
  parcel: ShipmentParcelInput;
  paymentOption?: InputMaybe<ShipmentPaymentOptionInput>;
  returnAddress?: InputMaybe<ShipmentAddressInput>;
  saturdayDelivery?: InputMaybe<Scalars['Boolean']>;
  service: ShippingServiceTypes;
  toAddress: ShipmentAddressInput;
};

export enum CreateAndPurchaseShipmentRequestInputLabelSize {
  Size_4X6 = 'SIZE_4X6',
  Size_4X7 = 'SIZE_4X7',
  Size_8_5X11 = 'SIZE_8_5X11'
}

export type CreateBuyerInput = {
  address?: InputMaybe<AddressInput>;
  alias?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  forwardingAddress?: InputMaybe<AddressInput>;
  forwardingAddressSameAsCurrentAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingRegion?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  isForeignAddress?: InputMaybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeOfBuyerSeller?: InputMaybe<Scalars['String']>;
  vesting?: InputMaybe<Scalars['String']>;
};

export type CreateChangePasswordUserEventInput = {
  id: Scalars['ID'];
};

export type CreateDcAdjustmentInput = {
  addendumLineNumber?: InputMaybe<Scalars['Int']>;
  amount?: InputMaybe<Scalars['Float']>;
  dcAddendumLineNumber?: InputMaybe<Scalars['Int']>;
  dcLineNumber?: InputMaybe<Scalars['Int']>;
  description: Scalars['String'];
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  lineNumber: Scalars['Int'];
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
};

export type CreateDirectoryCompanyInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['String']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  lenderLanguage?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentItemId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  tenantOrgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

export type CreateDirectoryContactInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  middleName?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
  notaryCommissions?: InputMaybe<Array<InputMaybe<NotaryCommissionsInput>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
};

export type CreateDraftPackageInput = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  orderId: Scalars['ID'];
  packageName: Scalars['String'];
};

export type CreateEntityDocumentFromKnownTemplateV2Input = {
  description?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  listMergeChoices?: InputMaybe<Scalars['String']>;
  mergeFieldData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  templateType: Scalars['String'];
};

export type CreateEntityDocumentFromTemplateIdV2Input = {
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  scopeId?: InputMaybe<Scalars['ID']>;
  templateId: Scalars['ID'];
};

export type CreateEntityDocumentFromTemplateResultV2 = {
  __typename?: 'CreateEntityDocumentFromTemplateResultV2';
  document?: Maybe<EntityDocumentV2>;
  error?: Maybe<CreateFromTemplateErrorV2>;
  success: Scalars['Boolean'];
  templateId: Scalars['ID'];
};

export type CreateEntityDocumentV2Input = {
  description?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  fileType: Scalars['String'];
  name: Scalars['String'];
  resourceId: Scalars['ID'];
  scopeId?: InputMaybe<Scalars['ID']>;
  skipClone?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateEpnAccountInput = {
  accountName: Scalars['String'];
  apiKey: Scalars['String'];
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  isAutoSubmitEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type CreateEscrowAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  accountNumberAlternate?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<InputMaybe<EscrowAccountAddressInput>>>;
  bankName: Scalars['String'];
  checkPrinting?: InputMaybe<CheckPrintingInput>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  escrowAccountName: Scalars['String'];
  integrations?: InputMaybe<EscrowAccountIntegrationsInput>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  positivePay?: InputMaybe<PositivePayInput>;
  routingNumber?: InputMaybe<Scalars['String']>;
  routingNumberDeposit?: InputMaybe<Scalars['String']>;
  routingNumberFractional?: InputMaybe<Scalars['String']>;
  routingNumberWire?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

export type CreateExceptionsInput = {
  exceptions?: InputMaybe<Array<InputMaybe<CreateTitleException>>>;
  orderId: Scalars['String'];
};

export type CreateFeatureAcknowledgmentInput = {
  featureKey: Scalars['String'];
  status: Scalars['String'];
  version: Scalars['Int'];
};

export type CreateFeeInput = {
  borrowerPaidAt?: InputMaybe<Scalars['Float']>;
  borrowerPaidBefore?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  feeLineType: Scalars['String'];
  feeTypeAdditionalData?: InputMaybe<FeeTypeAdditionalDataCreateInput>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  funding: Scalars['String'];
  gfeLineNumber?: InputMaybe<Scalars['String']>;
  isSetAsCDLastLine?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  pboBorrowerAmount?: InputMaybe<Scalars['Float']>;
  pboBorrowerPaidById?: InputMaybe<Scalars['String']>;
  pboSellerAmount?: InputMaybe<Scalars['Float']>;
  pboSellerPaidById?: InputMaybe<Scalars['String']>;
  sellerPaidAt?: InputMaybe<Scalars['Float']>;
  sellerPaidBefore?: InputMaybe<Scalars['Float']>;
  statementPayeeDisplayName?: InputMaybe<Scalars['String']>;
};

export type CreateFromTemplateErrorDataV2 = {
  __typename?: 'CreateFromTemplateErrorDataV2';
  templateBlockName?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type CreateFromTemplateErrorV2 = {
  __typename?: 'CreateFromTemplateErrorV2';
  data?: Maybe<CreateFromTemplateErrorDataV2>;
  errorCode: Scalars['Float'];
  message: Scalars['String'];
};

export type CreateFundInput = {
  escrowAccountId: Scalars['String'];
  orderId: Scalars['String'];
};

export type CreateLineDetailInput = {
  amount: Scalars['Float'];
  description?: InputMaybe<Scalars['String']>;
  escrowAccountId: Scalars['String'];
  isLocked?: InputMaybe<Scalars['Boolean']>;
  lineNumber?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  refMetadata?: InputMaybe<RefMetaDataInput>;
  transactionId: Scalars['String'];
};

export type CreateOrderFromMasterPayload = {
  __typename?: 'CreateOrderFromMasterPayload';
  newOrderId?: Maybe<Scalars['String']>;
  newOrderNumber?: Maybe<Scalars['String']>;
  sourceCloneId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CreateOrderFromMasterV2Payload = {
  __typename?: 'CreateOrderFromMasterV2Payload';
  newOrderId?: Maybe<Scalars['String']>;
  newOrderNumber?: Maybe<Scalars['String']>;
  sourceCloneId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type CreateOrderInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  appraisedValue?: InputMaybe<Scalars['String']>;
  assessedValue?: InputMaybe<Scalars['String']>;
  branch: Scalars['String'];
  businessSource?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  customOrderNumber?: InputMaybe<Scalars['String']>;
  parcelId?: InputMaybe<Scalars['String']>;
  parcelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poluId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  propertyState?: InputMaybe<Scalars['String']>;
  sequenceId: Scalars['String'];
  sourceOrderId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statementType: Scalars['String'];
  transactionTypeId: Scalars['String'];
  underwriterId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderMilestoneInput = {
  name: Scalars['String'];
};

/** This is an input structure for creating an OrderParty with either Directory IDs or complete PartyCompany/PartyContact data */
export type CreateOrderPartyInput = {
  /** When directoryCompanyId is specified, then the company field is ignored */
  company?: InputMaybe<PartyCompanyInput>;
  /** When directoryContactId is specified, then the contact field is ignored */
  contact?: InputMaybe<PartyContactInput>;
  /** Specify the ID of a DirectoryCompany to be copied into the PartyCompany. */
  directoryCompanyReferenceId?: InputMaybe<Scalars['String']>;
  /** Specify the ID of a DirectoryContact to be copied into the PartyContact. */
  directoryContactReferenceId?: InputMaybe<Scalars['String']>;
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  refSectionId?: InputMaybe<Scalars['String']>;
  refSectionLabel?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderPayload = {
  __typename?: 'CreateOrderPayload';
  order?: Maybe<OrderHeader>;
};

export type CreateOrderV2DepositInput = {
  dateReceived?: InputMaybe<Scalars['String']>;
  deductFromCommission?: InputMaybe<Scalars['Boolean']>;
  depositAmount?: InputMaybe<Scalars['Float']>;
  fundsHeldBy?: InputMaybe<Scalars['String']>;
  fundsHeldByResourceId?: InputMaybe<Scalars['String']>;
  receiptNumber?: InputMaybe<Scalars['String']>;
  typeOfFunds?: InputMaybe<Scalars['String']>;
};

export type CreateOrderV2Input = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  amountSale?: InputMaybe<Scalars['Float']>;
  appraisedValue?: InputMaybe<Scalars['String']>;
  assessedValue?: InputMaybe<Scalars['String']>;
  branch: Scalars['String'];
  businessSource?: InputMaybe<Scalars['String']>;
  buyers?: InputMaybe<Array<CreateOrderV2PartyInput>>;
  city?: InputMaybe<Scalars['String']>;
  company: Scalars['String'];
  county?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  customOrderNumber?: InputMaybe<Scalars['String']>;
  dateSettlement?: InputMaybe<Scalars['String']>;
  deposits?: InputMaybe<Array<CreateOrderV2DepositInput>>;
  lender?: InputMaybe<CreateOrderV2LenderInput>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  orcaSessionId?: InputMaybe<Scalars['String']>;
  ownerOccupied?: InputMaybe<Scalars['Boolean']>;
  parcelId?: InputMaybe<Scalars['String']>;
  parcelIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  poluId?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  propertyState?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<Scalars['String']>;
  sellers?: InputMaybe<Array<CreateOrderV2PartyInput>>;
  sequenceId: Scalars['String'];
  sourceOrderId?: InputMaybe<Scalars['String']>;
  statementType: Scalars['String'];
  transactionTypeId: Scalars['String'];
  underwriterId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderV2LenderInput = {
  companyName?: InputMaybe<Scalars['String']>;
  directoryCompanyReferenceId?: InputMaybe<Scalars['String']>;
};

export type CreateOrderV2PartyInput = {
  email?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<CreateOrderV2PhoneInput>;
  spouse?: InputMaybe<CreateOrderV2SpouseInput>;
  suffix?: InputMaybe<Scalars['String']>;
  typeOfBuyerSeller: Scalars['String'];
};

export type CreateOrderV2Payload = {
  __typename?: 'CreateOrderV2Payload';
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
};

export type CreateOrderV2PhoneInput = {
  ext?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateOrderV2SpouseInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<CreateOrderV2PhoneInput>;
  suffix?: InputMaybe<Scalars['String']>;
};

export type CreatePackageTemplateInput = {
  /** @minItems 1 */
  documents: Array<CreatePackageTemplateInputDocumentInput>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
};

export type CreatePackageTemplateInputDocumentInput = {
  documentData?: InputMaybe<Array<DataFieldInput>>;
  documentType: Scalars['String'];
  order: Scalars['Float'];
};

export type CreatePackageTemplateResponse = {
  __typename?: 'CreatePackageTemplateResponse';
  package?: Maybe<PackageDataCore>;
  type?: Maybe<Scalars['String']>;
  versionIdentifier?: Maybe<Scalars['String']>;
};

export type CreatePropertyTaxProrationConfigurationInput = {
  calendarYearStarts: Scalars['String'];
  daysInYear: Scalars['String'];
  dueDates: Array<DueDateInput>;
  includeProrationDate: Scalars['Boolean'];
  paymentFrequency: Scalars['String'];
  state: Scalars['String'];
  taxType: Scalars['String'];
};

export type CreateProrationCharge = {
  frequency?: InputMaybe<Scalars['String']>;
  lineItem?: InputMaybe<ProrationChargeLineItemInput>;
  payeePartyId?: InputMaybe<Scalars['String']>;
  prorationChargeSubtype?: InputMaybe<Scalars['String']>;
  prorationChargeType?: InputMaybe<Scalars['String']>;
  prorationDetails?: InputMaybe<ProrationDetailsInput>;
};

export type CreateProrationInput = {
  frequency: Scalars['String'];
  isPropertyTax: Scalars['Boolean'];
  lineItems?: InputMaybe<Array<InputMaybe<ProrationLineItemInput>>>;
  payeePartyId?: InputMaybe<Scalars['String']>;
  prorationDetails?: InputMaybe<ProrationDetailsInput_V2>;
  prorationSubtype: Scalars['String'];
};

export type CreateReconciliationInput = {
  beginningBalance: Scalars['Float'];
  clearedBalance: Scalars['Float'];
  endingDate: Scalars['String'];
  escrowAccountId: Scalars['String'];
  statementEndingBalance: Scalars['Float'];
  status: ReconciliationStatus;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type CreateRecordingDocumentInput = {
  actualFees?: InputMaybe<Scalars['Float']>;
  associatedDocumentId?: InputMaybe<Scalars['ID']>;
  associatedDocumentType?: InputMaybe<Scalars['String']>;
  book?: InputMaybe<Scalars['String']>;
  collectedFees?: InputMaybe<Scalars['Float']>;
  considerationAmount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['String']>;
  documentTime?: InputMaybe<Scalars['String']>;
  documentType: Scalars['String'];
  instrumentNumber?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  orderId: Scalars['ID'];
  page?: InputMaybe<Scalars['String']>;
  pageCount?: InputMaybe<Scalars['String']>;
  recordedDate?: InputMaybe<Scalars['String']>;
  recordedTime?: InputMaybe<Scalars['String']>;
};

export type CreateReportInput = {
  description?: InputMaybe<Scalars['String']>;
  parentReportId: Scalars['ID'];
  view: ReportViewInput;
  viewName: Scalars['String'];
  visibility: Scalars['ReportViewVisibility'];
};

export type CreateRequirementsInput = {
  orderId: Scalars['ID'];
  requirements?: InputMaybe<Array<InputMaybe<CreateTitleRequirement>>>;
};

export type CreateSecurityGroupInput = {
  description: Scalars['String'];
  name: Scalars['String'];
  permissions?: InputMaybe<Scalars['JSONObject']>;
  schemaVersion?: InputMaybe<Scalars['Int']>;
  type: Scalars['String'];
};

export type CreateSellerInput = {
  address?: InputMaybe<AddressInput>;
  alias?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  forwardingAddress?: InputMaybe<AddressInput>;
  forwardingAddressSameAsCurrentAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingRegion?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  isForeignAddress?: InputMaybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeOfBuyerSeller?: InputMaybe<Scalars['String']>;
  vesting?: InputMaybe<Scalars['String']>;
};

export type CreateStateWithholdingInput = {
  description?: InputMaybe<Scalars['String']>;
  oTotalWithholdingBasis?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  payorPayeeId: Scalars['String'];
  sellers: Array<InputMaybe<StateWithholdingSellerValuesInput>>;
};

export type CreateTagV2Input = {
  attributes?: InputMaybe<TagDataItemAttributesV2Input>;
  name: Scalars['String'];
  sortPriority?: InputMaybe<Scalars['Int']>;
};

export type CreateTemplateDocV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  resourceId: Scalars['ID'];
  tags?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateTemplateSetV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  templateIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateTenantChildInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactMiddleName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  contactPhoneExtension?: InputMaybe<Scalars['String']>;
  contactPhoneType?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  name: Scalars['String'];
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  parentItemId: Scalars['ID'];
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateTenantInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  billingContactEmail: Scalars['String'];
  billingContactFirstName: Scalars['String'];
  billingContactLastName: Scalars['String'];
  billingContactMiddleName?: InputMaybe<Scalars['String']>;
  billingContactPhone?: InputMaybe<Scalars['String']>;
  billingContactPhoneExtension?: InputMaybe<Scalars['String']>;
  billingContactPhoneType?: InputMaybe<Scalars['String']>;
  businessContactEmail?: InputMaybe<Scalars['String']>;
  businessContactFirstName?: InputMaybe<Scalars['String']>;
  businessContactLastName?: InputMaybe<Scalars['String']>;
  businessContactMiddleName?: InputMaybe<Scalars['String']>;
  businessContactPhone?: InputMaybe<Scalars['String']>;
  businessContactPhoneExtension?: InputMaybe<Scalars['String']>;
  businessContactPhoneType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  labelL1?: InputMaybe<Scalars['String']>;
  labelL2?: InputMaybe<Scalars['String']>;
  labelL3?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  technicalContactEmail?: InputMaybe<Scalars['String']>;
  technicalContactFirstName?: InputMaybe<Scalars['String']>;
  technicalContactLastName?: InputMaybe<Scalars['String']>;
  technicalContactMiddleName?: InputMaybe<Scalars['String']>;
  technicalContactPhone?: InputMaybe<Scalars['String']>;
  technicalContactPhoneExtension?: InputMaybe<Scalars['String']>;
  technicalContactPhoneType?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CreateTenantUnderwriterResponse = TenantUnderwriterResponse & {
  __typename?: 'CreateTenantUnderwriterResponse';
  tenantUnderwriter: TenantUnderwriter;
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type CreateTenantUnderwriterResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTitleCplInput = {
  address?: InputMaybe<AddressInput>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  agentRetainedV2?: InputMaybe<DollarsPercentInput>;
  agentRetainedV2Override?: InputMaybe<DollarsPercentInput>;
  amount?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  closingAttorney?: InputMaybe<Scalars['String']>;
  coveredParty?: InputMaybe<Scalars['String']>;
  cplNumber?: InputMaybe<Scalars['String']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  effectiveDateOverride?: InputMaybe<Scalars['String']>;
  lenderAddress?: InputMaybe<AddressInput>;
  lenderId?: InputMaybe<Scalars['String']>;
  letterType?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  underwriterRemittedV2?: InputMaybe<DollarsPercentInput>;
  underwriterRemittedV2Override?: InputMaybe<DollarsPercentInput>;
  useLenderAddress?: InputMaybe<Scalars['Boolean']>;
};

export type CreateTitleException = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  clauseDisplayType?: InputMaybe<Scalars['String']>;
  libraryId?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateTitleRequirement = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  clauseDisplayType?: InputMaybe<Scalars['String']>;
  libraryId?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  scope: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type CreateTitleSearchOrderInput = {
  orderId: Scalars['String'];
  payload: CreateTitleSearchOrderPayloadInput;
};

export type CreateTitleSearchOrderPayloadInput = {
  businessSegment?: InputMaybe<Scalars['String']>;
  copyType?: InputMaybe<Scalars['String']>;
  disclaimerMessage?: InputMaybe<Scalars['String']>;
  displayPropertyType?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<TitleSearchOrderDocumentInput>>;
  dueDate?: InputMaybe<Scalars['String']>;
  isDisclaimerAccepted?: InputMaybe<Scalars['Boolean']>;
  municipalSearchType?: InputMaybe<Scalars['String']>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmailAddress: Scalars['String'];
  productFields?: InputMaybe<Array<TitleSearchOrderProductFieldInput>>;
  productName: Scalars['String'];
  propertyType?: InputMaybe<Scalars['String']>;
  providerId: Scalars['String'];
  searchType?: InputMaybe<Scalars['String']>;
  transactionType: Scalars['String'];
};

export type CreateTransactionInput = {
  escrowAccountId: Scalars['String'];
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  isCleared?: InputMaybe<Scalars['Boolean']>;
  lastActivityDate?: InputMaybe<Scalars['String']>;
  lineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  oTaxId?: InputMaybe<FundingTaxIdInput>;
  oWireTransfer?: InputMaybe<WireInput>;
  orderId: Scalars['String'];
  orderNumber?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId: Scalars['String'];
  payorPayeeString_sk?: InputMaybe<Scalars['String']>;
  positivePayDate?: InputMaybe<Scalars['String']>;
  reconcileDate?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  searchData?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionCategory: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
  /**
   * @deprecated Sets payorPayeeId on target transaction but does NOT create an order party.
   * Order party is now derived from origin order partial automatically.
   */
  transferOrderPartyId?: InputMaybe<Scalars['String']>;
  transferredOrderId?: InputMaybe<Scalars['String']>;
  wireExpectedDate?: InputMaybe<Scalars['String']>;
};

export type CreateUserInput = {
  address?: InputMaybe<AddressInput>;
  department?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  homeL2Id?: InputMaybe<Scalars['ID']>;
  homeL3Id?: InputMaybe<Scalars['ID']>;
  initials?: InputMaybe<Scalars['String']>;
  isCheckAuthorizedSignatory?: InputMaybe<Scalars['Boolean']>;
  isDisclosureSettlementAgent?: InputMaybe<Scalars['Boolean']>;
  isUnderwriterAuthorizedSignatory?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  nameSuffix?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<UserPhoneNumberInput>>>;
  security?: InputMaybe<UserSecurityInput>;
  securityV2?: InputMaybe<SecurityGroupV2AssignmentsInput>;
  securityVersion?: InputMaybe<Scalars['String']>;
  sendEmailMethod?: InputMaybe<Scalars['String']>;
  smtpSettings?: InputMaybe<SmtpSettingsInput>;
};

export enum CredentialRequestOutcome {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PreviouslyRequested = 'PREVIOUSLY_REQUESTED',
  Sent = 'SENT'
}

export type CtOp236RealEstateTaxForm = {
  __typename?: 'CtOp236RealEstateTaxForm';
  buyer?: Maybe<CtOp236RealEstateTaxFormBuyerSeller>;
  hasMultipleBuyers?: Maybe<Scalars['Boolean']>;
  hasMultipleSellers?: Maybe<Scalars['Boolean']>;
  propertyAddress?: Maybe<Scalars['String']>;
  residential800kUpTo2500k?: Maybe<Scalars['Float']>;
  residentialOver2500k?: Maybe<Scalars['Float']>;
  residentialUpTo800k?: Maybe<Scalars['Float']>;
  saleAmount?: Maybe<Scalars['Float']>;
  seller?: Maybe<CtOp236RealEstateTaxFormBuyerSeller>;
  sellerSpouse?: Maybe<CtOp236RealEstateTaxFormBuyerSeller>;
  sellerType?: Maybe<Scalars['String']>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
  unimprovedLandConsideration?: Maybe<Scalars['Float']>;
};

export type CtOp236RealEstateTaxFormAddress = {
  __typename?: 'CtOp236RealEstateTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type CtOp236RealEstateTaxFormBuyerSeller = {
  __typename?: 'CtOp236RealEstateTaxFormBuyerSeller';
  address?: Maybe<CtOp236RealEstateTaxFormAddress>;
  name?: Maybe<Scalars['String']>;
  representatives?: Maybe<CtOp236RealEstateTaxFormRepresentatives>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
};

export type CtOp236RealEstateTaxFormRepresentatives = {
  __typename?: 'CtOp236RealEstateTaxFormRepresentatives';
  first?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
};

export type CurrentTitleHolderMetadata = {
  __typename?: 'CurrentTitleHolderMetadata';
  bodyContent?: Maybe<Scalars['String']>;
  mergeFields?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  templates?: Maybe<CurrentTitleHolderMetadataTemplates>;
  type?: Maybe<Scalars['String']>;
};

export type CurrentTitleHolderMetadataTemplates = {
  __typename?: 'CurrentTitleHolderMetadataTemplates';
  DEED_RECITAL?: Maybe<Scalars['String']>;
  NAMES?: Maybe<Scalars['String']>;
};

export type Dashboard = {
  __typename?: 'Dashboard';
  assignedTo?: Maybe<Scalars['String']>;
  buyers?: Maybe<Scalars['String']>;
  departmentName?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  milestoneId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  sellers?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['DateTime']>;
  status?: Maybe<Scalars['String']>;
  taskName?: Maybe<Scalars['String']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type DataField = {
  __typename?: 'DataField';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type DataFieldInput = {
  name: Scalars['String'];
  value: Scalars['String'];
};

export type DcFp7cTaxForm = {
  __typename?: 'DcFp7cTaxForm';
  grantee?: Maybe<DcFp7cTaxFormGrantorGrantee>;
  grantor?: Maybe<DcFp7cTaxFormGrantorGrantee>;
  lot?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyParcelNumbers?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  settlementAgentAddress?: Maybe<DcFp7cTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type DcFp7cTaxFormAddress = {
  __typename?: 'DcFp7cTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type DcFp7cTaxFormGrantorGrantee = {
  __typename?: 'DcFp7cTaxFormGrantorGrantee';
  address?: Maybe<DcFp7cTaxFormAddress>;
  four?: Maybe<Scalars['String']>;
  one?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  three?: Maybe<Scalars['String']>;
  two?: Maybe<Scalars['String']>;
};

export type DefaultLineMapping = {
  __typename?: 'DefaultLineMapping';
  cdAlta?: Maybe<Scalars['Boolean']>;
  hud1986?: Maybe<Scalars['Boolean']>;
  hud2010?: Maybe<Scalars['Boolean']>;
};

export enum DefaultPayeeType {
  None = 'NONE',
  Underwriter = 'UNDERWRITER'
}

export type DefaultPolicyFeeAndTaxItem = {
  __typename?: 'DefaultPolicyFeeAndTaxItem';
  /** Default policy fee amount effective now. Prefer effectiveFeeAmounts when an effective date is known. */
  amount: Scalars['Float'];
  /** Default payee type for the policy fee */
  defaultPayeeType?: Maybe<DefaultPayeeType>;
  /** Default description for the policy fee */
  description: Scalars['String'];
  /** Dated effective fee amounts for this fee, ascending by effectiveDate */
  effectiveFeeAmounts?: Maybe<Array<EffectiveFeeAmount>>;
  /** Stable Title catalog code for this default fee */
  feeCode?: Maybe<Scalars['String']>;
};

export type DefaultStatePolicyFeesMap = {
  __typename?: 'DefaultStatePolicyFeesMap';
  /** Policy fee map for the state */
  policyFees: Array<DefaultPolicyFeeAndTaxItem>;
  /** State code */
  state: Scalars['String'];
};

export type DeleteAdjustmentInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
};

export type DeleteAdminMilestoneResponse = {
  __typename?: 'DeleteAdminMilestoneResponse';
  milestone?: Maybe<DeletedAdminMilestone>;
  remainingTasks?: Maybe<Scalars['Int']>;
};

export type DeleteAdminTaskResponse = {
  __typename?: 'DeleteAdminTaskResponse';
  dependentTasks?: Maybe<Array<Maybe<DependentTask>>>;
  task?: Maybe<AdminTask>;
};

export type DeleteBuyerRepResponse = OrderResponse & {
  __typename?: 'DeleteBuyerRepResponse';
  deletedBuyerRepId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteBuyerResponse = OrderResponse & {
  __typename?: 'DeleteBuyerResponse';
  deletedBuyerId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteCarrierAccountRequestInput = {
  id: Scalars['ID'];
};

export type DeleteCarrierAccountResponse = {
  __typename?: 'DeleteCarrierAccountResponse';
  carrierType: CarrierType;
  deleted: Scalars['Boolean'];
  deletedAt: Scalars['String'];
  externalId: Scalars['ID'];
  id: Scalars['ID'];
};

export type DeleteDcAdjustmentInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
};

export type DeleteDepartmentResponse = {
  __typename?: 'DeleteDepartmentResponse';
  department?: Maybe<Department>;
  workflows?: Maybe<Array<Maybe<AdminWorkflow>>>;
};

export type DeleteDocTypeMappingByCountyNameInput = {
  countyName: Scalars['String'];
  documentType: Scalars['String'];
  epnAccountId: Scalars['ID'];
};

export type DeleteEpnAccountInput = {
  id: Scalars['ID'];
};

export type DeleteExceptionInput = {
  exceptionId: Scalars['String'];
  orderId: Scalars['ID'];
};

export type DeleteFeeInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
};

export type DeleteLineDetailInput = {
  escrowAccountId: Scalars['String'];
  lineDetailId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type DeleteNoteInput = {
  appliesToId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['String'];
  entityType: NoteEntityType;
  noteId: Scalars['String'];
  tenantOrgEntityId: Scalars['String'];
};

export type DeleteOrderPartyResponse = {
  __typename?: 'DeleteOrderPartyResponse';
  deletedPartyId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeletePackageInput = {
  orderId: Scalars['ID'];
  packageId: Scalars['ID'];
};

export type DeleteRequirementInput = {
  orderId: Scalars['ID'];
  requirementId: Scalars['String'];
};

export type DeleteSecurityGroupInput = {
  id: Scalars['ID'];
};

export type DeleteSellerRepResponse = OrderResponse & {
  __typename?: 'DeleteSellerRepResponse';
  deletedSellerRepId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteSellerResponse = OrderResponse & {
  __typename?: 'DeleteSellerResponse';
  deletedSellerId: Scalars['ID'];
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type DeleteTagFailureV2 = {
  __typename?: 'DeleteTagFailureV2';
  reason: Scalars['String'];
  tagId: Scalars['ID'];
};

export type DeleteTagsResponseV2 = {
  __typename?: 'DeleteTagsResponseV2';
  deletedTags: Array<TagV2>;
  failed: Array<DeleteTagFailureV2>;
};

export type DeleteTagsV2Input = {
  /**
   * @minItems 1
   * @maxItems 100
   */
  tagIds: Array<Scalars['String']>;
};

export type DeleteTaskResponse = {
  __typename?: 'DeleteTaskResponse';
  dependentTasks?: Maybe<Array<Maybe<DependentTask>>>;
  task?: Maybe<Task>;
};

export type DeleteTransactionInput = {
  escrowAccountId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type DeleteUserLocksInput = {
  id: Scalars['ID'];
};

export type DeletedAdminMilestone = {
  __typename?: 'DeletedAdminMilestone';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  workflowId: Scalars['ID'];
};

export type Department = {
  __typename?: 'Department';
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  users?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type DepartmentInput = {
  name: Scalars['String'];
  users: Array<InputMaybe<Scalars['String']>>;
};

export type DependentTask = {
  __typename?: 'DependentTask';
  milestone?: Maybe<Scalars['String']>;
  task?: Maybe<Scalars['String']>;
};

export type DepositPayLoad = {
  __typename?: 'DepositPayLoad';
  itemId: Scalars['ID'];
};

export type DisableFraudtoolsIntegrationRequestInput = {
  /** Internal discriminator field used only for schema generation uniqueness */
  _schemaDiscriminator?: InputMaybe<DisableFraudtoolsIntegrationRequestInput_SchemaDiscriminator>;
  /** Provider extracted from URL path parameter - not sent in request body by frontend */
  provider: DisableFraudtoolsIntegrationRequestInputProvider;
  toolType: ToolType;
};

/** Provider extracted from URL path parameter - not sent in request body by frontend */
export enum DisableFraudtoolsIntegrationRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

/** Internal discriminator field used only for schema generation uniqueness */
export enum DisableFraudtoolsIntegrationRequestInput_SchemaDiscriminator {
  DisableFraudtoolsIntegrationRequest = 'DisableFraudtoolsIntegrationRequest'
}

export type DisableFraudtoolsIntegrationResponse = {
  __typename?: 'DisableFraudtoolsIntegrationResponse';
  disabledAt: Scalars['String'];
  disabledBy?: Maybe<Scalars['String']>;
  provider: Provider;
  status: IntegrationStatus;
  toolType: ToolType;
};

export type DisbursementSummaryDetails = {
  __typename?: 'DisbursementSummaryDetails';
  balances?: Maybe<BalanceGridDisbursementSummaryDetails>;
  buyer?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  escrowAccountName?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  pendingDisbursements?: Maybe<FundItemsDisbursementSummaryDetails>;
  pendingReceipts?: Maybe<FundItemsDisbursementSummaryDetails>;
  postedDisbursements?: Maybe<FundItemsDisbursementSummaryDetails>;
  postedReceipts?: Maybe<FundItemsDisbursementSummaryDetails>;
  propertyAddress?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  seller?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type DisbursementSummaryForm = {
  __typename?: 'DisbursementSummaryForm';
  balances?: Maybe<BalanceGridDisbursementSummaryForm>;
  buyer?: Maybe<Scalars['String']>;
  closeDate?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  escrowAccountName?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  pendingDisbursements?: Maybe<FundItemsDisbursementSummaryForm>;
  pendingReceipts?: Maybe<FundItemsDisbursementSummaryForm>;
  postedDisbursements?: Maybe<FundItemsDisbursementSummaryForm>;
  postedReceipts?: Maybe<FundItemsDisbursementSummaryForm>;
  propertyAddress?: Maybe<Scalars['String']>;
  purchasePrice?: Maybe<Scalars['Float']>;
  seller?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type DocTypeMappingByCountyName = {
  __typename?: 'DocTypeMappingByCountyName';
  countyName: Scalars['String'];
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  documentType: Scalars['String'];
  dynamicDocumentName: Scalars['String'];
  dynamicDocumentType: Scalars['String'];
  epnAccountId: Scalars['ID'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type DocumentChangeGroup = {
  __typename?: 'DocumentChangeGroup';
  changes: Array<FieldChange>;
  documentDisplayName?: Maybe<Scalars['String']>;
  documentId: Scalars['ID'];
  id: Scalars['ID'];
};

export enum DocumentEntityTypeV2 {
  ConsolidatedPayment = 'CONSOLIDATED_PAYMENT',
  Escrow = 'ESCROW',
  Order = 'ORDER',
  PendingOrder = 'PENDING_ORDER'
}

export type DocumentExtractionResultV2 = {
  __typename?: 'DocumentExtractionResultV2';
  dataEntries?: Maybe<Array<ExtractionDataEntryV2>>;
  documentType: Scalars['String'];
  evidenceAssessmentEntries?: Maybe<Array<ExtractionDataEntryV2>>;
  metadataEntries?: Maybe<Array<ExtractionMetadataEntryV2>>;
  normalizedEntries?: Maybe<Array<ExtractionDataEntryV2>>;
  processingNotes?: Maybe<Scalars['String']>;
  sourceFiles?: Maybe<Array<Scalars['String']>>;
};

export type DocumentInsightsV2 = {
  __typename?: 'DocumentInsightsV2';
  analyzedAt?: Maybe<Scalars['String']>;
  chainOfTitle?: Maybe<ChainOfTitleV2>;
  classifications?: Maybe<Array<ClassifiedDocumentV2>>;
  documentCount?: Maybe<Scalars['Float']>;
  documentId: Scalars['ID'];
  documentTypes?: Maybe<Array<Scalars['String']>>;
  effectiveDate?: Maybe<Scalars['String']>;
  extractions?: Maybe<Array<DocumentExtractionResultV2>>;
  factCount: Scalars['Float'];
  insights?: Maybe<Array<ObservationV2>>;
  isStale: Scalars['Boolean'];
  legalDescription?: Maybe<Scalars['String']>;
  lienSummary?: Maybe<LienSummaryV2>;
  processingNotes?: Maybe<Scalars['String']>;
  releaseAnalysis?: Maybe<ReleaseAnalysisV2>;
  sourceFilename?: Maybe<Scalars['String']>;
  status: InsightsStatusV2;
  subjectApns?: Maybe<Array<Scalars['String']>>;
  subjectProperty?: Maybe<Scalars['String']>;
};

export type DocumentSaveAsRequestV2Input = {
  documentId: Scalars['ID'];
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  orderId: Scalars['ID'];
  subscriptionId?: InputMaybe<Scalars['ID']>;
  targetFormat: DocumentSaveAsRequestV2InputTargetFormat;
};

export enum DocumentSaveAsRequestV2InputTargetFormat {
  Docx = 'docx',
  Pdf = 'pdf'
}

export type DocumentStalenessV2 = {
  __typename?: 'DocumentStalenessV2';
  documentId: Scalars['ID'];
  /** True if the document could not be found (likely deleted) */
  isDeleted?: Maybe<Scalars['Boolean']>;
  /** True if document version has changed since analysis */
  isStale: Scalars['Boolean'];
};

export enum DocumentType {
  DriversLicense = 'DRIVERS_LICENSE',
  Other = 'OTHER',
  Passport = 'PASSPORT'
}

export type DollarsPercent = {
  __typename?: 'DollarsPercent';
  dollars?: Maybe<Scalars['Float']>;
  percent?: Maybe<Scalars['Float']>;
};

export type DollarsPercentInput = {
  dollars?: InputMaybe<Scalars['Float']>;
  percent?: InputMaybe<Scalars['Float']>;
};

export type DownloadAsyncRequestV2Input = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  subscriptionId?: InputMaybe<Scalars['ID']>;
};

export type DownloadEntityDocumentV2Input = {
  canBeHidden?: InputMaybe<Scalars['Boolean']>;
  documentId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  fileType: Scalars['String'];
  scopeId?: InputMaybe<Scalars['ID']>;
  versionId?: InputMaybe<Scalars['ID']>;
};

export type DownloadEntityDocumentsRequestV2Input = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DownloadEntityDocumentsRequestV2InputEntityType;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
};

export enum DownloadEntityDocumentsRequestV2InputEntityType {
  ConsolidatedPayment = 'CONSOLIDATED_PAYMENT',
  Escrow = 'ESCROW',
  Order = 'ORDER',
  PendingOrder = 'PENDING_ORDER'
}

export type DownloadTemplateV2Input = {
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  versionId?: InputMaybe<Scalars['ID']>;
};

export type DueDate = {
  __typename?: 'DueDate';
  date: Scalars['String'];
  period: Scalars['Int'];
};

export type DueDateInput = {
  date: Scalars['String'];
  period: Scalars['Int'];
};

export type DuplicateTemplateDocV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type DynamicDocumentType = {
  __typename?: 'DynamicDocumentType';
  documentName: Scalars['String'];
  documentType: Scalars['String'];
};

export type Edge = {
  node: Node;
};

export type EffectiveFeeAmount = {
  __typename?: 'EffectiveFeeAmount';
  /** Amount that applies while this effective fee amount is effective */
  amount: Scalars['Float'];
  /** First date this amount applies, inclusive, date-only YYYY-MM-DD */
  effectiveDate: Scalars['String'];
  /** Last date this amount applies, inclusive. Null means open-ended. */
  expirationDate?: Maybe<Scalars['String']>;
};

export type EffectiveOrderCommissions = {
  __typename?: 'EffectiveOrderCommissions';
  buyerPaidPercentage?: Maybe<Scalars['Float']>;
  commissionBasis?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  lineItems: Array<EffectiveOrderCommissionsLineItem>;
  sellerPaidPercentage?: Maybe<Scalars['Float']>;
  totalCommissionAmount?: Maybe<Scalars['Float']>;
};

export type EffectiveOrderCommissionsLineItem = BaseOrderCommissionsLineItem & {
  __typename?: 'EffectiveOrderCommissionsLineItem';
  agentType: Scalars['String'];
  commissionAmount?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  party?: Maybe<OrderParty>;
  partyId: Scalars['String'];
};

export type EligibleCounty = {
  __typename?: 'EligibleCounty';
  fips?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  state: Scalars['String'];
};

export type EmailAddressInput = {
  emailAddress?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
};

export type EmailAddressSchema = {
  __typename?: 'EmailAddressSchema';
  emailAddress?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
};

export type EmailAttachmentInput = {
  canBeHidden?: InputMaybe<Scalars['Boolean']>;
  documentId: Scalars['ID'];
  fileType: Scalars['String'];
  orderId: Scalars['ID'];
};

export type EmailSignature = {
  __typename?: 'EmailSignature';
  body: Scalars['String'];
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  signatureEnabled: Scalars['Boolean'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type EmailSignatureCreateOrUpdateInput = {
  body: Scalars['String'];
  signatureEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type EmailSignatureRequestInput = {
  signatureEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type EnableFraudtoolsIntegrationRequestInput = {
  /** Internal discriminator field used only for schema generation uniqueness */
  _schemaDiscriminator?: InputMaybe<EnableFraudtoolsIntegrationRequestInput_SchemaDiscriminator>;
  /** Provider extracted from URL path parameter - not sent in request body by frontend */
  provider: EnableFraudtoolsIntegrationRequestInputProvider;
  toolType: ToolType;
};

/** Provider extracted from URL path parameter - not sent in request body by frontend */
export enum EnableFraudtoolsIntegrationRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

/** Internal discriminator field used only for schema generation uniqueness */
export enum EnableFraudtoolsIntegrationRequestInput_SchemaDiscriminator {
  EnableFraudtoolsIntegrationRequest = 'EnableFraudtoolsIntegrationRequest'
}

export type EnableFraudtoolsIntegrationResponse = {
  __typename?: 'EnableFraudtoolsIntegrationResponse';
  enabledAt: Scalars['String'];
  enabledBy?: Maybe<Scalars['String']>;
  provider: Provider;
  status: IntegrationStatus;
  toolType: ToolType;
};

export type EnableIntegrationRequestInput = {
  active: Scalars['Boolean'];
  carrierType: CarrierType;
};

export type EndorsementFeeAdditionalData = {
  __typename?: 'EndorsementFeeAdditionalData';
  externalEndorsementId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type EndorsementRateCalculation = {
  __typename?: 'EndorsementRateCalculation';
  additionalQuestions: Array<AdditionalQuestion>;
  amount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type EndorsementRateRequest = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionsRateRequest>>;
  amount?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
};

export type EndorsementRateValidationRequest = {
  id?: InputMaybe<Scalars['String']>;
};

export type EntityDocumentFileVersionV2 = {
  __typename?: 'EntityDocumentFileVersionV2';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  fileType: Scalars['String'];
  resourceDataUri?: Maybe<Scalars['String']>;
  resourceSfdtUri?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['ID']>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
  versionId: Scalars['ID'];
};

export type EntityDocumentSaveAsRequestV2Input = {
  documentId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  subscriptionId?: InputMaybe<Scalars['ID']>;
  targetFormat: EntityDocumentSaveAsRequestV2InputTargetFormat;
};

export enum EntityDocumentSaveAsRequestV2InputTargetFormat {
  Docx = 'docx',
  Pdf = 'pdf'
}

export type EntityDocumentV2 = {
  __typename?: 'EntityDocumentV2';
  createdBy: UserDisplayNameV2;
  createdTimestamp: Scalars['String'];
  description: Scalars['String'];
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  fileType: Scalars['String'];
  id: Scalars['ID'];
  insightData?: Maybe<InsightDataV2>;
  isReadOnly: Scalars['Boolean'];
  listMergeChoices?: Maybe<Scalars['String']>;
  mergeFieldData?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  scopeId?: Maybe<Scalars['ID']>;
  skipClone?: Maybe<Scalars['Boolean']>;
  sourceTemplateId?: Maybe<Scalars['ID']>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedBy: UserDisplayNameV2;
  updatedTimestamp: Scalars['String'];
  uploadStatus: UploadStatusV2;
  wellKnownTemplateType?: Maybe<Scalars['String']>;
};

export type EntityGenerateAsyncResponseV2 = {
  __typename?: 'EntityGenerateAsyncResponseV2';
  generatingDocuments?: Maybe<Array<GeneratingEntityDocumentItemV2>>;
  subscriptionId: Scalars['ID'];
};

export type EntityPrintChecksRequestV2Input = {
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
  /** @minItems 1 */
  transactionIds: Array<Scalars['String']>;
};

export type EntityPrintChecksResponseV2 = {
  __typename?: 'EntityPrintChecksResponseV2';
  generatingDocuments?: Maybe<Array<GeneratingEntityDocumentItemV2>>;
  results: Array<PrintCheckResultEntryV2>;
  subscriptionId: Scalars['ID'];
};

export type EntityTypeAndIdV2Input = {
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  scopeId?: InputMaybe<Scalars['ID']>;
};

export type EpnAccount = {
  __typename?: 'EpnAccount';
  accountName: Scalars['String'];
  companyIds: Array<Scalars['String']>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  isAllCompanies: Scalars['Boolean'];
  isAutoSubmitEnabled: Scalars['Boolean'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type EpnAccountWithApiKey = {
  __typename?: 'EpnAccountWithApiKey';
  accountName: Scalars['String'];
  apiKey: Scalars['String'];
  companyIds: Array<Scalars['String']>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  isAllCompanies: Scalars['Boolean'];
  isAutoSubmitEnabled: Scalars['Boolean'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type EpnIntegrationStatus = {
  __typename?: 'EpnIntegrationStatus';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  isEnabled: Scalars['Boolean'];
  tenantId: Scalars['ID'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type Error = {
  __typename?: 'Error';
  errorCode: Scalars['String'];
  message: Scalars['String'];
};

export type ErrorStatus = {
  __typename?: 'ErrorStatus';
  errorCode: Scalars['String'];
  message: Scalars['String'];
};

export type EscrowAccount = {
  __typename?: 'EscrowAccount';
  accountNumber?: Maybe<Scalars['String']>;
  accountNumberAlternate?: Maybe<Scalars['String']>;
  addresses?: Maybe<Array<Maybe<EscrowAccountAddress>>>;
  bankName?: Maybe<Scalars['String']>;
  canActivate?: Maybe<Scalars['Boolean']>;
  canDelete?: Maybe<Scalars['Boolean']>;
  checkPrinting?: Maybe<CheckPrinting>;
  companies?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<User>;
  createdTimestamp?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  escrowAccountName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  integrations?: Maybe<EscrowAccountIntegrations>;
  isActive?: Maybe<Scalars['Boolean']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  positivePay?: Maybe<PositivePay>;
  quickbooksConfig?: Maybe<QuickBooksConfig>;
  routingNumber?: Maybe<Scalars['String']>;
  routingNumberDeposit?: Maybe<Scalars['String']>;
  routingNumberFractional?: Maybe<Scalars['String']>;
  routingNumberWire?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

export type EscrowAccountAddress = {
  __typename?: 'EscrowAccountAddress';
  address1?: Maybe<Scalars['String']>;
  address1AndAddress2?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  addressType?: Maybe<EscrowAddressTypes>;
  city?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  usePrimaryAddress?: Maybe<Scalars['Boolean']>;
};

export type EscrowAccountAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<EscrowAddressTypes>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  countyFips?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  postalCode?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  stateOrProvince?: InputMaybe<Scalars['String']>;
  usePrimaryAddress?: InputMaybe<Scalars['Boolean']>;
};

export type EscrowAccountIntegrations = {
  __typename?: 'EscrowAccountIntegrations';
  agentNetFinance?: Maybe<AgentNetFinance>;
  /**
   * Per-escrow-account FA Trust wire integration enabled flag. Stored directly on the escrow item;
   * toggling it on one escrow account does not affect others in the tenant.
   */
  faTrustWireIntegration?: Maybe<Scalars['Boolean']>;
  /**
   * @deprecated This field is computed from agentNetFinance settings and should no longer be used in new code.
   * Use the agentNetFinance object instead for more granular control.
   */
  isAgentNetReconActive?: Maybe<Scalars['Boolean']>;
};

export type EscrowAccountIntegrationsInput = {
  agentNetFinance?: InputMaybe<AgentNetFinanceInput>;
  /**
   * Per-escrow-account FA Trust wire integration enabled flag. Persisted on the escrow item,
   * independent per escrow account.
   */
  faTrustWireIntegration?: InputMaybe<Scalars['Boolean']>;
  /**
   * @deprecated This field is ignored by the backend and should no longer be used in new code.
   * Use the agentNetFinance object instead for more granular control.
   */
  isAgentNetReconActive?: InputMaybe<Scalars['Boolean']>;
};

export type EscrowAccountNumberAlternateProtected = {
  __typename?: 'EscrowAccountNumberAlternateProtected';
  accountNumberAlternateProtected: Scalars['String'];
  escrowAccountId: Scalars['ID'];
};

export type EscrowAccountNumberProtected = {
  __typename?: 'EscrowAccountNumberProtected';
  accountNumberProtected: Scalars['String'];
  escrowAccountId: Scalars['ID'];
};

export enum EscrowAddressTypes {
  Alternate = 'Alternate',
  Mailing = 'Mailing',
  Primary = 'Primary'
}

export type EscrowTrialEntry = {
  __typename?: 'EscrowTrialEntry';
  balance?: Maybe<Scalars['Float']>;
  createdDate?: Maybe<Scalars['String']>;
  disbursements?: Maybe<Scalars['Float']>;
  fundingDate?: Maybe<Scalars['String']>;
  lastActivityDate?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  receipts?: Maybe<Scalars['Float']>;
};

export type EstimatedTaxesInsuranceAssessments = {
  __typename?: 'EstimatedTaxesInsuranceAssessments';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  estimatedEscrow?: Maybe<Scalars['Float']>;
  estimatedEscrowOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  id?: Maybe<Scalars['ID']>;
  items?: Maybe<Array<Maybe<EstimatedTaxesInsuranceAssessmentsItem>>>;
  orderId?: Maybe<Scalars['ID']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type EstimatedTaxesInsuranceAssessmentsInput = {
  estimatedEscrow?: InputMaybe<Scalars['Float']>;
  items?: InputMaybe<Array<InputMaybe<EstimatedTaxesInsuranceAssessmentsItemInput>>>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type EstimatedTaxesInsuranceAssessmentsItem = {
  __typename?: 'EstimatedTaxesInsuranceAssessmentsItem';
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  inEscrow?: Maybe<Scalars['String']>;
  includedInEstimate?: Maybe<Scalars['Boolean']>;
  isDefaultLine?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['ID']>;
};

export type EstimatedTaxesInsuranceAssessmentsItemInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  inEscrow?: InputMaybe<Scalars['String']>;
  includedInEstimate?: InputMaybe<Scalars['Boolean']>;
};

export type ExceptionItemV2 = {
  __typename?: 'ExceptionItemV2';
  description: Scalars['String'];
  exceptionType?: Maybe<Scalars['String']>;
  pageNumbers?: Maybe<Array<Scalars['Float']>>;
  sourceDocuments?: Maybe<Array<Scalars['String']>>;
};

export type ExceptionReference = {
  exceptionId: Scalars['String'];
  exceptions?: InputMaybe<Array<InputMaybe<ExceptionReference>>>;
};

export type ExtractionDataEntryV2 = {
  __typename?: 'ExtractionDataEntryV2';
  key: Scalars['String'];
  value: Scalars['String'];
};

export type ExtractionMetadataEntryV2 = {
  __typename?: 'ExtractionMetadataEntryV2';
  key: Scalars['String'];
  sources: Array<ExtractionMetadataSourceV2>;
};

export type ExtractionMetadataSourceV2 = {
  __typename?: 'ExtractionMetadataSourceV2';
  pageNumber: Scalars['Float'];
  sourceFilename?: Maybe<Scalars['String']>;
  sourceText?: Maybe<Scalars['String']>;
};

export type FaTrustCredentialAuthResult = {
  __typename?: 'FaTrustCredentialAuthResult';
  success: Scalars['Boolean'];
};

/**
 * Non-secret FA Trust credential status for one escrow account, used to hydrate the
 * admin UI on re-entry: whether credentials are stored, the non-secret clientId, display-safe
 * last-4 masks of the secret + HMAC key, and when they were last written. Never carries the real
 * client secret or HMAC key. tenantId is auth-derived.
 */
export type FaTrustCredentialStatus = {
  __typename?: 'FaTrustCredentialStatus';
  clientId?: Maybe<Scalars['String']>;
  clientSecretMasked?: Maybe<Scalars['String']>;
  hmacKeyMasked?: Maybe<Scalars['String']>;
  lastAuthenticatedAt?: Maybe<Scalars['String']>;
  stored: Scalars['Boolean'];
};

export type FeatureAcknowledgment = {
  __typename?: 'FeatureAcknowledgment';
  acknowledgedAt: Scalars['String'];
  acknowledgedBy: Scalars['String'];
  featureKey: Scalars['String'];
  status: Scalars['String'];
  version: Scalars['Int'];
};

export type FedConfirmation = {
  __typename?: 'FedConfirmation';
  confirmedTimestamp?: Maybe<Scalars['String']>;
  imad?: Maybe<Scalars['String']>;
};

export enum FedexMfaPinMethod {
  Call = 'CALL',
  Email = 'EMAIL',
  Sms = 'SMS'
}

export type Fee = {
  __typename?: 'Fee';
  borrowerPaidAt?: Maybe<Scalars['Float']>;
  borrowerPaidAtOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  borrowerPaidBefore?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  defaultLineMapping?: Maybe<DefaultLineMapping>;
  description: Scalars['String'];
  feeLineType: Scalars['String'];
  feeTypeAdditionalData?: Maybe<FeeTypeAdditionalData>;
  funding?: Maybe<Scalars['String']>;
  gfeLineNumber?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSetAsCDLastLine?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<FeeLineNumber>;
  orderId: Scalars['String'];
  payeeId?: Maybe<Scalars['String']>;
  payeeIdOverrideMetadata?: Maybe<OverrideMetadataString>;
  payeeName?: Maybe<Scalars['String']>;
  pboBorrowerAmount?: Maybe<Scalars['Float']>;
  pboBorrowerPaidById?: Maybe<Scalars['String']>;
  pboBorrowerPaidByName?: Maybe<Scalars['String']>;
  pboSellerAmount?: Maybe<Scalars['Float']>;
  pboSellerPaidById?: Maybe<Scalars['String']>;
  pboSellerPaidByName?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
  sectionMapping: SectionMapping;
  sellerPaidAt?: Maybe<Scalars['Float']>;
  sellerPaidBefore?: Maybe<Scalars['Float']>;
  statementPayeeDisplayName?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type FeeAllocationInput = {
  feeAllocations?: InputMaybe<Array<InputMaybe<FeeAllocationItemInput>>>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type FeeAllocationItem = {
  __typename?: 'FeeAllocationItem';
  allocatedAmount?: Maybe<Scalars['Float']>;
  allocationMethod: AllocationMethod;
  description: Scalars['String'];
  feeId: Scalars['String'];
  id: Scalars['ID'];
  payeeId?: Maybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type FeeAllocationItemInput = {
  allocatedAmount: Scalars['Float'];
  allocationMethod: AllocationMethod;
  description: Scalars['String'];
  feeId: Scalars['String'];
  id?: InputMaybe<Scalars['ID']>;
  payeeId?: InputMaybe<Scalars['String']>;
  value: Scalars['Float'];
};

export type FeeAllocations = {
  __typename?: 'FeeAllocations';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  feeAllocations?: Maybe<Array<Maybe<FeeAllocationItem>>>;
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type FeeItem = {
  __typename?: 'FeeItem';
  amount?: Maybe<Scalars['Float']>;
  buyerPercentage: Scalars['Float'];
  gfe?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  payeeId?: Maybe<Scalars['String']>;
  payeeIdOverrideMetadata?: Maybe<OverrideMetadataString>;
  sellerPercentage: Scalars['Float'];
};

export type FeeLineNumber = {
  __typename?: 'FeeLineNumber';
  alta?: Maybe<Scalars['String']>;
  cd?: Maybe<Scalars['String']>;
  hud1986?: Maybe<Scalars['String']>;
  hud2010?: Maybe<Scalars['String']>;
};

export type FeeToUpdateInput = {
  feeLineType: Scalars['String'];
  id: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
};

export type FeeTypeAdditionalData = {
  __typename?: 'FeeTypeAdditionalData';
  agentDisclosureFeeData?: Maybe<AgentDisclosureFeeAdditionalData>;
  /** @deprecated Use commissionFeeData.agentType */
  agentType?: Maybe<Scalars['String']>;
  commissionFeeData?: Maybe<CommissionFeeAdditionalData>;
  cplFeeData?: Maybe<CplFeeAdditionalData>;
  /** @deprecated Use commissionFeeData.externalCommissionLineId */
  externalCommissionLineId?: Maybe<Scalars['String']>;
  homeownersInsurancePremiumEscrowFeeData?: Maybe<HomeownersInsurancePremiumEscrowFeeAdditionalData>;
  homeownersInsurancePremiumFeeData?: Maybe<HomeownersInsurancePremiumFeeAdditionalData>;
  lenderCreditsFeeData?: Maybe<LenderCreditsFeeAdditionalData>;
  lenderDisclosureFeeData?: Maybe<OwnerLenderDisclosureFeeAdditionalData>;
  lenderEndorsementFeeData?: Maybe<EndorsementFeeAdditionalData>;
  lenderPremiumFeeData?: Maybe<PremiumFeeAdditionalData>;
  lenderPremiumPolicyFeeData?: Maybe<PremiumPolicyFeeAdditionalData>;
  loanDiscountFeeData?: Maybe<LoanDiscountFeeAdditionalData>;
  loanOriginationFeeData?: Maybe<LoanOriginationFeeAdditionalData>;
  mortgageInsurancePremiumEscrowFeeData?: Maybe<MortgageInsurancePremiumEscrowFeeAdditionalData>;
  mortgageInsurancePremiumFeeData?: Maybe<MortgageInsurancePremiumFeeAdditionalData>;
  ownerDisclosureFeeData?: Maybe<OwnerLenderDisclosureFeeAdditionalData>;
  ownerEndorsementFeeData?: Maybe<EndorsementFeeAdditionalData>;
  ownerPremiumFeeData?: Maybe<PremiumFeeAdditionalData>;
  ownerPremiumPolicyFeeData?: Maybe<PremiumPolicyFeeAdditionalData>;
  prepaidInterestFeeData?: Maybe<PrepaidInterestFeeAdditionalData>;
  propertyTaxEscrowFeeData?: Maybe<PropertyTaxEscrowFeeAdditionalData>;
  propertyTaxFeeData?: Maybe<PropertyTaxFeeAdditionalData>;
  recordingFeeData?: Maybe<RecordingFeeAdditionalData>;
  standardEscrowFeeData?: Maybe<StandardEscrowFeeAdditionalData>;
  titleFeeData?: Maybe<TitleFeeAdditionalData>;
  transferTaxFeeData?: Maybe<TransferTaxFeeAdditionalData>;
  underwriterDisclosureFeeData?: Maybe<UnderwriterDisclosureFeeAdditionalData>;
};

export type FeeTypeAdditionalDataCreateInput = {
  amountPerMonth?: InputMaybe<Scalars['Float']>;
  numberOfMonths?: InputMaybe<Scalars['Float']>;
};

export type FeeTypeAdditionalDataInput = {
  additionalDescription?: InputMaybe<Scalars['String']>;
  agentType?: InputMaybe<Scalars['String']>;
  amountPerDay?: InputMaybe<Scalars['Float']>;
  amountPerMonth?: InputMaybe<Scalars['Float']>;
  externalCommissionLineId?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  lenderCreditsAmount?: InputMaybe<Scalars['Float']>;
  numberOfMonths?: InputMaybe<Scalars['Float']>;
  originationAdjustmentPercentage?: InputMaybe<Scalars['Float']>;
  originationPercentage?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type FeeWithAllocations = {
  __typename?: 'FeeWithAllocations';
  allocations: Array<Maybe<AllocationItem>>;
  description?: Maybe<Scalars['String']>;
  feeAmount?: Maybe<Scalars['Float']>;
  feeId: Scalars['String'];
  payeeId?: Maybe<Scalars['String']>;
  totalAllocatedAmount: Scalars['Float'];
};

export enum FeedbackRatingV2 {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export type FeesInput = {
  fees?: InputMaybe<Array<InputMaybe<FeesItemInput>>>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type FeesItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  buyerPercentage: Scalars['Float'];
  gfe?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  sellerPercentage: Scalars['Float'];
};

export type FidelityAdminConfiguration = {
  __typename?: 'FidelityAdminConfiguration';
  availableToAllCompanies: Scalars['Boolean'];
  configuredUnderwriterCode: Scalars['String'];
  configuredUnderwriterName: Scalars['String'];
  integrationActive: Scalars['Boolean'];
  tenantSupportedUnderwriters: Array<FidelityTenantSupportedUnderwriter>;
  tenantUnderwriterActive: Scalars['Boolean'];
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type FidelityAdminStatusInput = {
  active: Scalars['Boolean'];
};

export type FidelityAgentMapping = {
  __typename?: 'FidelityAgentMapping';
  branchId: Scalars['String'];
  companyId: Scalars['String'];
  selections: FidelityAgentMappingSelections;
  stateCode: Scalars['String'];
  underwriterCode: Scalars['String'];
};

export type FidelityAgentMappingInput = {
  branchId: Scalars['String'];
  companyId: Scalars['String'];
  selections: FidelityAgentMappingSelectionsInput;
  stateCode: Scalars['String'];
  underwriterCode: Scalars['String'];
};

export type FidelityAgentMappingKeyInput = {
  branchId: Scalars['String'];
  companyId: Scalars['String'];
  stateCode: Scalars['String'];
  underwriterCode: Scalars['String'];
};

export type FidelityAgentMappingResponse = {
  __typename?: 'FidelityAgentMappingResponse';
  mapping: Array<FidelityAgentMapping>;
};

export type FidelityAgentMappingSelections = {
  __typename?: 'FidelityAgentMappingSelections';
  cpl?: Maybe<FidelityAgentSelection>;
  jacket?: Maybe<FidelityAgentSelection>;
};

export type FidelityAgentMappingSelectionsInput = {
  cpl?: InputMaybe<FidelityAgentSelectionInput>;
  jacket?: InputMaybe<FidelityAgentSelectionInput>;
};

export type FidelityAgentOptionsLane = {
  __typename?: 'FidelityAgentOptionsLane';
  options: Array<FidelityAgentSelection>;
  reasonCode?: Maybe<Scalars['String']>;
  status: Scalars['String'];
};

export type FidelityAgentOptionsResponse = {
  __typename?: 'FidelityAgentOptionsResponse';
  cpl: FidelityAgentOptionsLane;
  jacket: FidelityAgentOptionsLane;
  stateCode: Scalars['String'];
  underwriterCode: Scalars['String'];
};

export type FidelityAgentSelection = {
  __typename?: 'FidelityAgentSelection';
  address?: Maybe<Scalars['String']>;
  agentAccountType?: Maybe<Scalars['String']>;
  agentContractLiabilityAmount?: Maybe<Scalars['Float']>;
  agentName?: Maybe<Scalars['String']>;
  agentNumber: Scalars['String'];
  applicationCode?: Maybe<Scalars['String']>;
  autoReports?: Maybe<Scalars['Boolean']>;
  city?: Maybe<Scalars['String']>;
  contractDocumentType?: Maybe<Scalars['String']>;
  contractName?: Maybe<Scalars['String']>;
  customerBusinessName?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  customerNumber?: Maybe<Scalars['String']>;
  customerStatus?: Maybe<Scalars['String']>;
  customerTypeCode?: Maybe<Scalars['String']>;
  dbaName?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  flatRemit?: Maybe<Scalars['Boolean']>;
  isDbaName?: Maybe<Scalars['Boolean']>;
  legalName?: Maybe<Scalars['String']>;
  liabilityLimitAmount?: Maybe<Scalars['Float']>;
  locationAddress1?: Maybe<Scalars['String']>;
  locationAddress2?: Maybe<Scalars['String']>;
  locationCity?: Maybe<Scalars['String']>;
  locationName?: Maybe<Scalars['String']>;
  locationNumber?: Maybe<Scalars['String']>;
  locationPhoneNumber?: Maybe<Scalars['String']>;
  locationStateCode?: Maybe<Scalars['String']>;
  locationZipCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  profitCenterEnvironmentName?: Maybe<Scalars['String']>;
  stateCode: Scalars['String'];
  underwriterCode?: Maybe<Scalars['String']>;
  underwriterId?: Maybe<Scalars['String']>;
  underwriterName?: Maybe<Scalars['String']>;
  underwriterNumber?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type FidelityAgentSelectionInput = {
  address?: InputMaybe<Scalars['String']>;
  agentAccountType?: InputMaybe<Scalars['String']>;
  agentContractLiabilityAmount?: InputMaybe<Scalars['Float']>;
  agentName?: InputMaybe<Scalars['String']>;
  agentNumber: Scalars['String'];
  applicationCode?: InputMaybe<Scalars['String']>;
  autoReports?: InputMaybe<Scalars['Boolean']>;
  city?: InputMaybe<Scalars['String']>;
  contractDocumentType?: InputMaybe<Scalars['String']>;
  contractName?: InputMaybe<Scalars['String']>;
  customerBusinessName?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  customerNumber?: InputMaybe<Scalars['String']>;
  customerStatus?: InputMaybe<Scalars['String']>;
  customerTypeCode?: InputMaybe<Scalars['String']>;
  dbaName?: InputMaybe<Scalars['String']>;
  displayName: Scalars['String'];
  flatRemit?: InputMaybe<Scalars['Boolean']>;
  isDbaName?: InputMaybe<Scalars['Boolean']>;
  legalName?: InputMaybe<Scalars['String']>;
  liabilityLimitAmount?: InputMaybe<Scalars['Float']>;
  locationAddress1?: InputMaybe<Scalars['String']>;
  locationAddress2?: InputMaybe<Scalars['String']>;
  locationCity?: InputMaybe<Scalars['String']>;
  locationName?: InputMaybe<Scalars['String']>;
  locationNumber?: InputMaybe<Scalars['String']>;
  locationPhoneNumber?: InputMaybe<Scalars['String']>;
  locationStateCode?: InputMaybe<Scalars['String']>;
  locationZipCode?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  profitCenterEnvironmentName?: InputMaybe<Scalars['String']>;
  stateCode: Scalars['String'];
  underwriterCode?: InputMaybe<Scalars['String']>;
  underwriterId?: InputMaybe<Scalars['String']>;
  underwriterName?: InputMaybe<Scalars['String']>;
  underwriterNumber?: InputMaybe<Scalars['String']>;
  zipCode?: InputMaybe<Scalars['String']>;
};

export type FidelityTenantSupportedUnderwriter = {
  __typename?: 'FidelityTenantSupportedUnderwriter';
  code: Scalars['String'];
  label: Scalars['String'];
};

export type FidelityUserStatus = {
  __typename?: 'FidelityUserStatus';
  active: Scalars['Boolean'];
  emailAddress: Scalars['String'];
  error: Scalars['Boolean'];
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type FieldChange = {
  __typename?: 'FieldChange';
  description: Scalars['String'];
  field: Scalars['String'];
  fieldDisplayName: Scalars['String'];
  newValue?: Maybe<Scalars['String']>;
  oldValue?: Maybe<Scalars['String']>;
};

export type FileCryptoKey = {
  __typename?: 'FileCryptoKey';
  algorithm: Scalars['String'];
  encoding: Scalars['String'];
  iv: Scalars['String'];
  key: Scalars['String'];
  tagDisposition: Scalars['String'];
  tagSizeBits: Scalars['Int'];
};

export type FileCryptoKeyV2 = {
  __typename?: 'FileCryptoKeyV2';
  algorithm: Scalars['String'];
  encoding: Scalars['String'];
  iv: Scalars['String'];
  key: Scalars['String'];
  tagDisposition: Scalars['String'];
  tagSizeBits: Scalars['Int'];
};

export type FileCryptoKeyV2Input = {
  algorithm: Scalars['String'];
  encoding: Scalars['String'];
  iv: Scalars['String'];
  key: Scalars['String'];
  tagDisposition: Scalars['String'];
  tagSizeBits: Scalars['Int'];
};

export type FileResourceDownloadV2 = {
  __typename?: 'FileResourceDownloadV2';
  compression?: Maybe<FileResourceDownloadV2Compression>;
  cryptoKey?: Maybe<FileCryptoKeyV2>;
  fileType: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  resourceUrl: Scalars['String'];
  size: Scalars['Int'];
};

export enum FileResourceDownloadV2Compression {
  Gzip = 'gzip'
}

export type FileResourceUploadUrlV2 = {
  __typename?: 'FileResourceUploadUrlV2';
  resourceId: Scalars['ID'];
  resourceUrl: Scalars['String'];
};

export type FilteredTenantCompanies = {
  __typename?: 'FilteredTenantCompanies';
  childNodes?: Maybe<Array<Maybe<TenantChildNode>>>;
  totalCompanies: Scalars['Int'];
};

export type FinalizedPayorPayeeData = {
  __typename?: 'FinalizedPayorPayeeData';
  address?: Maybe<Address>;
  displayName?: Maybe<Scalars['String']>;
};

export type FlUcc1Form = {
  __typename?: 'FlUcc1Form';
  buyers?: Maybe<Array<Maybe<FlUcc1FormBuyer>>>;
  lender?: Maybe<FlUcc1FormLender>;
  settlementAgent?: Maybe<FlUcc1FormSettlementAgent>;
  userEmail?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type FlUcc1FormAddress = {
  __typename?: 'FlUcc1FormAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type FlUcc1FormBuyer = {
  __typename?: 'FlUcc1FormBuyer';
  address?: Maybe<FlUcc1FormAddress>;
  buyerType?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
};

export type FlUcc1FormLender = {
  __typename?: 'FlUcc1FormLender';
  address?: Maybe<FlUcc1FormAddress>;
  name?: Maybe<Scalars['String']>;
};

export type FlUcc1FormSettlementAgent = {
  __typename?: 'FlUcc1FormSettlementAgent';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type FloridaPremiumDisclosureForm = {
  __typename?: 'FloridaPremiumDisclosureForm';
  buyerSellerSignatures?: Maybe<FloridaPremiumDisclosureFormSignatures>;
  closingDisclosureAmount?: Maybe<FloridaPremiumDisclosureFormAmount>;
  companyLicense?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  floridaPremium?: Maybe<FloridaPremiumDisclosureFormAmount>;
  orderNumber?: Maybe<Scalars['String']>;
  ownerPolicyAmount?: Maybe<Scalars['Float']>;
  settlementAgentSignature?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  titleOfficerLicense?: Maybe<Scalars['String']>;
  titleOfficerName?: Maybe<Scalars['String']>;
  underwriterName?: Maybe<Scalars['String']>;
};

export type FloridaPremiumDisclosureFormAmount = {
  __typename?: 'FloridaPremiumDisclosureFormAmount';
  buyer?: Maybe<FloridaPremiumDisclosureFormBuyerSeller>;
  seller?: Maybe<FloridaPremiumDisclosureFormBuyerSeller>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type FloridaPremiumDisclosureFormBuyerSeller = {
  __typename?: 'FloridaPremiumDisclosureFormBuyerSeller';
  lenderEndorsements?: Maybe<Scalars['Float']>;
  lenderPolicy?: Maybe<Scalars['Float']>;
  lenderPolicyTotal?: Maybe<Scalars['Float']>;
  ownerEndorsements?: Maybe<Scalars['Float']>;
  ownerPolicy?: Maybe<Scalars['Float']>;
  ownerPolicyTotal?: Maybe<Scalars['Float']>;
};

export type FloridaPremiumDisclosureFormSignature = {
  __typename?: 'FloridaPremiumDisclosureFormSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type FloridaPremiumDisclosureFormSignatures = {
  __typename?: 'FloridaPremiumDisclosureFormSignatures';
  buyers?: Maybe<Array<Maybe<FloridaPremiumDisclosureFormSignature>>>;
  sellers?: Maybe<Array<Maybe<FloridaPremiumDisclosureFormSignature>>>;
};

export type Fund = {
  __typename?: 'Fund';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  locked?: Maybe<Scalars['Boolean']>;
  orderId?: Maybe<Scalars['String']>;
  totals?: Maybe<FundTotals>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type FundItemsDisbursementSummaryDetails = {
  __typename?: 'FundItemsDisbursementSummaryDetails';
  items?: Maybe<Array<Maybe<FundLineItemDisbursementSummaryDetails>>>;
  total?: Maybe<Scalars['Float']>;
};

export type FundItemsDisbursementSummaryForm = {
  __typename?: 'FundItemsDisbursementSummaryForm';
  items?: Maybe<Array<Maybe<FundLineItemDisbursementSummaryForm>>>;
  total?: Maybe<Scalars['Float']>;
};

export type FundLineDetailsDisbursementSummaryDetails = {
  __typename?: 'FundLineDetailsDisbursementSummaryDetails';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type FundLineItemDisbursementSummaryDetails = {
  __typename?: 'FundLineItemDisbursementSummaryDetails';
  fundingTransactionType?: Maybe<Scalars['String']>;
  lineDetails?: Maybe<Array<Maybe<FundLineDetailsDisbursementSummaryDetails>>>;
  payeeName?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  transactionAmount?: Maybe<Scalars['Float']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
};

export type FundLineItemDisbursementSummaryForm = {
  __typename?: 'FundLineItemDisbursementSummaryForm';
  fundingTransactionType?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  transactionAmount?: Maybe<Scalars['Float']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionStatus?: Maybe<Scalars['String']>;
};

export type FundTotals = {
  __typename?: 'FundTotals';
  fundedDisbursementBalance?: Maybe<Scalars['Float']>;
  fundedReceiptBalance?: Maybe<Scalars['Float']>;
  orderDisbursementBalance?: Maybe<Scalars['Float']>;
  orderReceiptBalance?: Maybe<Scalars['Float']>;
};

export type FundingTaxId = {
  __typename?: 'FundingTaxId';
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
};

export type FundingTaxIdInput = {
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
};

export type GenerateAsyncResponseV2 = {
  __typename?: 'GenerateAsyncResponseV2';
  generatingDocuments?: Maybe<Array<GeneratingDocumentItemV2>>;
  subscriptionId: Scalars['ID'];
};

export type GeneratingDocumentItemV2 = {
  __typename?: 'GeneratingDocumentItemV2';
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  orderId: Scalars['ID'];
  sourceDocumentId: Scalars['ID'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type GeneratingEntityDocumentItemV2 = {
  __typename?: 'GeneratingEntityDocumentItemV2';
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  sourceDocumentId: Scalars['ID'];
  tags?: Maybe<Array<Scalars['String']>>;
};

export type GetActiveUsersOnEntityInput = {
  id: Scalars['ID'];
};

export type GetAdjustmentsResponse = {
  __typename?: 'GetAdjustmentsResponse';
  adjustments: Array<Adjustment>;
};

export type GetAllImportedTemplatesRequestV2Input = {
  documentType: TemplateDocTypeV2;
};

export type GetCarrierAccountRequestInput = {
  id: Scalars['ID'];
};

export type GetCarrierAccountsRequestInput = {
  carrierType?: InputMaybe<CarrierType>;
  includeInactive?: InputMaybe<Scalars['Boolean']>;
  includeUnauthenticated?: InputMaybe<Scalars['Boolean']>;
  orderId?: InputMaybe<Scalars['ID']>;
  requireIntegrationEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type GetContactValidationRequestInput = {
  /** Query parameter - Order identifier for context */
  orderId: Scalars['ID'];
  /** URL path parameter - Party identifier (buyerSellerId from orders service) */
  partyId: Scalars['ID'];
  /** URL path parameter - The fraud tool provider */
  provider: GetContactValidationRequestInputProvider;
};

/** URL path parameter - The fraud tool provider */
export enum GetContactValidationRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type GetContactValidationResponse = {
  __typename?: 'GetContactValidationResponse';
  data?: Maybe<ContactValidationResponse>;
  /** Whether validation data was found */
  success: Scalars['Boolean'];
};

export type GetDocTypeMappingsByCountyNameRequestInput = {
  countyName: Scalars['String'];
  epnAccountId: Scalars['ID'];
};

export type GetDocTypeMappingsByCountyNameResponse = {
  __typename?: 'GetDocTypeMappingsByCountyNameResponse';
  mappings: Array<DocTypeMappingByCountyName>;
};

export type GetDocumentInsightsV2Input = {
  documentId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  scopeId?: InputMaybe<Scalars['ID']>;
};

export type GetDynamicDocumentTypesByCountyNameInput = {
  countyName: Scalars['String'];
  epnAccountId: Scalars['ID'];
};

export type GetDynamicDocumentTypesInput = {
  featureFlags?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type GetDynamicDocumentTypesResponse = {
  __typename?: 'GetDynamicDocumentTypesResponse';
  documentTypes: Array<DynamicDocumentType>;
};

export type GetERecordingEligibilityInput = {
  featureFlags?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type GetERecordingEligibilityResponse = {
  __typename?: 'GetERecordingEligibilityResponse';
  availableJurisdictions: Array<AvailableJurisdiction>;
  countyFips: Scalars['String'];
  countyName: Scalars['String'];
  isAutoSubmitEnabled: Scalars['Boolean'];
  isEligible: Scalars['Boolean'];
  requiresJurisdictionSelection: Scalars['Boolean'];
  selectedJurisdiction?: Maybe<GetERecordingEligibilityResponse_SelectedJurisdiction>;
};

export type GetERecordingEligibilityResponse_SelectedJurisdiction = {
  __typename?: 'GetERecordingEligibilityResponse_SelectedJurisdiction';
  countyName: Scalars['String'];
};

export type GetEligibleCountiesByApiKeyRequestInput = {
  apiKey: Scalars['String'];
};

export type GetEligibleCountiesRequestInput = {
  epnAccountId: Scalars['ID'];
};

export type GetEligibleCountiesResponse = {
  __typename?: 'GetEligibleCountiesResponse';
  counties: Array<EligibleCounty>;
};

export type GetEntityDocumentV2Input = {
  canBeHidden?: InputMaybe<Scalars['Boolean']>;
  documentId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  scopeId?: InputMaybe<Scalars['ID']>;
};

export type GetEntityTagsRequestV2Input = {
  entityId: Scalars['ID'];
  entityType: GetEntityTagsRequestV2InputEntityType;
};

export enum GetEntityTagsRequestV2InputEntityType {
  Company = 'company',
  Order = 'order'
}

export type GetEpnAccountForOrderInput = {
  orderId: Scalars['ID'];
};

export type GetEpnAccountForOrderResponse = {
  __typename?: 'GetEpnAccountForOrderResponse';
  account?: Maybe<EpnAccountWithApiKey>;
};

export type GetEpnAccountInput = {
  id: Scalars['ID'];
};

export type GetIdentityVerificationRequestInput = {
  /** Order identifier for context and filtering */
  orderId: Scalars['ID'];
  /** Party identifier - corresponds to buyerSellerId from orders service */
  partyId: Scalars['ID'];
  /** Provider extracted from URL path parameter - not sent in request body by frontend */
  provider: GetIdentityVerificationRequestInputProvider;
  /** Optional transaction ID to fetch specific verification attempt */
  transactionId?: InputMaybe<Scalars['ID']>;
};

/** Provider extracted from URL path parameter - not sent in request body by frontend */
export enum GetIdentityVerificationRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type GetIdentityVerificationResponse = {
  __typename?: 'GetIdentityVerificationResponse';
  result?: Maybe<GetIdentityVerificationResponse_Result>;
};

/** The verification result data, or null/undefined if no verification exists for this party */
export type GetIdentityVerificationResponse_Result = {
  __typename?: 'GetIdentityVerificationResponse_Result';
  /** Number of failed/expired attempts since last successful completion. Used to enforce max 3 attempts limit. */
  attemptCount?: Maybe<Scalars['Int']>;
  checks?: Maybe<GetIdentityVerificationResponse_Result_Checks>;
  error?: Maybe<GetIdentityVerificationResponse_Result_Error>;
  /** When the SMS verification link was created/sent. Only present for pending status. Used for 'sent at' display. */
  linkCreatedAt?: Maybe<Scalars['String']>;
  /** When the SMS verification link expires (30 minutes from creation). Only present for pending status. Distinct from metadata.expiresAt which is 90-day report retention. */
  linkExpiresAt?: Maybe<Scalars['String']>;
  metadata: GetIdentityVerificationResponse_Result_Metadata;
  nameVerification?: Maybe<GetIdentityVerificationResponse_Result_NameVerification>;
  requestParameters?: Maybe<GetIdentityVerificationResponse_Result_RequestParameters>;
  /** Overall transaction status */
  status: GetIdentityVerificationResponse_ResultStatus;
  summary?: Maybe<GetIdentityVerificationResponse_Result_Summary>;
  /** Unique transaction identifier */
  transactionId: Scalars['ID'];
};

/** Overall transaction status */
export enum GetIdentityVerificationResponse_ResultStatus {
  Completed = 'completed',
  Expired = 'expired',
  Failed = 'failed',
  Pending = 'pending'
}

/** Individual verification check results */
export type GetIdentityVerificationResponse_Result_Checks = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks';
  barcodeRecognized: GetIdentityVerificationResponse_Result_Checks_BarcodeRecognized;
  deviceAddress: GetIdentityVerificationResponse_Result_Checks_DeviceAddress;
  documentLiveness: GetIdentityVerificationResponse_Result_Checks_DocumentLiveness;
  expired: GetIdentityVerificationResponse_Result_Checks_Expired;
  formatRecognized: GetIdentityVerificationResponse_Result_Checks_FormatRecognized;
  frontMatchesBack: GetIdentityVerificationResponse_Result_Checks_FrontMatchesBack;
  phoneNumber: GetIdentityVerificationResponse_Result_Checks_PhoneNumber;
  selfie: GetIdentityVerificationResponse_Result_Checks_Selfie;
  selfieLive: GetIdentityVerificationResponse_Result_Checks_SelfieLive;
  selfieMatch: GetIdentityVerificationResponse_Result_Checks_SelfieMatch;
};

/** Whether barcode was recognized */
export type GetIdentityVerificationResponse_Result_Checks_BarcodeRecognized = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_BarcodeRecognized';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_BarcodeRecognizedStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_BarcodeRecognizedStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Device address verification */
export type GetIdentityVerificationResponse_Result_Checks_DeviceAddress = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_DeviceAddress';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_DeviceAddressStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_DeviceAddressStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Whether document appears to be live/authentic */
export type GetIdentityVerificationResponse_Result_Checks_DocumentLiveness = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_DocumentLiveness';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_DocumentLivenessStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_DocumentLivenessStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Whether document is expired (passed = not expired) */
export type GetIdentityVerificationResponse_Result_Checks_Expired = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_Expired';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_ExpiredStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_ExpiredStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Whether document format was recognized */
export type GetIdentityVerificationResponse_Result_Checks_FormatRecognized = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_FormatRecognized';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_FormatRecognizedStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_FormatRecognizedStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Whether front of document matches back */
export type GetIdentityVerificationResponse_Result_Checks_FrontMatchesBack = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_FrontMatchesBack';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_FrontMatchesBackStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_FrontMatchesBackStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Whether phone number was verified */
export type GetIdentityVerificationResponse_Result_Checks_PhoneNumber = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_PhoneNumber';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_PhoneNumberStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_PhoneNumberStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Whether selfie was captured */
export type GetIdentityVerificationResponse_Result_Checks_Selfie = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_Selfie';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_SelfieStatus;
};

/** Whether selfie appears to be live person */
export type GetIdentityVerificationResponse_Result_Checks_SelfieLive = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_SelfieLive';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_SelfieLiveStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_SelfieLiveStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Whether selfie matches document photo */
export type GetIdentityVerificationResponse_Result_Checks_SelfieMatch = {
  __typename?: 'GetIdentityVerificationResponse_Result_Checks_SelfieMatch';
  /** Display name of the check */
  name: Scalars['String'];
  /** Result status: passed, warning, or failed */
  status: GetIdentityVerificationResponse_Result_Checks_SelfieMatchStatus;
};

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_SelfieMatchStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Result status: passed, warning, or failed */
export enum GetIdentityVerificationResponse_Result_Checks_SelfieStatus {
  Failed = 'failed',
  Passed = 'passed',
  Warning = 'warning'
}

/** Error information if verification failed */
export type GetIdentityVerificationResponse_Result_Error = {
  __typename?: 'GetIdentityVerificationResponse_Result_Error';
  /** Error code */
  code: Scalars['String'];
  /** Additional error details */
  details?: Maybe<Scalars['String']>;
  /** Human-readable error message */
  message: Scalars['String'];
  /** When error occurred */
  timestamp: Scalars['String'];
};

export type GetIdentityVerificationResponse_Result_Metadata = {
  __typename?: 'GetIdentityVerificationResponse_Result_Metadata';
  /** When report expires (90 days from verification for data retention) */
  expiresAt: Scalars['String'];
  /** Always Intellicheck for identity verification */
  provider: GetIdentityVerificationResponse_Result_MetadataProvider;
  /** Whether the report was automatically attached to the order's documents. False or absent means auto-attach failed and the user can retry via the retryAttachIdentityVerificationReport mutation. (ANP-2107) */
  reportAttached?: Maybe<Scalars['Boolean']>;
  /** URL to download full verification report (ANP-2107) */
  reportUrl?: Maybe<Scalars['String']>;
};

/** Always Intellicheck for identity verification */
export enum GetIdentityVerificationResponse_Result_MetadataProvider {
  IntelliCheck = 'IntelliCheck'
}

/** Name verification result comparing ID name to order party name. Advisory only - does not block order progression. */
export type GetIdentityVerificationResponse_Result_NameVerification = {
  __typename?: 'GetIdentityVerificationResponse_Result_NameVerification';
  /** Confidence level of the match determination */
  confidence?: Maybe<GetIdentityVerificationResponse_Result_NameVerificationConfidence>;
  /** Name extracted from the ID document */
  idName?: Maybe<Scalars['String']>;
  /** Whether the names are considered a match */
  isMatch?: Maybe<Scalars['Boolean']>;
  /** Human-readable error or skip message */
  message?: Maybe<Scalars['String']>;
  /** Name from the order party record */
  orderPartyName?: Maybe<Scalars['String']>;
  /** LLM explanation of the matching decision */
  reasoning?: Maybe<Scalars['String']>;
  /** Error status type */
  status?: Maybe<GetIdentityVerificationResponse_Result_NameVerificationStatus>;
};

/** Confidence level of the match determination */
export enum GetIdentityVerificationResponse_Result_NameVerificationConfidence {
  MatchConfident = 'match_confident',
  MatchUncertain = 'match_uncertain',
  MismatchConfident = 'mismatch_confident',
  MismatchUncertain = 'mismatch_uncertain'
}

/** Error status type */
export enum GetIdentityVerificationResponse_Result_NameVerificationStatus {
  Error = 'error',
  Skipped = 'skipped',
  Unavailable = 'unavailable'
}

/** Original request parameters submitted during verification initiation */
export type GetIdentityVerificationResponse_Result_RequestParameters = {
  __typename?: 'GetIdentityVerificationResponse_Result_RequestParameters';
  /** Method used to deliver verification link */
  contactMethod: GetIdentityVerificationResponse_Result_RequestParametersContactMethod;
  /** Type of document used for verification */
  documentType: GetIdentityVerificationResponse_Result_RequestParametersDocumentType;
  /** Language for verification interface */
  language: GetIdentityVerificationResponse_Result_RequestParametersLanguage;
  /** Phone number used for verification delivery */
  phoneNumber?: Maybe<Scalars['String']>;
};

/** Method used to deliver verification link */
export enum GetIdentityVerificationResponse_Result_RequestParametersContactMethod {
  TextMessage = 'TEXT_MESSAGE'
}

/** Type of document used for verification */
export enum GetIdentityVerificationResponse_Result_RequestParametersDocumentType {
  DriversLicense = 'DRIVERS_LICENSE',
  Other = 'OTHER',
  Passport = 'PASSPORT'
}

/** Language for verification interface */
export enum GetIdentityVerificationResponse_Result_RequestParametersLanguage {
  English = 'ENGLISH',
  French = 'FRENCH',
  Spanish = 'SPANISH'
}

/** Summary information extracted from verification */
export type GetIdentityVerificationResponse_Result_Summary = {
  __typename?: 'GetIdentityVerificationResponse_Result_Summary';
  /** Name extracted from the verified document */
  nameOnId: Scalars['ID'];
  /** When the verification was completed */
  transactionDate: Scalars['String'];
};

export type GetInsightResponseV2 = {
  __typename?: 'GetInsightResponseV2';
  analysisLevel: GetInsightResponseV2AnalysisLevel;
  callbackContextEntries?: Maybe<Array<ExtractionDataEntryV2>>;
  chainOfTitle?: Maybe<ChainOfTitleV2>;
  classifications?: Maybe<Array<ClassifiedDocumentV2>>;
  completenessChecks?: Maybe<Array<CompletenessCheckV2>>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  criticalCount?: Maybe<Scalars['Float']>;
  documentCount?: Maybe<Scalars['Float']>;
  /** Per-document staleness information */
  documentStaleness: Array<DocumentStalenessV2>;
  /** @minItems 1 */
  documents: Array<InsightDocumentV2>;
  effectiveDate?: Maybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  extractions?: Maybe<Array<DocumentExtractionResultV2>>;
  factCount?: Maybe<Scalars['Float']>;
  insightId: Scalars['ID'];
  insightType: Scalars['String'];
  insights?: Maybe<Array<ObservationV2>>;
  legalDescription?: Maybe<Scalars['String']>;
  lienSummary?: Maybe<LienSummaryV2>;
  processingNotes?: Maybe<Scalars['String']>;
  releaseAnalysis?: Maybe<ReleaseAnalysisV2>;
  scheduleB?: Maybe<ScheduleBv2>;
  status: InsightsStatusV2;
  subjectApns?: Maybe<Array<Scalars['String']>>;
  subjectProperty?: Maybe<Scalars['String']>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
  warningCount?: Maybe<Scalars['Float']>;
};

export enum GetInsightResponseV2AnalysisLevel {
  Classifications = 'classifications',
  Extractions = 'extractions',
  Insights = 'insights'
}

export type GetInsightV2Input = {
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  /** Insight ID */
  insightId: Scalars['ID'];
  /** Insight type identifier */
  insightType: Scalars['String'];
  scopeId?: InputMaybe<Scalars['ID']>;
};

export type GetIntegrationRequestInput = {
  carrierType: CarrierType;
};

export type GetIntegrationStatusRequestInput = {
  /** Provider extracted from URL path parameter - not sent in request body by frontend */
  provider: GetIntegrationStatusRequestInputProvider;
  toolType: ToolType;
};

/** Provider extracted from URL path parameter - not sent in request body by frontend */
export enum GetIntegrationStatusRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type GetIntegrationStatusResponse = {
  __typename?: 'GetIntegrationStatusResponse';
  lastModifiedAt?: Maybe<Scalars['String']>;
  lastModifiedBy?: Maybe<Scalars['String']>;
  provider: Provider;
  status: IntegrationStatus;
  toolType: ToolType;
};

export type GetLabelsByOrderIdRequestInput = {
  orderId: Scalars['ID'];
};

export type GetMergeFieldsResponseV2 = {
  __typename?: 'GetMergeFieldsResponseV2';
  mergeFields: Array<MergeFieldDataV2>;
};

export type GetMissingTemplateBlocksForImportRequestV2Input = {
  documentType: TemplateTypeV2;
  templateIds: Array<Scalars['String']>;
};

export type GetMissingTemplateBlocksForImportResponseV2 = {
  __typename?: 'GetMissingTemplateBlocksForImportResponseV2';
  found: Array<RepositoryBlockImportReferenceV2>;
  missing: Array<RepositoryBlockImportReferenceV2>;
  nameCollisions: Array<RepositoryBlockImportReferenceV2>;
  updated: Array<RepositoryBlockImportReferenceV2>;
};

export type GetPackagesRequestInput = {
  orderId: Scalars['ID'];
};

export type GetPackagesResponse = {
  __typename?: 'GetPackagesResponse';
  packages: Array<Package>;
};

export type GetRfttDocumentsInput = {
  city: Scalars['String'];
  county: Scalars['String'];
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  salesAmount: Scalars['Float'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GetRfttFeesByOrderInput = {
  city: Scalars['String'];
  county: Scalars['String'];
  documents: Array<GetRfttQuestionsDocumentInput>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['String'];
  propertyType: Scalars['String'];
  questions: Array<GetRfttFeesQuestionInput>;
  salesAmount?: InputMaybe<Scalars['Float']>;
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GetRfttFeesInput = {
  city: Scalars['String'];
  county: Scalars['String'];
  documents: Array<GetRfttQuestionsDocumentInput>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  questions: Array<GetRfttFeesQuestionInput>;
  salesAmount?: InputMaybe<Scalars['Float']>;
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GetRfttFeesQuestionInput = {
  answer: Scalars['String'];
  defaultAnswer?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<RfttQuestionOptionInput>>>;
  providerMetadata: RfttQuestionProviderMetadataInput;
  questionText?: InputMaybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType: Scalars['String'];
};

export type GetRfttQuestionsDocumentInput = {
  considerationAmount?: InputMaybe<Scalars['Float']>;
  documentId: Scalars['String'];
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  numberOfPages?: InputMaybe<Scalars['Float']>;
};

export type GetRfttQuestionsInput = {
  city: Scalars['String'];
  county: Scalars['String'];
  documents: Array<GetRfttQuestionsDocumentInput>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  salesAmount: Scalars['Float'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type GetRateValidation = RateValidation & {
  __typename?: 'GetRateValidation';
  missingFields: Array<Scalars['String']>;
  orderId: Scalars['String'];
  premiumType: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type GetRecordingDocumentInput = {
  id: Scalars['ID'];
  orderId: Scalars['ID'];
};

export type GetReportExportInput = {
  exportId: Scalars['ID'];
};

export type GetSetsContainingTemplateV2Input = {
  after?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: TemplateTypeV2;
  first?: InputMaybe<Scalars['Int']>;
};

export type GetSnapshotRequestInput = {
  orderId: Scalars['ID'];
  packageId: Scalars['ID'];
};

export type GetSnapshotResponse = {
  __typename?: 'GetSnapshotResponse';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  orderId: Scalars['ID'];
  packageData: PackageStatusSnapshotData;
  packageId: Scalars['ID'];
  snapshotType?: Maybe<PackageStatusSnapshotType>;
  status: PackageStatus;
  statusMessage?: Maybe<Scalars['String']>;
};

export type GetStatusHistoryRequestInput = {
  orderId: Scalars['ID'];
  packageId: Scalars['ID'];
};

export type GetStatusHistoryResponse = {
  __typename?: 'GetStatusHistoryResponse';
  orderId: Scalars['ID'];
  packageId: Scalars['ID'];
  statusHistory: Array<StatusChange>;
};

export type GetTemplatesByNameAndFileTypeV2Input = {
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  name: Scalars['String'];
};

export type GetTemplatesFromSetQueryV2Input = {
  filters?: InputMaybe<Array<PaginatedQueryFilterV2Input>>;
  setId: Scalars['ID'];
};

export type GetTenantUnderwritersResponse = TenantUnderwriterResponse & {
  __typename?: 'GetTenantUnderwritersResponse';
  tenantUnderwriter: TenantUnderwriter;
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type GetTenantUnderwritersResponseTenantUnderwriterArgs = {
  tenantUnderwriterId?: InputMaybe<Scalars['String']>;
};


export type GetTenantUnderwritersResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type GetTitleSearchOrderInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
  skipXmlProcessing?: InputMaybe<Scalars['Boolean']>;
};

export type GetTitleSearchOrdersInput = {
  orderId: Scalars['String'];
};

export type GetTitleSearchProductsInput = {
  orderId: Scalars['String'];
  propertyType?: InputMaybe<Scalars['String']>;
  providerId: Scalars['String'];
  stateOrProvince: Scalars['String'];
  transactionType?: InputMaybe<Scalars['String']>;
};

export type GfeCharge = {
  __typename?: 'GfeCharge';
  comparisonCategory?: Maybe<Scalars['String']>;
  comparisonCategoryLocked?: Maybe<Scalars['Boolean']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  gfeAmount?: Maybe<Scalars['Float']>;
  gfeChargeAdditionalData?: Maybe<GfeChargeAdditionalData>;
  gfeLineNumber?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lineNumber?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['ID']>;
  statementAmount?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type GfeChargeAdditionalData = {
  __typename?: 'GfeChargeAdditionalData';
  amountPerDay?: Maybe<Scalars['Float']>;
};

export type GoogleConfiguration = {
  __typename?: 'GoogleConfiguration';
  apiKey?: Maybe<Scalars['String']>;
};

export type HudBorrowerCalculations = {
  __typename?: 'HUDBorrowerCalculations';
  cashCheckFromBorrower?: Maybe<Scalars['Float']>;
  loanAmount?: Maybe<Scalars['Float']>;
  totalDisbursementsToBorrower?: Maybe<Scalars['Float']>;
  totalDisbursementsToOthers?: Maybe<Scalars['Float']>;
  totalSettlementCharges?: Maybe<Scalars['Float']>;
};

export type HiRequirements = {
  __typename?: 'HiRequirements';
  queue?: Maybe<Scalars['String']>;
};

export type HiRequirementsInput = {
  queue?: InputMaybe<Scalars['String']>;
};

export type HomeownersInsurancePremiumEscrowFeeAdditionalData = {
  __typename?: 'HomeownersInsurancePremiumEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  amountPerMonthOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type HomeownersInsurancePremiumFeeAdditionalData = {
  __typename?: 'HomeownersInsurancePremiumFeeAdditionalData';
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type Hud1986Statement = {
  __typename?: 'Hud1986Statement';
  addendum?: Maybe<HudStatementAddendum>;
  header?: Maybe<HudStatementHeader>;
  settlementCharges?: Maybe<HudStatementSettlementCharges>;
  signatures?: Maybe<HudStatementSignatures>;
  transactionSummary?: Maybe<HudStatementTransactionSummary>;
};

export type Hud2010Statement = {
  __typename?: 'Hud2010Statement';
  addendum?: Maybe<HudStatementAddendum>;
  gfeComparison?: Maybe<Hud2010StatementGfeComparison>;
  header?: Maybe<HudStatementHeader>;
  loanTerms?: Maybe<Hud2010StatementLoanTerms>;
  settlementCharges?: Maybe<HudStatementSettlementCharges>;
  signatures?: Maybe<HudStatementSignatures>;
  transactionSummary?: Maybe<HudStatementTransactionSummary>;
};

export type Hud2010StatementGfeComparison = {
  __typename?: 'Hud2010StatementGfeComparison';
  canChange?: Maybe<Hud2010StatementGfeComparisonSection>;
  cannotIncrease?: Maybe<Hud2010StatementGfeComparisonSection>;
  tenPercent?: Maybe<Hud2010StatementGfeComparisonSection>;
};

export type Hud2010StatementGfeComparisonSection = {
  __typename?: 'Hud2010StatementGfeComparisonSection';
  gfeTotal?: Maybe<Scalars['Float']>;
  increaseAmount?: Maybe<Scalars['Float']>;
  increasePercent?: Maybe<Scalars['Float']>;
  items?: Maybe<Array<Maybe<Hud2010StatementGfeComparisonSectionItem>>>;
  statementTotal?: Maybe<Scalars['Float']>;
};

export type Hud2010StatementGfeComparisonSectionItem = {
  __typename?: 'Hud2010StatementGfeComparisonSectionItem';
  description?: Maybe<Scalars['String']>;
  gfeAmount?: Maybe<Scalars['Float']>;
  lineNumber?: Maybe<Scalars['String']>;
  statementAmount?: Maybe<Scalars['Float']>;
};

export type Hud2010StatementLoanTerms = {
  __typename?: 'Hud2010StatementLoanTerms';
  balloonPayment?: Maybe<Hud2010StatementLoanTermsBalloonPayment>;
  escrowPayments?: Maybe<Hud2010StatementLoanTermsEscrowPayments>;
  interestRate?: Maybe<Scalars['Float']>;
  interestRateIncrease?: Maybe<Hud2010StatementLoanTermsInterestRateIncrease>;
  loanAmount?: Maybe<Scalars['Float']>;
  loanAmountIncrease?: Maybe<Hud2010StatementLoanTermsLoanAmountIncrease>;
  loanTerm?: Maybe<Scalars['String']>;
  monthlyAmountOwed?: Maybe<Hud2010StatementLoanTermsMonthlyAmountOwed>;
  monthlyPrincipalAndInterestIncrease?: Maybe<Hud2010StatementLoanTermsMonthlyPrincipalAndInterestIncrease>;
  prepaymentPenalty?: Maybe<Hud2010StatementLoanTermsPrepaymentPenalty>;
};

export type Hud2010StatementLoanTermsBalloonPayment = {
  __typename?: 'Hud2010StatementLoanTermsBalloonPayment';
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDueDate?: Maybe<Scalars['String']>;
  paymentDueIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsEscrowPayments = {
  __typename?: 'Hud2010StatementLoanTermsEscrowPayments';
  escrowIncludesOther?: Maybe<Array<Maybe<HudStatementLoanTermsEscrowPaymentsOther>>>;
  includesHomeownersInsurance?: Maybe<Scalars['Boolean']>;
  includesPropertyTaxes?: Maybe<Scalars['Boolean']>;
  initialMonthlyAmount?: Maybe<Scalars['Float']>;
  monthlyEscrowPayment?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsInterestRateIncrease = {
  __typename?: 'Hud2010StatementLoanTermsInterestRateIncrease';
  adjustsEveryAfterDate?: Maybe<Scalars['String']>;
  adjustsEveryIncrement?: Maybe<Scalars['String']>;
  changePercentage?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  maximumInterestPercentage?: Maybe<Scalars['Float']>;
  minimumInterestPercentage?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsLoanAmountIncrease = {
  __typename?: 'Hud2010StatementLoanTermsLoanAmountIncrease';
  asHighAsAmount?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsMonthlyAmountOwed = {
  __typename?: 'Hud2010StatementLoanTermsMonthlyAmountOwed';
  amount?: Maybe<Scalars['Float']>;
  includesInterest?: Maybe<Scalars['Boolean']>;
  includesMortgageInsurance?: Maybe<Scalars['Boolean']>;
  includesPrincipal?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsMonthlyPrincipalAndInterestIncrease = {
  __typename?: 'Hud2010StatementLoanTermsMonthlyPrincipalAndInterestIncrease';
  asHighAsAmount?: Maybe<Scalars['Float']>;
  firstChangeAsHighAsAmount?: Maybe<Scalars['Float']>;
  firstChangeDate?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type Hud2010StatementLoanTermsPrepaymentPenalty = {
  __typename?: 'Hud2010StatementLoanTermsPrepaymentPenalty';
  penaltyAsHighAsAmount?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type HudFormType = {
  __typename?: 'HudFormType';
  hudFormType?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
};

export type HudFormTypeInput = {
  hudFormType?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
};

export type HudStatementAddendum = {
  __typename?: 'HudStatementAddendum';
  settlementCharges?: Maybe<HudStatementSettlementCharges>;
  transactionSummary?: Maybe<HudStatementAddendumTransactionSummary>;
};

export type HudStatementAddendumTransactionSummary = {
  __typename?: 'HudStatementAddendumTransactionSummary';
  section100?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section200?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section400?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section500?: Maybe<HudStatementAddendumTransactionSummarySection>;
  section1500?: Maybe<HudStatementAddendumTransactionSummarySection>;
};

export type HudStatementAddendumTransactionSummarySection = {
  __typename?: 'HudStatementAddendumTransactionSummarySection';
  items?: Maybe<Array<Maybe<HudStatementAddendumTransactionSummarySectionItem>>>;
};

export type HudStatementAddendumTransactionSummarySectionItem = {
  __typename?: 'HudStatementAddendumTransactionSummarySectionItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['Float']>;
};

export type HudStatementBorrowerSeller = {
  __typename?: 'HudStatementBorrowerSeller';
  address?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type HudStatementHeader = {
  __typename?: 'HudStatementHeader';
  borrowers?: Maybe<Array<Maybe<HudStatementBorrowerSeller>>>;
  dateDisbursement?: Maybe<Scalars['String']>;
  dateSettlement?: Maybe<Scalars['String']>;
  lenderCompanyAddress?: Maybe<Scalars['String']>;
  lenderCompanyCityStateZip?: Maybe<Scalars['String']>;
  lenderCompanyName?: Maybe<Scalars['String']>;
  loanNumber?: Maybe<Scalars['String']>;
  loanType?: Maybe<Scalars['String']>;
  micNumber?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<HudStatementBorrowerSeller>>>;
  settlementAgentCompanyAddress?: Maybe<Scalars['String']>;
  settlementAgentCompanyName?: Maybe<Scalars['String']>;
  settlementAgentContactFullName?: Maybe<Scalars['String']>;
  settlementLocationAddress?: Maybe<Scalars['String']>;
  settlementLocationCityStateZip?: Maybe<Scalars['String']>;
};

export type HudStatementLoanTermsEscrowPaymentsOther = {
  __typename?: 'HudStatementLoanTermsEscrowPaymentsOther';
  description?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type HudStatementSettlementCharges = {
  __typename?: 'HudStatementSettlementCharges';
  section700?: Maybe<HudStatementSettlementChargesSection>;
  section800?: Maybe<HudStatementSettlementChargesSection>;
  section900?: Maybe<HudStatementSettlementChargesSection>;
  section1000?: Maybe<HudStatementSettlementChargesSection>;
  section1100?: Maybe<HudStatementSettlementChargesSection>;
  section1200?: Maybe<HudStatementSettlementChargesSection>;
  section1300?: Maybe<HudStatementSettlementChargesSection>;
  section1400?: Maybe<HudStatementSettlementChargesSection>;
};

export type HudStatementSettlementChargesSection = {
  __typename?: 'HudStatementSettlementChargesSection';
  items?: Maybe<Array<Maybe<HudStatementSettlementChargesSectionItem>>>;
  title?: Maybe<Scalars['String']>;
};

export type HudStatementSettlementChargesSectionItem = {
  __typename?: 'HudStatementSettlementChargesSectionItem';
  bpa?: Maybe<Scalars['Float']>;
  descriptionAndPayee?: Maybe<Scalars['String']>;
  gfe?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
  spa?: Maybe<Scalars['Float']>;
};

export type HudStatementSignature = {
  __typename?: 'HudStatementSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type HudStatementSignatures = {
  __typename?: 'HudStatementSignatures';
  buyers?: Maybe<Array<Maybe<HudStatementSignature>>>;
  escrowOfficer?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<HudStatementSignature>>>;
};

export type HudStatementTransactionSummary = {
  __typename?: 'HudStatementTransactionSummary';
  borrowerCalcTotal?: Maybe<Scalars['Float']>;
  cashFromBorrower?: Maybe<Scalars['Boolean']>;
  cashFromSeller?: Maybe<Scalars['Boolean']>;
  section100?: Maybe<StatementLineItemAdjustmentSection>;
  section200?: Maybe<StatementLineItemAdjustmentSection>;
  section400?: Maybe<StatementLineItemAdjustmentSection>;
  section500?: Maybe<StatementLineItemAdjustmentSection>;
  section1500?: Maybe<StatementLineItemAdjustmentSection>;
  section1600?: Maybe<HudStatementTransactionSummarySection1600>;
  sellerCalcTotal?: Maybe<Scalars['Float']>;
  totalDueFromBorrower?: Maybe<Scalars['Float']>;
  totalDueFromSeller?: Maybe<Scalars['Float']>;
  totalDueToSeller?: Maybe<Scalars['Float']>;
  totalPaidByBorrower?: Maybe<Scalars['Float']>;
};

export type HudStatementTransactionSummarySection1600 = {
  __typename?: 'HudStatementTransactionSummarySection1600';
  items?: Maybe<Array<Maybe<HudStatementTransactionSummarySection1600Item>>>;
};

export type HudStatementTransactionSummarySection1600Item = {
  __typename?: 'HudStatementTransactionSummarySection1600Item';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  descriptionPrefix?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
};

export type IdentityVerificationRequestInput = {
  contactMethod: ContactMethod;
  documentType?: InputMaybe<DocumentType>;
  language?: InputMaybe<Language>;
  orderId: Scalars['ID'];
  /** Party identifier - corresponds to buyerSellerId from orders service */
  partyId: Scalars['ID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  /** Provider extracted from URL path parameter - not sent in request body by frontend */
  provider: IdentityVerificationRequestInputProvider;
  /** Underwriter name for additional context (passed to ANS in userDefined) */
  underwriter?: InputMaybe<Scalars['String']>;
};

/** Provider extracted from URL path parameter - not sent in request body by frontend */
export enum IdentityVerificationRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type IdentityVerificationResponse = {
  __typename?: 'IdentityVerificationResponse';
  /** When verification was initiated (used for FE 30-minute timer and 90-day tracking) */
  createdAt: Scalars['String'];
  /** When verification link expires (createdAt + 30 minutes) */
  expiresAt: Scalars['String'];
  /** Current status of the verification transaction */
  status: IdentityVerificationResponseStatus;
  /** Unique transaction identifier from Intellicheck */
  transactionId: Scalars['ID'];
};

/** Current status of the verification transaction */
export enum IdentityVerificationResponseStatus {
  Completed = 'completed',
  Expired = 'expired',
  Failed = 'failed',
  Pending = 'pending'
}

export type Image = {
  __typename?: 'Image';
  dataUrl?: Maybe<Scalars['String']>;
  metadata?: Maybe<ImageMetadata>;
};

export type ImageMetadata = {
  __typename?: 'ImageMetadata';
  height?: Maybe<Scalars['Int']>;
  width?: Maybe<Scalars['Int']>;
};

export type ImportDataInput = {
  documents?: InputMaybe<Array<TitleSearchImportDocumentSelectedInput>>;
  exceptions?: InputMaybe<Array<TitleSearchImportRequirementsExceptionsDataSelectedInput>>;
  general?: InputMaybe<Array<TitleSearchImportGeneralDataSelectedInput>>;
  requirements?: InputMaybe<Array<TitleSearchImportRequirementsExceptionsDataSelectedInput>>;
};

export type ImportDataSnapshotInput = {
  importData: ImportDataInput;
};

export enum ImportItemStatus {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  Pending = 'PENDING'
}

export type ImportManifest = {
  __typename?: 'ImportManifest';
  createdAt: Scalars['String'];
  createdBy: Scalars['String'];
  executionArn?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  status: ImportItemStatus;
  tenantId: Scalars['String'];
  titleSearchId: Scalars['String'];
  updateId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['String'];
  updatedBy: Scalars['String'];
};

export type ImportManifestDocumentItem = {
  __typename?: 'ImportManifestDocumentItem';
  completedAt?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  status: ImportItemStatus;
};

export type ImportManifestExceptionItem = {
  __typename?: 'ImportManifestExceptionItem';
  clauseId: Scalars['String'];
  completedAt?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  status: ImportItemStatus;
};

export type ImportManifestRequirementItem = {
  __typename?: 'ImportManifestRequirementItem';
  clauseId: Scalars['String'];
  completedAt?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  status: ImportItemStatus;
};

export type ImportRepositoryAsyncRequestV2Input = {
  blockIds?: InputMaybe<Array<Scalars['String']>>;
  documentType: TemplateTypeV2;
  subscriptionId?: InputMaybe<Scalars['ID']>;
  templateIds?: InputMaybe<Array<Scalars['String']>>;
};

export type ImportRepositoryAsyncResponseV2 = {
  __typename?: 'ImportRepositoryAsyncResponseV2';
  subscriptionId: Scalars['ID'];
};

export type ImportRepositoryItemEntryV2 = {
  __typename?: 'ImportRepositoryItemEntryV2';
  error?: Maybe<Scalars['String']>;
  importCollision: Scalars['Boolean'];
  repositoryTemplateId: Scalars['ID'];
  success: Scalars['Boolean'];
  template?: Maybe<TemplateDocV2>;
};

export type ImportRepositoryTemplateRequestV2Input = {
  documentType: TemplateTypeV2;
  overwriteBlocks?: InputMaybe<Scalars['Boolean']>;
  repositoryTemplateIds: Array<Scalars['String']>;
};

export type ImportRepositoryTemplateResponseV2 = {
  __typename?: 'ImportRepositoryTemplateResponseV2';
  blockNameCollisions: Array<Scalars['String']>;
  importCollision: Scalars['Boolean'];
  results: Array<ImportRepositoryItemEntryV2>;
  success: Scalars['Boolean'];
};

export type ImportedTemplateSummaryV2 = {
  __typename?: 'ImportedTemplateSummaryV2';
  createdTimestamp: Scalars['String'];
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  name: Scalars['String'];
  repositoryFileVersion?: Maybe<Scalars['String']>;
  repositoryTemplateId?: Maybe<Scalars['ID']>;
  updatedTimestamp: Scalars['String'];
};

export type IncomingWire = IncomingWireTableRow & {
  __typename?: 'IncomingWire';
  amountCents?: Maybe<Scalars['SafeInt']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  faTrustWireId: Scalars['String'];
  imad?: Maybe<Scalars['String']>;
  matchedBy?: Maybe<Scalars['String']>;
  matchedOrderNumber?: Maybe<Scalars['String']>;
  matchedReceiptId?: Maybe<Scalars['String']>;
  matchedTimestamp?: Maybe<Scalars['String']>;
  obi?: Maybe<Scalars['String']>;
  omad?: Maybe<Scalars['String']>;
  originator?: Maybe<Scalars['String']>;
  originatorReference?: Maybe<Scalars['String']>;
  receivedTimestamp?: Maybe<Scalars['String']>;
  senderRef?: Maybe<Scalars['String']>;
  sendingBank?: Maybe<Scalars['String']>;
  sendingBankAba?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  wireStatus: IncomingWireStatus;
};

/**
 * Group-header row emitted for the incoming-wire table-data response when the request carries
 * a groupings array whose current level has no drill value. groupKey identifies the column the
 * header buckets on; groupValue is the canonical bucket value (day-truncated for dates, SDL
 * casing for wireStatus). groupChildCount is the number of leaf rows in the bucket.
 */
export type IncomingWireGroupRow = IncomingWireTableRow & {
  __typename?: 'IncomingWireGroupRow';
  amountCents?: Maybe<Scalars['SafeInt']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  faTrustWireId?: Maybe<Scalars['String']>;
  groupChildCount: Scalars['Int'];
  groupKey: Scalars['String'];
  groupValue?: Maybe<Scalars['JSONObject']>;
  imad?: Maybe<Scalars['String']>;
  matchedOrderNumber?: Maybe<Scalars['String']>;
  matchedReceiptId?: Maybe<Scalars['String']>;
  obi?: Maybe<Scalars['String']>;
  omad?: Maybe<Scalars['String']>;
  originator?: Maybe<Scalars['String']>;
  originatorReference?: Maybe<Scalars['String']>;
  receivedTimestamp?: Maybe<Scalars['String']>;
  sendingBank?: Maybe<Scalars['String']>;
  sendingBankAba?: Maybe<Scalars['String']>;
  wireStatus?: Maybe<IncomingWireStatus>;
};

export enum IncomingWireStatus {
  Matched = 'MATCHED',
  Unmatched = 'UNMATCHED'
}

/** Paginated/filterable/sortable/groupable read input for the incoming wires grid (SSRM; no total count). */
export type IncomingWireTableDataInput = {
  escrowAccountId: Scalars['String'];
  filters?: InputMaybe<Array<WireDataFilterInput>>;
  groupings?: InputMaybe<Array<WireGroupingInput>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Array<WireSortColumnInput>>;
};

/** Incoming wire table-data response envelope (no total count; SSRM block semantics). */
export type IncomingWireTableDataResponse = {
  __typename?: 'IncomingWireTableDataResponse';
  data: Array<IncomingWireTableRow>;
};

/** Common row contract for incoming-wire table data. Legacy clients can select leaf fields directly; grouped rows return null for them. */
export type IncomingWireTableRow = {
  amountCents?: Maybe<Scalars['SafeInt']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  faTrustWireId?: Maybe<Scalars['String']>;
  imad?: Maybe<Scalars['String']>;
  matchedOrderNumber?: Maybe<Scalars['String']>;
  matchedReceiptId?: Maybe<Scalars['String']>;
  obi?: Maybe<Scalars['String']>;
  omad?: Maybe<Scalars['String']>;
  originator?: Maybe<Scalars['String']>;
  originatorReference?: Maybe<Scalars['String']>;
  receivedTimestamp?: Maybe<Scalars['String']>;
  sendingBank?: Maybe<Scalars['String']>;
  sendingBankAba?: Maybe<Scalars['String']>;
  wireStatus?: Maybe<IncomingWireStatus>;
};

export type IndividualSendEmailResponse = {
  __typename?: 'IndividualSendEmailResponse';
  failed: Scalars['Boolean'];
  from: Scalars['String'];
  messageId: Scalars['ID'];
  response: Scalars['String'];
  to: Array<Scalars['String']>;
};

export type IneligibleTransactions = {
  __typename?: 'IneligibleTransactions';
  reason?: Maybe<Scalars['String']>;
  transaction?: Maybe<Transaction>;
};

/** Input for initiating an outgoing wire: client supplies escrow account + transaction; backend derives beneficiary/payee/address/amount. snapshot overrides individual derived fields. */
export type InitiateWireInput = {
  continueWithoutValidation?: InputMaybe<Scalars['Boolean']>;
  escrowAccountId: Scalars['String'];
  /** Reference from a prior failed attempt, echoed on the Continue-Without-Validation retry so its audit events land on one wire; ignored when malformed. */
  reference?: InputMaybe<Scalars['String']>;
  snapshot?: InputMaybe<WireValidationSnapshot>;
  transactionId: Scalars['String'];
};

export type InsightDataV2 = {
  __typename?: 'InsightDataV2';
  documentCount?: Maybe<Scalars['Float']>;
  documentTypes?: Maybe<Array<Scalars['String']>>;
  factCount?: Maybe<Scalars['Float']>;
  insightId?: Maybe<Scalars['ID']>;
  isStale?: Maybe<Scalars['Boolean']>;
  previousInsightId?: Maybe<Scalars['ID']>;
  status: InsightsStatusV2;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type InsightDocument = {
  __typename?: 'InsightDocument';
  documentId: Scalars['String'];
  documentVersionHash: Scalars['String'];
  entityId: Scalars['String'];
  entityType: Scalars['String'];
};

export type InsightDocumentV2 = {
  __typename?: 'InsightDocumentV2';
  documentId: Scalars['ID'];
  documentVersionHash: Scalars['String'];
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
};

export type InsightItem = {
  __typename?: 'InsightItem';
  analysisLevel: Scalars['String'];
  callbackContext?: Maybe<Scalars['JSONObject']>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  documents: Array<InsightDocument>;
  entityId: Scalars['String'];
  entityType: Scalars['String'];
  errorCode?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  insightId: Scalars['String'];
  insightType: Scalars['String'];
  status: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export enum InsightsStatusV2 {
  Completed = 'completed',
  Failed = 'failed',
  NotAnalyzed = 'not_analyzed',
  Pending = 'pending',
  Processing = 'processing',
  Submitted = 'submitted',
  TimedOut = 'timed_out'
}

export type InsuredVesting = {
  __typename?: 'InsuredVesting';
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  mergeFields?: Maybe<Scalars['String']>;
  requirementMergeable?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type InsuredVestingRequirementMergeableArgs = {
  showSyntax?: InputMaybe<Scalars['Boolean']>;
};

export type IntegratedRfttAnswerInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type IntegratedRfttDocument = {
  __typename?: 'IntegratedRFTTDocument';
  considerationAmount?: Maybe<Scalars['Float']>;
  considerationAmountFallback?: Maybe<Scalars['Float']>;
  documentId: Scalars['String'];
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  isDefault: Scalars['Boolean'];
  numberOfPages?: Maybe<Scalars['Float']>;
  numberOfPagesFallback?: Maybe<Scalars['Float']>;
};

export type IntegratedRfttDocumentsParams = {
  __typename?: 'IntegratedRFTTDocumentsParams';
  city: Scalars['String'];
  cityFallback?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  countyFallback?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  propertyType?: Maybe<Scalars['String']>;
  salesAmount?: Maybe<Scalars['Float']>;
  settlementDate: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type IntegratedRfttDocumentsParamsInput = {
  city: Scalars['String'];
  cityFallback?: InputMaybe<Scalars['String']>;
  county: Scalars['String'];
  countyFallback?: InputMaybe<Scalars['String']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  propertyType: Scalars['String'];
  salesAmount?: InputMaybe<Scalars['Float']>;
  settlementDate: Scalars['String'];
  state: Scalars['String'];
  transactionType: Scalars['String'];
};

export type IntegratedRfttFeesQuestionInput = {
  answer: Scalars['String'];
  defaultAnswer?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  options?: InputMaybe<Array<InputMaybe<IntegratedRfttQuestionOptionInput>>>;
  providerMetadata: IntegratedRfttQuestionProviderMetadataInput;
  questionText?: InputMaybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType: Scalars['String'];
};

export type IntegratedRfttInput = {
  documents: Array<IntegratedRfttQuestionsDocumentInput>;
  documentsParams: IntegratedRfttDocumentsParamsInput;
  orderId: Scalars['String'];
  questions: Array<IntegratedRfttFeesQuestionInput>;
  recordingFees: IntegratedRecordingFeesInput;
  transferTaxes: IntegratedTransferTaxesInput;
};

export type IntegratedRfttQuestion = {
  __typename?: 'IntegratedRFTTQuestion';
  answer?: Maybe<Scalars['String']>;
  defaultAnswer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  options?: Maybe<Array<IntegratedRfttQuestionOption>>;
  providerMetadata: IntegratedRfttQuestionProviderMetadata;
  questionText?: Maybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType?: Maybe<Scalars['String']>;
};

export type IntegratedRfttQuestionOption = {
  __typename?: 'IntegratedRFTTQuestionOption';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type IntegratedRfttQuestionOptionInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type IntegratedRfttQuestionProviderMetadata = {
  __typename?: 'IntegratedRFTTQuestionProviderMetadata';
  lvis: IntegratedRfttQuestionProviderMetadataLvis;
};

export type IntegratedRfttQuestionProviderMetadataInput = {
  lvis: IntegratedRfttQuestionProviderMetadataLvisInput;
};

export type IntegratedRfttQuestionProviderMetadataLvis = {
  __typename?: 'IntegratedRFTTQuestionProviderMetadataLVIS';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type IntegratedRfttQuestionProviderMetadataLvisInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type IntegratedRfttQuestionsDocumentInput = {
  considerationAmount?: InputMaybe<Scalars['Float']>;
  considerationAmountFallback?: InputMaybe<Scalars['Float']>;
  documentId: Scalars['String'];
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  isDefault: Scalars['Boolean'];
  numberOfPages: Scalars['Float'];
  numberOfPagesFallback?: InputMaybe<Scalars['Float']>;
};

export type IntegratedRecordingFeeInput = {
  amount: Scalars['Float'];
  amountFallback?: InputMaybe<Scalars['Float']>;
  buyerAmount: Scalars['Float'];
  buyerAmountFallback?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameFallback: Scalars['String'];
  type: Scalars['String'];
};

export type IntegratedRecordingFeesInput = {
  lineItems: Array<IntegratedRecordingFeeInput>;
  payeeId: Scalars['String'];
  payeeSuggested?: InputMaybe<Scalars['String']>;
};

export type IntegratedTransferTaxInput = {
  amount: Scalars['Float'];
  amountFallback?: InputMaybe<Scalars['Float']>;
  buyerAmount: Scalars['Float'];
  buyerAmountFallback?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  nameFallback: Scalars['String'];
  payeeId: Scalars['String'];
  payeeSuggested?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type IntegratedTransferTaxesInput = {
  lineItems: Array<IntegratedTransferTaxInput>;
};

export type Integration = {
  __typename?: 'Integration';
  cplPricing: Scalars['JSONObject'];
  cplProduct: Scalars['JSONObject'];
  externalFileIntegrator?: Maybe<Scalars['String']>;
  pricing: Scalars['JSONObject'];
  products: Scalars['JSONObject'];
};

export type IntegrationObject = {
  __typename?: 'IntegrationObject';
  active: Scalars['Boolean'];
  carrierType: CarrierType;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  tenantId: Scalars['ID'];
  updatedBy: UserDisplayName;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type IntegrationOrderReadiness = {
  __typename?: 'IntegrationOrderReadiness';
  cpl: IntegrationOrderReadinessLane;
  jacket: IntegrationOrderReadinessLane;
};

export type IntegrationOrderReadinessLane = {
  __typename?: 'IntegrationOrderReadinessLane';
  ready: Scalars['Boolean'];
  reasons: Array<IntegrationOrderReadinessReason>;
};

export enum IntegrationOrderReadinessReason {
  AgentOptionNotAvailableToUser = 'AGENT_OPTION_NOT_AVAILABLE_TO_USER',
  AgentOptionNotConfigured = 'AGENT_OPTION_NOT_CONFIGURED',
  OrderContextMissing = 'ORDER_CONTEXT_MISSING',
  ProviderNotEnabled = 'PROVIDER_NOT_ENABLED',
  ProviderUnavailable = 'PROVIDER_UNAVAILABLE',
  UserAuthRequired = 'USER_AUTH_REQUIRED',
  UserNotEntitled = 'USER_NOT_ENTITLED'
}

export enum IntegrationStatus {
  Disabled = 'Disabled',
  Enabled = 'Enabled'
}

export type InviteUserInput = {
  id: Scalars['ID'];
};

export type IssueConsolidatedPaymentInput = {
  directoryCompanyId: Scalars['String'];
  escrowAccountId: Scalars['String'];
  fundingTransactionType: Scalars['String'];
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<Scalars['JSONObject']>;
  oWireTransfer?: InputMaybe<Scalars['JSONObject']>;
  refNumber?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['String']>;
  transactionIds: Array<Scalars['String']>;
};

export type IssueConsolidatedPaymentResult = {
  __typename?: 'IssueConsolidatedPaymentResult';
  amount?: Maybe<Scalars['Float']>;
  consolidatedPaymentId?: Maybe<Scalars['String']>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  originTransactionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  refNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
};

export type Jacket = {
  __typename?: 'Jacket';
  documentId?: Maybe<Scalars['String']>;
  errors?: Maybe<Array<Error>>;
  fileId?: Maybe<Scalars['Int']>;
  flatRemitAvailable?: Maybe<Scalars['Boolean']>;
  fluentPremiumType: Scalars['String'];
  fluentStatus: Scalars['String'];
  policyNumber?: Maybe<Scalars['String']>;
  warnings?: Maybe<Array<Warning>>;
};

export type JacketInput = {
  orderId: Scalars['String'];
  premiumType: Scalars['String'];
};

export type JacketSyncResponse = {
  __typename?: 'JacketSyncResponse';
  errors?: Maybe<Array<Error>>;
  warnings?: Maybe<Array<Warning>>;
};

export type JoinNewTransactionInput = {
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['String']>;
};

export type JoinTransactionsInput = {
  escrowAccountId: Scalars['String'];
  joinTransactions: Array<JoinTransactionsItemInput>;
  newTransaction?: InputMaybe<JoinNewTransactionInput>;
  orderId: Scalars['String'];
};

export type JoinTransactionsItemInput = {
  transactionId: Scalars['String'];
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type JoinTransactionsResponse = {
  __typename?: 'JoinTransactionsResponse';
  removedTransactions?: Maybe<Array<Maybe<Scalars['String']>>>;
  transaction?: Maybe<Transaction>;
};

/**
 * KY Municipal Tax Code option for dropdown
 * Static reference data from svc-title
 * ANP-4864: Tax code dropdown
 */
export type KyMunicipalTaxCode = {
  __typename?: 'KyMunicipalTaxCode';
  /** City and county display name (e.g., 'Louisville - Jefferson') */
  cityCounty: Scalars['String'];
  /** Tax code identifier (e.g., '1037') */
  taxCode: Scalars['String'];
};

export type LabelObject = {
  __typename?: 'LabelObject';
  buyerAddress?: Maybe<ShipmentAddress>;
  carrierType: CarrierType;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  customField?: Maybe<Scalars['String']>;
  documentId: Scalars['ID'];
  externalLabelUrl: Scalars['String'];
  fromAddress: ShipmentAddress;
  labelFormat: LabelObjectLabelFormat;
  labelSize?: Maybe<LabelObjectLabelSize>;
  labelUrl: Scalars['String'];
  orderId: Scalars['ID'];
  rate?: Maybe<Scalars['String']>;
  returnAddress?: Maybe<ShipmentAddress>;
  shipmentId?: Maybe<Scalars['ID']>;
  status: LabelStatus;
  tenantId: Scalars['ID'];
  toAddress: ShipmentAddress;
  trackingNumber: Scalars['String'];
  updatedBy: UserDisplayName;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export enum LabelObjectLabelFormat {
  Pdf = 'PDF'
}

export enum LabelObjectLabelSize {
  Size_4X6 = 'SIZE_4X6',
  Size_4X7 = 'SIZE_4X7',
  Size_8_5X11 = 'SIZE_8_5X11'
}

export enum LabelStatus {
  Issued = 'ISSUED',
  Voided = 'VOIDED'
}

export enum Language {
  English = 'ENGLISH',
  French = 'FRENCH',
  Spanish = 'SPANISH'
}

export type Latisso107PremiumDisclosureForm = {
  __typename?: 'Latisso107PremiumDisclosureForm';
  companyLicense?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  lenderDisclosedAmount?: Maybe<Scalars['String']>;
  lenderPolicyAmount?: Maybe<Scalars['String']>;
  mortgageInsuredAmount?: Maybe<Scalars['String']>;
  ownerDisclosedAmount?: Maybe<Scalars['String']>;
  ownerInsuredAmount?: Maybe<Scalars['String']>;
  ownerPolicyAmount?: Maybe<Scalars['String']>;
  signatures?: Maybe<Latisso107PremiumDisclosureFormSignatures>;
  titleOfficerLicense?: Maybe<Scalars['String']>;
  titleOfficerName?: Maybe<Scalars['String']>;
  totalDisclosedAmount?: Maybe<Scalars['String']>;
  totalPolicyAmount?: Maybe<Scalars['String']>;
  underwriter?: Maybe<Scalars['String']>;
};

export type Latisso107PremiumDisclosureFormSignature = {
  __typename?: 'Latisso107PremiumDisclosureFormSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type Latisso107PremiumDisclosureFormSignatures = {
  __typename?: 'Latisso107PremiumDisclosureFormSignatures';
  buyers?: Maybe<Array<Maybe<Latisso107PremiumDisclosureFormSignature>>>;
  sellers?: Maybe<Array<Maybe<Latisso107PremiumDisclosureFormSignature>>>;
};

export type LegacyBuyerSellerRepInput = {
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  representativeCapacity?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderBuyerSellerInput = {
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  entityType?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  representatives?: InputMaybe<Array<InputMaybe<LegacyBuyerSellerRepInput>>>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  spouseFirstName?: InputMaybe<Scalars['String']>;
  spouseLastName?: InputMaybe<Scalars['String']>;
  spouseMiddleName?: InputMaybe<Scalars['String']>;
  spouseSuffix?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

export type LegacyOrderDocumentInput = {
  documentAlias?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['String']>;
  documentFileName?: InputMaybe<Scalars['String']>;
  documentPath?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderDocumentResponse = {
  __typename?: 'LegacyOrderDocumentResponse';
  documentDate?: Maybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentName?: Maybe<Scalars['String']>;
  presignedURL?: Maybe<Scalars['String']>;
};

export type LegacyOrderNotesInput = {
  note?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderParcelIdInput = {
  parcelId?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderPolicyExceptionInput = {
  exception?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
};

export type LegacyOrderPropertyInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  addressType?: InputMaybe<Scalars['String']>;
  briefLegalDescription?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  countyName?: InputMaybe<Scalars['String']>;
  fullLegalDescription?: InputMaybe<Scalars['String']>;
  municipalityName?: InputMaybe<Scalars['String']>;
  municipalityType?: InputMaybe<Scalars['String']>;
  parcelIds?: InputMaybe<Array<InputMaybe<LegacyOrderParcelIdInput>>>;
  postalCode?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
};

export type LegacyOrderResponse = {
  __typename?: 'LegacyOrderResponse';
  documents?: Maybe<Array<Maybe<LegacyOrderDocumentResponse>>>;
  orderNumber?: Maybe<Scalars['String']>;
};

export type LegacyOrdersInput = {
  buyerNames?: InputMaybe<Array<InputMaybe<LegacyOrderBuyerSellerInput>>>;
  commitmentExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  commonExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  companyAddress?: InputMaybe<Scalars['String']>;
  companyAddress1?: InputMaybe<Scalars['String']>;
  companyAddress2?: InputMaybe<Scalars['String']>;
  companyCity?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyState?: InputMaybe<Scalars['String']>;
  companyZip?: InputMaybe<Scalars['String']>;
  documents?: InputMaybe<Array<InputMaybe<LegacyOrderDocumentInput>>>;
  fileUniqueId?: InputMaybe<Scalars['String']>;
  lenderPolicyExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  notes?: InputMaybe<Array<InputMaybe<LegacyOrderNotesInput>>>;
  openDate?: InputMaybe<Scalars['String']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  orderStatus?: InputMaybe<Scalars['String']>;
  ownerPolicyExceptions?: InputMaybe<Array<InputMaybe<LegacyOrderPolicyExceptionInput>>>;
  properties?: InputMaybe<Array<InputMaybe<LegacyOrderPropertyInput>>>;
  sellerNames?: InputMaybe<Array<InputMaybe<LegacyOrderBuyerSellerInput>>>;
  settlementDate?: InputMaybe<Scalars['String']>;
  statementType?: InputMaybe<Scalars['String']>;
  transactionType?: InputMaybe<Scalars['String']>;
};

export type LegalDescription = {
  __typename?: 'LegalDescription';
  fullDescription?: Maybe<Scalars['String']>;
  parcelIds?: Maybe<Array<Scalars['String']>>;
  platted?: Maybe<PlattedLand>;
  unPlatted?: Maybe<UnPlattedLand>;
};

export type LegalDescriptionInput = {
  fullDescription?: InputMaybe<Scalars['String']>;
  parcelIds?: InputMaybe<Array<Scalars['String']>>;
  platted?: InputMaybe<PlattedLandInput>;
  unPlatted?: InputMaybe<UnPlattedLandInput>;
};

export type LenderCreditsFeeAdditionalData = {
  __typename?: 'LenderCreditsFeeAdditionalData';
  additionalDescription?: Maybe<Scalars['String']>;
  lenderCreditsAmount?: Maybe<Scalars['Float']>;
};

export type LenderLanguageOptions = {
  __typename?: 'LenderLanguageOptions';
  FHA?: Maybe<Scalars['String']>;
  MERS?: Maybe<Scalars['String']>;
  OTHER?: Maybe<Scalars['String']>;
  STANDARD?: Maybe<Scalars['String']>;
  SUCCESSOR_OWNERSHIP?: Maybe<Scalars['String']>;
  VA?: Maybe<Scalars['String']>;
};

export type LenderLanguageOptionsInput = {
  FHA?: InputMaybe<Scalars['String']>;
  MERS?: InputMaybe<Scalars['String']>;
  OTHER?: InputMaybe<Scalars['String']>;
  STANDARD?: InputMaybe<Scalars['String']>;
  SUCCESSOR_OWNERSHIP?: InputMaybe<Scalars['String']>;
  VA?: InputMaybe<Scalars['String']>;
};

export type LenderLanguageOptionsOverrideMetadata = {
  __typename?: 'LenderLanguageOptionsOverrideMetadata';
  FHA?: Maybe<OverrideMetadataString>;
  MERS?: Maybe<OverrideMetadataString>;
  OTHER?: Maybe<OverrideMetadataString>;
  STANDARD?: Maybe<OverrideMetadataString>;
  SUCCESSOR_OWNERSHIP?: Maybe<OverrideMetadataString>;
  VA?: Maybe<OverrideMetadataString>;
};

export type LenderLanguageOptionsType = {
  __typename?: 'LenderLanguageOptionsType';
  FHA?: Maybe<Scalars['String']>;
  MERS?: Maybe<Scalars['String']>;
  OTHER?: Maybe<Scalars['String']>;
  STANDARD?: Maybe<Scalars['String']>;
  SUCCESSOR_OWNERSHIP?: Maybe<Scalars['String']>;
  VA?: Maybe<Scalars['String']>;
};

export type License = {
  __typename?: 'License';
  licenseNumber?: Maybe<Scalars['String']>;
  licensedState?: Maybe<Scalars['String']>;
};

export type LicenseInput = {
  licenseNumber?: InputMaybe<Scalars['String']>;
  licensedState?: InputMaybe<Scalars['String']>;
};

export type LienReferenceV2 = {
  __typename?: 'LienReferenceV2';
  holder?: Maybe<Scalars['String']>;
  lienType?: Maybe<Scalars['String']>;
  originalAmount?: Maybe<Scalars['String']>;
  pageNumbers?: Maybe<Array<Scalars['Float']>>;
  recordingDate?: Maybe<Scalars['String']>;
  recordingInfo?: Maybe<Scalars['String']>;
  releaseRecordingInfo?: Maybe<Scalars['String']>;
};

export type LienSummaryV2 = {
  __typename?: 'LienSummaryV2';
  openLiens?: Maybe<Scalars['Float']>;
  openMortgages?: Maybe<Scalars['Float']>;
  satisfiedCount?: Maybe<Scalars['Float']>;
  totalLienAmount?: Maybe<Scalars['String']>;
};

export type LineDetail = {
  __typename?: 'LineDetail';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isLocked?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lineNumber?: Maybe<Scalars['String']>;
  oAmount?: Maybe<Scalars['Float']>;
  oDescription?: Maybe<Scalars['String']>;
  oLineNumber?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  refMetadata?: Maybe<RefMetaData>;
  transactionId?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type LineTypeMapping = {
  __typename?: 'LineTypeMapping';
  alta?: Maybe<StatementSections>;
  cd?: Maybe<StatementSections>;
  hud1986?: Maybe<StatementSections>;
  hud2010?: Maybe<StatementSections>;
  lineType: Scalars['String'];
};

export type ListEpnAccountsResponse = {
  __typename?: 'ListEpnAccountsResponse';
  accounts: Array<EpnAccount>;
};

export type LoanBalloonPaymentQuestion = {
  __typename?: 'LoanBalloonPaymentQuestion';
  paymentAmount?: Maybe<Scalars['Float']>;
  paymentDueDate?: Maybe<Scalars['String']>;
  paymentDueIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type LoanBalloonPaymentQuestionInput = {
  paymentAmount?: InputMaybe<Scalars['Float']>;
  paymentDueDate?: InputMaybe<Scalars['String']>;
  paymentDueIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
};

export type LoanCalculationsDisclosures = {
  __typename?: 'LoanCalculationsDisclosures';
  amountFinanced?: Maybe<Scalars['Float']>;
  annualPercentageRate?: Maybe<Scalars['Float']>;
  contacts?: Maybe<Array<Maybe<LoanCalculationsDisclosuresContact>>>;
  financeCharge?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  liabilityAfterForeclosure?: Maybe<Scalars['String']>;
  receiptConfirmed?: Maybe<Scalars['Boolean']>;
  totalInterestPercentage?: Maybe<Scalars['Float']>;
  totalOfPayments?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type LoanCalculationsDisclosuresContact = {
  __typename?: 'LoanCalculationsDisclosuresContact';
  address1?: Maybe<Scalars['String']>;
  cityStatePostalCode?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  contactEmailAddress?: Maybe<Scalars['String']>;
  contactLicenseNumber?: Maybe<Scalars['String']>;
  contactName?: Maybe<Scalars['String']>;
  contactNmlsId?: Maybe<Scalars['String']>;
  contactPhoneNumber?: Maybe<Scalars['String']>;
  contactType?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  licenseNumber?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
};

export type LoanCalculationsDisclosuresContactInput = {
  address1?: InputMaybe<Scalars['String']>;
  cityStatePostalCode?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  contactEmailAddress?: InputMaybe<Scalars['String']>;
  contactLicenseNumber?: InputMaybe<Scalars['String']>;
  contactName?: InputMaybe<Scalars['String']>;
  contactNmlsId?: InputMaybe<Scalars['String']>;
  contactPhoneNumber?: InputMaybe<Scalars['String']>;
  contactType?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  licenseNumber?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
};

export type LoanCalculationsDisclosuresInput = {
  amountFinanced?: InputMaybe<Scalars['Float']>;
  annualPercentageRate?: InputMaybe<Scalars['Float']>;
  contacts?: InputMaybe<Array<InputMaybe<LoanCalculationsDisclosuresContactInput>>>;
  financeCharge?: InputMaybe<Scalars['Float']>;
  liabilityAfterForeclosure?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  receiptConfirmed?: InputMaybe<Scalars['Boolean']>;
  totalInterestPercentage?: InputMaybe<Scalars['Float']>;
  totalOfPayments?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type LoanDisclosures = {
  __typename?: 'LoanDisclosures';
  adjustableInterestRateTable?: Maybe<AdjustableInterestRateTable>;
  adjustablePaymentsTable?: Maybe<AdjustablePaymentsTable>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  escrowAccount?: Maybe<Scalars['String']>;
  escrowWaiverFee?: Maybe<Scalars['Float']>;
  escrowWaiverFeeDescription?: Maybe<Scalars['String']>;
  escrowedCostsFirstYear?: Maybe<Scalars['Float']>;
  escrowedCostsFirstYearOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  escrowedCostsListing?: Maybe<Scalars['String']>;
  escrowedCostsListingOverrideMetadata?: Maybe<OverrideMetadataString>;
  estimatedCostsOverFirstYear?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  initialEscrowPayment?: Maybe<Scalars['Float']>;
  initialEscrowPaymentOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  latePaymentDays?: Maybe<Scalars['Int']>;
  latePaymentFeeDescription?: Maybe<Scalars['String']>;
  loanAssumptionPermitted?: Maybe<Scalars['String']>;
  loanHasDemandFeature?: Maybe<Scalars['String']>;
  monthlyEscrowAmount?: Maybe<Scalars['Float']>;
  monthlyEscrowAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  negativeAmortization?: Maybe<Scalars['String']>;
  nonEscrowedCostFirstYear?: Maybe<Scalars['Float']>;
  nonEscrowedCostsListing?: Maybe<Scalars['String']>;
  nonEscrowedCostsListingOverrideMetadata?: Maybe<OverrideMetadataString>;
  orderId?: Maybe<Scalars['ID']>;
  partialPayments?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type LoanDiscountFeeAdditionalData = {
  __typename?: 'LoanDiscountFeeAdditionalData';
  originationAdjustmentPercentage?: Maybe<Scalars['Float']>;
};

export type LoanOriginationFeeAdditionalData = {
  __typename?: 'LoanOriginationFeeAdditionalData';
  originationPercentage?: Maybe<Scalars['Float']>;
};

export type LoanPrepaymentPenaltyQuestion = {
  __typename?: 'LoanPrepaymentPenaltyQuestion';
  penaltyAsHighAsAmount?: Maybe<Scalars['Float']>;
  penaltyDuringFirstIncrement?: Maybe<Scalars['Float']>;
  response?: Maybe<Scalars['Boolean']>;
};

export type LoanPrepaymentPenaltyQuestionInput = {
  penaltyAsHighAsAmount?: InputMaybe<Scalars['Float']>;
  penaltyDuringFirstIncrement?: InputMaybe<Scalars['Float']>;
  response?: InputMaybe<Scalars['Boolean']>;
};

export type LoginInfoItem = {
  __typename?: 'LoginInfoItem';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  dateInvited: Scalars['String'];
  forceLogout: Scalars['Boolean'];
  lastActivityDate: Scalars['String'];
  lastLoginDate: Scalars['String'];
  passwordChangedDate: Scalars['String'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  userStatus: Scalars['String'];
};

export type MasterOrder = {
  __typename?: 'MasterOrder';
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  orderNumber: Scalars['String'];
  propertyState?: Maybe<Scalars['String']>;
  statementType?: Maybe<Scalars['String']>;
  transactionType: TransactionType;
  underwriter?: Maybe<Underwriter>;
  underwriterId?: Maybe<Scalars['String']>;
};

export type MasterOrderResponseObject = {
  __typename?: 'MasterOrderResponseObject';
  masterOrders: Array<MasterOrder>;
};

export type MdLandInstrumentSheet = {
  __typename?: 'MdLandInstrumentSheet';
  block?: Maybe<Scalars['String']>;
  buyerAddress?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  containsMortgage?: Maybe<Scalars['Boolean']>;
  containsPurchase?: Maybe<Scalars['Boolean']>;
  countyTransferTax?: Maybe<Scalars['Float']>;
  existingMortgageBalance?: Maybe<Scalars['Float']>;
  instrumentSubmittedByAddress?: Maybe<Scalars['String']>;
  instrumentSubmittedByFirm?: Maybe<Scalars['String']>;
  instrumentSubmittedByName?: Maybe<Scalars['String']>;
  instrumentSubmittedByPhone?: Maybe<Scalars['String']>;
  interestInLand?: Maybe<Scalars['String']>;
  lenderName?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  lot?: Maybe<Scalars['String']>;
  mapNumber?: Maybe<Scalars['String']>;
  notContainsCash?: Maybe<Scalars['Boolean']>;
  plat?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyDistrict?: Maybe<Scalars['String']>;
  propertyParcelNumber?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  recordingChargeOne?: Maybe<Scalars['Float']>;
  recordingChargeTwo?: Maybe<Scalars['Float']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellerNames?: Maybe<Scalars['String']>;
  stateRecordationTax?: Maybe<Scalars['Float']>;
  stateTransferTax?: Maybe<Scalars['Float']>;
  subDivision?: Maybe<Scalars['String']>;
  surchargeOne?: Maybe<Scalars['Float']>;
  surchargeTwo?: Maybe<Scalars['Float']>;
};

export type MdMw506aeForm = {
  __typename?: 'MdMw506aeForm';
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  propertyCounty?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MdMw506aeFormSellers>>>;
  settlementAgentAddress?: Maybe<MdMw506aeFormAddress>;
  settlementAgentEmailAddress?: Maybe<Scalars['String']>;
  settlementAgentFaxNumber?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MdMw506aeFormAddress = {
  __typename?: 'MdMw506aeFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MdMw506aeFormSellers = {
  __typename?: 'MdMw506aeFormSellers';
  address?: Maybe<MdMw506aeFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  sellerType?: Maybe<Scalars['String']>;
  spouse?: Maybe<MdMw506aeFormSpouse>;
  taxIDNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type MdMw506aeFormSpouse = {
  __typename?: 'MdMw506aeFormSpouse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  taxIDNumber?: Maybe<Scalars['String']>;
};

export type MdMw506nrsForm = {
  __typename?: 'MdMw506nrsForm';
  closingCostsAmount?: Maybe<Scalars['Float']>;
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  netSalesPrice?: Maybe<Scalars['Float']>;
  payoffsAmount?: Maybe<Scalars['Float']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MdMw506nrsFormSellers>>>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  totalWithholdingBasis?: Maybe<Scalars['Float']>;
};

export type MdMw506nrsFormSellers = {
  __typename?: 'MdMw506nrsFormSellers';
  address?: Maybe<Scalars['String']>;
  addressCityStateZip?: Maybe<Scalars['String']>;
  allFullNames?: Maybe<Scalars['String']>;
  dueAmount?: Maybe<Scalars['Float']>;
  entityName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['String']>;
  sellerType?: Maybe<Scalars['String']>;
  spouseTaxIDNumber?: Maybe<Scalars['String']>;
  taxIDNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
  withholdingBasis?: Maybe<Scalars['Float']>;
};

export type MdMw506rForm = {
  __typename?: 'MdMw506rForm';
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  propertyCounty?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<MdMw506rFormSellers>>>;
  settlementAgentAddress?: Maybe<Scalars['String']>;
  settlementAgentEmailAddress?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MdMw506rFormAddress = {
  __typename?: 'MdMw506rFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MdMw506rFormSellers = {
  __typename?: 'MdMw506rFormSellers';
  address?: Maybe<MdMw506rFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  sellerType?: Maybe<Scalars['String']>;
  spouse?: Maybe<MdMw506rFormSpouse>;
  taxIDNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type MdMw506rFormSpouse = {
  __typename?: 'MdMw506rFormSpouse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  taxIDNumber?: Maybe<Scalars['String']>;
};

export type MeRettdTaxForm = {
  __typename?: 'MeRettdTaxForm';
  acreage?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buyer?: Maybe<MeRettdTaxFormBuyerSeller>;
  county?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  map?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  physicalLocation?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  seller?: Maybe<MeRettdTaxFormBuyerSeller>;
  settlementAgent?: Maybe<MeRettdTaxFormSettlementAgent>;
  settlementDate?: Maybe<Scalars['String']>;
  staffName?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormAddress = {
  __typename?: 'MeRettdTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormBuyerSeller = {
  __typename?: 'MeRettdTaxFormBuyerSeller';
  address?: Maybe<MeRettdTaxFormAddress>;
  name?: Maybe<Scalars['String']>;
  spouse?: Maybe<MeRettdTaxFormSpouse>;
  taxId?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormSettlementAgent = {
  __typename?: 'MeRettdTaxFormSettlementAgent';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  faxNumber?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type MeRettdTaxFormSpouse = {
  __typename?: 'MeRettdTaxFormSpouse';
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type MeRew5ExemptionReductionForm = {
  __typename?: 'MeRew5ExemptionReductionForm';
  buyerAllNames?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MeRew5ExemptionReductionFormSeller>>>;
  sellersAllNames?: Maybe<Scalars['String']>;
  settlementAgent?: Maybe<MeRew5ExemptionReductionFormSettlementAgent>;
  settlementDate?: Maybe<Scalars['String']>;
  staff?: Maybe<MeRew5ExemptionReductionFormStaff>;
};

export type MeRew5ExemptionReductionFormAddress = {
  __typename?: 'MeRew5ExemptionReductionFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRew5ExemptionReductionFormSeller = {
  __typename?: 'MeRew5ExemptionReductionFormSeller';
  address?: Maybe<MeRew5ExemptionReductionFormAddress>;
  applicantName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  printFullName?: Maybe<Scalars['String']>;
  spouse?: Maybe<MeRew5ExemptionReductionFormSpouse>;
  taxId?: Maybe<Scalars['String']>;
};

export type MeRew5ExemptionReductionFormSettlementAgent = {
  __typename?: 'MeRew5ExemptionReductionFormSettlementAgent';
  address?: Maybe<MeRew5ExemptionReductionFormAddress>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type MeRew5ExemptionReductionFormSpouse = {
  __typename?: 'MeRew5ExemptionReductionFormSpouse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  printFullName?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type MeRew5ExemptionReductionFormStaff = {
  __typename?: 'MeRew5ExemptionReductionFormStaff';
  emailAddress?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivForm = {
  __typename?: 'MeRew1040SellersIndivForm';
  buyer?: Maybe<MeRew1040SellersIndivFormBuyer>;
  municipality?: Maybe<Scalars['String']>;
  propertyStreet?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MeRew1040SellersIndivFormSeller>>>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivFormAddress = {
  __typename?: 'MeRew1040SellersIndivFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivFormBuyer = {
  __typename?: 'MeRew1040SellersIndivFormBuyer';
  address?: Maybe<MeRew1040SellersIndivFormAddress>;
  fullName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1040SellersIndivFormSeller = {
  __typename?: 'MeRew1040SellersIndivFormSeller';
  address?: Maybe<MeRew1040SellersIndivFormAddress>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  spouse?: Maybe<MeRew1040SellersIndivFormSpouse>;
  taxIdNumber?: Maybe<Scalars['String']>;
  withheldAmount?: Maybe<Scalars['Float']>;
};

export type MeRew1040SellersIndivFormSpouse = {
  __typename?: 'MeRew1040SellersIndivFormSpouse';
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateForm = {
  __typename?: 'MeRew1041SellersEstateForm';
  buyer?: Maybe<MeRew1041SellersEstateFormBuyer>;
  municipality?: Maybe<Scalars['String']>;
  propertyStreet?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MeRew1041SellersEstateFormSeller>>>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateFormAddress = {
  __typename?: 'MeRew1041SellersEstateFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateFormBuyer = {
  __typename?: 'MeRew1041SellersEstateFormBuyer';
  address?: Maybe<MeRew1041SellersEstateFormAddress>;
  fullName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1041SellersEstateFormSeller = {
  __typename?: 'MeRew1041SellersEstateFormSeller';
  address?: Maybe<MeRew1041SellersEstateFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  repName?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
  withheldAmount?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersForm = {
  __typename?: 'MeRew1120CorporateSellersForm';
  buyer?: Maybe<MeRew1120CorporateSellersFormBuyer>;
  municipality?: Maybe<Scalars['String']>;
  propertyStreet?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<MeRew1120CorporateSellersFormSeller>>>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersFormAddress = {
  __typename?: 'MeRew1120CorporateSellersFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersFormBuyer = {
  __typename?: 'MeRew1120CorporateSellersFormBuyer';
  address?: Maybe<MeRew1120CorporateSellersFormAddress>;
  fullName?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type MeRew1120CorporateSellersFormSeller = {
  __typename?: 'MeRew1120CorporateSellersFormSeller';
  address?: Maybe<MeRew1120CorporateSellersFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  withheldAmount?: Maybe<Scalars['Float']>;
};

export type MergeData = {
  __typename?: 'MergeData';
  al_nr_af2_sellerGainForm?: Maybe<AlNrAf2SellerGainForm>;
  al_wnr_withholding_SalesForm?: Maybe<AlWnrWithholdingSalesForm>;
  altaStatement?: Maybe<AltaStatement>;
  buyerAltaStatement?: Maybe<AltaStatement>;
  buyerCdStatement?: Maybe<CdStatement>;
  buyerHud1986Statement?: Maybe<Hud1986Statement>;
  buyerHud2010Statement?: Maybe<Hud2010Statement>;
  cashAltaStatement?: Maybe<AltaStatement>;
  cdStatement?: Maybe<CdStatement>;
  checkDetails?: Maybe<CheckPrintingData>;
  ct_op236_realEstateTaxForm?: Maybe<CtOp236RealEstateTaxForm>;
  dcFp7cTaxForm?: Maybe<DcFp7cTaxForm>;
  disbursementSummaryDetails?: Maybe<DisbursementSummaryDetails>;
  disbursementSummaryForm?: Maybe<DisbursementSummaryForm>;
  fl_ucc1Form?: Maybe<FlUcc1Form>;
  florida_premium_disclosureForm?: Maybe<FloridaPremiumDisclosureForm>;
  hud1986Statement?: Maybe<Hud1986Statement>;
  hud2010Statement?: Maybe<Hud2010Statement>;
  id: Scalars['ID'];
  latisso107_premiumDisclosureForm?: Maybe<Latisso107PremiumDisclosureForm>;
  mdLandInstrumentSheet?: Maybe<MdLandInstrumentSheet>;
  md_mw506aeForm?: Maybe<MdMw506aeForm>;
  md_mw506nrsForm?: Maybe<MdMw506nrsForm>;
  md_mw506rForm?: Maybe<MdMw506rForm>;
  me_rettd_taxForm?: Maybe<MeRettdTaxForm>;
  me_rew5_exemptionReductionForm?: Maybe<MeRew5ExemptionReductionForm>;
  me_rew1040_sellersIndivForm?: Maybe<MeRew1040SellersIndivForm>;
  me_rew1041_sellersEstateForm?: Maybe<MeRew1041SellersEstateForm>;
  me_rew1120_corporateSellersForm?: Maybe<MeRew1120CorporateSellersForm>;
  mi_purchase_mineralsForm?: Maybe<MiPurchaseMineralsForm>;
  mi_realEstate_transferTaxValuationAffidavit?: Maybe<MiRealEstateTransferTaxValuationAffidavit>;
  nhInventoryPropertyTaxForm?: Maybe<NhInventoryPropertyTaxForm>;
  nhRealEstatePurchaserTaxForm?: Maybe<NhRealEstatePurchaserTaxForm>;
  nhRealEstateSellerTaxForm?: Maybe<NhRealEstateSellerTaxForm>;
  noSellerCdStatement?: Maybe<CdStatement>;
  noSellerHud1986Statement?: Maybe<Hud1986Statement>;
  noSellerHud2010Statement?: Maybe<Hud2010Statement>;
  oh_conveyanceFee_dteForm?: Maybe<OhConveyanceFeeDteForm>;
  order?: Maybe<Order>;
  pa_philadelphia_entityTaxForm?: Maybe<PaPhiladelphiaEntityTaxForm>;
  pa_philadelphia_transferTaxForm?: Maybe<PaPhiladelphiaTransferTaxForm>;
  pa_rev183_transferTaxForm?: Maybe<PaRev183TransferTaxForm>;
  payoffs?: Maybe<Array<Maybe<Payoff>>>;
  prorations?: Maybe<Array<Maybe<ProrationCharge>>>;
  recordingFeeTransferTax?: Maybe<RecordingFeeTransferTaxCalc>;
  sc_affidavit_taxForm?: Maybe<ScAffidavitTaxForm>;
  sellerAltaStatement?: Maybe<AltaStatement>;
  sellerCdStatement?: Maybe<CdStatement>;
  sellerHud1986Statement?: Maybe<Hud1986Statement>;
  sellerHud2010Statement?: Maybe<Hud2010Statement>;
  system?: Maybe<System>;
  ten99Form?: Maybe<Ten99Form>;
  title?: Maybe<TitleFields>;
  titleCpls?: Maybe<Array<Maybe<TitleCpl>>>;
  titleExceptions?: Maybe<TitleExceptions>;
  titleFees?: Maybe<TitleFees>;
  titleGeneral?: Maybe<TitleGeneral>;
  titlePremiums?: Maybe<TitlePremiums>;
  titleRequirements?: Maybe<TitleRequirements>;
  titleRestrictiveCovenants?: Maybe<RestrictiveCovenant>;
  txDisclosureT64Form?: Maybe<TxDisclosureT64Form>;
  txStatementBuyer?: Maybe<TxStatementBuyer>;
  txStatementCombined?: Maybe<TxStatementCombined>;
  txStatementSeller?: Maybe<TxStatementBuyer>;
  va2012R5PForm?: Maybe<Va2012R5PForm>;
};


export type MergeDataCheckDetailsArgs = {
  transactionId: Scalars['ID'];
};

export type MergeDataFundingEscrowAccount = {
  __typename?: 'MergeDataFundingEscrowAccount';
  accountNumber?: Maybe<Scalars['String']>;
  accountNumberAlternate?: Maybe<Scalars['String']>;
  addresses?: Maybe<Array<Address>>;
  bankName?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<EmailAddressSchema>>;
  escrowAccountName?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<PhoneNumberType>>;
  routingNumber?: Maybe<Scalars['String']>;
  routingNumberDeposit?: Maybe<Scalars['String']>;
  routingNumberFractional?: Maybe<Scalars['String']>;
  routingNumberWire?: Maybe<Scalars['String']>;
};

export type MergeDataFundingTransaction = {
  __typename?: 'MergeDataFundingTransaction';
  amount?: Maybe<Scalars['Float']>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  lineDetails?: Maybe<Array<Maybe<MergeDataFundingTransactionLineDetails>>>;
  memo?: Maybe<Scalars['String']>;
  oWireTransfer?: Maybe<MergeDataFundingTransactionWireTransfer>;
  payorPayee?: Maybe<MergeDataFundingTransactionPayorPayee>;
  payorPayeeDisplayName?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
};

export type MergeDataFundingTransactionLineDetails = {
  __typename?: 'MergeDataFundingTransactionLineDetails';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  lineNumber?: Maybe<Scalars['String']>;
};

export type MergeDataFundingTransactionPayorPayee = {
  __typename?: 'MergeDataFundingTransactionPayorPayee';
  addresses?: Maybe<Array<Address>>;
  displayName?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<EmailAddressSchema>>;
  id?: Maybe<Scalars['ID']>;
  phoneNumbers?: Maybe<Array<PhoneNumberType>>;
  roleId?: Maybe<Scalars['String']>;
};

export type MergeDataFundingTransactionReceivingBank = {
  __typename?: 'MergeDataFundingTransactionReceivingBank';
  address?: Maybe<Address>;
  bankIdNumber?: Maybe<Scalars['String']>;
  bankIdType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  obiLines?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type MergeDataFundingTransactionWireTransfer = {
  __typename?: 'MergeDataFundingTransactionWireTransfer';
  receivingBank?: Maybe<MergeDataFundingTransactionReceivingBank>;
  recipientAccountNum?: Maybe<Scalars['String']>;
  recipientAddress?: Maybe<Address>;
  recipientName?: Maybe<Scalars['String']>;
  unmaskedRecipientAccountNum?: Maybe<Scalars['String']>;
};

export type MergeDataOrderFunding = {
  __typename?: 'MergeDataOrderFunding';
  balances?: Maybe<BalanceGridDisbursementSummaryForm>;
  escrowAccount?: Maybe<MergeDataFundingEscrowAccount>;
  transactions?: Maybe<Array<Maybe<MergeDataFundingTransaction>>>;
};

export type MergeDataRecordingDocument = {
  __typename?: 'MergeDataRecordingDocument';
  actualFees?: Maybe<Scalars['Float']>;
  book?: Maybe<Scalars['String']>;
  collectedFees?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  documentDate?: Maybe<Scalars['String']>;
  documentTime?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  instrumentNumber?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
  pageCount?: Maybe<Scalars['String']>;
  recordedDate?: Maybe<Scalars['String']>;
  recordedTime?: Maybe<Scalars['String']>;
  rfttDocumentType?: Maybe<Scalars['String']>;
};

export type MergeFieldDataV2 = {
  __typename?: 'MergeFieldDataV2';
  category?: Maybe<Scalars['String']>;
  dataType: Scalars['String'];
  defaultFormat: Scalars['String'];
  domain: Scalars['String'];
  label: Scalars['String'];
  mergeFieldId: Scalars['ID'];
  mergeKey: Scalars['String'];
};

export type MiPurchaseMineralsForm = {
  __typename?: 'MiPurchaseMineralsForm';
  buyer?: Maybe<MiPurchaseMineralsFormBuyer>;
  buyersAllNames?: Maybe<Scalars['String']>;
  property?: Maybe<MiPurchaseMineralsFormProperty>;
};

export type MiPurchaseMineralsFormBuyer = {
  __typename?: 'MiPurchaseMineralsFormBuyer';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type MiPurchaseMineralsFormProperty = {
  __typename?: 'MiPurchaseMineralsFormProperty';
  briefLegalDescription?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  fullLegalDescription?: Maybe<Scalars['String']>;
  range?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  township?: Maybe<Scalars['String']>;
};

export type MiRealEstateTransferTaxValuationAffidavit = {
  __typename?: 'MiRealEstateTransferTaxValuationAffidavit';
  amountSale?: Maybe<Scalars['Float']>;
  buyerAddress?: Maybe<Scalars['String']>;
  buyerCity?: Maybe<Scalars['String']>;
  buyerState?: Maybe<Scalars['String']>;
  buyerZip?: Maybe<Scalars['String']>;
  buyersAllNames?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  legalDescription?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  sellerAddress?: Maybe<Scalars['String']>;
  sellerCity?: Maybe<Scalars['String']>;
  sellerState?: Maybe<Scalars['String']>;
  sellerZip?: Maybe<Scalars['String']>;
  sellersAllNames?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  totalRevenue?: Maybe<Scalars['Float']>;
};

export type Milestone = {
  __typename?: 'Milestone';
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  tasks?: Maybe<Array<Maybe<Task>>>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  workflowId: Scalars['ID'];
};

export type MissingDocumentItemV2 = {
  __typename?: 'MissingDocumentItemV2';
  documentType: Scalars['String'];
  reason?: Maybe<Scalars['String']>;
  severity?: Maybe<MissingDocumentItemV2Severity>;
};

export enum MissingDocumentItemV2Severity {
  Critical = 'critical',
  Info = 'info',
  Warning = 'warning'
}

export type MortgageInsurancePremiumEscrowFeeAdditionalData = {
  __typename?: 'MortgageInsurancePremiumEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  amountPerMonthOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type MortgageInsurancePremiumFeeAdditionalData = {
  __typename?: 'MortgageInsurancePremiumFeeAdditionalData';
  monthlyMIP?: Maybe<Scalars['Float']>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type MortgageRecital = {
  __typename?: 'MortgageRecital';
  applyToPolicy?: Maybe<Scalars['String']>;
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  mergeFields?: Maybe<Scalars['String']>;
  recitalType?: Maybe<SecurityInstrumentRecitalType>;
  requirementMergeable?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type MortgageRecitalRequirementMergeableArgs = {
  showSyntax?: InputMaybe<Scalars['Boolean']>;
};

export type MoveAdminTaskInput = {
  destinationMilestoneId?: InputMaybe<Scalars['String']>;
  destinationSortOrder?: InputMaybe<Scalars['Int']>;
};

export type MoveOrderTaskInput = {
  destinationMilestoneId?: InputMaybe<Scalars['String']>;
  destinationSortOrder?: InputMaybe<Scalars['Int']>;
};

/**
 * KY Municipal Tax information for a premium
 * Provides comprehensive tax data including code, rate, and metadata
 * ANP-3103, ANP-1261, ANP-1282
 */
export type MunicipalTaxInfo = {
  __typename?: 'MunicipalTaxInfo';
  /** Date the tax rate is effective from */
  effectiveFrom?: Maybe<Scalars['String']>;
  /** Whether KY municipal tax is applicable (true for KY properties) */
  isApplicable: Scalars['Boolean'];
  /** Municipality name */
  municipalityName?: Maybe<Scalars['String']>;
  /** Rate level (City, County, etc.) */
  rateLevel?: Maybe<Scalars['String']>;
  /** Tax code for the property address */
  taxCode?: Maybe<Scalars['String']>;
  /** Tax rate as decimal (e.g., 0.09 for 9%) */
  taxRate?: Maybe<Scalars['Float']>;
  /** Tax rate as percentage (e.g., 9.0 for 9%) */
  taxRatePercent?: Maybe<Scalars['Float']>;
  /** TriTech match code from address lookup */
  triTechMatchCode?: Maybe<Scalars['String']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _empty?: Maybe<Scalars['String']>;
  addBuyer?: Maybe<OrderPayload>;
  addCarrierAccount: CarrierAccountObject;
  addConsolidatedPayees?: Maybe<Array<Maybe<ConsolidatedPayee>>>;
  addNote: Note;
  /** @deprecated Use createOrderParty instead */
  addPartyToOrder?: Maybe<AddPartyToOrderResult>;
  addSeller?: Maybe<OrderPayload>;
  addSequence?: Maybe<Sequence>;
  addUserRecentOrder: AddUserRecentOrderPayload;
  analyzeDocumentV2: AnalyzeDocumentResponseV2;
  analyzeOrderAssistDocuments: AnalyzeOrderAssistDocumentsPayload;
  analyzeSearchPackage: AnalyzeSearchPackageResponse;
  approveWireValidationEula?: Maybe<WireValidationEula>;
  authenticateFaTrustCredentials: FaTrustCredentialAuthResult;
  authorizeCarrierAccount: CarrierAccountAuthorizationResult;
  calculateCplRates: CalculateCplRateResponse;
  calculatePremiumRate: PremiumRateCalculationResponse;
  cancelTitleSearchOrder: TitleSearchOrder;
  cancelTitleSearchOrderUpdate: TitleSearchOrder;
  changeOrderWorkflow: Workflow;
  clearDcAdjustment: AdjustmentResponseWithMirror;
  clearFee?: Maybe<Fee>;
  clearTransactions?: Maybe<ClearTransactionsResponse>;
  cloneAdminTask: AdminTask;
  cloneAdminWorkflow: AdminWorkflow;
  cloneOrder?: Maybe<OrderPayload>;
  cloneOrderAsynchronous?: Maybe<OrderCloneResponse>;
  combineDocumentsAsyncV2: GenerateAsyncResponseV2;
  combineEntityDocumentsAsyncV2: EntityGenerateAsyncResponseV2;
  companyPortalAssign: SuccessResponse;
  companyPortalUnassign: SuccessResponse;
  contactValidation: ContactValidationResponse;
  convertEntityDocumentScopeV2: ConvertEntityDocumentScopeResponseV2;
  convertPendingOrderDocumentsV2: ConvertEntityDocumentScopeResponseV2;
  convertTemplateToEntityDocumentV2: CreateEntityDocumentFromTemplateResultV2;
  createAdminMilestone: CreateAdminMilestoneResponse;
  createAdminTask: AdminTask;
  createAdminWorkflow: CreateAdminWorkflowResponse;
  createAndBuy: ShipmentObject;
  createChangePasswordUserEvent: LoginInfoItem;
  createClausePackage: ClausePackage;
  createClauseTemplate: ClauseTemplate;
  createDcAdjustment: AdjustmentResponseWithMirror;
  createDepartment: Department;
  createDirectoryCompany?: Maybe<Company>;
  createDirectoryContact?: Maybe<Contact>;
  createDraftPackage: Package;
  createEntityDocumentV2: EntityDocumentV2;
  createEpnAccount: EpnAccount;
  createEscrowAccount?: Maybe<EscrowAccount>;
  createExceptions?: Maybe<Array<Maybe<TitleException>>>;
  createFeatureAcknowledgment: FeatureAcknowledgment;
  createFee?: Maybe<Fee>;
  createFromMasterOrder?: Maybe<CreateOrderFromMasterPayload>;
  createFund?: Maybe<Fund>;
  createJacket: Jacket;
  createOrder?: Maybe<CreateOrderPayload>;
  createOrderFromMasterV2?: Maybe<CreateOrderFromMasterV2Payload>;
  createOrderMilestone: Milestone;
  createOrderParty?: Maybe<OrderParty>;
  createOrderTask: Task;
  createOrderV2?: Maybe<CreateOrderV2Payload>;
  createOrderWorkflowFromAdminWorkflow: Workflow;
  createPackageTemplate: CreatePackageTemplateResponse;
  createPayoff: Payoff;
  createPositivePaySubmission?: Maybe<PositivePayFile>;
  createPropertyTaxAndProrationConfiguration: PropertyTaxProrationConfiguration;
  createProration: Proration;
  createProrationCharge: ProrationCharge;
  createReconciliation?: Maybe<Reconciliation>;
  createRecordingDocument: RecordingDocument;
  createReport: ReportEntry;
  createReportExport: ReportDownload;
  createRequirements?: Maybe<Array<Maybe<Requirement>>>;
  createSecurityGroup?: Maybe<SecurityGroup>;
  createStateWithholding?: Maybe<StateWithholding>;
  createTagV2: TagV2;
  createTemplateSetV2: TemplateSetV2;
  createTemplateV2: TemplateDocV2;
  createTenant?: Maybe<Tenant>;
  createTenantChild?: Maybe<TenantChildNode>;
  createTenantUnderwriter: CreateTenantUnderwriterResponse;
  createTitleSearchOrder: TitleSearchOrder;
  createTransaction?: Maybe<Transaction>;
  createTransactionLineDetail?: Maybe<LineDetail>;
  createUser: User;
  deactivateAgentNet: AdminCredentialAgentNetStatus;
  deleteAdminMilestone: DeleteAdminMilestoneResponse;
  deleteAdminTask: DeleteAdminTaskResponse;
  deleteAdminWorkflow: AdminWorkflow;
  deleteBuyer: Array<Buyer>;
  deleteBuyerRep?: Maybe<DeleteBuyerRepResponse>;
  deleteBuyerV2: DeleteBuyerResponse;
  deleteCarrierAccount: DeleteCarrierAccountResponse;
  deleteClausePackage: ClausePackage;
  deleteClauseTemplate: ClauseTemplate;
  deleteDcAdjustment: AdjustmentResponseWithMirror;
  deleteDepartment: DeleteDepartmentResponse;
  deleteDocTypeMappingByCountyName: DocTypeMappingByCountyName;
  deleteEntityDocumentV2: EntityDocumentV2;
  deleteEpnAccount: EpnAccount;
  deleteEscrowAccount?: Maybe<EscrowAccount>;
  deleteException?: Maybe<Scalars['Boolean']>;
  deleteFee?: Maybe<Fee>;
  deleteFidelityAdminAgentMapping: FidelityAgentMappingResponse;
  deleteFund?: Maybe<Scalars['String']>;
  deleteNote: Note;
  deleteOrderMilestone: Milestone;
  deleteOrderParty: DeleteOrderPartyResponse;
  deleteOrderTask: DeleteTaskResponse;
  deletePackage: Package;
  deletePayoff: Payoff;
  deletePropertyTaxAndProrationConfiguration: PropertyTaxProrationConfiguration;
  deleteProration: Proration;
  deleteProrationCharge: ProrationCharge;
  deleteReconciliation?: Maybe<Scalars['Boolean']>;
  deleteRecordingDocument: RecordingDocument;
  deleteRecordingFeeTransferTaxCalc: RecordingFeeTransferTaxCalc;
  deleteReport: ReportEntry;
  deleteRequirement?: Maybe<Scalars['Boolean']>;
  deleteSecurityGroup: SecurityGroup;
  deleteSeller: DeleteSellerResponse;
  deleteSellerRep?: Maybe<DeleteSellerRepResponse>;
  deleteSequence?: Maybe<Sequence>;
  deleteStateWithholding?: Maybe<StateWithholding>;
  deleteTagsV2: DeleteTagsResponseV2;
  deleteTemplateSetV2: TemplateSetV2;
  deleteTemplateV2: TemplateDocV2;
  deleteTransaction?: Maybe<Transaction>;
  deleteTransactionLineDetail?: Maybe<LineDetail>;
  deleteUserLocks: User;
  deleteWireValidationEula?: Maybe<WireValidationEula>;
  disableFraudtoolsIntegration: DisableFraudtoolsIntegrationResponse;
  documentSaveAsAsyncV2: GenerateAsyncResponseV2;
  downloadDocumentsAsyncV2: GenerateAsyncResponseV2;
  downloadEntityDocumentV2: FileResourceDownloadV2;
  downloadEntityDocumentsAsyncV2: EntityGenerateAsyncResponseV2;
  downloadTemplateV2: FileResourceDownloadV2;
  duplicateTemplateV2: TemplateDocV2;
  emailSignatureSave: EmailSignature;
  enableFraudtoolsIntegration: EnableFraudtoolsIntegrationResponse;
  enableIntegration: IntegrationObject;
  entityDocumentSaveAsAsyncV2: EntityGenerateAsyncResponseV2;
  entityPrintChecksV2: EntityPrintChecksResponseV2;
  exportQuickBooksIIF: QuickBooksExportResult;
  finalizeReconciliation?: Maybe<Reconciliation>;
  getEligibleCountiesByApiKey: GetEligibleCountiesResponse;
  getMissingTemplateBlocksForImportV2: GetMissingTemplateBlocksForImportResponseV2;
  getPaginatedEntityDocumentsV2: PaginatedEntityDocumentsV2;
  getPaginatedRecordingDocuments: PaginatedRecordingDocuments;
  getSetsContainingTemplateV2: PaginatedTemplateSetsV2;
  handleOldRepublicUserAuthCallback: OldRepublicUserAuthCallbackResponse;
  identityVerification: IdentityVerificationResponse;
  importRepositoryAsyncV2: ImportRepositoryAsyncResponseV2;
  importRepositoryTemplateV2: ImportRepositoryTemplateResponseV2;
  initiateOldRepublicUserAuth: OldRepublicUserAuthResponse;
  initiateWire: OutgoingWire;
  inviteUser: LoginInfoItem;
  issueConsolidatedPayment?: Maybe<IssueConsolidatedPaymentResult>;
  joinTransactions?: Maybe<JoinTransactionsResponse>;
  legacyOrdersPost?: Maybe<Array<Maybe<LegacyOrderResponse>>>;
  matchIncomingWire: IncomingWire;
  moveAdminTask: AdminTask;
  moveOrderTask: Task;
  orderDocumentMarkViewed: OrderDocumentMarkViewedResponse;
  orderDocumentShare: OrderDocumentShareResponse;
  orderPartyInvite: SuccessResponse;
  orderPartyRemove: SuccessResponse;
  orderTitleCplProduct: TitleCpls;
  orderTitleCplProductV2: TitleCpls;
  overwriteEntityDocumentV2: FileResourceUploadUrlV2;
  overwriteTemplateV2: FileResourceUploadUrlV2;
  patchBuyerSpouse?: Maybe<OrderBuyerSellerSoRep>;
  patchBuyers?: Maybe<Array<Maybe<Buyer>>>;
  patchCalculatingCashToClose: CalculatingCashToClose;
  patchSellerSpouse?: Maybe<OrderBuyerSellerSoRep>;
  patchSellerSpouseV2: PatchSellerSpouseResponse;
  patchSellers?: Maybe<Array<Maybe<Seller>>>;
  pollPackageStatus: Package;
  portalAccountCreate: PortalAccount;
  portalAccountSetActive: PortalAccountSetActiveResponse;
  portalAccountUpdate: PortalAccount;
  postAutoClear?: Maybe<PostAutoClearResponse>;
  printChecks?: Maybe<PrintChecksResult>;
  printChecksFast?: Maybe<PrintChecksResult>;
  printChecksV2: PrintChecksResponseV2;
  printDocumentsAsyncV2: GenerateAsyncResponseV2;
  printEntityDocumentsAsyncV2: EntityGenerateAsyncResponseV2;
  printTestChecks?: Maybe<PrintChecksResultTest>;
  purchaseShippingRate: ShipmentObject;
  putAgentNetFinanceIntegration?: Maybe<AgentNetFinanceIntegrationResponse>;
  putEntityDocumentFromKnownTemplateV2: EntityDocumentV2;
  putIntegratedRecordingFeeTransferTax: RecordingFeeTransferTaxCalc;
  putOrderCommissions: OrderCommissionsV2;
  putOrderDeposits: OrderDeposits;
  putProjectedPayments: ProjectedPayments;
  putRecordingFeeTransferTax: RecordingFeeTransferTaxCalc;
  putTenantChildImage?: Maybe<TenantChildImage>;
  refreshCommissions?: Maybe<Array<Fee>>;
  refreshDepositsForAdjustments: GetAdjustmentsResponse;
  refreshDepositsForFees?: Maybe<Array<Fee>>;
  refreshPremiumsAndFees?: Maybe<Array<Fee>>;
  regeneratePositivePayFile?: Maybe<PositivePayFile>;
  rejectWire: OutgoingWire;
  removeConsolidatedPayee?: Maybe<ConsolidatedPayee>;
  /** @deprecated Use updateOrderParty instead */
  replacePartyCompanyAndContact?: Maybe<ReplacePartyCompanyAndContactResult>;
  reprintChecks?: Maybe<PrintChecksResult>;
  requestFedexMfaPin: RequestFedexMfaPinResponse;
  requestFedexMfaPinCreate: RequestFedexMfaPinCreateResponse;
  requestShippingRates: ShipmentObject;
  resetAgentNetUserCredentials: UserCredentialAgentNetStatus;
  resetContactValidation: ResetContactValidationResponse;
  resetOldRepublicUserAuth: Scalars['Boolean'];
  resetUserMultiFactorAuthentication: Scalars['Boolean'];
  retryAttachIdentityVerificationReport: RetryAttachIdentityVerificationReportResponse;
  retryRejectedPackage: Package;
  revertEntityDocumentToVersionV2: EntityDocumentV2;
  revertTemplateDocToVersionV2: TemplateDocV2;
  saveSnapshot: GetSnapshotResponse;
  securePortalConfigureIntegrationUpdate: SecurePortalIntegrationConfigUpdateResponse;
  sendContactForm: Scalars['Boolean'];
  sendEmail: SendEmailResponse;
  sendOrderEmail: SendEmailResponse;
  setAgentNetAdminCredentials: AdminCredentialAgentNetStatus;
  setAgentNetAdminOffices: AgentNetAdminSetOfficesResponse;
  setAgentNetUserCredentials: UserCredentialAgentNetStatus;
  setFidelityAdminAgentMapping: FidelityAgentMappingResponse;
  setFidelityAdminStatus: FidelityAdminConfiguration;
  setOldRepublicAdminAgentMapping: OldRepublicAgentMappingResponse;
  setOldRepublicAdminStatus: OldRepublicAdminConfiguration;
  setOrderRecordingJurisdiction: SetOrderRecordingJurisdictionResponse;
  setUserDepartments: Array<Department>;
  splitTransaction?: Maybe<SplitTransactionDetailsResponse>;
  startFedexMfa: StartFedexMfaResponse;
  startFedexMfaCreate: StartFedexMfaCreateResponse;
  submitInsightFeedbackV2: SubmitInsightFeedbackResponseV2;
  submitPackage: Package;
  submitPackageAsync: AsyncTaskResponse;
  switchRecordingFeeTransferTaxCalculator: RecordingFeeTransferTaxCalc;
  syncJacket: JacketSyncResponse;
  synchronizeGfeCharges: Array<GfeCharge>;
  toggleTen99: ToggleTen99Response;
  transferTransactionDetails?: Maybe<TransferTransactionDetailsResponse>;
  transmitWire: OutgoingWire;
  triggerTitleSearchImport: TriggerTitleSearchImportResponse;
  unmatchIncomingWire: IncomingWire;
  updateAdminMilestone: UpdateAdminMilestoneResponse;
  updateAdminTask: UpdateAdminTaskResponse;
  updateAdminWorkflow: UpdateAdminWorkflowResponse;
  updateCarrierAccount: CarrierAccountObject;
  updateClausePackage: ClausePackage;
  updateClauseTemplate: ClauseTemplate;
  updateClosingInformation: ClosingInformation;
  updateClosingQuestions: ClosingQuestions;
  updateDcAdjustment: AdjustmentResponseWithMirror;
  updateDepartment: Department;
  updateDirectoryCompany?: Maybe<Company>;
  updateDirectoryContact?: Maybe<Contact>;
  updateEntityDocumentTagsV2: Array<Maybe<EntityDocumentV2>>;
  updateEntityDocumentV2: EntityDocumentV2;
  updateEpnAccount: EpnAccount;
  updateEpnIntegrationStatus: EpnIntegrationStatus;
  updateEscrowAccount?: Maybe<EscrowAccount>;
  updateEstimatedTaxesInsuranceAssessments: EstimatedTaxesInsuranceAssessments;
  updateException: TitleException;
  updateExceptions?: Maybe<Array<Maybe<TitleException>>>;
  updateExceptionsHeader: TitleExceptions;
  updateFee?: Maybe<Fee>;
  updateFeeAllocations?: Maybe<FeeAllocations>;
  updateFund?: Maybe<Fund>;
  updateFundingForFees: Array<Fee>;
  updateGfeCharge: GfeCharge;
  updateGfeCharges: Array<GfeCharge>;
  updateHudFormType: HudFormType;
  updateIsSetAsCDLastLine?: Maybe<Fee>;
  updateLoanCalculationsDisclosures: LoanCalculationsDisclosures;
  updateLoanDisclosures: LoanDisclosures;
  updateNote: Note;
  updateNotifications?: Maybe<Array<Maybe<Notification>>>;
  updateOrder?: Maybe<OrderPayload>;
  updateOrderBuyerSellerRepresentativeById?: Maybe<OrderBuyerSellerSoRepPayload>;
  updateOrderMilestone: Milestone;
  updateOrderParty?: Maybe<OrderParty>;
  /** @deprecated Use updateOrderParty instead */
  updateOrderPartyById?: Maybe<OrderPartyPayLoad>;
  updateOrderTask: UpdateOrderTaskResponse;
  updatePackage: Package;
  updatePayoffs: WrappedPayoff;
  updatePolicyMetadata?: Maybe<PolicyMetadata>;
  updatePropertyTaxAndProrationConfiguration: PropertyTaxProrationConfiguration;
  updateProration: Proration;
  updateProrationCharge: ProrationCharge;
  updateReconciliation?: Maybe<Reconciliation>;
  updateRecordingDocument: RecordingDocument;
  updateReport: ReportEntry;
  updateRequirement?: Maybe<Requirement>;
  updateRequirements?: Maybe<Array<Maybe<Requirement>>>;
  updateRequirementsHeader?: Maybe<TitleRequirements>;
  updateRestrictiveCovenant: RestrictiveCovenant;
  updateSecurityGroup: SecurityGroup;
  updateSequence?: Maybe<Sequence>;
  updateStaffRole: StaffRole;
  updateStateWithholding?: Maybe<StateWithholding>;
  updateTagV2: TagV2;
  updateTemplateDocTagsV2: Array<Maybe<TemplateDocV2>>;
  updateTemplateSetV2: TemplateSetV2;
  updateTemplateV2: TemplateDocV2;
  updateTen99: UpdateTen99Response;
  updateTenant?: Maybe<Tenant>;
  updateTenantChild?: Maybe<TenantChildNode>;
  updateTenantProfileImage?: Maybe<TenantProfileImage>;
  updateTenantUnderwriter: UpdateTenantUnderwriterResponse;
  updateTitleAllocations?: Maybe<TitleAllocations>;
  updateTitleCpls: TitleCpls;
  updateTitleFees?: Maybe<TitleFees>;
  updateTitleGeneral: TitleGeneral;
  updateTitlePremium: TitlePremium;
  updateTitleProductsRemittanceDate: UpdateTitleProductsRemittanceDateResponse;
  updateTitleSearchOrder: TitleSearchOrder;
  updateTransaction?: Maybe<Array<Maybe<Transaction>>>;
  updateTransactionLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  updateTransactions?: Maybe<Array<Maybe<Transaction>>>;
  updateUser: User;
  updateUserSignatureImage: UserSignatureImage;
  updateUserStatus: User;
  uploadNewEntityDocumentV2: FileResourceUploadUrlV2;
  uploadNewTemplateV2: FileResourceUploadUrlV2;
  uploadTitleSearchImportDocuments: Scalars['Boolean'];
  upsertBuyerSellerSplit?: Maybe<BuyerSellerSplit>;
  upsertDocTypeMappingByCountyName: DocTypeMappingByCountyName;
  validateFedexMfaPin: ValidateFedexMfaPinResponse;
  validateFedexMfaPinCreate: ValidateFedexMfaPinCreateResponse;
  validatePackage: ValidatePackageResponse;
  validatePackageAsync: AsyncTaskResponse;
  validateRate?: Maybe<ValidateRate>;
  validateSdn: ValidateSdnResponse;
  /**
   * Validate wire transfer details via SES (Safe Escrow Services).
   *
   * Backend gathers wire data from escrow account, transaction, and order,
   * then invokes VPC Lambda to call SES AuthenticateBankAccount API.
   *
   * Returns validation result with success/failure status, result message,
   * and recommended actions.
   */
  validateWire: ValidateWireResponse;
  voidConsolidatedPayment?: Maybe<VoidConsolidatedPaymentResult>;
  voidJacket: Jacket;
  voidTitleCpl: TitleCpls;
  wireTransactions?: Maybe<Array<Maybe<Transaction>>>;
};


export type MutationAddBuyerArgs = {
  input?: InputMaybe<AddBuyerInput>;
};


export type MutationAddCarrierAccountArgs = {
  input: AddCarrierAccountRequestInput;
};


export type MutationAddConsolidatedPayeesArgs = {
  input: AddConsolidatedPayeesInput;
};


export type MutationAddNoteArgs = {
  input: AddNoteInput;
};


export type MutationAddPartyToOrderArgs = {
  orderId: Scalars['ID'];
  payload: AddPartyToOrderPayload;
};


export type MutationAddSellerArgs = {
  input?: InputMaybe<AddSellerInput>;
};


export type MutationAddSequenceArgs = {
  input: AddSequenceInput;
};


export type MutationAddUserRecentOrderArgs = {
  input: AddUserRecentOrderInput;
};


export type MutationAnalyzeDocumentV2Args = {
  input: AnalyzeDocumentV2Input;
};


export type MutationAnalyzeOrderAssistDocumentsArgs = {
  input: AnalyzeOrderAssistDocumentsInput;
};


export type MutationAnalyzeSearchPackageArgs = {
  input: AnalyzeSearchPackageInput;
};


export type MutationAuthenticateFaTrustCredentialsArgs = {
  input: AuthenticateFaTrustCredentialsInput;
};


export type MutationAuthorizeCarrierAccountArgs = {
  input: AuthorizeCarrierAccountRequestInput;
};


export type MutationCalculateCplRatesArgs = {
  input: CalculateCplRateRequest;
  orderId: Scalars['ID'];
};


export type MutationCalculatePremiumRateArgs = {
  input: CalculatePremiumRateRequest;
  orderId: Scalars['ID'];
};


export type MutationCancelTitleSearchOrderArgs = {
  input?: InputMaybe<CancelTitleSearchOrderInput>;
};


export type MutationCancelTitleSearchOrderUpdateArgs = {
  input: CancelTitleSearchOrderUpdateInput;
  orderId: Scalars['String'];
};


export type MutationChangeOrderWorkflowArgs = {
  adminWorkflowId: Scalars['ID'];
  orderId: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  workflowId: Scalars['ID'];
};


export type MutationClearDcAdjustmentArgs = {
  input: ClearDcAdjustmentInput;
};


export type MutationClearFeeArgs = {
  input?: InputMaybe<ClearFeeInput>;
};


export type MutationClearTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  input?: InputMaybe<ClearTransactionsInput>;
};


export type MutationCloneAdminTaskArgs = {
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationCloneAdminWorkflowArgs = {
  source: Scalars['ID'];
};


export type MutationCloneOrderArgs = {
  orderId: Scalars['ID'];
};


export type MutationCloneOrderAsynchronousArgs = {
  orderId: Scalars['ID'];
};


export type MutationCombineDocumentsAsyncV2Args = {
  input: CombineDocumentsRequestV2Input;
};


export type MutationCombineEntityDocumentsAsyncV2Args = {
  input: CombineEntityDocumentsRequestV2Input;
};


export type MutationCompanyPortalAssignArgs = {
  input: PortalCompanyIdsRequestInput;
};


export type MutationCompanyPortalUnassignArgs = {
  input: PortalCompanyIdsRequestInput;
};


export type MutationContactValidationArgs = {
  input: ContactValidationRequestInput;
};


export type MutationConvertEntityDocumentScopeV2Args = {
  input: ConvertEntityDocumentScopeV2Input;
};


export type MutationConvertPendingOrderDocumentsV2Args = {
  input: ConvertPendingOrderDocumentsV2Input;
};


export type MutationConvertTemplateToEntityDocumentV2Args = {
  input: CreateEntityDocumentFromTemplateIdV2Input;
};


export type MutationCreateAdminMilestoneArgs = {
  input: AdminMilestoneInput;
  workflowId: Scalars['ID'];
};


export type MutationCreateAdminTaskArgs = {
  input: AdminTaskInput;
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationCreateAdminWorkflowArgs = {
  input: AdminWorkflowInput;
};


export type MutationCreateAndBuyArgs = {
  input: CreateAndPurchaseShipmentRequestInput;
};


export type MutationCreateChangePasswordUserEventArgs = {
  input?: InputMaybe<CreateChangePasswordUserEventInput>;
};


export type MutationCreateClausePackageArgs = {
  input?: InputMaybe<ClausePackageInput>;
};


export type MutationCreateClauseTemplateArgs = {
  input?: InputMaybe<ClauseTemplateInput>;
};


export type MutationCreateDcAdjustmentArgs = {
  input: CreateDcAdjustmentInput;
};


export type MutationCreateDepartmentArgs = {
  input: DepartmentInput;
};


export type MutationCreateDirectoryCompanyArgs = {
  input?: InputMaybe<CreateDirectoryCompanyInput>;
};


export type MutationCreateDirectoryContactArgs = {
  directoryCompanyId: Scalars['String'];
  input?: InputMaybe<CreateDirectoryContactInput>;
};


export type MutationCreateDraftPackageArgs = {
  input: CreateDraftPackageInput;
};


export type MutationCreateEntityDocumentV2Args = {
  input: CreateEntityDocumentV2Input;
};


export type MutationCreateEpnAccountArgs = {
  input: CreateEpnAccountInput;
};


export type MutationCreateEscrowAccountArgs = {
  input?: InputMaybe<CreateEscrowAccountInput>;
};


export type MutationCreateExceptionsArgs = {
  input?: InputMaybe<CreateExceptionsInput>;
};


export type MutationCreateFeatureAcknowledgmentArgs = {
  input: CreateFeatureAcknowledgmentInput;
};


export type MutationCreateFeeArgs = {
  input?: InputMaybe<CreateFeeInput>;
};


export type MutationCreateFromMasterOrderArgs = {
  input?: InputMaybe<CreateOrderInput>;
};


export type MutationCreateFundArgs = {
  input?: InputMaybe<CreateFundInput>;
};


export type MutationCreateJacketArgs = {
  jacketInput: JacketInput;
};


export type MutationCreateOrderArgs = {
  input?: InputMaybe<CreateOrderInput>;
};


export type MutationCreateOrderFromMasterV2Args = {
  input: CreateOrderV2Input;
};


export type MutationCreateOrderMilestoneArgs = {
  orderId: Scalars['ID'];
  payload: CreateOrderMilestoneInput;
};


export type MutationCreateOrderPartyArgs = {
  input?: InputMaybe<CreateOrderPartyInput>;
  orderId: Scalars['ID'];
};


export type MutationCreateOrderTaskArgs = {
  input: OrderTaskInput;
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationCreateOrderV2Args = {
  input: CreateOrderV2Input;
};


export type MutationCreateOrderWorkflowFromAdminWorkflowArgs = {
  adminWorkflowId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationCreatePackageTemplateArgs = {
  input: CreatePackageTemplateInput;
};


export type MutationCreatePayoffArgs = {
  orderId: Scalars['String'];
};


export type MutationCreatePositivePaySubmissionArgs = {
  escrowAccountId: Scalars['ID'];
};


export type MutationCreatePropertyTaxAndProrationConfigurationArgs = {
  input: CreatePropertyTaxProrationConfigurationInput;
};


export type MutationCreateProrationArgs = {
  orderId: Scalars['String'];
  prorationInput: CreateProrationInput;
};


export type MutationCreateProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeInput: CreateProrationCharge;
};


export type MutationCreateReconciliationArgs = {
  input?: InputMaybe<CreateReconciliationInput>;
};


export type MutationCreateRecordingDocumentArgs = {
  input: CreateRecordingDocumentInput;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
};


export type MutationCreateReportExportArgs = {
  input: ReportDownloadInput;
};


export type MutationCreateRequirementsArgs = {
  input?: InputMaybe<CreateRequirementsInput>;
};


export type MutationCreateSecurityGroupArgs = {
  input?: InputMaybe<CreateSecurityGroupInput>;
};


export type MutationCreateStateWithholdingArgs = {
  input: CreateStateWithholdingInput;
};


export type MutationCreateTagV2Args = {
  input: CreateTagV2Input;
};


export type MutationCreateTemplateSetV2Args = {
  input: CreateTemplateSetV2Input;
};


export type MutationCreateTemplateV2Args = {
  input: CreateTemplateDocV2Input;
};


export type MutationCreateTenantArgs = {
  input?: InputMaybe<CreateTenantInput>;
};


export type MutationCreateTenantChildArgs = {
  input?: InputMaybe<CreateTenantChildInput>;
};


export type MutationCreateTenantUnderwriterArgs = {
  input?: InputMaybe<TenantUnderwriterInput>;
};


export type MutationCreateTitleSearchOrderArgs = {
  input?: InputMaybe<CreateTitleSearchOrderInput>;
};


export type MutationCreateTransactionArgs = {
  input?: InputMaybe<CreateTransactionInput>;
};


export type MutationCreateTransactionLineDetailArgs = {
  input?: InputMaybe<CreateLineDetailInput>;
};


export type MutationCreateUserArgs = {
  input?: InputMaybe<CreateUserInput>;
};


export type MutationDeleteAdminMilestoneArgs = {
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeleteAdminTaskArgs = {
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeleteAdminWorkflowArgs = {
  workflowId: Scalars['ID'];
};


export type MutationDeleteBuyerArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteBuyerRepArgs = {
  buyerId: Scalars['ID'];
  buyerRepId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteBuyerV2Args = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteCarrierAccountArgs = {
  input: DeleteCarrierAccountRequestInput;
};


export type MutationDeleteClausePackageArgs = {
  id: Scalars['ID'];
};


export type MutationDeleteClauseTemplateArgs = {
  clauseId: Scalars['ID'];
  isConfirmed?: InputMaybe<Scalars['Boolean']>;
};


export type MutationDeleteDcAdjustmentArgs = {
  input: DeleteDcAdjustmentInput;
};


export type MutationDeleteDepartmentArgs = {
  departmentId: Scalars['ID'];
};


export type MutationDeleteDocTypeMappingByCountyNameArgs = {
  input: DeleteDocTypeMappingByCountyNameInput;
};


export type MutationDeleteEntityDocumentV2Args = {
  input: GetEntityDocumentV2Input;
};


export type MutationDeleteEpnAccountArgs = {
  input: DeleteEpnAccountInput;
};


export type MutationDeleteEscrowAccountArgs = {
  escrowAccountId: Scalars['String'];
};


export type MutationDeleteExceptionArgs = {
  input?: InputMaybe<DeleteExceptionInput>;
};


export type MutationDeleteFeeArgs = {
  input?: InputMaybe<DeleteFeeInput>;
};


export type MutationDeleteFidelityAdminAgentMappingArgs = {
  input: FidelityAgentMappingKeyInput;
};


export type MutationDeleteFundArgs = {
  orderId: Scalars['String'];
};


export type MutationDeleteNoteArgs = {
  input?: InputMaybe<DeleteNoteInput>;
};


export type MutationDeleteOrderMilestoneArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type MutationDeleteOrderPartyArgs = {
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
};


export type MutationDeleteOrderTaskArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationDeletePackageArgs = {
  input: DeletePackageInput;
};


export type MutationDeletePayoffArgs = {
  orderId: Scalars['String'];
  payoffId: Scalars['String'];
};


export type MutationDeletePropertyTaxAndProrationConfigurationArgs = {
  configurationId: Scalars['ID'];
};


export type MutationDeleteProrationArgs = {
  orderId: Scalars['String'];
  prorationId: Scalars['String'];
};


export type MutationDeleteProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeId: Scalars['String'];
};


export type MutationDeleteReconciliationArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type MutationDeleteRecordingDocumentArgs = {
  input: GetRecordingDocumentInput;
};


export type MutationDeleteRecordingFeeTransferTaxCalcArgs = {
  orderId: Scalars['String'];
};


export type MutationDeleteReportArgs = {
  reportId: Scalars['ID'];
  viewId: Scalars['ID'];
};


export type MutationDeleteRequirementArgs = {
  input?: InputMaybe<DeleteRequirementInput>;
};


export type MutationDeleteSecurityGroupArgs = {
  input?: InputMaybe<DeleteSecurityGroupInput>;
};


export type MutationDeleteSellerArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type MutationDeleteSellerRepArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
  sellerRepId: Scalars['ID'];
};


export type MutationDeleteSequenceArgs = {
  sequenceId: Scalars['ID'];
};


export type MutationDeleteStateWithholdingArgs = {
  orderId: Scalars['ID'];
};


export type MutationDeleteTagsV2Args = {
  input: DeleteTagsV2Input;
};


export type MutationDeleteTemplateSetV2Args = {
  input: TemplateSetIdV2Input;
};


export type MutationDeleteTemplateV2Args = {
  input: TemplateDocTypeAndIdV2Input;
};


export type MutationDeleteTransactionArgs = {
  input?: InputMaybe<DeleteTransactionInput>;
};


export type MutationDeleteTransactionLineDetailArgs = {
  input?: InputMaybe<DeleteLineDetailInput>;
};


export type MutationDeleteUserLocksArgs = {
  input?: InputMaybe<DeleteUserLocksInput>;
};


export type MutationDisableFraudtoolsIntegrationArgs = {
  input: DisableFraudtoolsIntegrationRequestInput;
};


export type MutationDocumentSaveAsAsyncV2Args = {
  input: DocumentSaveAsRequestV2Input;
};


export type MutationDownloadDocumentsAsyncV2Args = {
  input: DownloadAsyncRequestV2Input;
};


export type MutationDownloadEntityDocumentV2Args = {
  input: DownloadEntityDocumentV2Input;
};


export type MutationDownloadEntityDocumentsAsyncV2Args = {
  input: DownloadEntityDocumentsRequestV2Input;
};


export type MutationDownloadTemplateV2Args = {
  input: DownloadTemplateV2Input;
};


export type MutationDuplicateTemplateV2Args = {
  input: DuplicateTemplateDocV2Input;
};


export type MutationEmailSignatureSaveArgs = {
  input: EmailSignatureCreateOrUpdateInput;
};


export type MutationEnableFraudtoolsIntegrationArgs = {
  input: EnableFraudtoolsIntegrationRequestInput;
};


export type MutationEnableIntegrationArgs = {
  input: EnableIntegrationRequestInput;
};


export type MutationEntityDocumentSaveAsAsyncV2Args = {
  input: EntityDocumentSaveAsRequestV2Input;
};


export type MutationEntityPrintChecksV2Args = {
  input: EntityPrintChecksRequestV2Input;
};


export type MutationExportQuickBooksIifArgs = {
  orderId: Scalars['String'];
  subAccountValue?: InputMaybe<Scalars['String']>;
};


export type MutationFinalizeReconciliationArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};


export type MutationGetEligibleCountiesByApiKeyArgs = {
  input: GetEligibleCountiesByApiKeyRequestInput;
};


export type MutationGetMissingTemplateBlocksForImportV2Args = {
  input: GetMissingTemplateBlocksForImportRequestV2Input;
};


export type MutationGetPaginatedEntityDocumentsV2Args = {
  input: PaginatedEntityDocumentsQueryV2Input;
};


export type MutationGetPaginatedRecordingDocumentsArgs = {
  input: PaginatedRecordingDocumentsQueryInput;
};


export type MutationGetSetsContainingTemplateV2Args = {
  input: GetSetsContainingTemplateV2Input;
};


export type MutationHandleOldRepublicUserAuthCallbackArgs = {
  input: OldRepublicUserAuthCallbackInput;
};


export type MutationIdentityVerificationArgs = {
  input: IdentityVerificationRequestInput;
};


export type MutationImportRepositoryAsyncV2Args = {
  input: ImportRepositoryAsyncRequestV2Input;
};


export type MutationImportRepositoryTemplateV2Args = {
  input: ImportRepositoryTemplateRequestV2Input;
};


export type MutationInitiateOldRepublicUserAuthArgs = {
  input: OldRepublicUserAuthInput;
};


export type MutationInitiateWireArgs = {
  input: InitiateWireInput;
};


export type MutationInviteUserArgs = {
  input?: InputMaybe<InviteUserInput>;
};


export type MutationIssueConsolidatedPaymentArgs = {
  input: IssueConsolidatedPaymentInput;
};


export type MutationJoinTransactionsArgs = {
  input?: InputMaybe<JoinTransactionsInput>;
};


export type MutationLegacyOrdersPostArgs = {
  input?: InputMaybe<Array<InputMaybe<LegacyOrdersInput>>>;
};


export type MutationMatchIncomingWireArgs = {
  escrowAccountId: Scalars['String'];
  incomingWireId: Scalars['String'];
  receiptId: Scalars['String'];
};


export type MutationMoveAdminTaskArgs = {
  input?: InputMaybe<MoveAdminTaskInput>;
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationMoveOrderTaskArgs = {
  input: MoveOrderTaskInput;
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationOrderDocumentMarkViewedArgs = {
  input: OrderDocumentMarkViewedRequestInput;
};


export type MutationOrderDocumentShareArgs = {
  input: OrderDocumentShareRequestInput;
};


export type MutationOrderPartyInviteArgs = {
  input: OrderPartyInviteRequestInput;
};


export type MutationOrderPartyRemoveArgs = {
  input: OrderPartyRemoveRequestInput;
};


export type MutationOrderTitleCplProductArgs = {
  input?: InputMaybe<OrderTitleCplProductInput>;
  orderId: Scalars['ID'];
};


export type MutationOrderTitleCplProductV2Args = {
  input?: InputMaybe<OrderTitleCplProductInput>;
  orderId: Scalars['ID'];
};


export type MutationOverwriteEntityDocumentV2Args = {
  input: OverwriteEntityDocumentV2Input;
};


export type MutationOverwriteTemplateV2Args = {
  input: OverwriteTemplateV2Input;
};


export type MutationPatchBuyerSpouseArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
  spouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};


export type MutationPatchBuyersArgs = {
  buyers?: InputMaybe<Array<InputMaybe<BuyerSellerCollectionPatchInput>>>;
  orderId: Scalars['ID'];
};


export type MutationPatchCalculatingCashToCloseArgs = {
  input: CalculatingCashToCloseInput;
};


export type MutationPatchSellerSpouseArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
  spouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};


export type MutationPatchSellerSpouseV2Args = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
  spouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};


export type MutationPatchSellersArgs = {
  orderId: Scalars['ID'];
  sellers?: InputMaybe<Array<InputMaybe<BuyerSellerCollectionPatchInput>>>;
};


export type MutationPollPackageStatusArgs = {
  input: PollPackageStatusRequestInput;
};


export type MutationPortalAccountCreateArgs = {
  input: PortalAccountCreateRequestInput;
};


export type MutationPortalAccountSetActiveArgs = {
  input: PortalAccountSetActiveRequestInput;
};


export type MutationPortalAccountUpdateArgs = {
  input: PortalAccountUpdateRequestInput;
};


export type MutationPostAutoClearArgs = {
  input?: InputMaybe<PostAutoClearInput>;
};


export type MutationPrintChecksArgs = {
  input?: InputMaybe<PrintChecksInput>;
};


export type MutationPrintChecksFastArgs = {
  input?: InputMaybe<PrintChecksInput>;
};


export type MutationPrintChecksV2Args = {
  input: PrintChecksRequestV2Input;
};


export type MutationPrintDocumentsAsyncV2Args = {
  input: PrintDocumentsRequestV2Input;
};


export type MutationPrintEntityDocumentsAsyncV2Args = {
  input: PrintEntityDocumentsRequestV2Input;
};


export type MutationPrintTestChecksArgs = {
  input?: InputMaybe<CheckPrintingTestInput>;
};


export type MutationPurchaseShippingRateArgs = {
  input: PurchaseShippingRateRequestInput;
};


export type MutationPutAgentNetFinanceIntegrationArgs = {
  input: PutAgentNetFinanceIntegrationInput;
};


export type MutationPutEntityDocumentFromKnownTemplateV2Args = {
  input: CreateEntityDocumentFromKnownTemplateV2Input;
};


export type MutationPutIntegratedRecordingFeeTransferTaxArgs = {
  input: IntegratedRfttInput;
};


export type MutationPutOrderCommissionsArgs = {
  input: PutOrderCommissionsInput;
  metadata: PutOrderCommissionsMetadata;
};


export type MutationPutOrderDepositsArgs = {
  input: PutOrderDepositsInput;
  orderId: Scalars['ID'];
};


export type MutationPutProjectedPaymentsArgs = {
  input: ProjectedPaymentsInput;
};


export type MutationPutRecordingFeeTransferTaxArgs = {
  input: PutRecordingFeeTransferTaxInput;
};


export type MutationPutTenantChildImageArgs = {
  input?: InputMaybe<PutTenantChildImageInput>;
};


export type MutationRefreshCommissionsArgs = {
  input?: InputMaybe<RefreshCommissionsInput>;
};


export type MutationRefreshDepositsForAdjustmentsArgs = {
  input: RefreshDepositsForAdjustmentsInput;
};


export type MutationRefreshDepositsForFeesArgs = {
  input: RefreshDepositsForFeesInput;
};


export type MutationRefreshPremiumsAndFeesArgs = {
  input?: InputMaybe<RefreshPremiumsAndFeesInput>;
};


export type MutationRegeneratePositivePayFileArgs = {
  escrowAccountId: Scalars['ID'];
  submissionId: Scalars['ID'];
};


export type MutationRejectWireArgs = {
  escrowAccountId: Scalars['String'];
  reason: Scalars['String'];
  reference: Scalars['String'];
};


export type MutationRemoveConsolidatedPayeeArgs = {
  input: RemoveConsolidatedPayeeInput;
};


export type MutationReplacePartyCompanyAndContactArgs = {
  metadata: ReplacePartyCompanyAndContactMetadata;
  payload: ReplacePartyCompanyAndContactPayload;
};


export type MutationReprintChecksArgs = {
  input?: InputMaybe<PrintChecksInput>;
};


export type MutationRequestFedexMfaPinArgs = {
  input: RequestFedexMfaPinRequestInput;
};


export type MutationRequestFedexMfaPinCreateArgs = {
  input: RequestFedexMfaPinCreateRequestInput;
};


export type MutationRequestShippingRatesArgs = {
  input: RequestShippingRatesRequestInput;
};


export type MutationResetContactValidationArgs = {
  input: ResetContactValidationRequestInput;
};


export type MutationResetUserMultiFactorAuthenticationArgs = {
  input?: InputMaybe<ResetUserMultiFactorAuthenticationInput>;
};


export type MutationRetryAttachIdentityVerificationReportArgs = {
  input: RetryAttachIdentityVerificationReportRequestInput;
};


export type MutationRetryRejectedPackageArgs = {
  input: RetryRejectedPackageRequestInput;
};


export type MutationRevertEntityDocumentToVersionV2Args = {
  input: RevertEntityDocumentVersionRequestV2Input;
};


export type MutationRevertTemplateDocToVersionV2Args = {
  input: RevertTemplateDocVersionRequestV2Input;
};


export type MutationSaveSnapshotArgs = {
  input: SaveSnapshotRequestInput;
};


export type MutationSecurePortalConfigureIntegrationUpdateArgs = {
  input: SecurePortalIntegrationConfigUpdateRequestInput;
};


export type MutationSendContactFormArgs = {
  input?: InputMaybe<SendContactFormInput>;
};


export type MutationSendEmailArgs = {
  input: SendEmailRequestInput;
};


export type MutationSendOrderEmailArgs = {
  input: SendOrderEmailRequestInput;
};


export type MutationSetAgentNetAdminCredentialsArgs = {
  input: AdminSetCredentialAgentNet;
};


export type MutationSetAgentNetAdminOfficesArgs = {
  input: AdminSetAgentNetOffices;
};


export type MutationSetAgentNetUserCredentialsArgs = {
  input: UserSetCredentialAgentNet;
};


export type MutationSetFidelityAdminAgentMappingArgs = {
  input: FidelityAgentMappingInput;
};


export type MutationSetFidelityAdminStatusArgs = {
  input: FidelityAdminStatusInput;
};


export type MutationSetOldRepublicAdminAgentMappingArgs = {
  input: OldRepublicSetAgentMappingInput;
};


export type MutationSetOldRepublicAdminStatusArgs = {
  input: OldRepublicAdminStatusInput;
};


export type MutationSetOrderRecordingJurisdictionArgs = {
  input: SetOrderRecordingJurisdictionInput;
};


export type MutationSetUserDepartmentsArgs = {
  input: SetUserDepartmentsInput;
};


export type MutationSplitTransactionArgs = {
  input?: InputMaybe<SplitTransactionInput>;
};


export type MutationStartFedexMfaArgs = {
  input: StartFedexMfaRequestInput;
};


export type MutationStartFedexMfaCreateArgs = {
  input: StartFedexMfaCreateRequestInput;
};


export type MutationSubmitInsightFeedbackV2Args = {
  input: SubmitInsightFeedbackInputV2Input;
};


export type MutationSubmitPackageArgs = {
  input: SubmitPackageInput;
};


export type MutationSubmitPackageAsyncArgs = {
  input: SubmitPackageAsyncInput;
};


export type MutationSwitchRecordingFeeTransferTaxCalculatorArgs = {
  input: SwitchRecordingFeeTransferTaxCalculatorInput;
};


export type MutationSyncJacketArgs = {
  orderId: Scalars['ID'];
};


export type MutationSynchronizeGfeChargesArgs = {
  orderId: Scalars['String'];
};


export type MutationToggleTen99Args = {
  input: ToggleTen99Input;
};


export type MutationTransferTransactionDetailsArgs = {
  input?: InputMaybe<TransferTransactionDetailsInput>;
};


export type MutationTransmitWireArgs = {
  escrowAccountId: Scalars['String'];
  reference: Scalars['String'];
};


export type MutationTriggerTitleSearchImportArgs = {
  input: TriggerTitleSearchImportInput;
};


export type MutationUnmatchIncomingWireArgs = {
  escrowAccountId: Scalars['String'];
  incomingWireId: Scalars['String'];
};


export type MutationUpdateAdminMilestoneArgs = {
  input: UpdateAdminMilestoneInput;
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationUpdateAdminTaskArgs = {
  input: UpdateAdminTaskInput;
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationUpdateAdminWorkflowArgs = {
  input: UpdateAdminWorkflowInput;
  workflowId: Scalars['ID'];
};


export type MutationUpdateCarrierAccountArgs = {
  input: UpdateCarrierAccountRequestInput;
};


export type MutationUpdateClausePackageArgs = {
  id: Scalars['ID'];
  input?: InputMaybe<ClausePackageInput>;
};


export type MutationUpdateClauseTemplateArgs = {
  clauseId: Scalars['ID'];
  input?: InputMaybe<ClauseTemplateInput>;
};


export type MutationUpdateClosingInformationArgs = {
  input: ClosingInformationInput;
};


export type MutationUpdateClosingQuestionsArgs = {
  input: ClosingQuestionsInput;
};


export type MutationUpdateDcAdjustmentArgs = {
  input: UpdateDcAdjustmentInput;
};


export type MutationUpdateDepartmentArgs = {
  departmentId: Scalars['ID'];
  input: UpdateDepartmentInput;
};


export type MutationUpdateDirectoryCompanyArgs = {
  input?: InputMaybe<UpdateDirectoryCompanyInput>;
};


export type MutationUpdateDirectoryContactArgs = {
  directoryCompanyId: Scalars['String'];
  input?: InputMaybe<UpdateDirectoryContactInput>;
};


export type MutationUpdateEntityDocumentTagsV2Args = {
  input: UpdateEntityDocumentTagsV2Input;
};


export type MutationUpdateEntityDocumentV2Args = {
  input: UpdateEntityDocumentV2Input;
};


export type MutationUpdateEpnAccountArgs = {
  input: UpdateEpnAccountInput;
};


export type MutationUpdateEpnIntegrationStatusArgs = {
  input: UpdateEpnIntegrationStatusInput;
};


export type MutationUpdateEscrowAccountArgs = {
  input?: InputMaybe<UpdateEscrowAccountInput>;
};


export type MutationUpdateEstimatedTaxesInsuranceAssessmentsArgs = {
  input: EstimatedTaxesInsuranceAssessmentsInput;
};


export type MutationUpdateExceptionArgs = {
  input?: InputMaybe<UpdateExceptionInput>;
};


export type MutationUpdateExceptionsArgs = {
  input?: InputMaybe<UpdateExceptionsInput>;
};


export type MutationUpdateExceptionsHeaderArgs = {
  input?: InputMaybe<UpdateExceptionsHeaderInput>;
};


export type MutationUpdateFeeArgs = {
  input?: InputMaybe<UpdateFeeInput>;
};


export type MutationUpdateFeeAllocationsArgs = {
  orderId: Scalars['String'];
  updateFeeAllocationsInput?: InputMaybe<FeeAllocationInput>;
};


export type MutationUpdateFundArgs = {
  input?: InputMaybe<UpdateFundInput>;
};


export type MutationUpdateFundingForFeesArgs = {
  input?: InputMaybe<UpdateFundingForFeesInput>;
};


export type MutationUpdateGfeChargeArgs = {
  input: UpdateGfeChargeInput;
};


export type MutationUpdateGfeChargesArgs = {
  input: UpdateGfeChargesInput;
};


export type MutationUpdateHudFormTypeArgs = {
  input: HudFormTypeInput;
};


export type MutationUpdateIsSetAsCdLastLineArgs = {
  input?: InputMaybe<UpdateIsSetAsCdLastLineInput>;
};


export type MutationUpdateLoanCalculationsDisclosuresArgs = {
  input: LoanCalculationsDisclosuresInput;
};


export type MutationUpdateLoanDisclosuresArgs = {
  input: UpdateLoanDisclosuresInput;
};


export type MutationUpdateNoteArgs = {
  input: UpdateNoteInput;
};


export type MutationUpdateNotificationsArgs = {
  input?: InputMaybe<UpdateNotificationsInput>;
};


export type MutationUpdateOrderArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOrderBuyerSellerRepresentativeByIdArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOrderMilestoneArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  payload: UpdateOrderMilestoneInput;
};


export type MutationUpdateOrderPartyArgs = {
  input?: InputMaybe<UpdateOrderPartyInput>;
  orderId: Scalars['ID'];
};


export type MutationUpdateOrderPartyByIdArgs = {
  input?: InputMaybe<UpdateOrderInput>;
};


export type MutationUpdateOrderTaskArgs = {
  input: UpdateOrderTaskInput;
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type MutationUpdatePackageArgs = {
  input: UpdatePackageInput;
};


export type MutationUpdatePayoffsArgs = {
  orderId: Scalars['String'];
  payoffs?: InputMaybe<Array<InputMaybe<UpdatePayoffInput>>>;
};


export type MutationUpdatePolicyMetadataArgs = {
  input?: InputMaybe<UpdatePolicyMetadataInput>;
};


export type MutationUpdatePropertyTaxAndProrationConfigurationArgs = {
  input: UpdatePropertyTaxProrationConfigurationInput;
};


export type MutationUpdateProrationArgs = {
  orderId: Scalars['String'];
  prorationInput: UpdateProrationInput;
};


export type MutationUpdateProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeId: Scalars['String'];
  prorationChargeInput: UpdateProrationCharge;
};


export type MutationUpdateReconciliationArgs = {
  input?: InputMaybe<UpdateReconciliationInput>;
};


export type MutationUpdateRecordingDocumentArgs = {
  input: UpdateRecordingDocumentInput;
};


export type MutationUpdateReportArgs = {
  input: UpdateReportInput;
  reportId: Scalars['ID'];
  viewId: Scalars['ID'];
};


export type MutationUpdateRequirementArgs = {
  input?: InputMaybe<UpdateRequirementInput>;
};


export type MutationUpdateRequirementsArgs = {
  input?: InputMaybe<UpdateRequirementsInput>;
};


export type MutationUpdateRequirementsHeaderArgs = {
  input?: InputMaybe<UpdateRequirementsHeaderInput>;
};


export type MutationUpdateRestrictiveCovenantArgs = {
  input?: InputMaybe<UpdateRestrictiveCovenantInput>;
};


export type MutationUpdateSecurityGroupArgs = {
  input?: InputMaybe<UpdateSecurityGroupInput>;
};


export type MutationUpdateSequenceArgs = {
  input: UpdateSequenceInput;
};


export type MutationUpdateStaffRoleArgs = {
  id: Scalars['ID'];
  input: StaffRolePatchInput;
};


export type MutationUpdateStateWithholdingArgs = {
  input: UpdateStateWithholdingInput;
};


export type MutationUpdateTagV2Args = {
  input: UpdateTagV2Input;
};


export type MutationUpdateTemplateDocTagsV2Args = {
  input: UpdateTemplateDocTagsV2Input;
};


export type MutationUpdateTemplateSetV2Args = {
  input: UpdateTemplateSetV2Input;
};


export type MutationUpdateTemplateV2Args = {
  input: UpdateTemplateDocV2Input;
};


export type MutationUpdateTen99Args = {
  input?: InputMaybe<Ten99Input>;
};


export type MutationUpdateTenantArgs = {
  input?: InputMaybe<UpdateTenantInput>;
};


export type MutationUpdateTenantChildArgs = {
  input?: InputMaybe<UpdateTenantChildInput>;
};


export type MutationUpdateTenantProfileImageArgs = {
  input?: InputMaybe<UpdateTenantProfileImageInput>;
};


export type MutationUpdateTenantUnderwriterArgs = {
  input?: InputMaybe<UpdateTenantUnderwriterInput>;
};


export type MutationUpdateTitleAllocationsArgs = {
  orderId: Scalars['String'];
  updateTitleAllocationsInput?: InputMaybe<TitleAllocationInput>;
};


export type MutationUpdateTitleCplsArgs = {
  input?: InputMaybe<UpdateTitleCplsInput>;
  orderId: Scalars['ID'];
};


export type MutationUpdateTitleFeesArgs = {
  orderId: Scalars['String'];
  updateTitleFeesInput?: InputMaybe<FeesInput>;
};


export type MutationUpdateTitleGeneralArgs = {
  input?: InputMaybe<UpdateTitleGeneralInput>;
};


export type MutationUpdateTitlePremiumArgs = {
  input?: InputMaybe<UpdateTitlePremiumInput>;
  orderId: Scalars['ID'];
  premiumType: Scalars['String'];
};


export type MutationUpdateTitleProductsRemittanceDateArgs = {
  input: UpdateTitleProductsRemittanceDateInput;
};


export type MutationUpdateTitleSearchOrderArgs = {
  input?: InputMaybe<UpdateTitleSearchOrderInput>;
};


export type MutationUpdateTransactionArgs = {
  input?: InputMaybe<UpdateTransactionInput>;
};


export type MutationUpdateTransactionLineDetailsArgs = {
  input?: InputMaybe<UpdateLineDetailsInput>;
};


export type MutationUpdateTransactionsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateTransactionInput>>>;
};


export type MutationUpdateUserArgs = {
  input?: InputMaybe<UpdateUserInput>;
};


export type MutationUpdateUserSignatureImageArgs = {
  input?: InputMaybe<UpdateUserSignatureImageInput>;
};


export type MutationUpdateUserStatusArgs = {
  input?: InputMaybe<UpdateUserStatusInput>;
};


export type MutationUploadNewEntityDocumentV2Args = {
  input: UploadNewEntityDocumentV2Input;
};


export type MutationUploadNewTemplateV2Args = {
  input: UploadNewTemplateV2Input;
};


export type MutationUploadTitleSearchImportDocumentsArgs = {
  input?: InputMaybe<UploadTitleSearchImportDocumentsInput>;
};


export type MutationUpsertBuyerSellerSplitArgs = {
  input?: InputMaybe<BuyerSellerSplitInput>;
};


export type MutationUpsertDocTypeMappingByCountyNameArgs = {
  input: UpsertDocTypeMappingByCountyNameInput;
};


export type MutationValidateFedexMfaPinArgs = {
  input: ValidateFedexMfaPinRequestInput;
};


export type MutationValidateFedexMfaPinCreateArgs = {
  input: ValidateFedexMfaPinCreateRequestInput;
};


export type MutationValidatePackageArgs = {
  input: ValidatePackageInput;
};


export type MutationValidatePackageAsyncArgs = {
  input: ValidatePackageAsyncInput;
};


export type MutationValidateRateArgs = {
  input: RateValidationRequest;
  orderId: Scalars['String'];
};


export type MutationValidateSdnArgs = {
  input: ValidateSdnInput;
};


export type MutationValidateWireArgs = {
  input: ValidateWireInput;
};


export type MutationVoidConsolidatedPaymentArgs = {
  input: VoidConsolidatedPaymentInput;
};


export type MutationVoidJacketArgs = {
  jacketInput: JacketInput;
};


export type MutationVoidTitleCplArgs = {
  input: VoidTitleCplInput;
  orderId: Scalars['ID'];
};


export type MutationWireTransactionsArgs = {
  input?: InputMaybe<Array<InputMaybe<UpdateTransactionInput>>>;
};

export type Name = {
  __typename?: 'Name';
  displayName?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxForm = {
  __typename?: 'NhInventoryPropertyTaxForm';
  acreage?: Maybe<Scalars['String']>;
  block?: Maybe<Scalars['String']>;
  buyer?: Maybe<NhInventoryPropertyTaxFormBuyer>;
  lot?: Maybe<Scalars['String']>;
  property?: Maybe<NhInventoryPropertyTaxFormProperty>;
  seller?: Maybe<NhInventoryPropertyTaxFormSeller>;
  settlementAgentAddress?: Maybe<NhInventoryPropertyTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  staff?: Maybe<NhInventoryPropertyTaxFormStaff>;
  taxMap?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormAddress = {
  __typename?: 'NhInventoryPropertyTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormBuyer = {
  __typename?: 'NhInventoryPropertyTaxFormBuyer';
  address?: Maybe<NhInventoryPropertyTaxFormAddress>;
  buyerType?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  representatives?: Maybe<NhInventoryPropertyTaxFormRepresentatives>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseFullName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormProperty = {
  __typename?: 'NhInventoryPropertyTaxFormProperty';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormRepresentatives = {
  __typename?: 'NhInventoryPropertyTaxFormRepresentatives';
  first?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
  third?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormSeller = {
  __typename?: 'NhInventoryPropertyTaxFormSeller';
  address?: Maybe<NhInventoryPropertyTaxFormAddress>;
  email?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  sellerType?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhInventoryPropertyTaxFormStaff = {
  __typename?: 'NhInventoryPropertyTaxFormStaff';
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxForm = {
  __typename?: 'NhRealEstatePurchaserTaxForm';
  buyers?: Maybe<Array<Maybe<NhRealEstatePurchaserTaxFormBuyer>>>;
  county?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<NhRealEstatePurchaserTaxFormSeller>;
  settlementAgentAddress?: Maybe<NhRealEstatePurchaserTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  staff?: Maybe<NhRealEstatePurchaserTaxFormStaff>;
  street?: Maybe<Scalars['String']>;
  subtotalBuyersTax?: Maybe<Scalars['Float']>;
  totalTaxPaidToCounty?: Maybe<Scalars['Float']>;
  transferTaxBorrowerPaidAt?: Maybe<Scalars['Float']>;
  transferTaxCalcBasisNH?: Maybe<Scalars['Float']>;
  transferTaxTotal?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormAddress = {
  __typename?: 'NhRealEstatePurchaserTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormBuyer = {
  __typename?: 'NhRealEstatePurchaserTaxFormBuyer';
  address?: Maybe<NhRealEstatePurchaserTaxFormAddress>;
  buyerType?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  representatives?: Maybe<NhRealEstatePurchaserTaxFormRepresentatives>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseFullName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  spouseTaxIdNumber?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormRepresentatives = {
  __typename?: 'NhRealEstatePurchaserTaxFormRepresentatives';
  first?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormSeller = {
  __typename?: 'NhRealEstatePurchaserTaxFormSeller';
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  sellerType?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
};

export type NhRealEstatePurchaserTaxFormStaff = {
  __typename?: 'NhRealEstatePurchaserTaxFormStaff';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxForm = {
  __typename?: 'NhRealEstateSellerTaxForm';
  buyers?: Maybe<NhRealEstateSellerTaxFormBuyer>;
  county?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<NhRealEstateSellerTaxFormSeller>>>;
  settlementAgentAddress?: Maybe<NhRealEstateSellerTaxFormAddress>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  staff?: Maybe<NhRealEstateSellerTaxFormStaff>;
  street?: Maybe<Scalars['String']>;
  subtotalSellersTax?: Maybe<Scalars['Float']>;
  totalTaxPaidToCounty?: Maybe<Scalars['Float']>;
  transferTaxCalcBasisNH?: Maybe<Scalars['Float']>;
  transferTaxSellerPaidAt?: Maybe<Scalars['Float']>;
  transferTaxTotal?: Maybe<Scalars['Float']>;
  unit?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormAddress = {
  __typename?: 'NhRealEstateSellerTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormBuyer = {
  __typename?: 'NhRealEstateSellerTaxFormBuyer';
  buyerType?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormRepresentatives = {
  __typename?: 'NhRealEstateSellerTaxFormRepresentatives';
  first?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormSeller = {
  __typename?: 'NhRealEstateSellerTaxFormSeller';
  address?: Maybe<NhRealEstateSellerTaxFormAddress>;
  entityName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  representatives?: Maybe<NhRealEstateSellerTaxFormRepresentatives>;
  sellerType?: Maybe<Scalars['String']>;
  spouseFirstName?: Maybe<Scalars['String']>;
  spouseFullName?: Maybe<Scalars['String']>;
  spouseLastName?: Maybe<Scalars['String']>;
  spouseTaxIdNumber?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type NhRealEstateSellerTaxFormStaff = {
  __typename?: 'NhRealEstateSellerTaxFormStaff';
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
};

export type Node = {
  id: Scalars['ID'];
};

export type NotaryCommissions = {
  __typename?: 'NotaryCommissions';
  notaryCommissionExpiration?: Maybe<Scalars['String']>;
  notaryCommissionState?: Maybe<Scalars['String']>;
};

export type NotaryCommissionsInput = {
  notaryCommissionExpiration?: InputMaybe<Scalars['String']>;
  notaryCommissionState?: InputMaybe<Scalars['String']>;
};

export type Note = {
  __typename?: 'Note';
  appliesTo?: Maybe<AppliesTo>;
  body: Scalars['String'];
  createdBy?: Maybe<NoteUser>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<NoteEntityType>;
  id?: Maybe<Scalars['String']>;
  subject?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<NoteUser>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export enum NoteEntityType {
  Directory = 'directory',
  Order = 'order',
  Reconciliation = 'reconciliation',
  Workflow = 'workflow'
}

export type NoteUser = {
  __typename?: 'NoteUser';
  displayName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
};

export type Notification = {
  __typename?: 'Notification';
  createdTimestamp?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['DataObject']>;
  href?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  message?: Maybe<Scalars['String']>;
  seen?: Maybe<Scalars['Boolean']>;
  status?: Maybe<ReadStatus>;
};

export type NotificationInput = {
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  seen?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<ReadStatus>;
  updatedTimestamp: Scalars['String'];
};

export type NotificationRole = {
  __typename?: 'NotificationRole';
  notificationType: NotificationType;
  staffRole: Scalars['String'];
};

export type NotificationRoleInput = {
  notificationType: NotificationType;
  staffRole: Scalars['String'];
};

export enum NotificationType {
  InApp = 'IN_APP'
}

export type NumberOverrideMetadata = {
  __typename?: 'NumberOverrideMetadata';
  effectiveValue?: Maybe<Scalars['Float']>;
  fallbackValue?: Maybe<Scalars['Float']>;
  overridden?: Maybe<Scalars['Boolean']>;
  overrideValue?: Maybe<Scalars['Float']>;
};

export type ObservationV2 = {
  __typename?: 'ObservationV2';
  category?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  recommendation?: Maybe<Scalars['String']>;
  severity: ObservationV2Severity;
  supportingEvidence?: Maybe<Array<SupportingEvidenceV2>>;
  title: Scalars['String'];
};

export enum ObservationV2Severity {
  Critical = 'critical',
  Info = 'info',
  Warning = 'warning'
}

export type OhConveyanceFeeDteForm = {
  __typename?: 'OhConveyanceFeeDteForm';
  granteeAddress?: Maybe<Scalars['String']>;
  granteeName?: Maybe<Scalars['String']>;
  granteePhone?: Maybe<Scalars['String']>;
  grantorName?: Maybe<Scalars['String']>;
  grantorPhone?: Maybe<Scalars['String']>;
  lenderCompanyName?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  property?: Maybe<OhConveyanceFeeDteFormProperty>;
};

export type OhConveyanceFeeDteFormProperty = {
  __typename?: 'OhConveyanceFeeDteFormProperty';
  address?: Maybe<Scalars['String']>;
  isPlatted?: Maybe<Scalars['Boolean']>;
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  propertyParcelNumbers?: Maybe<Scalars['String']>;
};

export type OldRepublicAdminConfiguration = {
  __typename?: 'OldRepublicAdminConfiguration';
  configuredUnderwriterCode: Scalars['String'];
  configuredUnderwriterName: Scalars['String'];
  integrationActive: Scalars['Boolean'];
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type OldRepublicAdminStatusInput = {
  active: Scalars['Boolean'];
};

export type OldRepublicAgentMapping = {
  __typename?: 'OldRepublicAgentMapping';
  agencyId: Scalars['Int'];
  agencyNumber: Scalars['String'];
  branchId: Scalars['String'];
  companyId: Scalars['String'];
  hasCplAuthorizationCode: Scalars['Boolean'];
};

export type OldRepublicAgentMappingItemInput = {
  agencyId: Scalars['Int'];
  agencyNumber: Scalars['String'];
  authorizationCode?: InputMaybe<Scalars['String']>;
  branchId: Scalars['String'];
  companyId: Scalars['String'];
};

export type OldRepublicAgentMappingResponse = {
  __typename?: 'OldRepublicAgentMappingResponse';
  mapping: Array<OldRepublicAgentMapping>;
};

export type OldRepublicAgentOption = {
  __typename?: 'OldRepublicAgentOption';
  agencyAddress?: Maybe<Scalars['String']>;
  agencyCity?: Maybe<Scalars['String']>;
  agencyId: Scalars['Int'];
  agencyName?: Maybe<Scalars['String']>;
  agencyNumber?: Maybe<Scalars['String']>;
  agencyPhone?: Maybe<Scalars['String']>;
  agencyState?: Maybe<Scalars['String']>;
  agencyStateId?: Maybe<Scalars['Int']>;
  agencyZip?: Maybe<Scalars['String']>;
};

export type OldRepublicAgentOptionsResponse = {
  __typename?: 'OldRepublicAgentOptionsResponse';
  options: Array<OldRepublicAgentOption>;
  status: Scalars['String'];
};

export type OldRepublicSetAgentMappingInput = {
  mapping: Array<OldRepublicAgentMappingItemInput>;
};

export type OldRepublicUserAuthCallbackInput = {
  code: Scalars['String'];
  state: Scalars['String'];
};

export type OldRepublicUserAuthCallbackResponse = {
  __typename?: 'OldRepublicUserAuthCallbackResponse';
  redirectPath?: Maybe<Scalars['String']>;
};

export type OldRepublicUserAuthInput = {
  redirectPath?: InputMaybe<Scalars['String']>;
};

export type OldRepublicUserAuthResponse = {
  __typename?: 'OldRepublicUserAuthResponse';
  state: Scalars['String'];
  url: Scalars['String'];
};

export type OldRepublicUserAuthStatus = {
  __typename?: 'OldRepublicUserAuthStatus';
  active: Scalars['Boolean'];
  error: Scalars['Boolean'];
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Order = {
  __typename?: 'Order';
  branch?: Maybe<TenantChildNode>;
  branchLogo?: Maybe<Image>;
  buyerReps?: Maybe<Array<Maybe<OrderBuyerSellerSoRep>>>;
  buyers?: Maybe<Array<Buyer>>;
  buyersAllNames?: Maybe<Scalars['String']>;
  buyersAllNamesWithCommas?: Maybe<Scalars['String']>;
  buyersAllNamesWithMarital?: Maybe<Scalars['String']>;
  buyersAllNamesWithMaritalAndVesting?: Maybe<Scalars['String']>;
  buyersAllNamesWithVesting?: Maybe<Scalars['String']>;
  commissions?: Maybe<OrderCommissions>;
  companyLogo?: Maybe<Image>;
  deposits?: Maybe<OrderDeposits>;
  funding?: Maybe<MergeDataOrderFunding>;
  header?: Maybe<OrderHeader>;
  id: Scalars['ID'];
  lenderName?: Maybe<Scalars['String']>;
  loan?: Maybe<OrderLoan>;
  main?: Maybe<OrderMain>;
  parties?: Maybe<Array<Maybe<OrderParty>>>;
  piq?: Maybe<OrderPiq>;
  recordingDocuments?: Maybe<Array<Maybe<MergeDataRecordingDocument>>>;
  restrictions: Array<Restriction>;
  sellerReps?: Maybe<Array<Maybe<OrderBuyerSellerSoRep>>>;
  sellers?: Maybe<Array<Seller>>;
  sellersAllNames?: Maybe<Scalars['String']>;
  sellersAllNamesWithCommas?: Maybe<Scalars['String']>;
  sellersAllNamesWithMarital?: Maybe<Scalars['String']>;
  sellersAllNamesWithMaritalAndVesting?: Maybe<Scalars['String']>;
  sellersAllNamesWithVesting?: Maybe<Scalars['String']>;
  settlement?: Maybe<Settlement>;
  ten99?: Maybe<Ten99>;
  title?: Maybe<TitleDomain>;
  transactionType?: Maybe<TransactionType>;
};

export type OrderAssistDeposit = {
  __typename?: 'OrderAssistDeposit';
  dateReceived?: Maybe<ConfidenceString>;
  deductFromCommission?: Maybe<Scalars['Boolean']>;
  depositAmount?: Maybe<ConfidenceFloat>;
  fundsHeldBy?: Maybe<Scalars['String']>;
  fundsHeldByResourceId?: Maybe<Scalars['String']>;
  receiptNumber?: Maybe<ConfidenceString>;
  typeOfFunds?: Maybe<ConfidenceString>;
};

export type OrderAssistDocumentInput = {
  documentId: Scalars['String'];
};

export type OrderAssistExtraction = {
  __typename?: 'OrderAssistExtraction';
  data: OrderAssistInsightData;
  documentType: Scalars['String'];
};

export type OrderAssistInsightData = {
  __typename?: 'OrderAssistInsightData';
  amountSale?: Maybe<ConfidenceFloat>;
  briefLegalDescription?: Maybe<ConfidenceString>;
  buyers?: Maybe<Array<OrderAssistParty>>;
  county?: Maybe<ConfidenceString>;
  dateSettlement?: Maybe<ConfidenceString>;
  deposits?: Maybe<Array<OrderAssistDeposit>>;
  loanAmount?: Maybe<ConfidenceFloat>;
  parcelId?: Maybe<Array<ConfidenceString>>;
  propertyAddress?: Maybe<OrderAssistPropertyAddress>;
  propertyState?: Maybe<ConfidenceString>;
  propertyType?: Maybe<ConfidenceString>;
  sellers?: Maybe<Array<OrderAssistParty>>;
  transactionType?: Maybe<ConfidenceString>;
};

export type OrderAssistInsightItem = {
  __typename?: 'OrderAssistInsightItem';
  createdTimestamp: Scalars['String'];
  extraction?: Maybe<OrderAssistExtraction>;
  insightId: Scalars['String'];
  status: Scalars['String'];
};

export type OrderAssistParty = {
  __typename?: 'OrderAssistParty';
  email?: Maybe<ConfidenceString>;
  entityName?: Maybe<ConfidenceString>;
  firstName?: Maybe<ConfidenceString>;
  lastName?: Maybe<ConfidenceString>;
  middleName?: Maybe<ConfidenceString>;
  phoneNumber?: Maybe<ConfidenceString>;
  phoneType?: Maybe<ConfidenceString>;
  spouse?: Maybe<OrderAssistPartySpouse>;
  suffix?: Maybe<ConfidenceString>;
  typeOfBuyerSeller: ConfidenceString;
};

export type OrderAssistPartySpouse = {
  __typename?: 'OrderAssistPartySpouse';
  email?: Maybe<ConfidenceString>;
  firstName?: Maybe<ConfidenceString>;
  lastName?: Maybe<ConfidenceString>;
  middleName?: Maybe<ConfidenceString>;
  phoneNumber?: Maybe<ConfidenceString>;
  phoneType?: Maybe<ConfidenceString>;
  suffix?: Maybe<ConfidenceString>;
};

export type OrderAssistPropertyAddress = {
  __typename?: 'OrderAssistPropertyAddress';
  address1?: Maybe<ConfidenceString>;
  address2?: Maybe<ConfidenceString>;
  city?: Maybe<ConfidenceString>;
  county?: Maybe<ConfidenceString>;
  postalCode?: Maybe<ConfidenceString>;
  state?: Maybe<ConfidenceString>;
};

export type OrderBuyerSeller = {
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']>;
  buyerSellerId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayNameMetadata?: Maybe<OverrideMetadataString>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  entityDateOfAgreement?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entityStateOfAgreement?: Maybe<Scalars['String']>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  forwardingAddress?: Maybe<Address>;
  forwardingAddressSameAsCurrentAddress?: Maybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: Maybe<Scalars['Boolean']>;
  forwardingRegion?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isForeignAddress?: Maybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  ownershipPercentage?: Maybe<Scalars['Float']>;
  ownershipPercentageMetadata?: Maybe<OverrideMetadataNumber>;
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  recordName?: Maybe<BuyerSellerRecordName>;
  representatives?: Maybe<Array<OrderBuyerSellerSoRep>>;
  representativesAllNames?: Maybe<Scalars['String']>;
  representativesAllNamesWithCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  spouse?: Maybe<OrderBuyerSellerSoRep>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  typeOfBuyerSeller?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type OrderBuyerSellerSoRep = {
  __typename?: 'OrderBuyerSellerSORep';
  alias?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isBuyer?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  refBuyerSellerId?: Maybe<Scalars['String']>;
  referencedAs?: Maybe<Scalars['String']>;
  representativeCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  soRepId?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type OrderBuyerSellerSoRepPayload = {
  __typename?: 'OrderBuyerSellerSORepPayload';
  buyerReps?: Maybe<OrderBuyerSellerSoRep>;
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  sellerReps?: Maybe<OrderBuyerSellerSoRep>;
};

export type OrderCloneResponse = {
  __typename?: 'OrderCloneResponse';
  newOrderId?: Maybe<Scalars['String']>;
  sourceCloneId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type OrderCommissionLineItemInput = {
  commissionAmount?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['ID']>;
  realEstateAgentPartyReferenceId?: InputMaybe<Scalars['String']>;
  realEstateAgentType?: InputMaybe<Scalars['String']>;
};

export type OrderCommissions = {
  __typename?: 'OrderCommissions';
  buyerPaidPercent?: Maybe<Scalars['Float']>;
  commissionBasis?: Maybe<Scalars['Float']>;
  commissionLineItems?: Maybe<Array<Maybe<CommissionLineItem>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isCommissionBasisOverride?: Maybe<Scalars['Boolean']>;
  sellerPaidPercent?: Maybe<Scalars['Float']>;
  totalCommission?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type OrderCommissionsInput = {
  buyerPaidPercent?: InputMaybe<Scalars['Float']>;
  commissionBasis?: InputMaybe<Scalars['Float']>;
  commissionLineItems?: InputMaybe<Array<InputMaybe<OrderCommissionLineItemInput>>>;
  isCommissionBasisOverride?: InputMaybe<Scalars['Boolean']>;
  itemId?: InputMaybe<Scalars['ID']>;
  sellerPaidPercent?: InputMaybe<Scalars['Float']>;
  totalCommission?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['String'];
};

export type OrderCommissionsV2 = {
  __typename?: 'OrderCommissionsV2';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  effectiveCommissions?: Maybe<EffectiveOrderCommissions>;
  id: Scalars['ID'];
  orderId: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
  userEnteredCommissions: UserEnteredCommissions;
};

export type OrderDepositLineItem = {
  __typename?: 'OrderDepositLineItem';
  dateReceived?: Maybe<Scalars['String']>;
  deductFromCommission?: Maybe<Scalars['Boolean']>;
  depositAmount?: Maybe<Scalars['Float']>;
  fundsHeldBy?: Maybe<Scalars['String']>;
  fundsHeldByName?: Maybe<Scalars['String']>;
  fundsHeldByResourceId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  receiptNumber?: Maybe<Scalars['String']>;
  typeOfFunds?: Maybe<Scalars['String']>;
};

export type OrderDepositLineItemInput = {
  dateReceived?: InputMaybe<Scalars['String']>;
  deductFromCommission?: InputMaybe<Scalars['Boolean']>;
  depositAmount?: InputMaybe<Scalars['Float']>;
  fundsHeldBy?: InputMaybe<Scalars['String']>;
  fundsHeldByName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  receiptNumber?: InputMaybe<Scalars['String']>;
  typeOfFunds?: InputMaybe<Scalars['String']>;
};

export type OrderDeposits = {
  __typename?: 'OrderDeposits';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  lineItems: Array<OrderDepositLineItem>;
  totalAmount?: Maybe<Scalars['Float']>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type OrderDocumentHistory = {
  __typename?: 'OrderDocumentHistory';
  historyTypeId: Scalars['Int'];
  message?: Maybe<Scalars['String']>;
  recordedDate: Scalars['String'];
  submessage?: Maybe<Scalars['String']>;
  userName?: Maybe<Scalars['String']>;
};

export type OrderDocumentHistoryGetRequestInput = {
  companyId: Scalars['ID'];
  documentId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
};

export type OrderDocumentMarkViewedRequestInput = {
  companyId: Scalars['ID'];
  documentId: Scalars['ID'];
  orderId: Scalars['ID'];
};

export type OrderDocumentMarkViewedResponse = {
  __typename?: 'OrderDocumentMarkViewedResponse';
  success: Scalars['Boolean'];
};

export type OrderDocumentShareItemInput = {
  documentId: Scalars['ID'];
  documentName?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['String']>;
};

export type OrderDocumentSharePartyInput = {
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  partyId: Scalars['ID'];
  partyType: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type OrderDocumentShareRequestInput = {
  companyId: Scalars['ID'];
  /** @minItems 1 */
  documents: Array<OrderDocumentShareItemInput>;
  message?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  /** @minItems 1 */
  parties: Array<OrderDocumentSharePartyInput>;
};

export type OrderDocumentShareResponse = {
  __typename?: 'OrderDocumentShareResponse';
  deactivatedParties?: Maybe<Array<Scalars['String']>>;
  employeeParties?: Maybe<Array<Scalars['String']>>;
  success: Scalars['Boolean'];
};

export type OrderDocumentStatus = {
  __typename?: 'OrderDocumentStatus';
  isIntegrationEnabled: Scalars['Boolean'];
  receivedDocuments: Array<OrderDocumentStatusItem>;
  sharedDocuments: Array<OrderDocumentStatusItem>;
};

export type OrderDocumentStatusItem = {
  __typename?: 'OrderDocumentStatusItem';
  documentId: Scalars['Int'];
  extension?: Maybe<Scalars['String']>;
  integrationDocumentId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  partyDetail?: Maybe<OrderDocumentStatusPartyDetail>;
};

export type OrderDocumentStatusPartyDetail = {
  __typename?: 'OrderDocumentStatusPartyDetail';
  companyName?: Maybe<Scalars['String']>;
  dateOpened?: Maybe<Scalars['String']>;
  dateShared?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['String']>;
  filePartyId: Scalars['Int'];
  partyName?: Maybe<Scalars['String']>;
  partyType?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type OrderDocumentStatusRequestInput = {
  companyId: Scalars['ID'];
  orderId: Scalars['ID'];
};

export enum OrderDocumentTypeV2 {
  Document = 'Document',
  Hidden = 'Hidden'
}

export type OrderHeader = {
  __typename?: 'OrderHeader';
  branch: Scalars['String'];
  businessSource?: Maybe<Scalars['String']>;
  clonedOrderSourceId?: Maybe<Scalars['ID']>;
  clonedOrderSourceOrderNumber?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  createdTimestamp: Scalars['String'];
  dateCancelled?: Maybe<Scalars['String']>;
  dateClosed?: Maybe<Scalars['String']>;
  dateOnHold?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isFeeAccount?: Maybe<Scalars['Boolean']>;
  isMasterOrder?: Maybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  orderNumber: Scalars['String'];
  propertyState?: Maybe<Scalars['String']>;
  propertyStateDetail?: Maybe<StateDetail>;
  statementType: Scalars['String'];
  status: Scalars['String'];
  tenantId: Scalars['String'];
  transactionType: TransactionType;
  updatedTimestamp: Scalars['String'];
};

export type OrderLoan = {
  __typename?: 'OrderLoan';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  dateFirstPayment?: Maybe<Scalars['DateTime']>;
  dateLoanContingency?: Maybe<Scalars['DateTime']>;
  fundingTypes?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  insuredLanguage?: Maybe<Scalars['String']>;
  interestRate?: Maybe<Scalars['Float']>;
  interestType?: Maybe<Scalars['String']>;
  loanAmount?: Maybe<Scalars['Float']>;
  loanNumber?: Maybe<Scalars['String']>;
  loanPurpose?: Maybe<Scalars['String']>;
  loanTerm?: Maybe<Scalars['Float']>;
  loanTermIdentifier?: Maybe<Scalars['String']>;
  mers?: Maybe<Scalars['String']>;
  mersMin?: Maybe<Scalars['String']>;
  monthlyMip?: Maybe<Scalars['Float']>;
  mortgageInsurance?: Maybe<Scalars['String']>;
  mortgageInsuranceCaseNumber?: Maybe<Scalars['String']>;
  mortgageType?: Maybe<Scalars['String']>;
  mortgageTypeOtherDescription?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  principalAndInterestAmount?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type OrderLoanInput = {
  dateFirstPayment?: InputMaybe<Scalars['DateTime']>;
  dateLoanContingency?: InputMaybe<Scalars['DateTime']>;
  fundingTypes?: InputMaybe<Scalars['String']>;
  insuredLanguage?: InputMaybe<Scalars['String']>;
  interestRate?: InputMaybe<Scalars['Float']>;
  interestType?: InputMaybe<Scalars['String']>;
  loanAmount?: InputMaybe<Scalars['Float']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  loanPurpose?: InputMaybe<Scalars['String']>;
  loanTerm?: InputMaybe<Scalars['Float']>;
  loanTermIdentifier?: InputMaybe<Scalars['String']>;
  mers?: InputMaybe<Scalars['String']>;
  mersMin?: InputMaybe<Scalars['String']>;
  monthlyMip?: InputMaybe<Scalars['Float']>;
  mortgageInsurance?: InputMaybe<Scalars['String']>;
  mortgageInsuranceCaseNumber?: InputMaybe<Scalars['String']>;
  mortgageType?: InputMaybe<Scalars['String']>;
  mortgageTypeOtherDescription?: InputMaybe<Scalars['String']>;
  principalAndInterestAmount?: InputMaybe<Scalars['Float']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type OrderMain = {
  __typename?: 'OrderMain';
  /** Amount of Initial Draw */
  amountInitialDraw?: Maybe<Scalars['Float']>;
  /**
   * (Deprecated) Amount of Loan
   * @deprecated Use OrderLoan
   */
  amountLoan?: Maybe<Scalars['Float']>;
  /** Amount of Sale */
  amountSale?: Maybe<Scalars['Float']>;
  /** Closing Location */
  closingLocation?: Maybe<Address>;
  /** Time of record creation */
  createdTimestamp?: Maybe<Scalars['String']>;
  /** Date of Disbursement */
  dateDisbursement?: Maybe<Scalars['String']>;
  /** Date of Funding */
  dateFunding?: Maybe<Scalars['String']>;
  /** Date of Rescission */
  dateRecission?: Maybe<Scalars['String']>;
  /** Date of the Settlement */
  dateSettlement?: Maybe<Scalars['String']>;
  /** ID of the Order */
  id: Scalars['ID'];
  /** Other Reference Number */
  otherReferenceNumber?: Maybe<Scalars['String']>;
  /** Staff associated to Order */
  staff?: Maybe<Array<Maybe<OrderStaff>>>;
  /** Time of the Settlement */
  timeSettlement?: Maybe<Scalars['String']>;
  /** Underwriter */
  underwriter?: Maybe<Underwriter>;
  /** ID of Underwriter */
  underwriterId?: Maybe<Scalars['String']>;
  /** Time of last update - needed to update Main */
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type OrderPiq = {
  __typename?: 'OrderPIQ';
  acreage?: Maybe<Scalars['String']>;
  address?: Maybe<Address>;
  airResourcesBoardNumber?: Maybe<Scalars['String']>;
  appraisedValue?: Maybe<Scalars['String']>;
  assessedValue?: Maybe<Scalars['String']>;
  assessorsParcelNumbers?: Maybe<Array<Maybe<Scalars['String']>>>;
  block?: Maybe<Scalars['String']>;
  boatslip?: Maybe<Scalars['String']>;
  book?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  carport?: Maybe<Scalars['String']>;
  commonElementOwnership?: Maybe<Scalars['String']>;
  condominiumName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  displayPropertyType?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  firstTimeBuyer?: Maybe<Scalars['Boolean']>;
  garage?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  instrumentNumber?: Maybe<Scalars['String']>;
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  legalDescriptionBriefHtml?: Maybe<Scalars['String']>;
  legalDescriptionBriefMergeable?: Maybe<Scalars['String']>;
  legalDescriptionFull?: Maybe<Scalars['String']>;
  legalDescriptionFullMergeable?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  mapNumber?: Maybe<Scalars['String']>;
  mudName?: Maybe<Scalars['String']>;
  municipalityName?: Maybe<Scalars['String']>;
  municipalityType?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  outlot?: Maybe<Scalars['String']>;
  ownerOccupied?: Maybe<Scalars['Boolean']>;
  page?: Maybe<Scalars['String']>;
  parcel?: Maybe<Scalars['String']>;
  parkingSpace?: Maybe<Scalars['String']>;
  part?: Maybe<Scalars['String']>;
  phase?: Maybe<Scalars['String']>;
  platName?: Maybe<Scalars['String']>;
  propertyDetailsGroup?: Maybe<Scalars['String']>;
  propertyParcelNumbersAll?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  pudName?: Maybe<Scalars['String']>;
  q1Q3?: Maybe<Scalars['String']>;
  range?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  storage?: Maybe<Scalars['String']>;
  subdivisionName?: Maybe<Scalars['String']>;
  townhouse?: Maybe<Scalars['String']>;
  township?: Maybe<Scalars['String']>;
  tract?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  ward?: Maybe<Scalars['String']>;
};

export type OrderPiqInput = {
  acreage?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<AddressInput>;
  airResourcesBoardNumber?: InputMaybe<Scalars['String']>;
  appraisedValue?: InputMaybe<Scalars['String']>;
  assessedValue?: InputMaybe<Scalars['String']>;
  assessorsParcelNumbers?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  block?: InputMaybe<Scalars['String']>;
  boatslip?: InputMaybe<Scalars['String']>;
  book?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  carport?: InputMaybe<Scalars['String']>;
  commonElementOwnership?: InputMaybe<Scalars['String']>;
  condominiumName?: InputMaybe<Scalars['String']>;
  displayPropertyType?: InputMaybe<Scalars['String']>;
  district?: InputMaybe<Scalars['String']>;
  firstTimeBuyer?: InputMaybe<Scalars['Boolean']>;
  garage?: InputMaybe<Scalars['String']>;
  instrumentNumber?: InputMaybe<Scalars['String']>;
  legalDescriptionBrief?: InputMaybe<Scalars['String']>;
  legalDescriptionBriefHtml?: InputMaybe<Scalars['String']>;
  legalDescriptionFull?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  mapNumber?: InputMaybe<Scalars['String']>;
  mudName?: InputMaybe<Scalars['String']>;
  municipalityName?: InputMaybe<Scalars['String']>;
  municipalityType?: InputMaybe<Scalars['String']>;
  outlot?: InputMaybe<Scalars['String']>;
  ownerOccupied?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['String']>;
  parcel?: InputMaybe<Scalars['String']>;
  parkingSpace?: InputMaybe<Scalars['String']>;
  part?: InputMaybe<Scalars['String']>;
  phase?: InputMaybe<Scalars['String']>;
  platName?: InputMaybe<Scalars['String']>;
  propertyDetailsGroup?: InputMaybe<Scalars['String']>;
  propertyType?: InputMaybe<Scalars['String']>;
  pudName?: InputMaybe<Scalars['String']>;
  q1Q3?: InputMaybe<Scalars['String']>;
  range?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  storage?: InputMaybe<Scalars['String']>;
  subdivisionName?: InputMaybe<Scalars['String']>;
  townhouse?: InputMaybe<Scalars['String']>;
  township?: InputMaybe<Scalars['String']>;
  tract?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  ward?: InputMaybe<Scalars['String']>;
};

/** This is the complete result structure of an Order Party */
export type OrderParty = {
  __typename?: 'OrderParty';
  company?: Maybe<PartyCompany>;
  contact?: Maybe<PartyContact>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isSettlementUseOnly?: Maybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  /** ID from api used to resolve ID! */
  partyId: Scalars['ID'];
  refSectionId?: Maybe<Scalars['String']>;
  refSectionLabel?: Maybe<Scalars['String']>;
  roleId: Scalars['String'];
  roleName?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

/** This is the input structure for creating or updating an OrderParty through the updateOrder Mutation - deprecated (Use CreateOrderPartyInput or UpdateOrderPartyInput instead) */
export type OrderPartyInput = {
  company?: InputMaybe<CompanyPartialInput>;
  contact?: InputMaybe<ContactPartialInput>;
  createdBy?: InputMaybe<Scalars['String']>;
  createdTimestamp?: InputMaybe<Scalars['String']>;
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  partyId?: InputMaybe<Scalars['String']>;
  refSectionId?: InputMaybe<Scalars['String']>;
  refSectionLabel?: InputMaybe<Scalars['String']>;
  roleId?: InputMaybe<Scalars['String']>;
  updatedBy?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type OrderPartyInviteRequestInput = {
  companyId: Scalars['ID'];
  orderId: Scalars['ID'];
  /** @minItems 1 */
  parties: Array<OrderPartyInviteeInput>;
};

export type OrderPartyInviteeInput = {
  companyName?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  partyId: Scalars['ID'];
  partyType: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
};

export type OrderPartyPayLoad = {
  __typename?: 'OrderPartyPayLoad';
  party?: Maybe<OrderParty>;
};

export type OrderPartyRemoveRequestInput = {
  companyId: Scalars['ID'];
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
};

export type OrderPayload = {
  __typename?: 'OrderPayload';
  order?: Maybe<Order>;
};

export type OrderResponse = {
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
};

export type OrderStaff = {
  __typename?: 'OrderStaff';
  roleId?: Maybe<Scalars['String']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']>;
};

export type OrderStaffInput = {
  roleId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type OrderSummary = Node & {
  __typename?: 'OrderSummary';
  addresses?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  branchName?: Maybe<Scalars['String']>;
  buyerNames?: Maybe<Scalars['String']>;
  buyersDisplayName?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  createdByName?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lenderNames?: Maybe<Scalars['String']>;
  loanAmounts?: Maybe<Scalars['String']>;
  loanNumbers?: Maybe<Scalars['String']>;
  masterOrder?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  salesPrice?: Maybe<Scalars['String']>;
  sellerNames?: Maybe<Scalars['String']>;
  sellersDisplayName?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  transactionTypeName?: Maybe<Scalars['String']>;
  underwriterName?: Maybe<Scalars['String']>;
};

export type OrderSummaryConnection = {
  __typename?: 'OrderSummaryConnection';
  edges?: Maybe<Array<Maybe<OrderSummaryEdge>>>;
  pageInfo?: Maybe<PageInfo>;
};

export type OrderSummaryEdge = {
  __typename?: 'OrderSummaryEdge';
  node?: Maybe<OrderSummary>;
};

export enum OrderSummaryField {
  Addresses = 'addresses',
  BranchName = 'branchName',
  BuyerNames = 'buyerNames',
  BuyersDisplayName = 'buyersDisplayName',
  CompanyName = 'companyName',
  CreatedByName = 'createdByName',
  CreatedTimestamp = 'createdTimestamp',
  DisbursementDate = 'disbursementDate',
  LenderNames = 'lenderNames',
  LoanAmounts = 'loanAmounts',
  LoanNumbers = 'loanNumbers',
  MasterOrder = 'masterOrder',
  OrderNumber = 'orderNumber',
  SalesPrice = 'salesPrice',
  SellerNames = 'sellerNames',
  SellersDisplayName = 'sellersDisplayName',
  SettlementDate = 'settlementDate',
  Status = 'status',
  TransactionTypeName = 'transactionTypeName',
  UnderwriterName = 'underwriterName'
}

export type OrderSummaryFilter = {
  field: OrderSummaryField;
  operator: ApiFilterOperator;
  value: Scalars['String'];
};

export type OrderTaskInput = {
  active: Scalars['Boolean'];
  assignment: TaskAssignmentInput;
  completedBy?: InputMaybe<Scalars['String']>;
  completedTimestamp?: InputMaybe<Scalars['String']>;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<TaskDueInput>;
  dueDate?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  sortIndex: Scalars['Int'];
  start?: InputMaybe<TaskStartInput>;
  startDate?: InputMaybe<Scalars['String']>;
  status: Scalars['String'];
  timeTracking?: InputMaybe<TaskTimeTrackingInput>;
  type: Scalars['String'];
};

export type OrderTitleCplProductInput = {
  additionalFields?: InputMaybe<Scalars['JSONObject']>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  agentRetainedV2?: InputMaybe<DollarsPercentInput>;
  agentRetainedV2Override?: InputMaybe<DollarsPercentInput>;
  amount?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  closingAttorney?: InputMaybe<Scalars['String']>;
  coveredParty: Scalars['String'];
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  effectiveDateOverride?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  letterType: Scalars['String'];
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status: Scalars['String'];
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  underwriterRemittedV2?: InputMaybe<DollarsPercentInput>;
  underwriterRemittedV2Override?: InputMaybe<DollarsPercentInput>;
  updatedTimestamp: Scalars['String'];
};

export type OutgoingWire = {
  __typename?: 'OutgoingWire';
  amountCents?: Maybe<Scalars['SafeInt']>;
  beneficiary?: Maybe<WireBeneficiary>;
  createdTimestamp?: Maybe<Scalars['String']>;
  deletedTimestamp?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  fedConfirmation?: Maybe<FedConfirmation>;
  initiatorId?: Maybe<Scalars['String']>;
  isDeleted?: Maybe<Scalars['Boolean']>;
  obiLine1?: Maybe<Scalars['String']>;
  obiLine2?: Maybe<Scalars['String']>;
  obiLine3?: Maybe<Scalars['String']>;
  obiLine4?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  originator?: Maybe<WireOriginator>;
  reference: Scalars['String'];
  requester?: Maybe<User>;
  statusBucket?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transmitterId?: Maybe<Scalars['String']>;
  transmitterTimestamp?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  validatedTimestamp?: Maybe<Scalars['String']>;
  validationStatus?: Maybe<Scalars['String']>;
  version?: Maybe<Scalars['Int']>;
  wireStatus?: Maybe<WireStatus>;
};

/** One entry in an outgoing wire's lifecycle history; user is the acting user (null for system changes), reason holds rejection detail. */
export type OutgoingWireHistoryEntry = {
  __typename?: 'OutgoingWireHistoryEntry';
  eventType: OutgoingWireHistoryEventType;
  reason?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
  user?: Maybe<User>;
};

export enum OutgoingWireHistoryEventType {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Initiated = 'INITIATED',
  ProceededWithoutValidation = 'PROCEEDED_WITHOUT_VALIDATION',
  Rejected = 'REJECTED',
  Sent = 'SENT',
  Transmitted = 'TRANSMITTED',
  Validated = 'VALIDATED',
  ValidationFailed = 'VALIDATION_FAILED'
}

/** Paginated/filterable/sortable read input for the outgoing wires grid (SSRM; no total count). */
export type OutgoingWireTableDataInput = {
  escrowAccountId: Scalars['String'];
  filters?: InputMaybe<Array<WireDataFilterInput>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Array<WireSortColumnInput>>;
};

/** Outgoing wire table-data response envelope (no total count; SSRM block semantics). */
export type OutgoingWireTableDataResponse = {
  __typename?: 'OutgoingWireTableDataResponse';
  data: Array<OutgoingWire>;
};

export type OverrideMetadataDollarsPercent = {
  __typename?: 'OverrideMetadataDollarsPercent';
  effectiveValue?: Maybe<DollarsPercent>;
  fallbackValue?: Maybe<DollarsPercent>;
  overridden: Scalars['Boolean'];
  overrideValue?: Maybe<DollarsPercent>;
};

export type OverrideMetadataNumber = {
  __typename?: 'OverrideMetadataNumber';
  effectiveValue?: Maybe<Scalars['Float']>;
  fallbackValue?: Maybe<Scalars['Float']>;
  overridden: Scalars['Boolean'];
  overrideValue?: Maybe<Scalars['Float']>;
};

export type OverrideMetadataString = {
  __typename?: 'OverrideMetadataString';
  effectiveValue?: Maybe<Scalars['String']>;
  fallbackValue?: Maybe<Scalars['String']>;
  overridden: Scalars['Boolean'];
  overrideValue?: Maybe<Scalars['String']>;
};

export type OverwriteEntityDocumentV2Input = {
  compression?: InputMaybe<OverwriteEntityDocumentV2InputCompression>;
  cryptoKey: FileCryptoKeyV2Input;
  documentId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  fileSize: Scalars['Float'];
  fileType: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
};

export enum OverwriteEntityDocumentV2InputCompression {
  Gzip = 'gzip'
}

export type OverwriteTemplateV2Input = {
  compression?: InputMaybe<OverwriteTemplateV2InputCompression>;
  cryptoKey?: InputMaybe<FileCryptoKeyV2Input>;
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  fileSize: Scalars['Float'];
  fileType: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
};

export enum OverwriteTemplateV2InputCompression {
  Gzip = 'gzip'
}

export type OwnerLenderDisclosureFeeAdditionalData = {
  __typename?: 'OwnerLenderDisclosureFeeAdditionalData';
  derivedActualAmount?: Maybe<Scalars['Float']>;
  externalLenderPremiumId?: Maybe<Scalars['String']>;
  externalOwnerPremiumId?: Maybe<Scalars['String']>;
  liabilityAmount?: Maybe<Scalars['Float']>;
};

export type PaPhiladelphiaEntityTaxForm = {
  __typename?: 'PaPhiladelphiaEntityTaxForm';
  propertyParcelNumbers?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<PaPhiladelphiaEntityTaxFormSeller>>>;
  settlementAgent?: Maybe<PaPhiladelphiaEntityTaxFormSettlementAgent>;
  staffName?: Maybe<Scalars['String']>;
};

export type PaPhiladelphiaEntityTaxFormAddress = {
  __typename?: 'PaPhiladelphiaEntityTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PaPhiladelphiaEntityTaxFormSeller = {
  __typename?: 'PaPhiladelphiaEntityTaxFormSeller';
  address?: Maybe<PaPhiladelphiaEntityTaxFormAddress>;
  dateOfAgreement?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
};

export type PaPhiladelphiaEntityTaxFormSettlementAgent = {
  __typename?: 'PaPhiladelphiaEntityTaxFormSettlementAgent';
  address?: Maybe<PaPhiladelphiaEntityTaxFormAddress>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PaPhiladelphiaTransferTaxForm = {
  __typename?: 'PaPhiladelphiaTransferTaxForm';
  buyer?: Maybe<PaPhiladelphiaTransferTaxFormBuyer>;
  buyerAllNames?: Maybe<Scalars['String']>;
  clrFactor?: Maybe<Scalars['Float']>;
  computedValue?: Maybe<Scalars['Float']>;
  property?: Maybe<PaPhiladelphiaTransferTaxFormProperty>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<PaPhiladelphiaTransferTaxFormSeller>>>;
  settlementAgent?: Maybe<PaPhiladelphiaTransferTaxFormSettlementAgent>;
  settlementDate?: Maybe<Scalars['String']>;
  staffName?: Maybe<Scalars['String']>;
};

export type PaPhiladelphiaTransferTaxFormAddress = {
  __typename?: 'PaPhiladelphiaTransferTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PaPhiladelphiaTransferTaxFormBuyer = {
  __typename?: 'PaPhiladelphiaTransferTaxFormBuyer';
  address?: Maybe<PaPhiladelphiaTransferTaxFormAddress>;
};

export type PaPhiladelphiaTransferTaxFormProperty = {
  __typename?: 'PaPhiladelphiaTransferTaxFormProperty';
  assessedValue?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  propertyParcelNumbers?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type PaPhiladelphiaTransferTaxFormSeller = {
  __typename?: 'PaPhiladelphiaTransferTaxFormSeller';
  address?: Maybe<PaPhiladelphiaTransferTaxFormAddress>;
  name?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
};

export type PaPhiladelphiaTransferTaxFormSettlementAgent = {
  __typename?: 'PaPhiladelphiaTransferTaxFormSettlementAgent';
  address?: Maybe<PaPhiladelphiaTransferTaxFormAddress>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PaRev183TransferTaxForm = {
  __typename?: 'PaRev183TransferTaxForm';
  buyer?: Maybe<PaRev183TransferTaxFormBuyer>;
  clrFactor?: Maybe<Scalars['Float']>;
  computedValue?: Maybe<Scalars['Float']>;
  property?: Maybe<PaRev183TransferTaxFormProperty>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<PaRev183TransferTaxFormSeller>>>;
  settlementAgent?: Maybe<PaRev183TransferTaxFormSettlementAgent>;
  settlementDate?: Maybe<Scalars['String']>;
  staffName?: Maybe<Scalars['String']>;
};

export type PaRev183TransferTaxFormAddress = {
  __typename?: 'PaRev183TransferTaxFormAddress';
  city?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type PaRev183TransferTaxFormBuyer = {
  __typename?: 'PaRev183TransferTaxFormBuyer';
  address?: Maybe<PaRev183TransferTaxFormAddress>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PaRev183TransferTaxFormProperty = {
  __typename?: 'PaRev183TransferTaxFormProperty';
  assessedValue?: Maybe<Scalars['Float']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  district?: Maybe<Scalars['String']>;
  propertyParcelNumbers?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type PaRev183TransferTaxFormSeller = {
  __typename?: 'PaRev183TransferTaxFormSeller';
  address?: Maybe<PaRev183TransferTaxFormAddress>;
  name?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type PaRev183TransferTaxFormSettlementAgent = {
  __typename?: 'PaRev183TransferTaxFormSettlementAgent';
  address?: Maybe<PaRev183TransferTaxFormAddress>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type Package = {
  __typename?: 'Package';
  associatedReceiptDocumentId?: Maybe<Scalars['ID']>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  documentStatuses?: Maybe<Array<SubmitPackageResponseDocumentStatus>>;
  epnOrderId?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  isDeleted: Scalars['Boolean'];
  lastPolledTimestamp?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  packageLink?: Maybe<SubmitPackageResponsePackageLink>;
  packageName: Scalars['String'];
  packageStatus: PackageStatusInfo;
  submitImmediately: Scalars['Boolean'];
  submittedTimestamp?: Maybe<Scalars['String']>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type PackageDataCore = {
  __typename?: 'PackageDataCore';
  collectedDisclosureAmounts?: Maybe<Array<PackageResponseCollectedDisclosureAmounts>>;
  documents?: Maybe<Array<PackageDocument>>;
  id?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['ID']>;
  packageData?: Maybe<Array<DataField>>;
  packageName?: Maybe<Scalars['String']>;
  recordingJurisdiction?: Maybe<RecordingJurisdiction>;
  requestingParty?: Maybe<Scalars['String']>;
  stateRequirements?: Maybe<StateRequirements>;
  submitImmediately?: Maybe<Scalars['Boolean']>;
  userEmailAddress?: Maybe<Scalars['String']>;
};

export type PackageDocument = {
  __typename?: 'PackageDocument';
  associatedDocuments?: Maybe<Array<AssociatedDocument>>;
  certificateNumbers?: Maybe<Array<Scalars['String']>>;
  consideration?: Maybe<Consideration>;
  displayName?: Maybe<Scalars['String']>;
  documentData?: Maybe<Array<DataField>>;
  documentId?: Maybe<Scalars['ID']>;
  documentSequenceIdentifier?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
  parties?: Maybe<Array<Party>>;
  property?: Maybe<Property>;
  propertyType?: Maybe<Scalars['String']>;
};

export type PackageDocumentInput = {
  associatedDocuments?: InputMaybe<Array<AssociatedDocumentInput>>;
  certificateNumbers?: InputMaybe<Array<Scalars['String']>>;
  consideration?: InputMaybe<ConsiderationInput>;
  displayName?: InputMaybe<Scalars['String']>;
  documentData?: InputMaybe<Array<DataFieldInput>>;
  documentId?: InputMaybe<Scalars['ID']>;
  documentSequenceIdentifier?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  executionDate?: InputMaybe<Scalars['String']>;
  parties?: InputMaybe<Array<PartyInput>>;
  property?: InputMaybe<PropertyInput>;
  propertyType?: InputMaybe<Scalars['String']>;
};

export type PackageResponseCollectedDisclosureAmounts = {
  __typename?: 'PackageResponseCollectedDisclosureAmounts';
  feeAmount?: Maybe<Scalars['Float']>;
  feeType?: Maybe<Scalars['String']>;
};

export type PackageResponseCollectedDisclosureAmountsInput = {
  feeAmount?: InputMaybe<Scalars['Float']>;
  feeType?: InputMaybe<Scalars['String']>;
};

export type PackageResponseFee = {
  __typename?: 'PackageResponseFee';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PackageResponseRecordingEndorsement = {
  __typename?: 'PackageResponseRecordingEndorsement';
  fees?: Maybe<Array<PackageResponseFee>>;
  instrumentNumber?: Maybe<Scalars['String']>;
  officerName?: Maybe<Scalars['String']>;
  page?: Maybe<Scalars['String']>;
  pageCount?: Maybe<Scalars['Float']>;
  recordedDate?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['Float']>;
  volume?: Maybe<Scalars['String']>;
};

export enum PackageStatus {
  AnpDraft = 'AnpDraft',
  AtCounty = 'AtCounty',
  Draft = 'Draft',
  Error = 'Error',
  NotFound = 'NotFound',
  Preparing = 'Preparing',
  Ready = 'Ready',
  Received = 'Received',
  Recorded = 'Recorded',
  Rejected = 'Rejected',
  Retrieving = 'Retrieving',
  Sending = 'Sending',
  Submitted = 'Submitted'
}

export type PackageStatusInfo = {
  __typename?: 'PackageStatusInfo';
  createdTimestamp: Scalars['String'];
  status: PackageStatus;
  statusMessage?: Maybe<Scalars['String']>;
};

export type PackageStatusSnapshotData = {
  __typename?: 'PackageStatusSnapshotData';
  collectedDisclosureAmounts?: Maybe<Array<PackageResponseCollectedDisclosureAmounts>>;
  documentStatuses?: Maybe<Array<SubmitPackageResponseDocumentStatus>>;
  documents?: Maybe<Array<PackageStatusSnapshotDocument>>;
  epnOrderId?: Maybe<Scalars['ID']>;
  id?: Maybe<Scalars['ID']>;
  orderId?: Maybe<Scalars['ID']>;
  packageData?: Maybe<Array<DataField>>;
  packageLink?: Maybe<SubmitPackageResponsePackageLink>;
  packageName?: Maybe<Scalars['String']>;
  recordingJurisdiction?: Maybe<RecordingJurisdiction>;
  requestingParty?: Maybe<Scalars['String']>;
  stateRequirements?: Maybe<StateRequirements>;
  submitImmediately?: Maybe<Scalars['Boolean']>;
  userEmailAddress?: Maybe<Scalars['String']>;
};

export type PackageStatusSnapshotDocument = {
  __typename?: 'PackageStatusSnapshotDocument';
  associatedDocuments?: Maybe<Array<AssociatedDocument>>;
  certificateNumbers?: Maybe<Array<Scalars['String']>>;
  consideration?: Maybe<Consideration>;
  displayName?: Maybe<Scalars['String']>;
  documentData?: Maybe<Array<DataField>>;
  documentId?: Maybe<Scalars['ID']>;
  documentSequenceIdentifier?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  executionDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  parties?: Maybe<Array<Party>>;
  property?: Maybe<Property>;
  propertyType?: Maybe<Scalars['String']>;
  recordingEndorsement?: Maybe<PackageResponseRecordingEndorsement>;
  rejectionReasons?: Maybe<Array<Scalars['String']>>;
  status?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export enum PackageStatusSnapshotType {
  PackageStructure = 'PACKAGE_STRUCTURE',
  StatusEvent = 'STATUS_EVENT',
  UserDraft = 'USER_DRAFT'
}

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export type PaginatedEntityDocumentsQueryV2Input = {
  after?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  first?: InputMaybe<Scalars['Int']>;
  scopeId?: InputMaybe<Scalars['ID']>;
};

export type PaginatedEntityDocumentsV2 = {
  __typename?: 'PaginatedEntityDocumentsV2';
  documents?: Maybe<Array<EntityDocumentV2>>;
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export enum PaginatedQueryFilterOperatorV2 {
  Begins = 'begins',
  Contains = 'contains',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq',
  NotContains = 'notContains',
  Size = 'size'
}

export type PaginatedQueryFilterV2Input = {
  field: Scalars['String'];
  operator: PaginatedQueryFilterOperatorV2;
  shouldFilterEmpty?: InputMaybe<Scalars['Boolean']>;
  sizeOperator?: InputMaybe<PaginatedQuerySizeOperatorV2>;
  value: Scalars['String'];
};

export enum PaginatedQuerySizeOperatorV2 {
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte',
  Neq = 'neq'
}

export type PaginatedRecordingDocument = {
  __typename?: 'PaginatedRecordingDocument';
  actualFees?: Maybe<Scalars['Float']>;
  associatedDocumentId?: Maybe<Scalars['ID']>;
  associatedDocumentType?: Maybe<Scalars['String']>;
  associatedRFTTDocumentId?: Maybe<Scalars['ID']>;
  associatedReturnDocumentId?: Maybe<Scalars['ID']>;
  book?: Maybe<Scalars['String']>;
  collectedFees?: Maybe<Scalars['Float']>;
  considerationAmount?: Maybe<Scalars['Float']>;
  considerationAmountOverrideMetadata: NumberOverrideMetadata;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  description: Scalars['String'];
  documentDate?: Maybe<Scalars['String']>;
  documentTime?: Maybe<Scalars['String']>;
  documentType: Scalars['String'];
  documentTypeDisplayName?: Maybe<Scalars['String']>;
  documentTypeOverrideMetadata: StringOverrideMetadata;
  id: Scalars['ID'];
  instrumentNumber?: Maybe<Scalars['String']>;
  isAssociatedRFTTDocumentDeleted: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isERecorded: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  isUserUpdated: Scalars['Boolean'];
  name: Scalars['String'];
  nameOverrideMetadata: StringOverrideMetadata;
  orderId: Scalars['ID'];
  page?: Maybe<Scalars['String']>;
  pageCount?: Maybe<Scalars['String']>;
  pageCountOverrideMetadata: StringOverrideMetadata;
  recordedDate?: Maybe<Scalars['String']>;
  recordedTime?: Maybe<Scalars['String']>;
  updatedBy: UserDisplayName;
  updatedTimestamp: Scalars['String'];
};

export type PaginatedRecordingDocuments = {
  __typename?: 'PaginatedRecordingDocuments';
  documents?: Maybe<Array<PaginatedRecordingDocument>>;
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
};

export type PaginatedRecordingDocumentsQueryInput = {
  after?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  showDisplayName?: InputMaybe<Scalars['Boolean']>;
};

export type PaginatedTemplateSetQueryV2Input = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<PaginatedQueryFilterV2Input>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type PaginatedTemplateSetsV2 = {
  __typename?: 'PaginatedTemplateSetsV2';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  sets?: Maybe<Array<TemplateSetV2>>;
};

export type PaginatedTemplatesQueryV2Input = {
  after?: InputMaybe<Scalars['String']>;
  documentType: TemplateDocTypeV2;
  filters?: InputMaybe<Array<PaginatedQueryFilterV2Input>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};

export type PaginatedTemplatesV2 = {
  __typename?: 'PaginatedTemplatesV2';
  endCursor?: Maybe<Scalars['String']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  templates?: Maybe<Array<TemplateDocV2>>;
};

export type ParameterError = {
  __typename?: 'ParameterError';
  fieldName: Scalars['String'];
  issue: Scalars['String'];
  message: Scalars['String'];
};

export type ParameterValidation = {
  __typename?: 'ParameterValidation';
  errorFields: Array<ParameterError>;
};

export type Party = {
  __typename?: 'Party';
  address?: Maybe<Address>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  nonPersonIndicator?: Maybe<Scalars['Boolean']>;
  subType?: Maybe<Scalars['String']>;
  suffix?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  unparsedName?: Maybe<Scalars['String']>;
};

/** PartyCompany, one component of an OrderParty */
export type PartyCompany = {
  __typename?: 'PartyCompany';
  addresses?: Maybe<Array<Maybe<Address>>>;
  altaId?: Maybe<Scalars['String']>;
  alternateSearchName?: Maybe<Scalars['String']>;
  companyName?: Maybe<Scalars['String']>;
  companyTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** If the PartyCompany was copied from the Directory, then directoryCompanyReferenceId will hold the Directory's Company ID */
  directoryCompanyReferenceId?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  lenderLanguage?: Maybe<Scalars['String']>;
  lenderLanguageDefaultType?: Maybe<Scalars['String']>;
  lenderLanguageOptions?: Maybe<LenderLanguageOptionsType>;
  licenses?: Maybe<Array<Maybe<License>>>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  /** If the PartyCompany was copied from the Tenant Hierarchy, then tenantOrgReferenceId will hold the Org ID (usually a Branch) */
  tenantOrgReferenceId?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
  wireInstructions?: Maybe<WireSchema>;
};

/** Input for a PartyCompany, used for both creating and updating */
export type PartyCompanyInput = {
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['String']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  directoryCompanyReferenceId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  lenderLanguage?: InputMaybe<Scalars['String']>;
  lenderLanguageDefaultType?: InputMaybe<Scalars['String']>;
  lenderLanguageOptions?: InputMaybe<LenderLanguageOptionsInput>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  tenantOrgReferenceId?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

/** PartyContact, one component of an OrderParty */
export type PartyContact = {
  __typename?: 'PartyContact';
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  /** If the PartyContact was copied from the Directory, then directoryContactReferenceId will hold the Directory's Contact ID */
  directoryContactReferenceId?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  licenses?: Maybe<Array<Maybe<License>>>;
  middleName?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  suffix?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  useCompanyAddress?: Maybe<Scalars['Boolean']>;
  /** If the PartyContact was copied from the Users list, then userReferenceId will hold the User ID */
  userReferenceId?: Maybe<Scalars['String']>;
};

/** Input for a PartyContact, used for both creating and updating */
export type PartyContactInput = {
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  directoryContactReferenceId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  middleName?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
  userReferenceId?: InputMaybe<Scalars['String']>;
};

export type PartyInput = {
  address?: InputMaybe<AddressInput>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  nonPersonIndicator?: InputMaybe<Scalars['Boolean']>;
  subType?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  unparsedName?: InputMaybe<Scalars['String']>;
};

export type PartySelection = {
  __typename?: 'PartySelection';
  party?: Maybe<OrderParty>;
};

export type PasteConversionResponse = {
  __typename?: 'PasteConversionResponse';
  error?: Maybe<PasteErrorBody>;
  tracking?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type PasteErrorBody = {
  __typename?: 'PasteErrorBody';
  data?: Maybe<PasteErrorBodyData>;
  errorCode?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
};

export type PasteErrorBodyData = {
  __typename?: 'PasteErrorBodyData';
  templateBlockName?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PatchSellerSpouseResponse = OrderResponse & {
  __typename?: 'PatchSellerSpouseResponse';
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  spouse?: Maybe<OrderBuyerSellerSoRep>;
};

export enum PaymentOption {
  Collect = 'COLLECT',
  Receiver = 'RECEIVER',
  Sender = 'SENDER',
  ThirdParty = 'THIRD_PARTY'
}

export type Payoff = {
  __typename?: 'Payoff';
  additionalDaysAfterDisbursement?: Maybe<Scalars['Int']>;
  additionalFees?: Maybe<Array<Maybe<PayoffAdditionalFee>>>;
  appendedDescription?: Maybe<Scalars['String']>;
  asOfDate?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isDefault?: Maybe<Scalars['Boolean']>;
  lender?: Maybe<OrderParty>;
  lenderPartyId?: Maybe<Scalars['String']>;
  loanNumber?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  paidBy?: Maybe<Scalars['String']>;
  perDiemInterestAmount?: Maybe<Scalars['Float']>;
  principalBalance?: Maybe<Scalars['Float']>;
  totalAdditionalInterest?: Maybe<Scalars['Float']>;
  totalAdditionalInterestOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type PayoffAdditionalFee = {
  __typename?: 'PayoffAdditionalFee';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type PermissionDefinition = {
  __typename?: 'PermissionDefinition';
  key: Scalars['String'];
  prerequisites?: Maybe<Scalars['JSONObject']>;
  type: Scalars['String'];
};

export type PermissionsRule = {
  __typename?: 'PermissionsRule';
  key: Scalars['String'];
  prerequisites?: Maybe<Prerequisites>;
};

export type PermissionsRuleSet = {
  __typename?: 'PermissionsRuleSet';
  name: Scalars['String'];
  permissionsRules: Array<PermissionsRule>;
  sortOrder: Scalars['Int'];
};

export type PermissionsRuleSets = {
  __typename?: 'PermissionsRuleSets';
  adminPermissionsRuleSets: Array<PermissionsRuleSet>;
  applicationPermissionsRuleSets: Array<PermissionsRuleSet>;
};

export type Phone = {
  __typename?: 'Phone';
  extension?: Maybe<Scalars['String']>;
  phoneNumber: Scalars['String'];
  phoneNumberFull?: Maybe<Scalars['String']>;
  phoneType: Scalars['String'];
};

export type PhoneNumberInput = {
  ext?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  type: Scalars['String'];
};

export type PhoneNumberType = {
  __typename?: 'PhoneNumberType';
  ext?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  phoneNumberFull?: Maybe<Scalars['String']>;
  type: Scalars['String'];
};

export type PlacePrediction = {
  __typename?: 'PlacePrediction';
  place: Scalars['String'];
  placeId: Scalars['String'];
  structuredFormat: PlacePredictionStructuredFormat;
  text: PlacePredictionText;
  types: Array<Scalars['String']>;
};

export type PlacePredictionSecondaryText = {
  __typename?: 'PlacePredictionSecondaryText';
  text: Scalars['String'];
};

export type PlacePredictionStructuredFormat = {
  __typename?: 'PlacePredictionStructuredFormat';
  mainText: PlacePredictionText;
  secondaryText: PlacePredictionSecondaryText;
};

export type PlacePredictionText = {
  __typename?: 'PlacePredictionText';
  matches: Array<PlacePredictionTextMatch>;
  text: Scalars['String'];
};

export type PlacePredictionTextMatch = {
  __typename?: 'PlacePredictionTextMatch';
  endOffset: Scalars['Int'];
  startOffset?: Maybe<Scalars['Int']>;
};

export type PlacesSuggestion = {
  __typename?: 'PlacesSuggestion';
  placePrediction: PlacePrediction;
};

export type PlattedLand = {
  __typename?: 'PlattedLand';
  block?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  lot?: Maybe<Scalars['String']>;
  municipality?: Maybe<Scalars['String']>;
  subdivision?: Maybe<Scalars['String']>;
  unit?: Maybe<Scalars['String']>;
};

export type PlattedLandInput = {
  block?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  lot?: InputMaybe<Scalars['String']>;
  municipality?: InputMaybe<Scalars['String']>;
  subdivision?: InputMaybe<Scalars['String']>;
  unit?: InputMaybe<Scalars['String']>;
};

export type PolicyData = {
  __typename?: 'PolicyData';
  effectiveDate?: Maybe<Scalars['String']>;
  effectiveDateFallbackValue?: Maybe<Scalars['String']>;
  effectiveDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  effectiveTime?: Maybe<Scalars['String']>;
  isAddendumAttached?: Maybe<Scalars['Boolean']>;
  policyNumber?: Maybe<Scalars['String']>;
  remittanceDate?: Maybe<Scalars['String']>;
  signatoryId?: Maybe<Scalars['String']>;
  signatoryName?: Maybe<Scalars['String']>;
};

export type PolicyDataInput = {
  effectiveDate?: InputMaybe<Scalars['String']>;
  effectiveTime?: InputMaybe<Scalars['String']>;
  isAddendumAttached?: InputMaybe<Scalars['Boolean']>;
  policyNumber?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
  signatoryId?: InputMaybe<Scalars['String']>;
  signatoryName?: InputMaybe<Scalars['String']>;
};

export type PolicyDetails = {
  __typename?: 'PolicyDetails';
  attorneySelectionType?: Maybe<Scalars['String']>;
  canPrice: Scalars['Boolean'];
  coveredParties: Array<Scalars['String']>;
  coveredPartyStatisticalCodes?: Maybe<Array<Maybe<CoveredPartyStatisticalCode>>>;
  letterType: Scalars['String'];
};

export type PolicyFeeAndTaxItem = {
  __typename?: 'PolicyFeeAndTaxItem';
  amount?: Maybe<Scalars['Float']>;
  amountOverride?: Maybe<Scalars['Float']>;
  amountOverrideMetadata: OverrideMetadataNumber;
  buyerPays: DollarsPercent;
  buyerPaysOverride: DollarsPercent;
  buyerPaysOverrideMetadata: OverrideMetadataDollarsPercent;
  description: Scalars['String'];
  /**
   * Disclosed amount (system-calculated)
   * For KY Municipal Tax: calculated as premiumDisclosed × taxRate
   */
  disclosedAmount?: Maybe<Scalars['Float']>;
  /**
   * User override for disclosed amount
   * Allows manual adjustment of disclosed tax amount
   */
  disclosedAmountOverride?: Maybe<Scalars['Float']>;
  /**
   * Override metadata for disclosed amount
   * Tracks system value vs user override with effectiveValue
   */
  disclosedAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  /** Stable Title catalog code for a known policy fee */
  feeCode?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  /**
   * Source product type for KY municipal tax items
   * Values: "POLICY", "ENDORSEMENT", or "CPL"
   * Used to identify which product generated this tax line item
   */
  municipalTaxProductType?: Maybe<Scalars['String']>;
  payeeId: Scalars['String'];
  sellerPays: DollarsPercent;
  sellerPaysOverride: DollarsPercent;
  sellerPaysOverrideMetadata: OverrideMetadataDollarsPercent;
};

export type PolicyFeeAndTaxItemInput = {
  /**
   * We allow this to be sent from the frontend to assert an initial non-null value
   * because we dont have reference ids to map default values back to an individual policy fee item,
   * but it is not user-editable once set. see: svc-title
   */
  amount?: InputMaybe<Scalars['Float']>;
  amountOverride?: InputMaybe<Scalars['Float']>;
  buyerPays?: InputMaybe<DollarsPercentInput>;
  buyerPaysOverride: DollarsPercentInput;
  description: Scalars['String'];
  disclosedAmount?: InputMaybe<Scalars['Float']>;
  /** Allows manual adjustment of disclosed tax amount */
  disclosedAmountOverride?: InputMaybe<Scalars['Float']>;
  /** Stable Title catalog code for a known policy fee */
  feeCode?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  /**
   * ANP-4536: Source product type for KY municipal tax
   * Values: "POLICY", "ENDORSEMENT", or "CPL"
   */
  municipalTaxProductType?: InputMaybe<Scalars['String']>;
  payeeId: Scalars['String'];
  sellerPays?: InputMaybe<DollarsPercentInput>;
  sellerPaysOverride: DollarsPercentInput;
};

export type PolicyMetadata = {
  __typename?: 'PolicyMetadata';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  insuredVesting?: Maybe<InsuredVesting>;
  loanPolicy?: Maybe<PolicyData>;
  mortgageRecital?: Maybe<MortgageRecital>;
  orderId: Scalars['String'];
  ownerPolicy?: Maybe<PolicyData>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type PolicyRateRequest = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionsRateRequest>>;
  disclosedAmountOverrideValue?: InputMaybe<Scalars['Float']>;
  effectiveDate: Scalars['String'];
  endorsements?: InputMaybe<Array<EndorsementRateRequest>>;
  isExtendedCoverage?: InputMaybe<Scalars['Boolean']>;
  policyAmountOverrideValue?: InputMaybe<Scalars['Float']>;
  policyId: Scalars['String'];
  policyName?: InputMaybe<Scalars['String']>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  priorPolicyDate?: InputMaybe<Scalars['String']>;
  rateId: Scalars['String'];
};

export type PolicyRateValidationRequest = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionsRateValidationRequest>>;
  effectiveDate?: InputMaybe<Scalars['String']>;
  endorsements?: InputMaybe<Array<EndorsementRateValidationRequest>>;
  policyId?: InputMaybe<Scalars['String']>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  rateId?: InputMaybe<Scalars['String']>;
};

export type PolicyRates = {
  __typename?: 'PolicyRates';
  autoEnablePriorPolicy?: Maybe<Scalars['Boolean']>;
  effectiveDate?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  rateType: Scalars['String'];
  statisticalCodes?: Maybe<Array<Maybe<StatisticalCode>>>;
};

export type PolicyType = {
  __typename?: 'PolicyType';
  endorsements?: Maybe<Array<Maybe<PolicyTypeEndorsement>>>;
  hasAddendum: Scalars['Boolean'];
  hasExtendedCoverage: Scalars['Boolean'];
  id: Scalars['String'];
  /** ANP-3736: Indicates if the policy requires a signatory to be selected */
  isSignatoryRequired?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  policyType: Scalars['String'];
  rates?: Maybe<Array<Maybe<PolicyRates>>>;
};

export type PolicyTypeEndorsement = {
  __typename?: 'PolicyTypeEndorsement';
  /** @deprecated Use agentRetainedV2 instead for dollar/percentage values */
  agentRetained?: Maybe<Scalars['Float']>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  agentRetainedV2Override?: Maybe<DollarsPercent>;
  amount?: Maybe<Scalars['Float']>;
  amountOverride?: Maybe<Scalars['Float']>;
  effectiveDate?: Maybe<Scalars['String']>;
  expirationDate?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefaultEndorsement?: Maybe<Scalars['Boolean']>;
  name: Scalars['String'];
  statisticalCodes?: Maybe<Array<Maybe<StatisticalCode>>>;
  /** @deprecated Use underwriterRemittedV2 instead for dollar/percentage values */
  underwriterRemitted?: Maybe<Scalars['Float']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
  underwriterRemittedV2Override?: Maybe<DollarsPercent>;
};

export type PollPackageStatusRequestInput = {
  orderId: Scalars['ID'];
  packageId: Scalars['ID'];
};

export type PortalAccount = {
  __typename?: 'PortalAccount';
  agentAddress1: Scalars['String'];
  agentAddress2?: Maybe<Scalars['String']>;
  agentCity: Scalars['String'];
  agentEmail: Scalars['String'];
  agentFax?: Maybe<Scalars['String']>;
  agentName: Scalars['String'];
  agentPhone: Scalars['String'];
  agentState: Scalars['String'];
  agentZipCode: Scalars['String'];
  branding: PortalBrandingResponse;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  email: Scalars['String'];
  firmId: Scalars['ID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notificationRoles: Array<NotificationRole>;
  phoneNumber: Scalars['String'];
  portalId: Scalars['ID'];
  portalUrlSlug: Scalars['String'];
  status: PortalStatus;
  updatedBy: UserDisplayName;
  updatedTimestamp: Scalars['String'];
};

export type PortalAccountCreateRequestInput = {
  agentAddress1: Scalars['String'];
  agentAddress2?: InputMaybe<Scalars['String']>;
  agentCity: Scalars['String'];
  agentEmail: Scalars['String'];
  agentFax?: InputMaybe<Scalars['String']>;
  agentName: Scalars['String'];
  agentPhone: Scalars['String'];
  agentState: Scalars['String'];
  agentZipCode: Scalars['String'];
  branding: PortalBrandingRequestInput;
  /** @minItems 1 */
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notificationRoles: Array<NotificationRoleInput>;
  phoneNumber: Scalars['String'];
  portalUrlSlug: Scalars['String'];
};

export type PortalAccountGetAllItem = {
  __typename?: 'PortalAccountGetAllItem';
  companies: Array<Scalars['String']>;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  displayName: Scalars['String'];
  firmId: Scalars['ID'];
  portalId: Scalars['ID'];
  portalUrlSlug: Scalars['String'];
  status: PortalStatus;
  updatedBy: UserDisplayName;
  updatedTimestamp: Scalars['String'];
};

export type PortalAccountSetActiveRequestInput = {
  active: Scalars['Boolean'];
  portalId: Scalars['ID'];
};

export type PortalAccountSetActiveResponse = {
  __typename?: 'PortalAccountSetActiveResponse';
  firmId: Scalars['ID'];
  portalId: Scalars['ID'];
  status: PortalStatus;
};

export type PortalAccountUpdateRequestInput = {
  agentAddress1: Scalars['String'];
  agentAddress2?: InputMaybe<Scalars['String']>;
  agentCity: Scalars['String'];
  agentEmail: Scalars['String'];
  agentFax?: InputMaybe<Scalars['String']>;
  agentName: Scalars['String'];
  agentPhone: Scalars['String'];
  agentState: Scalars['String'];
  agentZipCode: Scalars['String'];
  branding?: InputMaybe<PortalBrandingRequestInput>;
  /** @minItems 1 */
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  deleteAgentLogo?: InputMaybe<Scalars['Boolean']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  notificationRoles?: InputMaybe<Array<NotificationRoleInput>>;
  phoneNumber: Scalars['String'];
  portalId: Scalars['ID'];
};

export type PortalAgentNameCheckRequestInput = {
  agentName: Scalars['String'];
};

export type PortalAgentNameCheckResponse = {
  __typename?: 'PortalAgentNameCheckResponse';
  agentName: Scalars['String'];
  available: Scalars['Boolean'];
};

export type PortalBrandingRequestInput = {
  logoBase64?: InputMaybe<Scalars['String']>;
  logoExtension?: InputMaybe<Scalars['String']>;
  primaryColor?: InputMaybe<Scalars['String']>;
  secondaryColor?: InputMaybe<Scalars['String']>;
};

export type PortalBrandingResponse = {
  __typename?: 'PortalBrandingResponse';
  logoUrl?: Maybe<Scalars['String']>;
  primaryColor?: Maybe<Scalars['String']>;
  secondaryColor?: Maybe<Scalars['String']>;
};

export type PortalCompanyIdsRequestInput = {
  /** @minItems 1 */
  companyIds: Array<Scalars['String']>;
  portalId: Scalars['ID'];
};

export type PortalIdRequestInput = {
  portalId: Scalars['ID'];
};

export type PortalSlugCheckRequestInput = {
  portalUrlSlug: Scalars['String'];
};

export type PortalSlugCheckResponse = {
  __typename?: 'PortalSlugCheckResponse';
  available: Scalars['Boolean'];
  portalUrlSlug: Scalars['String'];
};

export enum PortalStatus {
  Active = 'active',
  Inactive = 'inactive'
}

export type PositivePay = {
  __typename?: 'PositivePay';
  exportFileName?: Maybe<Scalars['String']>;
  fileExportTemplate?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
};

export type PositivePayFile = {
  __typename?: 'PositivePayFile';
  fileBuffer?: Maybe<Scalars['String']>;
  fileExtension?: Maybe<Scalars['String']>;
  fileName?: Maybe<Scalars['String']>;
};

export type PositivePayInput = {
  exportFileName?: InputMaybe<Scalars['String']>;
  fileExportTemplate?: InputMaybe<Scalars['String']>;
  fileExtension?: InputMaybe<Scalars['String']>;
};

export type PositivePaySubmission = {
  __typename?: 'PositivePaySubmission';
  createdBy?: Maybe<User>;
  createdDate?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  transactionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type PostAutoClearInput = {
  bai2: Scalars['String'];
  escrowAccountId: Scalars['String'];
  fileType: Scalars['String'];
  reconciliationId: Scalars['String'];
};

export type PostAutoClearResponse = {
  __typename?: 'PostAutoClearResponse';
  result: Scalars['String'];
  totals: AutoClearTotals;
  unmatchedTransactions: Array<Bai2TransactionSummary>;
};

export type PowerOfAttorney = {
  __typename?: 'PowerOfAttorney';
  address?: Maybe<Address>;
  associatedToParty?: Maybe<Scalars['String']>;
  attorneyFirstName?: Maybe<Scalars['String']>;
  attorneyLastName?: Maybe<Scalars['String']>;
  attorneyMiddleName?: Maybe<Scalars['String']>;
  attorneySuffix?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Scalars['EmailAddress']>>;
  endDate?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Scalars['PhoneNumber']>>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  startDate?: Maybe<Scalars['String']>;
};

export type PowerOfAttorneyInput = {
  address?: InputMaybe<AddressInput>;
  associatedToParty?: InputMaybe<Scalars['String']>;
  attorneyFirstName?: InputMaybe<Scalars['String']>;
  attorneyLastName?: InputMaybe<Scalars['String']>;
  attorneyMiddleName?: InputMaybe<Scalars['String']>;
  attorneySuffix?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<Scalars['EmailAddress']>>;
  endDate?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<Scalars['PhoneNumber']>>;
  signingName?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
};

export type PremiumAdditionalQuestion = {
  __typename?: 'PremiumAdditionalQuestion';
  answer?: Maybe<PremiumAdditionalQuestionAnswer>;
  defaultAnswer?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  inputType: Scalars['String'];
  options: Array<PremiumAdditionalQuestionAnswerOption>;
  question: Scalars['String'];
};

export type PremiumAdditionalQuestionAnswer = {
  __typename?: 'PremiumAdditionalQuestionAnswer';
  answerType?: Maybe<Scalars['String']>;
  response?: Maybe<Scalars['String']>;
};

export type PremiumAdditionalQuestionAnswerOption = {
  __typename?: 'PremiumAdditionalQuestionAnswerOption';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type PremiumFeeAdditionalData = {
  __typename?: 'PremiumFeeAdditionalData';
  externalPremiumLineId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type PremiumPolicyFeeAdditionalData = {
  __typename?: 'PremiumPolicyFeeAdditionalData';
  externalPolicyFeeId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type PremiumRateCalculation = {
  __typename?: 'PremiumRateCalculation';
  actual?: Maybe<Scalars['Float']>;
  additionalQuestions: Array<PremiumAdditionalQuestion>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  disclosed?: Maybe<Scalars['Float']>;
  discountApplied?: Maybe<Scalars['Float']>;
  endorsements: Array<PremiumRateCalculationEndorsement>;
  remittanceAmount?: Maybe<Scalars['Float']>;
  riskRateId?: Maybe<Scalars['String']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
};

export type PremiumRateCalculationEndorsement = {
  __typename?: 'PremiumRateCalculationEndorsement';
  additionalQuestions: Array<PremiumAdditionalQuestion>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  amount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
};

export type PremiumRateCalculationResponse = {
  __typename?: 'PremiumRateCalculationResponse';
  lender?: Maybe<PremiumRateCalculation>;
  owner?: Maybe<PremiumRateCalculation>;
  statuses?: Maybe<Array<CplProductStatus>>;
  warnings: Array<Scalars['String']>;
};

export type PrepaidInterestFeeAdditionalData = {
  __typename?: 'PrepaidInterestFeeAdditionalData';
  amountPerDay?: Maybe<Scalars['Float']>;
  amountPerDayOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  fromDate?: Maybe<Scalars['String']>;
  fromDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  toDate?: Maybe<Scalars['String']>;
  toDateOverrideMetadata?: Maybe<OverrideMetadataString>;
};

export type PrerequisiteAnd = {
  __typename?: 'PrerequisiteAnd';
  and: Array<Prerequisites>;
};

export type PrerequisiteKey = {
  __typename?: 'PrerequisiteKey';
  key: Scalars['String'];
};

export type PrerequisiteOr = {
  __typename?: 'PrerequisiteOr';
  or: Array<Prerequisites>;
};

export type Prerequisites = PrerequisiteAnd | PrerequisiteKey | PrerequisiteOr;

export type PrintCheckResultEntryV2 = {
  __typename?: 'PrintCheckResultEntryV2';
  error?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
  transactionId: Scalars['ID'];
};

export type PrintChecksInput = {
  orderId: Scalars['ID'];
  subscriptionId?: InputMaybe<Scalars['ID']>;
  transactionIds: Array<Scalars['ID']>;
};

export type PrintChecksRequestV2Input = {
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  subscriptionId?: InputMaybe<Scalars['ID']>;
  /** @minItems 1 */
  transactionIds: Array<Scalars['String']>;
};

export type PrintChecksResponseV2 = {
  __typename?: 'PrintChecksResponseV2';
  generatingDocuments?: Maybe<Array<GeneratingDocumentItemV2>>;
  results: Array<PrintCheckResultEntryV2>;
  subscriptionId: Scalars['ID'];
};

export type PrintChecksResult = {
  __typename?: 'PrintChecksResult';
  results: Array<PrintChecksResultItemEntry>;
  subscriptionId?: Maybe<Scalars['String']>;
  successFullyPrintedAllChecks: Scalars['Boolean'];
};

export type PrintChecksResultItemEntry = {
  __typename?: 'PrintChecksResultItemEntry';
  error?: Maybe<Scalars['String']>;
  success?: Maybe<Scalars['Boolean']>;
  transaction?: Maybe<Transaction>;
  transactionId: Scalars['ID'];
};

export type PrintChecksResultTest = {
  __typename?: 'PrintChecksResultTest';
  subscriptionId?: Maybe<Scalars['String']>;
};

export type PrintDocumentsRequestV2Input = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  subscriptionId?: InputMaybe<Scalars['ID']>;
};

export type PrintEntityDocumentsRequestV2Input = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
};

export type ProjectedPayments = {
  __typename?: 'ProjectedPayments';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  orderId?: Maybe<Scalars['String']>;
  terms?: Maybe<Array<Maybe<ProjectedPaymentsTerm>>>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type ProjectedPaymentsInput = {
  orderId: Scalars['String'];
  terms: Array<InputMaybe<ProjectedPaymentsTermInput>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type ProjectedPaymentsTerm = {
  __typename?: 'ProjectedPaymentsTerm';
  endYear: Scalars['Float'];
  estimatedEscrow?: Maybe<Scalars['Float']>;
  estimatedEscrowOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  estimatedTotalMonthlyPayments?: Maybe<Scalars['Float']>;
  mortgageInsurance?: Maybe<Scalars['Float']>;
  principalAndInterest?: Maybe<Scalars['Float']>;
  startYear: Scalars['Float'];
};

export type ProjectedPaymentsTermInput = {
  endYear: Scalars['Float'];
  estimatedEscrow?: InputMaybe<Scalars['Float']>;
  mortgageInsurance?: InputMaybe<Scalars['Float']>;
  principalAndInterest?: InputMaybe<Scalars['Float']>;
  startYear: Scalars['Float'];
};

export type Property = {
  __typename?: 'Property';
  address?: Maybe<Address>;
  legalDescription?: Maybe<Array<LegalDescription>>;
};

export type PropertyInput = {
  address?: InputMaybe<AddressInput>;
  legalDescription?: InputMaybe<Array<LegalDescriptionInput>>;
};

export enum PropertyLookupType {
  Apn = 'APN',
  Address = 'Address'
}

export type PropertySearchAddress = {
  __typename?: 'PropertySearchAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
};

export type PropertyTaxEscrowFeeAdditionalData = {
  __typename?: 'PropertyTaxEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  amountPerMonthOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type PropertyTaxFeeAdditionalData = {
  __typename?: 'PropertyTaxFeeAdditionalData';
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type PropertyTaxProrationConfiguration = {
  __typename?: 'PropertyTaxProrationConfiguration';
  calendarYearStarts: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  daysInYear: Scalars['String'];
  dueDates: Array<DueDate>;
  id: Scalars['ID'];
  includeProrationDate: Scalars['Boolean'];
  paymentFrequency: Scalars['String'];
  state: Scalars['String'];
  taxType: Scalars['String'];
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Proration = {
  __typename?: 'Proration';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isPropertyTax?: Maybe<Scalars['Boolean']>;
  lineItems?: Maybe<Array<Maybe<ProrationLineItem>>>;
  payeePartyId?: Maybe<Scalars['String']>;
  prorationDetails?: Maybe<ProrationDetails_V2>;
  prorationSubtype?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ProrationCharge = {
  __typename?: 'ProrationCharge';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  frequency?: Maybe<Scalars['String']>;
  frequencyDisplayText?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  lineItem?: Maybe<ProrationChargeLineItem>;
  orderId: Scalars['ID'];
  payee?: Maybe<OrderParty>;
  payeePartyId?: Maybe<Scalars['String']>;
  prorationChargeSubtype?: Maybe<Scalars['String']>;
  prorationChargeType?: Maybe<Scalars['String']>;
  prorationDetails?: Maybe<ProrationDetails>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type ProrationChargeLineItem = {
  __typename?: 'ProrationChargeLineItem';
  amountDue?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['String']>;
  payment?: Maybe<ProrationChargeLineItemPayment>;
};

export type ProrationChargeLineItemInput = {
  amountDue?: InputMaybe<Scalars['Float']>;
  dueDate?: InputMaybe<Scalars['String']>;
  payment?: InputMaybe<ProrationChargeLineItemPaymentInput>;
};

export type ProrationChargeLineItemPayment = {
  __typename?: 'ProrationChargeLineItemPayment';
  amountPaid?: Maybe<Scalars['Float']>;
  discountAmount?: Maybe<Scalars['Float']>;
  penaltyInterestAmountDue?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type ProrationChargeLineItemPaymentInput = {
  amountPaid?: InputMaybe<Scalars['Float']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  penaltyInterestAmountDue?: InputMaybe<Scalars['Float']>;
  type?: InputMaybe<Scalars['String']>;
};

export type ProrationDetails = {
  __typename?: 'ProrationDetails';
  daysInYear?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['String']>;
  fromDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  includeIn1099?: Maybe<Scalars['Boolean']>;
  includeProrateDate?: Maybe<Scalars['Boolean']>;
  perDiem?: Maybe<Scalars['Float']>;
  perDiemOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  prorateAmount?: Maybe<Scalars['Float']>;
  prorateAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  prorateDate?: Maybe<Scalars['String']>;
  prorateDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  prorateDays?: Maybe<Scalars['Float']>;
  prorateDaysOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  toDate?: Maybe<Scalars['String']>;
  toDateOverrideMetadata?: Maybe<OverrideMetadataString>;
};

export type ProrationDetailsInput = {
  daysInYear?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  includeIn1099?: InputMaybe<Scalars['Boolean']>;
  includeProrateDate?: InputMaybe<Scalars['Boolean']>;
  perDiem?: InputMaybe<Scalars['Float']>;
  prorateAmount?: InputMaybe<Scalars['Float']>;
  prorateDate?: InputMaybe<Scalars['String']>;
  prorateDays?: InputMaybe<Scalars['Float']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type ProrationDetailsInput_V2 = {
  daysInYear?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  fromDateOverride?: InputMaybe<Scalars['String']>;
  includeIn1099?: InputMaybe<Scalars['Boolean']>;
  includeProrateDate?: InputMaybe<Scalars['Boolean']>;
  perDiem?: InputMaybe<Scalars['Float']>;
  perDiemOverride?: InputMaybe<Scalars['Float']>;
  prorateAmount?: InputMaybe<Scalars['Float']>;
  prorateAmountOverride?: InputMaybe<Scalars['Float']>;
  prorateDate?: InputMaybe<Scalars['String']>;
  prorateDateOverride?: InputMaybe<Scalars['String']>;
  prorateDays?: InputMaybe<Scalars['Float']>;
  prorateDaysOverride?: InputMaybe<Scalars['Float']>;
  shouldProrate?: InputMaybe<Scalars['Boolean']>;
  taxAmount?: InputMaybe<Scalars['Float']>;
  taxAmountOverride?: InputMaybe<Scalars['Float']>;
  toDate?: InputMaybe<Scalars['String']>;
  toDateOverride?: InputMaybe<Scalars['String']>;
};

export type ProrationDetails_V2 = {
  __typename?: 'ProrationDetails_v2';
  daysInYear?: Maybe<Scalars['String']>;
  fromDate?: Maybe<Scalars['String']>;
  fromDateOverride?: Maybe<Scalars['String']>;
  includeIn1099?: Maybe<Scalars['Boolean']>;
  includeProrateDate?: Maybe<Scalars['Boolean']>;
  perDiem?: Maybe<Scalars['Float']>;
  perDiemOverride?: Maybe<Scalars['Float']>;
  prorateAmount?: Maybe<Scalars['Float']>;
  prorateAmountOverride?: Maybe<Scalars['Float']>;
  prorateDate?: Maybe<Scalars['String']>;
  prorateDateOverride?: Maybe<Scalars['String']>;
  prorateDays?: Maybe<Scalars['Float']>;
  prorateDaysOverride?: Maybe<Scalars['Float']>;
  shouldProrate?: Maybe<Scalars['Boolean']>;
  taxAmount?: Maybe<Scalars['Float']>;
  taxAmountOverride?: Maybe<Scalars['Float']>;
  toDate?: Maybe<Scalars['String']>;
  toDateOverride?: Maybe<Scalars['String']>;
};

export type ProrationLineItem = {
  __typename?: 'ProrationLineItem';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  discountAmount?: Maybe<Scalars['Float']>;
  dueDate?: Maybe<Scalars['String']>;
  paidType?: Maybe<Scalars['String']>;
  penaltyInterestAmountDue?: Maybe<Scalars['Float']>;
};

export type ProrationLineItemInput = {
  amountDue?: InputMaybe<Scalars['Float']>;
  amountPaid?: InputMaybe<Scalars['Float']>;
  discountAmount?: InputMaybe<Scalars['Float']>;
  dueDate?: InputMaybe<Scalars['String']>;
  paidType?: InputMaybe<Scalars['String']>;
  penaltyInterestAmountDue?: InputMaybe<Scalars['Float']>;
};

export type ProtectedRecipientAccountNumber = {
  __typename?: 'ProtectedRecipientAccountNumber';
  recipientAccountNumberProtected?: Maybe<Scalars['String']>;
};

export type ProtectedTaxId = {
  __typename?: 'ProtectedTaxId';
  taxIdProtected?: Maybe<Scalars['String']>;
};

export enum Provider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type PurchaseShippingRateRequestInput = {
  orderId: Scalars['ID'];
  rateId: Scalars['ID'];
  shipmentId: Scalars['ID'];
};

export type PutAgentNetFinanceIntegrationInput = {
  features?: InputMaybe<AgentNetFinanceInput>;
  isEnabled: Scalars['Boolean'];
};

export type PutOrderCommissionBasisOverrideInput = {
  value?: InputMaybe<Scalars['Float']>;
};

export type PutOrderCommissionsInput = {
  commissionBasisOverride?: InputMaybe<PutOrderCommissionBasisOverrideInput>;
  distributionMethod: Scalars['String'];
  lineItems: Array<PutUserEnteredCommissionsLineItemInput>;
  sellerPaidPercentage?: InputMaybe<Scalars['Float']>;
  totalCommissionAmount: PutTotalCommissionAmountInput;
};

export type PutOrderCommissionsMetadata = {
  orderId: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
};

export type PutOrderDepositsInput = {
  lineItems: Array<OrderDepositLineItemInput>;
  updatedTimestamp: Scalars['String'];
};

export type PutRecordingFeeTransferTaxInput = {
  orderId: Scalars['String'];
  recordingFees: RecordingFeesInput;
  transferTaxes: TransferTaxesInput;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type PutTenantChildImageInput = {
  id: Scalars['ID'];
  profileImage?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type PutTotalCommissionAmountInput = {
  calculatedValue?: InputMaybe<Scalars['Float']>;
  calculationMethod: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

export type PutUserEnteredCommissionsLineItemInput = {
  agentType: Scalars['String'];
  calculatedValue?: InputMaybe<Scalars['Float']>;
  id: Scalars['ID'];
  partyId: Scalars['String'];
  value?: InputMaybe<Scalars['Float']>;
};

export type QuarterSection = {
  __typename?: 'QuarterSection';
  q?: Maybe<Scalars['String']>;
  qq?: Maybe<Scalars['String']>;
  qqq?: Maybe<Scalars['String']>;
  qqqq?: Maybe<Scalars['String']>;
};

export type QuarterSectionInput = {
  q?: InputMaybe<Scalars['String']>;
  qq?: InputMaybe<Scalars['String']>;
  qqq?: InputMaybe<Scalars['String']>;
  qqqq?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  _empty?: Maybe<Scalars['String']>;
  additionalPropertyDetails?: Maybe<Array<Maybe<AdditionalPropertyDetails>>>;
  admin: AdminDomain;
  clauseTemplates?: Maybe<ClauseTemplateConnection>;
  companyPortalGet: PortalAccount;
  configuration?: Maybe<Configuration>;
  dashboard?: Maybe<Array<Maybe<Dashboard>>>;
  defaults: UserDefaults;
  directoryCompanies?: Maybe<Array<Maybe<CompanySummary>>>;
  directoryContacts?: Maybe<Array<ContactSummary>>;
  directoryDetail?: Maybe<CompanyContact>;
  /** Eligible (unmatched, exact-amount) receipts for a specific incoming wire — Match drawer (fetched fresh on open). */
  eligibleReceiptsForWire?: Maybe<Array<Maybe<WireManagement>>>;
  emailSignatureGet: EmailSignature;
  feeLineTypes?: Maybe<Array<Scalars['String']>>;
  fees?: Maybe<Array<Fee>>;
  fluentClauseTemplates?: Maybe<ClauseTemplateConnection>;
  getActiveUsersOnEntity: Array<ActiveUserOnEntity>;
  getAdjustmentStatementSectionTotals?: Maybe<SectionSummariesTotals>;
  getAdjustments: Array<Adjustment>;
  getAdminMilestone: AdminMilestone;
  getAdminMilestones: Array<AdminMilestone>;
  getAdminTask: AdminTask;
  getAdminTasks: Array<AdminTask>;
  getAdminWorkflow: AdminWorkflow;
  getAdminWorkflows: Array<AdminWorkflow>;
  getAgentNetAdminOffices: AgentNetAdminOfficesResponse;
  getAgentNetAdminStatus: AdminCredentialAgentNetStatus;
  getAgentNetFinanceIntegration?: Maybe<AgentNetFinanceIntegrationResponse>;
  getAgentNetUserStatus: UserCredentialAgentNetStatus;
  getAllImportedTemplatesV2: Array<Maybe<ImportedTemplateSummaryV2>>;
  getAllTagsV2: Array<Maybe<TagV2>>;
  getAllTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getAuthorizedSignatoryUsers?: Maybe<Array<Maybe<AuthorizedSignatoryUser>>>;
  getAutocompleteResults: Array<PlacesSuggestion>;
  getAvailableWorkflows?: Maybe<Array<Maybe<AvailableWorkflow>>>;
  getBuyerSpouseTaxId: ProtectedTaxId;
  getBuyerTaxId: ProtectedTaxId;
  getCalculatingCashToClose: CalculatingCashToClose;
  getCarrierAccount: CarrierAccountObject;
  getCarrierAccounts: Array<Maybe<CarrierAccountObject>>;
  getCheckAuthorizedSignatories?: Maybe<Array<Maybe<CheckAuthorizedSignatory>>>;
  getClausePackages: WrappedClausePackageResponse;
  getClauseTemplates: WrappedClauseTemplateResponse;
  getClosingCosts: ClosingCosts;
  getClosingInformation: ClosingInformation;
  getClosingQuestions: ClosingQuestions;
  getCompanyTypes?: Maybe<CompanyTypes>;
  getConsolidatedPayee?: Maybe<ConsolidatedPayee>;
  getConsolidatedPayeeEligibility?: Maybe<ConsolidatedPayeeEligibility>;
  getConsolidatedPayeesPending?: Maybe<Array<Maybe<ConsolidatedPayee>>>;
  getConsolidatedPayment?: Maybe<ConsolidatedPaymentWithLineDetails>;
  getConsolidatedPaymentReport?: Maybe<ConsolidatedPaymentReport>;
  getConsolidatedPaymentsCompleted?: Maybe<Array<Maybe<ConsolidatedDisbursementRow>>>;
  getConsolidatedPaymentsDisbursed?: Maybe<Array<Maybe<ConsolidatedPayee>>>;
  getConsolidatedPaymentsPendingTransactions?: Maybe<Array<Maybe<ConsolidatedPendingTransaction>>>;
  getContactValidation: GetContactValidationResponse;
  getCurrentTenant: Tenant;
  getDcAdjustments: GetAdjustmentsResponse;
  getDepartment: Department;
  getDepartments: Array<Department>;
  getDirectoryCompanyTaxId?: Maybe<CompanyTaxId>;
  getDirectoryContactSummaries?: Maybe<Array<Maybe<ContactWithCompanySummary>>>;
  getDirectoryRecipientAccountNumber?: Maybe<CompanyRecipientAccountNumber>;
  getDocTypeMappingsByCountyName: GetDocTypeMappingsByCountyNameResponse;
  getDocumentInsightsV2: DocumentInsightsV2;
  getDynamicDocumentTypes: GetDynamicDocumentTypesResponse;
  getDynamicDocumentTypesByCountyName: GetDynamicDocumentTypesResponse;
  getERecordingEligibility: GetERecordingEligibilityResponse;
  getEffectiveOrderCommissions?: Maybe<EffectiveOrderCommissions>;
  getEligibleCounties: GetEligibleCountiesResponse;
  getEntityDocumentV2: EntityDocumentV2;
  getEntityDocumentVersionHistoryV2: Array<Maybe<EntityDocumentFileVersionV2>>;
  getEntityDocumentsV2: Array<Maybe<EntityDocumentV2>>;
  getEntityTagsV2: Array<Maybe<TagV2>>;
  getEpnAccountForOrder: GetEpnAccountForOrderResponse;
  getEpnIntegrationStatus: EpnIntegrationStatus;
  getEscrowAccount?: Maybe<EscrowAccount>;
  getEscrowAccountNumberAlternateProtected?: Maybe<EscrowAccountNumberAlternateProtected>;
  getEscrowAccountNumberProtected?: Maybe<EscrowAccountNumberProtected>;
  getEscrowAccounts?: Maybe<Array<Maybe<EscrowAccount>>>;
  getEstimatedTaxesInsuranceAssessments: EstimatedTaxesInsuranceAssessments;
  getFaTrustCredentialStatus?: Maybe<FaTrustCredentialStatus>;
  getFeatureAcknowledgment?: Maybe<FeatureAcknowledgment>;
  getFeeAllocations?: Maybe<FeeAllocations>;
  getFeesWithAllocations: Array<Maybe<FeeWithAllocations>>;
  getFidelityAdminAgentMapping: FidelityAgentMappingResponse;
  getFidelityAdminAgentOptions: FidelityAgentOptionsResponse;
  getFidelityAdminConfiguration: FidelityAdminConfiguration;
  getFidelityUserStatus: FidelityUserStatus;
  getFilteredTenantCompanies?: Maybe<FilteredTenantCompanies>;
  getFinalizedReconciliationBookBalanceTransactions?: Maybe<Array<Maybe<BookBalanceTransaction>>>;
  getFinalizedReconciliationEscrowTrialBalanceTransactions?: Maybe<Array<Maybe<EscrowTrialEntry>>>;
  getFinalizedReconciliationReconciledBankBalanceTransactions?: Maybe<Array<Maybe<ReconciledBankBalanceTransaction>>>;
  getFinalizedReconciliationSummary?: Maybe<ReconciliationSummary>;
  getFraudtoolsIntegrationStatus: GetIntegrationStatusResponse;
  getFund?: Maybe<Fund>;
  getGfeCharges: Array<GfeCharge>;
  getHUDBorrowerCalculations: HudBorrowerCalculations;
  getHudFormType: HudFormType;
  getIdentityVerification: GetIdentityVerificationResponse;
  getInProgressReconciliationBookBalanceTransactions?: Maybe<Array<Maybe<BookBalanceTransaction>>>;
  getInProgressReconciliationEscrowTrialBalanceTransactions?: Maybe<Array<Maybe<EscrowTrialEntry>>>;
  getInProgressReconciliationReconciledBankBalanceTransactions?: Maybe<Array<Maybe<ReconciledBankBalanceTransaction>>>;
  getInProgressReconciliationSummary?: Maybe<ReconciliationSummary>;
  getInsightV2: GetInsightResponseV2;
  getIntegration: IntegrationObject;
  getIntegrationOrderReadiness: IntegrationOrderReadiness;
  getIntegrations: Array<Maybe<IntegrationObject>>;
  getJacket: Jacket;
  getL3RecipientAccountNumber?: Maybe<ProtectedRecipientAccountNumber>;
  getLabelsByOrderId: Array<Maybe<LabelObject>>;
  getLatestInsight?: Maybe<InsightItem>;
  getLoanCalculationsDisclosures: LoanCalculationsDisclosures;
  getLoanDisclosures: LoanDisclosures;
  getMasterOrders: MasterOrderResponseObject;
  getMergeFieldsV2: GetMergeFieldsResponseV2;
  getNotes?: Maybe<Array<Maybe<Note>>>;
  getOldRepublicAdminAgentMapping: OldRepublicAgentMappingResponse;
  getOldRepublicAdminAgentOptions: OldRepublicAgentOptionsResponse;
  getOldRepublicAdminConfiguration: OldRepublicAdminConfiguration;
  getOldRepublicUserAuthStatus: OldRepublicUserAuthStatus;
  getOrderAssistLatestInsight?: Maybe<OrderAssistInsightItem>;
  getOrderBuyer: Buyer;
  getOrderCommissions?: Maybe<OrderCommissionsV2>;
  getOrderDeposits: OrderDeposits;
  getOrderFundsHeldByName: Scalars['String'];
  getOrderLineDetails_v2?: Maybe<Array<Maybe<LineDetail>>>;
  getOrderMilestone?: Maybe<Milestone>;
  getOrderMilestones?: Maybe<Array<Maybe<Milestone>>>;
  getOrderPartyRecipientAccountNum: CompanyRecipientAccountNumber;
  getOrderPartyTaxId: ProtectedTaxId;
  getOrderSeller: Seller;
  getOrderSummaries?: Maybe<OrderSummaryConnection>;
  getOrderSummariesForL1Search?: Maybe<OrderSummaryConnection>;
  getOrderSummariesV2?: Maybe<OrderSummaryConnection>;
  getOrderTaskById?: Maybe<Task>;
  getOrderTasks?: Maybe<Array<Maybe<Task>>>;
  getOrderWorkflow?: Maybe<Workflow>;
  getPackages: GetPackagesResponse;
  getPaginatedDirectoryCompanies?: Maybe<CompanySummaryConnection>;
  getPaginatedDirectoryContacts?: Maybe<ContactWithCompanySummaryConnection>;
  getPayoffs: WrappedPayoff;
  getPositivePaySubmissions?: Maybe<Array<Maybe<PositivePaySubmission>>>;
  getProductsEligibleForRemittance?: Maybe<Array<Maybe<TitleRemittableProduct>>>;
  getProjectedPayments: ProjectedPayments;
  getPropertyTaxAndProrationConfiguration: PropertyTaxProrationConfiguration;
  getPropertyTaxAndProrationConfigurationList: Array<PropertyTaxProrationConfiguration>;
  getProration: Proration;
  getProrationCharge: ProrationCharge;
  getProrationCharges: Array<ProrationCharge>;
  getProrations: Array<Proration>;
  getRFTTCities: Array<RfttCity>;
  getRFTTCounties: Array<RfttCounty>;
  getRFTTDocuments?: Maybe<Array<Maybe<RfttDocument>>>;
  getRFTTFees?: Maybe<RfttFee>;
  getRFTTFeesByOrder?: Maybe<RfttFee>;
  getRFTTPropertyTypes: Array<RfttPropertyType>;
  getRFTTQuestions?: Maybe<Array<Maybe<RfttQuestion>>>;
  getRFTTTransactionTypes: Array<RfttTransactionType>;
  getRateValidation?: Maybe<GetRateValidation>;
  getReconciliation?: Maybe<Reconciliation>;
  getReconciliationTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getReconciliationTransactionsAvailable?: Maybe<Array<Maybe<Transaction>>>;
  getReconciliationTransactionsFinalized?: Maybe<Array<Maybe<Transaction>>>;
  getReconciliations?: Maybe<Array<Maybe<Reconciliation>>>;
  getRecordingDocument: RecordingDocument;
  getRecordingFeeTransferTaxCalc: RecordingFeeTransferTaxCalc;
  getRemittanceReport: Array<TitleRemittanceReportEntry>;
  getRemittanceTotals?: Maybe<RemittanceTotals>;
  getReportExport: ReportDownloadFile;
  getRestrictiveCovenant: RestrictiveCovenant;
  getSectionSummaryTotals: SectionSummaryTotals;
  getSecurityGroups?: Maybe<Array<SecurityGroup>>;
  getSellerSpouseTaxId: ProtectedTaxId;
  getSellerTaxId: ProtectedTaxId;
  getSequence?: Maybe<Sequence>;
  getSequences?: Maybe<Array<Maybe<Sequence>>>;
  getSignatories: SignatoriesResponse;
  getSnapshot: GetSnapshotResponse;
  getStaffRoles: Array<Maybe<StaffRole>>;
  getStateWithholding?: Maybe<StateWithholding>;
  getStatusHistory: GetStatusHistoryResponse;
  /**
   * Get tax rate for a given KY municipal tax code (ANP-4864)
   * Called when user changes the tax code dropdown
   */
  getTaxRate?: Maybe<TaxRateResponse>;
  getTemplateByNameV2: Array<Maybe<TemplateDocV2>>;
  getTemplateDocVersionHistoryV2: Array<Maybe<TemplateDocFileVersionV2>>;
  getTemplateSetV2: TemplateSetV2;
  getTemplateSetsV2: PaginatedTemplateSetsV2;
  getTemplateV2: TemplateDocV2;
  getTemplatesFromSetV2: Array<Maybe<TemplateDocV2>>;
  getTemplatesV2: PaginatedTemplatesV2;
  getTenant: Tenant;
  getTenantChild: TenantChildNode;
  getTenantChildProfileImage: TenantChildProfileImage;
  getTenantChildTaxId?: Maybe<ProtectedTaxId>;
  getTenantProfileImage: TenantProfileImage;
  getTenantTaxId?: Maybe<ProtectedTaxId>;
  getTenantUnderwriters: GetTenantUnderwritersResponse;
  getTitleAllocations?: Maybe<TitleAllocations>;
  getTitleFees?: Maybe<TitleFees>;
  getTitleSearchOrder: TitleSearchOrder;
  getTitleSearchOrders: Array<TitleSearchOrder>;
  getTitleSearchProducts: TitleSearchProductsResponse;
  getTitleSearchProviders: Array<TitleSearchProvider>;
  getTransaction?: Maybe<Transaction>;
  getTransactionLineDetail?: Maybe<LineDetail>;
  getTransactionLineDetailTransferTargets?: Maybe<Array<Maybe<TransactionLineDetailTransferTarget>>>;
  getTransactionLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  getTransactionTableData?: Maybe<TransactionTableDataResponse>;
  getTransactions?: Maybe<Array<Maybe<Transaction>>>;
  getUnderwriter: Underwriter;
  getUser: User;
  getUserDepartments: Array<Department>;
  getUserLock: UserLockStatus;
  getUserNotifications?: Maybe<Array<Maybe<Notification>>>;
  getUserProfileImage: UserProfileImage;
  getUserSignatureImage: UserSignatureImage;
  getUsers?: Maybe<Array<User>>;
  getWireManagement?: Maybe<Array<Maybe<WireManagement>>>;
  getWireValidationEula?: Maybe<WireValidationEula>;
  /**
   * Check if wire details have been previously validated.
   * Returns hash lookup result without triggering new validation.
   */
  getWireValidationHash: WireValidationHashResponse;
  /**
   * Get wire validation history for a transaction.
   * Returns historical validation attempts with masked account details.
   */
  getWireValidationHistory: Array<ValidationHistoryItem>;
  /** MATCH/UNMATCH audit timeline for a single incoming wire (newest-first) — Wire Details drawer. */
  incomingWireHistory: Array<WireHistoryEntry>;
  incomingWiresTableData: IncomingWireTableDataResponse;
  listConsolidatedPayees?: Maybe<Array<Maybe<ConsolidatedPayee>>>;
  listEpnAccounts: ListEpnAccountsResponse;
  mergeData: MergeData;
  mergeDataSchema?: Maybe<Scalars['JSONObject']>;
  order: Order;
  orderDocumentHistoryGet: Array<Maybe<OrderDocumentHistory>>;
  orderDocumentStatus: OrderDocumentStatus;
  /** @deprecated Use getOrderSummaries */
  orderList: Array<BaseOrder>;
  orderParties: Array<OrderParty>;
  /** Status-transition timeline for a single outgoing wire (newest-first) — Wire Details drawer. */
  outgoingWireHistory: Array<OutgoingWireHistoryEntry>;
  outgoingWiresTableData: OutgoingWireTableDataResponse;
  pasteConversion?: Maybe<PasteConversionResponse>;
  payeesForPBODrawer?: Maybe<Array<PartySelection>>;
  policyMetadata: PolicyMetadata;
  portalAccountGet: PortalAccount;
  portalAccountGetAll: Array<Maybe<PortalAccountGetAllItem>>;
  portalAgentNameCheck: PortalAgentNameCheckResponse;
  portalSlugCheck: PortalSlugCheckResponse;
  report: ReportEntryWithViewAndData;
  reports: Array<ReportEntry>;
  searchLegacyOrders?: Maybe<Array<Maybe<QuerySearchLegacyOrdersResponse>>>;
  searchOrders?: Maybe<Array<BaseOrder>>;
  searchRepositoryTemplates: RepositoryTemplateConnection;
  securePortalConfigureIntegrationGet: SecurePortalIntegrationConfigGetResponse;
  statementMappings?: Maybe<Array<LineTypeMapping>>;
  titleCpls: Array<Maybe<TitleCpl>>;
  titleExceptions: TitleExceptions;
  titleGeneral: TitleGeneral;
  titlePremium: TitlePremium;
  titleRequirements: TitleRequirements;
  transactionType: TransactionType;
  transactionTypeList: Array<TransactionType>;
  underwriterList: Array<Underwriter>;
  unmaskTransactionRecipientAccountNumber?: Maybe<WireAccountNumberUnmasked>;
  unmaskWireAccountNumber?: Maybe<WireAccountNumberUnmasked>;
  uploadRecordingFeesDocument: UploadRecordingFeesDocumentResponse;
  validateUnderwriter: UnderwriterValidationResult;
  verifyAddress: VerifiedAddress;
  viewer: User;
  wire?: Maybe<OutgoingWire>;
  /** Latest non-deleted outgoing wire for a transaction (null when none) — Edit Disbursement drawer lock banners. */
  wireByTransaction?: Maybe<OutgoingWire>;
};


export type QueryAdditionalPropertyDetailsArgs = {
  input: AdditionalPropertyDetailsInput;
};


export type QueryClauseTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryCompanyPortalGetArgs = {
  input: CompanyIdRequestInput;
};


export type QueryDirectoryCompaniesArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyIdOnOrder?: InputMaybe<Scalars['String']>;
  companyNameContains?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Scalars['String']>;
};


export type QueryDirectoryContactsArgs = {
  active?: InputMaybe<Scalars['Boolean']>;
  directoryCompanyId: Scalars['String'];
};


export type QueryDirectoryDetailArgs = {
  directoryCompanyId: Scalars['ID'];
  directoryContactId?: InputMaybe<Scalars['ID']>;
};


export type QueryEligibleReceiptsForWireArgs = {
  escrowAccountId: Scalars['ID'];
  incomingWireId: Scalars['ID'];
};


export type QueryEmailSignatureGetArgs = {
  input?: InputMaybe<EmailSignatureRequestInput>;
};


export type QueryFeesArgs = {
  orderId: Scalars['String'];
  statementSection?: InputMaybe<Scalars['String']>;
  statementType: Scalars['String'];
};


export type QueryFluentClauseTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<ClauseTemplateFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetActiveUsersOnEntityArgs = {
  input: GetActiveUsersOnEntityInput;
};


export type QueryGetAdjustmentStatementSectionTotalsArgs = {
  orderId: Scalars['String'];
  statementSections: Array<Scalars['String']>;
  statementType: Scalars['String'];
};


export type QueryGetAdjustmentsArgs = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};


export type QueryGetAdminMilestoneArgs = {
  includeTasks?: InputMaybe<Scalars['Boolean']>;
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetAdminMilestonesArgs = {
  workflowId: Scalars['ID'];
};


export type QueryGetAdminTaskArgs = {
  milestoneId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetAdminTasksArgs = {
  milestoneId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetAdminWorkflowArgs = {
  workflowId: Scalars['ID'];
};


export type QueryGetAllImportedTemplatesV2Args = {
  input: GetAllImportedTemplatesRequestV2Input;
};


export type QueryGetAllTransactionsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetAutocompleteResultsArgs = {
  input: Scalars['String'];
  state?: InputMaybe<Scalars['String']>;
};


export type QueryGetAvailableWorkflowsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetBuyerSpouseTaxIdArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetBuyerTaxIdArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetCalculatingCashToCloseArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetCarrierAccountArgs = {
  input: GetCarrierAccountRequestInput;
};


export type QueryGetCarrierAccountsArgs = {
  input?: InputMaybe<GetCarrierAccountsRequestInput>;
};


export type QueryGetClausePackagesArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetClauseTemplatesArgs = {
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetClosingCostsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetClosingInformationArgs = {
  orderId: Scalars['String'];
};


export type QueryGetClosingQuestionsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetConsolidatedPayeeArgs = {
  directoryCompanyId: Scalars['String'];
};


export type QueryGetConsolidatedPayeeEligibilityArgs = {
  directoryCompanyId: Scalars['String'];
};


export type QueryGetConsolidatedPayeesPendingArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetConsolidatedPaymentArgs = {
  consolidatedPaymentId: Scalars['String'];
  escrowAccountId: Scalars['String'];
};


export type QueryGetConsolidatedPaymentReportArgs = {
  escrowAccountId: Scalars['String'];
  parentTransactionId: Scalars['String'];
  windowDays?: InputMaybe<Scalars['Int']>;
};


export type QueryGetConsolidatedPaymentsCompletedArgs = {
  directoryCompanyId?: InputMaybe<Scalars['String']>;
  escrowAccountId: Scalars['String'];
};


export type QueryGetConsolidatedPaymentsDisbursedArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetConsolidatedPaymentsPendingTransactionsArgs = {
  directoryCompanyId: Scalars['String'];
  escrowAccountId: Scalars['String'];
};


export type QueryGetContactValidationArgs = {
  input: GetContactValidationRequestInput;
};


export type QueryGetDcAdjustmentsArgs = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};


export type QueryGetDepartmentArgs = {
  departmentId: Scalars['ID'];
};


export type QueryGetDirectoryCompanyTaxIdArgs = {
  directoryCompanyId: Scalars['ID'];
};


export type QueryGetDirectoryRecipientAccountNumberArgs = {
  directoryCompanyId: Scalars['ID'];
};


export type QueryGetDocTypeMappingsByCountyNameArgs = {
  input: GetDocTypeMappingsByCountyNameRequestInput;
};


export type QueryGetDocumentInsightsV2Args = {
  input: GetDocumentInsightsV2Input;
};


export type QueryGetDynamicDocumentTypesArgs = {
  input: GetDynamicDocumentTypesInput;
};


export type QueryGetDynamicDocumentTypesByCountyNameArgs = {
  input: GetDynamicDocumentTypesByCountyNameInput;
};


export type QueryGetERecordingEligibilityArgs = {
  input: GetERecordingEligibilityInput;
};


export type QueryGetEffectiveOrderCommissionsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetEligibleCountiesArgs = {
  input: GetEligibleCountiesRequestInput;
};


export type QueryGetEntityDocumentV2Args = {
  input: GetEntityDocumentV2Input;
};


export type QueryGetEntityDocumentVersionHistoryV2Args = {
  input: GetEntityDocumentV2Input;
};


export type QueryGetEntityDocumentsV2Args = {
  input: EntityTypeAndIdV2Input;
};


export type QueryGetEntityTagsV2Args = {
  input: GetEntityTagsRequestV2Input;
};


export type QueryGetEpnAccountForOrderArgs = {
  input: GetEpnAccountForOrderInput;
};


export type QueryGetEscrowAccountArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetEscrowAccountNumberAlternateProtectedArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryGetEscrowAccountNumberProtectedArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryGetEstimatedTaxesInsuranceAssessmentsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetFaTrustCredentialStatusArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetFeatureAcknowledgmentArgs = {
  featureKey: Scalars['String'];
};


export type QueryGetFeeAllocationsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetFeesWithAllocationsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetFidelityAdminAgentOptionsArgs = {
  stateCode: Scalars['String'];
  underwriterCode: Scalars['String'];
};


export type QueryGetFilteredTenantCompaniesArgs = {
  tenantId: Scalars['ID'];
};


export type QueryGetFinalizedReconciliationBookBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFinalizedReconciliationEscrowTrialBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFinalizedReconciliationReconciledBankBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFinalizedReconciliationSummaryArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetFraudtoolsIntegrationStatusArgs = {
  input: GetIntegrationStatusRequestInput;
};


export type QueryGetFundArgs = {
  orderId: Scalars['String'];
};


export type QueryGetGfeChargesArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetHudBorrowerCalculationsArgs = {
  orderId: Scalars['ID'];
  statementType: Scalars['String'];
};


export type QueryGetHudFormTypeArgs = {
  orderId: Scalars['String'];
};


export type QueryGetIdentityVerificationArgs = {
  input: GetIdentityVerificationRequestInput;
};


export type QueryGetInProgressReconciliationBookBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetInProgressReconciliationEscrowTrialBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetInProgressReconciliationReconciledBankBalanceTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetInProgressReconciliationSummaryArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetInsightV2Args = {
  input: GetInsightV2Input;
};


export type QueryGetIntegrationArgs = {
  input: GetIntegrationRequestInput;
};


export type QueryGetIntegrationOrderReadinessArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetJacketArgs = {
  jacketInput: JacketInput;
};


export type QueryGetL3RecipientAccountNumberArgs = {
  itemId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QueryGetLabelsByOrderIdArgs = {
  input: GetLabelsByOrderIdRequestInput;
};


export type QueryGetLatestInsightArgs = {
  orderId: Scalars['String'];
};


export type QueryGetLoanCalculationsDisclosuresArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetLoanDisclosuresArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetMasterOrdersArgs = {
  companyId: Scalars['ID'];
};


export type QueryGetNotesArgs = {
  appliesToId?: InputMaybe<Scalars['String']>;
  entityId: Scalars['String'];
  type: NoteEntityType;
};


export type QueryGetOrderAssistLatestInsightArgs = {
  companyId: Scalars['String'];
  sessionId: Scalars['String'];
};


export type QueryGetOrderBuyerArgs = {
  buyerId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetOrderCommissionsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetOrderDepositsArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetOrderFundsHeldByNameArgs = {
  fundsHeldBy: Scalars['String'];
  orderId: Scalars['ID'];
};


export type QueryGetOrderLineDetails_V2Args = {
  escrowAccountId: Scalars['String'];
  orderId: Scalars['String'];
};


export type QueryGetOrderMilestoneArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
};


export type QueryGetOrderMilestonesArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetOrderPartyRecipientAccountNumArgs = {
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
};


export type QueryGetOrderPartyTaxIdArgs = {
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
};


export type QueryGetOrderSellerArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type QueryGetOrderSummariesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<OrderSummaryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrderSummariesForL1SearchArgs = {
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
  useV2?: InputMaybe<Scalars['Boolean']>;
};


export type QueryGetOrderSummariesV2Args = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<OrderSummaryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetOrderTaskByIdArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  taskId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetOrderTasksArgs = {
  milestoneId: Scalars['ID'];
  orderId: Scalars['ID'];
  workflowId: Scalars['ID'];
};


export type QueryGetOrderWorkflowArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetPackagesArgs = {
  input: GetPackagesRequestInput;
};


export type QueryGetPaginatedDirectoryCompaniesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<QueryFilter>>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetPaginatedDirectoryContactsArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<InputMaybe<QueryFilter>>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryGetPayoffsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetPositivePaySubmissionsArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryGetProductsEligibleForRemittanceArgs = {
  underwriterId: Scalars['String'];
};


export type QueryGetProjectedPaymentsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetPropertyTaxAndProrationConfigurationArgs = {
  configurationId: Scalars['ID'];
};


export type QueryGetProrationArgs = {
  orderId: Scalars['String'];
  prorationId: Scalars['String'];
};


export type QueryGetProrationChargeArgs = {
  orderId: Scalars['String'];
  prorationChargeId: Scalars['String'];
};


export type QueryGetProrationChargesArgs = {
  orderId: Scalars['String'];
  prorationChargeType?: InputMaybe<Scalars['String']>;
};


export type QueryGetProrationsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetRfttCitiesArgs = {
  county: Scalars['String'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
};


export type QueryGetRfttCountiesArgs = {
  state: Scalars['String'];
};


export type QueryGetRfttDocumentsArgs = {
  input: GetRfttDocumentsInput;
};


export type QueryGetRfttFeesArgs = {
  input: GetRfttFeesInput;
};


export type QueryGetRfttFeesByOrderArgs = {
  input: GetRfttFeesByOrderInput;
};


export type QueryGetRfttPropertyTypesArgs = {
  settlementDate: Scalars['String'];
  state: Scalars['String'];
};


export type QueryGetRfttQuestionsArgs = {
  input: GetRfttQuestionsInput;
};


export type QueryGetRfttTransactionTypesArgs = {
  propertyType: Scalars['String'];
  settlementDate: Scalars['String'];
  state: Scalars['String'];
};


export type QueryGetRateValidationArgs = {
  orderId: Scalars['String'];
  premiumType: Scalars['String'];
};


export type QueryGetReconciliationArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationTransactionsArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationTransactionsAvailableArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationTransactionsFinalizedArgs = {
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
};


export type QueryGetReconciliationsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetRecordingDocumentArgs = {
  input: GetRecordingDocumentInput;
};


export type QueryGetRecordingFeeTransferTaxCalcArgs = {
  orderId: Scalars['String'];
};


export type QueryGetRemittanceReportArgs = {
  remittanceDateFrom: Scalars['String'];
  remittanceDateTo: Scalars['String'];
  underwriterId: Scalars['String'];
};


export type QueryGetRemittanceTotalsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetReportExportArgs = {
  input: GetReportExportInput;
};


export type QueryGetRestrictiveCovenantArgs = {
  orderId: Scalars['String'];
};


export type QueryGetSectionSummaryTotalsArgs = {
  orderId: Scalars['String'];
  statementSections: Array<Scalars['String']>;
  statementType: Scalars['String'];
};


export type QueryGetSellerSpouseTaxIdArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type QueryGetSellerTaxIdArgs = {
  orderId: Scalars['ID'];
  sellerId: Scalars['ID'];
};


export type QueryGetSequenceArgs = {
  sequenceId: Scalars['ID'];
};


export type QueryGetSequencesArgs = {
  orgId?: InputMaybe<Scalars['ID']>;
};


export type QueryGetSignatoriesArgs = {
  branch: Scalars['String'];
  stateCode: Scalars['String'];
  underwriterId: Scalars['String'];
};


export type QueryGetSnapshotArgs = {
  input: GetSnapshotRequestInput;
};


export type QueryGetStateWithholdingArgs = {
  orderId: Scalars['ID'];
};


export type QueryGetStatusHistoryArgs = {
  input: GetStatusHistoryRequestInput;
};


export type QueryGetTaxRateArgs = {
  effectiveDate?: InputMaybe<Scalars['String']>;
  taxCode: Scalars['String'];
};


export type QueryGetTemplateByNameV2Args = {
  input: GetTemplatesByNameAndFileTypeV2Input;
};


export type QueryGetTemplateDocVersionHistoryV2Args = {
  input: TemplateDocTypeAndIdV2Input;
};


export type QueryGetTemplateSetV2Args = {
  input: TemplateSetIdV2Input;
};


export type QueryGetTemplateSetsV2Args = {
  input?: InputMaybe<PaginatedTemplateSetQueryV2Input>;
};


export type QueryGetTemplateV2Args = {
  input: TemplateDocTypeAndIdV2Input;
};


export type QueryGetTemplatesFromSetV2Args = {
  input: GetTemplatesFromSetQueryV2Input;
};


export type QueryGetTemplatesV2Args = {
  input: PaginatedTemplatesQueryV2Input;
};


export type QueryGetTenantArgs = {
  id: Scalars['String'];
  permissionFilter?: InputMaybe<Scalars['String']>;
};


export type QueryGetTenantChildArgs = {
  itemId?: InputMaybe<Scalars['String']>;
};


export type QueryGetTenantChildProfileImageArgs = {
  itemId: Scalars['ID'];
};


export type QueryGetTenantChildTaxIdArgs = {
  itemId: Scalars['ID'];
  tenantId: Scalars['ID'];
};


export type QueryGetTenantProfileImageArgs = {
  tenantId: Scalars['ID'];
};


export type QueryGetTenantTaxIdArgs = {
  id: Scalars['ID'];
};


export type QueryGetTitleAllocationsArgs = {
  orderId: Scalars['String'];
};


export type QueryGetTitleFeesArgs = {
  orderId: Scalars['String'];
};


export type QueryGetTitleSearchOrderArgs = {
  input?: InputMaybe<GetTitleSearchOrderInput>;
};


export type QueryGetTitleSearchOrdersArgs = {
  input?: InputMaybe<GetTitleSearchOrdersInput>;
};


export type QueryGetTitleSearchProductsArgs = {
  input?: InputMaybe<GetTitleSearchProductsInput>;
};


export type QueryGetTransactionArgs = {
  escrowAccountId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionLineDetailArgs = {
  escrowAccountId: Scalars['String'];
  lineDetailId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionLineDetailTransferTargetsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetTransactionLineDetailsArgs = {
  escrowAccountId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type QueryGetTransactionTableDataArgs = {
  input: TransactionTableDataInput;
};


export type QueryGetTransactionsArgs = {
  escrowAccountId: Scalars['String'];
};


export type QueryGetUnderwriterArgs = {
  underwriterId: Scalars['ID'];
};


export type QueryGetUserArgs = {
  id: Scalars['String'];
};


export type QueryGetUserDepartmentsArgs = {
  userId: Scalars['ID'];
};


export type QueryGetUserLockArgs = {
  id: Scalars['String'];
};


export type QueryGetUserNotificationsArgs = {
  status?: InputMaybe<ReadStatus>;
};


export type QueryGetUserProfileImageArgs = {
  id: Scalars['String'];
};


export type QueryGetUserSignatureImageArgs = {
  id: Scalars['String'];
};


export type QueryGetUsersArgs = {
  l3Id?: InputMaybe<Scalars['String']>;
};


export type QueryGetWireManagementArgs = {
  escrowAccountId: Scalars['ID'];
};


export type QueryGetWireValidationHashArgs = {
  input: WireValidationHashInput;
};


export type QueryGetWireValidationHistoryArgs = {
  input: WireValidationHistoryInput;
};


export type QueryIncomingWireHistoryArgs = {
  escrowAccountId: Scalars['String'];
  incomingWireId: Scalars['String'];
};


export type QueryIncomingWiresTableDataArgs = {
  input: IncomingWireTableDataInput;
};


export type QueryMergeDataArgs = {
  orderId: Scalars['ID'];
};


export type QueryOrderArgs = {
  id: Scalars['ID'];
  retrieveAllParties?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOrderDocumentHistoryGetArgs = {
  input: OrderDocumentHistoryGetRequestInput;
};


export type QueryOrderDocumentStatusArgs = {
  input: OrderDocumentStatusRequestInput;
};


export type QueryOrderPartiesArgs = {
  id: Scalars['ID'];
  retrieveAllParties?: InputMaybe<Scalars['Boolean']>;
};


export type QueryOutgoingWireHistoryArgs = {
  escrowAccountId: Scalars['String'];
  reference: Scalars['String'];
};


export type QueryOutgoingWiresTableDataArgs = {
  input: OutgoingWireTableDataInput;
};


export type QueryPasteConversionArgs = {
  content: Scalars['String'];
  type: Scalars['String'];
};


export type QueryPayeesForPboDrawerArgs = {
  orderId: Scalars['String'];
};


export type QueryPolicyMetadataArgs = {
  id: Scalars['ID'];
};


export type QueryPortalAccountGetArgs = {
  input: PortalIdRequestInput;
};


export type QueryPortalAgentNameCheckArgs = {
  input: PortalAgentNameCheckRequestInput;
};


export type QueryPortalSlugCheckArgs = {
  input: PortalSlugCheckRequestInput;
};


export type QueryReportArgs = {
  id: Scalars['ID'];
  viewId?: InputMaybe<Scalars['ID']>;
};


export type QuerySearchLegacyOrdersArgs = {
  input?: InputMaybe<QuerySearchLegacyOrdersInput>;
};


export type QuerySearchOrdersArgs = {
  orderNumber: Scalars['String'];
};


export type QuerySearchRepositoryTemplatesArgs = {
  after?: InputMaybe<Scalars['String']>;
  filters?: InputMaybe<Array<QueryFilter>>;
  first?: InputMaybe<Scalars['Int']>;
  search?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['String']>;
};


export type QueryTitleCplsArgs = {
  orderId: Scalars['ID'];
};


export type QueryTitleExceptionsArgs = {
  id: Scalars['ID'];
};


export type QueryTitleGeneralArgs = {
  id: Scalars['ID'];
};


export type QueryTitlePremiumArgs = {
  id: Scalars['ID'];
  premiumType: Scalars['String'];
};


export type QueryTitleRequirementsArgs = {
  id: Scalars['ID'];
};


export type QueryTransactionTypeArgs = {
  id: Scalars['String'];
};


export type QueryUnderwriterListArgs = {
  companyId?: InputMaybe<Scalars['ID']>;
  filterGloballyInactive?: InputMaybe<Scalars['Boolean']>;
};


export type QueryUnmaskTransactionRecipientAccountNumberArgs = {
  escrowAccountId: Scalars['ID'];
  transactionId: Scalars['ID'];
};


export type QueryUnmaskWireAccountNumberArgs = {
  escrowAccountId: Scalars['ID'];
  field: WireAccountField;
  reference: Scalars['String'];
};


export type QueryUploadRecordingFeesDocumentArgs = {
  input: UploadRecordingFeesDocumentInput;
};


export type QueryValidateUnderwriterArgs = {
  underwriterId: Scalars['ID'];
};


export type QueryVerifyAddressArgs = {
  formattedAddress: Scalars['String'];
};


export type QueryWireArgs = {
  escrowAccountId: Scalars['String'];
  reference: Scalars['String'];
};


export type QueryWireByTransactionArgs = {
  escrowAccountId: Scalars['ID'];
  transactionId: Scalars['ID'];
};

export type QueryFilter = {
  field: Scalars['String'];
  operator: ApiFilterOperator;
  shouldFilterEmpty?: InputMaybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type QuerySearchLegacyOrdersInput = {
  address1?: InputMaybe<Scalars['String']>;
  parcelId?: InputMaybe<Scalars['String']>;
  state: Scalars['String'];
};

export type QuerySearchLegacyOrdersResponse = {
  __typename?: 'QuerySearchLegacyOrdersResponse';
  address?: Maybe<SearchLegacyAddress>;
  buyers?: Maybe<Scalars['String']>;
  legacyOrderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  parcelIdsDisplay?: Maybe<Scalars['String']>;
  sellers?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionType?: Maybe<Scalars['String']>;
};

export type QuickBooksConfig = {
  __typename?: 'QuickBooksConfig';
  accountName?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  includePartyAddress?: Maybe<Scalars['Boolean']>;
  subAccountFormat?: Maybe<QuickBooksSubAccountFormat>;
};

export type QuickBooksConfigInput = {
  accountName?: InputMaybe<Scalars['String']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  includePartyAddress?: InputMaybe<Scalars['Boolean']>;
  subAccountFormat?: InputMaybe<QuickBooksSubAccountFormat>;
};

/**
 *  Result of exporting QuickBooks IIF file for a funded order.
 *  Contains the IIF file content (text data with
 * line endings) and
 *  the generated file name following the pattern YYYY-<sequence>.iif.
 */
export type QuickBooksExportResult = {
  __typename?: 'QuickBooksExportResult';
  /**
   *    IIF file content as text with
   * line endings
   */
  fileContent: Scalars['String'];
  /** Generated IIF file name in pattern YYYY-<sequence>.iif */
  fileName: Scalars['String'];
};

export enum QuickBooksSubAccountFormat {
  AnpOrderNumber = 'ANP_ORDER_NUMBER',
  Other = 'OTHER'
}

export type RfttAnswerInput = {
  value?: InputMaybe<Scalars['String']>;
};

export type RfttCity = {
  __typename?: 'RFTTCity';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttCounty = {
  __typename?: 'RFTTCounty';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttDocument = {
  __typename?: 'RFTTDocument';
  considerationAmount?: Maybe<Scalars['Float']>;
  documentName: Scalars['String'];
  documentType: Scalars['String'];
  isDefault: Scalars['Boolean'];
  numberOfPages?: Maybe<Scalars['Float']>;
};

export type RfttFee = {
  __typename?: 'RFTTFee';
  recordingFees: RfttRecordingFees;
  transferTaxes: RfttTransferTaxes;
};

export type RfttPropertyType = {
  __typename?: 'RFTTPropertyType';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttQuestion = {
  __typename?: 'RFTTQuestion';
  defaultAnswer?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  options?: Maybe<Array<RfttQuestionOption>>;
  providerMetadata: RfttQuestionProviderMetadata;
  questionText?: Maybe<Scalars['String']>;
  shouldPrompt: Scalars['Boolean'];
  valueType?: Maybe<Scalars['String']>;
};

export type RfttQuestionOption = {
  __typename?: 'RFTTQuestionOption';
  key?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type RfttQuestionOptionInput = {
  key?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type RfttQuestionProviderMetadata = {
  __typename?: 'RFTTQuestionProviderMetadata';
  lvis: RfttQuestionProviderMetadataLvis;
};

export type RfttQuestionProviderMetadataInput = {
  lvis: RfttQuestionProviderMetadataLvisInput;
};

export type RfttQuestionProviderMetadataLvis = {
  __typename?: 'RFTTQuestionProviderMetadataLVIS';
  code?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type RfttQuestionProviderMetadataLvisInput = {
  code: Scalars['String'];
  name: Scalars['String'];
};

export type RfttRecordingFeeItem = {
  __typename?: 'RFTTRecordingFeeItem';
  buyerAmount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  sellerAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type RfttRecordingFees = {
  __typename?: 'RFTTRecordingFees';
  items: Array<RfttRecordingFeeItem>;
  party?: Maybe<OrderParty>;
  payee?: Maybe<Scalars['String']>;
};

export type RfttTransactionType = {
  __typename?: 'RFTTTransactionType';
  description: Scalars['String'];
  id: Scalars['String'];
};

export type RfttTransferTaxItem = {
  __typename?: 'RFTTTransferTaxItem';
  buyerAmount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  party?: Maybe<OrderParty>;
  payee?: Maybe<Scalars['String']>;
  sellerAmount?: Maybe<Scalars['Float']>;
  totalAmount?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type RfttTransferTaxes = {
  __typename?: 'RFTTTransferTaxes';
  items: Array<RfttTransferTaxItem>;
};

export type RateObject = {
  __typename?: 'RateObject';
  carrierAccountId: Scalars['ID'];
  carrierType: CarrierType;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  deliveryDate?: Maybe<Scalars['String']>;
  deliveryDateGuaranteed?: Maybe<Scalars['Boolean']>;
  deliveryDays?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  rate: Scalars['String'];
  service: Scalars['String'];
  shipmentId?: Maybe<Scalars['ID']>;
  status: RateStatus;
  tenantId: Scalars['ID'];
  updatedBy: UserDisplayName;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export enum RateStatus {
  Purchased = 'PURCHASED',
  Requested = 'REQUESTED'
}

export type RateValidation = {
  missingFields: Array<Scalars['String']>;
  orderId: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type RateValidationRequest = {
  lenderPolicy?: InputMaybe<PolicyRateValidationRequest>;
  ownerPolicy?: InputMaybe<PolicyRateValidationRequest>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  simultaneousIssue?: InputMaybe<Scalars['Boolean']>;
};

export enum ReadStatus {
  Read = 'read',
  Unread = 'unread'
}

/**
 * Tracks the state of automatic premium recalculation (ANP-6975).
 * Used by the frontend to show visual indicators when recalculation
 * is in progress or has failed.
 */
export enum RecalculationStatus {
  Failed = 'FAILED',
  None = 'NONE',
  Pending = 'PENDING'
}

export type ReceivingBankInput = {
  address?: InputMaybe<AddressInput>;
  bankIdNumber?: InputMaybe<Scalars['String']>;
  bankIdType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  obiLine1?: InputMaybe<Scalars['String']>;
  obiLine2?: InputMaybe<Scalars['String']>;
  obiLine3?: InputMaybe<Scalars['String']>;
  obiLine4?: InputMaybe<Scalars['String']>;
};

export type ReceivingBankSchema = {
  __typename?: 'ReceivingBankSchema';
  address?: Maybe<Address>;
  bankIdNumber?: Maybe<Scalars['String']>;
  bankIdType?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  obiLine1?: Maybe<Scalars['String']>;
  obiLine2?: Maybe<Scalars['String']>;
  obiLine3?: Maybe<Scalars['String']>;
  obiLine4?: Maybe<Scalars['String']>;
};

export type RecentAttorneySelection = {
  __typename?: 'RecentAttorneySelection';
  address?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  role: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type ReconciledBankBalanceTransaction = {
  __typename?: 'ReconciledBankBalanceTransaction';
  amount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeName?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  typeOfFunds?: Maybe<Scalars['String']>;
};

export type Reconciliation = {
  __typename?: 'Reconciliation';
  bankName?: Maybe<Scalars['String']>;
  beginningBalance?: Maybe<Scalars['Float']>;
  clearedBalance?: Maybe<Scalars['Float']>;
  completedAt?: Maybe<Scalars['String']>;
  completedByDisplayName?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdTimestamp?: Maybe<Scalars['String']>;
  difference?: Maybe<Scalars['Float']>;
  eligibleTransactions?: Maybe<Array<Maybe<Transaction>>>;
  endingDate?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  escrowAccountName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  statementEndingBalance?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  summary?: Maybe<ReconciliationSummary>;
  transactionIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy?: Maybe<User>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export enum ReconciliationStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type ReconciliationSummary = {
  __typename?: 'ReconciliationSummary';
  bankEndingBalance: Scalars['Float'];
  bookBalanceTotal: Scalars['Float'];
  escrowTrialBalanceTotal: Scalars['Float'];
  previousReconciliationEndingBalance: Scalars['Float'];
  reconciledBankBalanceTotal: Scalars['Float'];
  reconciliationId: Scalars['String'];
  totalDisbursements: Scalars['Float'];
  totalOutstandingDisbursements: Scalars['Float'];
  totalOutstandingReceipts: Scalars['Float'];
  totalReceipts: Scalars['Float'];
};

export type RecordingDocument = {
  __typename?: 'RecordingDocument';
  actualFees?: Maybe<Scalars['Float']>;
  associatedDocumentId?: Maybe<Scalars['ID']>;
  associatedDocumentType?: Maybe<Scalars['String']>;
  associatedRFTTDocumentId?: Maybe<Scalars['ID']>;
  associatedReturnDocumentId?: Maybe<Scalars['ID']>;
  book?: Maybe<Scalars['String']>;
  collectedFees?: Maybe<Scalars['Float']>;
  considerationAmount?: Maybe<Scalars['Float']>;
  considerationAmountOverrideMetadata: NumberOverrideMetadata;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  description: Scalars['String'];
  documentDate?: Maybe<Scalars['String']>;
  documentTime?: Maybe<Scalars['String']>;
  documentType: Scalars['String'];
  documentTypeOverrideMetadata: StringOverrideMetadata;
  id: Scalars['ID'];
  instrumentNumber?: Maybe<Scalars['String']>;
  isAssociatedRFTTDocumentDeleted: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  isERecorded: Scalars['Boolean'];
  isReadOnly: Scalars['Boolean'];
  isUserUpdated: Scalars['Boolean'];
  name: Scalars['String'];
  nameOverrideMetadata: StringOverrideMetadata;
  orderId: Scalars['ID'];
  page?: Maybe<Scalars['String']>;
  pageCount?: Maybe<Scalars['String']>;
  pageCountOverrideMetadata: StringOverrideMetadata;
  recordedDate?: Maybe<Scalars['String']>;
  recordedTime?: Maybe<Scalars['String']>;
  updatedBy: UserDisplayName;
  updatedTimestamp: Scalars['String'];
};

export type RecordingFeeAdditionalData = {
  __typename?: 'RecordingFeeAdditionalData';
  externalCalculatorLineItemId?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  rfttFeeLineType?: Maybe<Scalars['String']>;
};

export type RecordingFeeCalculatorLineItem = {
  __typename?: 'RecordingFeeCalculatorLineItem';
  amount?: Maybe<Scalars['Float']>;
  amountFallback?: Maybe<Scalars['Float']>;
  buyerAmount?: Maybe<Scalars['Float']>;
  buyerAmountFallback?: Maybe<Scalars['Float']>;
  buyerPercentage?: Maybe<Scalars['Float']>;
  default?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  nameFallback?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  sellerAmount?: Maybe<Scalars['Float']>;
  sellerPercentage?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type RecordingFeeCalculatorLineItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  buyerPercentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  type: Scalars['String'];
};

export type RecordingFeeTransferTaxCalc = {
  __typename?: 'RecordingFeeTransferTaxCalc';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<Maybe<IntegratedRfttDocument>>>;
  documentsParams?: Maybe<IntegratedRfttDocumentsParams>;
  providerType?: Maybe<Scalars['String']>;
  questions?: Maybe<Array<Maybe<IntegratedRfttQuestion>>>;
  recordingFees: RecordingFees;
  totalAmount?: Maybe<Scalars['Float']>;
  totalBuyerAmount?: Maybe<Scalars['Float']>;
  totalPboAmount?: Maybe<Scalars['Float']>;
  totalSellerAmount?: Maybe<Scalars['Float']>;
  transferTaxes: TransferTaxes;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type RecordingFeeTransferTaxPayee = {
  __typename?: 'RecordingFeeTransferTaxPayee';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  directoryCompanyReferenceId?: Maybe<Scalars['String']>;
  emailAddress?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  roleId?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
};

export type RecordingFees = {
  __typename?: 'RecordingFees';
  lineItems: Array<RecordingFeeCalculatorLineItem>;
  payee?: Maybe<RecordingFeeTransferTaxPayee>;
  payeeId?: Maybe<Scalars['String']>;
  payeeSuggested?: Maybe<Scalars['String']>;
};

export type RecordingFeesInput = {
  lineItems?: InputMaybe<Array<InputMaybe<RecordingFeeCalculatorLineItemInput>>>;
  payeeId?: InputMaybe<Scalars['String']>;
};

export type RecordingJurisdiction = {
  __typename?: 'RecordingJurisdiction';
  fips?: Maybe<Scalars['String']>;
  fullCountyName?: Maybe<Scalars['String']>;
  requesterCountyName?: Maybe<Scalars['String']>;
  rjid?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  stateAbbreviation?: Maybe<Scalars['String']>;
};

export type RefMetaData = {
  __typename?: 'RefMetaData';
  refItemAmount?: Maybe<Scalars['Float']>;
  refItemId?: Maybe<Scalars['String']>;
  refItemType?: Maybe<Scalars['String']>;
  refItemUpdatedTimestamp?: Maybe<Scalars['String']>;
};

export type RefMetaDataInput = {
  refItemAmount?: InputMaybe<Scalars['Float']>;
  refItemId?: InputMaybe<Scalars['String']>;
  refItemType?: InputMaybe<Scalars['String']>;
  refItemUpdatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type RefreshCommissionsInput = {
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
};

export type RefreshDepositsForAdjustmentsInput = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};

export type RefreshDepositsForFeesInput = {
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
};

export type RefreshPremiumsAndFeesInput = {
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
};

export type ReleaseAnalysisV2 = {
  __typename?: 'ReleaseAnalysisV2';
  openLiens?: Maybe<Array<LienReferenceV2>>;
  releaseIssues?: Maybe<Array<Scalars['String']>>;
  satisfiedLiens?: Maybe<Array<LienReferenceV2>>;
};

export type RemittanceProduct = {
  __typename?: 'RemittanceProduct';
  orderId: Scalars['String'];
  productId: Scalars['String'];
  productIndex?: Maybe<Scalars['Int']>;
  productType: Scalars['String'];
};

export type RemittanceProductInput = {
  orderId: Scalars['String'];
  productId: Scalars['String'];
  productIndex?: InputMaybe<Scalars['Int']>;
  productType: Scalars['String'];
};

export type RemittanceTotals = {
  __typename?: 'RemittanceTotals';
  agentRetainedTotal?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['String']>;
  underwriterRemittedTotal?: Maybe<Scalars['Float']>;
};

export type RemoveConsolidatedPayeeInput = {
  directoryCompanyId: Scalars['String'];
};

/** These fields are required to update the OrderParty, but their values will not be included in the update. - deprecated (Use UpdateOrderPartyInput instead) */
export type ReplacePartyCompanyAndContactMetadata = {
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['ID'];
  partyId: Scalars['ID'];
  /** This field is required to correctly identify the OrderParty. It will be removed once an OrderParty can be identified by its ID alone. */
  refSectionId?: InputMaybe<Scalars['String']>;
  /** This field is required to correctly identify the OrderParty. It will be removed once an OrderParty can be identified by its ID alone. */
  refSectionLabel?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

/** These are the only properties that will be updated on the OrderParty - deprecated (Use CreateOrderPartyInput or UpdateOrderPartyInput instead) */
export type ReplacePartyCompanyAndContactPayload = {
  directoryCompanyId?: InputMaybe<Scalars['String']>;
  directoryContactId?: InputMaybe<Scalars['String']>;
};

export type ReplacePartyCompanyAndContactResult = {
  __typename?: 'ReplacePartyCompanyAndContactResult';
  party?: Maybe<OrderParty>;
};

export type ReportDataAggregation = {
  __typename?: 'ReportDataAggregation';
  aggregation: Scalars['String'];
  column: Scalars['String'];
};

export type ReportDataAggregationInput = {
  aggregation: Scalars['String'];
  column: Scalars['String'];
};

export type ReportDataFilter = {
  __typename?: 'ReportDataFilter';
  column: Scalars['String'];
  /** Date From value to filter by. If the operator is not 'inRange' and type is date, this field is ignored. */
  dateFromValue?: Maybe<Scalars['String']>;
  /** Date To value to filter by. If the operator is not 'inRange' and type is date, this field is ignored. */
  dateToValue?: Maybe<Scalars['String']>;
  /** Maximum value to filter by. If the operator is not 'inRange' and type is number, this field is ignored. */
  maxValue?: Maybe<Scalars['Float']>;
  /** Minimum value to filter by. If the operator is not 'inRange' and type is number, this field is ignored. */
  minValue?: Maybe<Scalars['Float']>;
  operator: Scalars['ReportDataFilterOperator'];
  type?: Maybe<Scalars['ReportDataFilterType']>;
  /** Value to filter by. If the operator is 'blank' or 'notBlank', this field is ignored. */
  value?: Maybe<Scalars['ANY']>;
};

export type ReportDataFilterInput = {
  column: Scalars['String'];
  /** Date From value to filter by. If the operator is not 'inRange' and type is date, this field is ignored. */
  dateFromValue?: InputMaybe<Scalars['String']>;
  /** Date To value to filter by. If the operator is not 'inRange' and type is date, this field is ignored. */
  dateToValue?: InputMaybe<Scalars['String']>;
  /** Maximum value to filter by. If the operator is not 'inRange' and type is number, this field is ignored. */
  maxValue?: InputMaybe<Scalars['Float']>;
  /** Minimum value to filter by. If the operator is not 'inRange' and type is number, this field is ignored. */
  minValue?: InputMaybe<Scalars['Float']>;
  operator: Scalars['ReportDataFilterOperator'];
  type: Scalars['ReportDataFilterType'];
  /** Value to filter by. If the operator is 'blank' or 'notBlank', this field is ignored. */
  value?: InputMaybe<Scalars['ANY']>;
};

export type ReportDataInput = {
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  preview?: InputMaybe<ReportDataPreviewInput>;
};

export type ReportDataPreviewInput = {
  aggregations?: InputMaybe<Array<ReportDataAggregationInput>>;
  columns?: InputMaybe<Array<Scalars['String']>>;
  filters?: InputMaybe<Array<ReportDataFilterInput>>;
  groupings?: InputMaybe<Array<ReportViewGroupingFieldInput>>;
  search?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Array<ReportViewSortColumnInput>>;
};

export type ReportDataset = {
  __typename?: 'ReportDataset';
  columns: Array<ReportDatasetColumn>;
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type ReportDatasetColumn = {
  __typename?: 'ReportDatasetColumn';
  category: Scalars['String'];
  column: Scalars['String'];
  columnDescription: Scalars['String'];
  columnType: Scalars['ReportColumnType'];
};

export type ReportDownload = {
  __typename?: 'ReportDownload';
  exportId: Scalars['String'];
  id: Scalars['ID'];
};

export type ReportDownloadFile = {
  __typename?: 'ReportDownloadFile';
  compression?: Maybe<Scalars['String']>;
  cryptoKey: FileCryptoKey;
  fileType: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
  resourceUrl: Scalars['String'];
  size: Scalars['Int'];
};

export type ReportDownloadInput = {
  columns: Array<Scalars['String']>;
  decrypt: Scalars['Boolean'];
  filters?: InputMaybe<Array<ReportDataFilterInput>>;
  reportId: Scalars['String'];
  sorting?: InputMaybe<Array<ReportViewSortColumnInput>>;
};

export type ReportEntry = {
  __typename?: 'ReportEntry';
  dataset?: Maybe<ReportDataset>;
  /** @deprecated Use dataset instead */
  datasetId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['String']>;
  parentReportId?: Maybe<Scalars['String']>;
  type?: Maybe<ReportViewType>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
  visibility: Scalars['ReportVisibility'];
};

export type ReportEntryWithViewAndData = {
  __typename?: 'ReportEntryWithViewAndData';
  data: Array<Scalars['JSONObject']>;
  dataset?: Maybe<ReportDataset>;
  /** @deprecated Use dataset instead */
  datasetId: Scalars['ID'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  ownerId?: Maybe<Scalars['String']>;
  parentReportId?: Maybe<Scalars['String']>;
  type?: Maybe<ReportViewType>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
  view: ReportView;
  visibility: Scalars['ReportVisibility'];
};


export type ReportEntryWithViewAndDataDataArgs = {
  input?: InputMaybe<ReportDataInput>;
};

export type ReportView = {
  __typename?: 'ReportView';
  aggregations: Array<ReportDataAggregation>;
  columnSets: Array<ColumnSets>;
  filters: Array<ReportDataFilter>;
  groupings: Array<Scalars['String']>;
  id: Scalars['ID'];
  pinnedColumns: Array<ReportViewPinnedColumn>;
  quickFilters: Array<Scalars['String']>;
  sortColumns: Array<ReportViewSortColumn>;
  visibleColumns: Array<Scalars['String']>;
};

export type ReportViewGroupingFieldInput = {
  groupKey: Scalars['String'];
  groupPriority: Scalars['Int'];
  groupValue?: InputMaybe<Scalars['ANY']>;
};

export type ReportViewInput = {
  aggregations: Array<ReportDataAggregationInput>;
  filters: Array<ReportDataFilterInput>;
  groupings: Array<Scalars['String']>;
  pinnedColumns: Array<ReportViewPinnedColumnInput>;
  quickFilters: Array<Scalars['String']>;
  sortColumns: Array<ReportViewSortColumnInput>;
  visibleColumns: Array<Scalars['String']>;
};

export type ReportViewPinnedColumn = {
  __typename?: 'ReportViewPinnedColumn';
  column: Scalars['String'];
  pinnedSide: Scalars['ReportViewColumnPinnedSide'];
  priority: Scalars['Int'];
};

export type ReportViewPinnedColumnInput = {
  column: Scalars['String'];
  pinnedSide: Scalars['ReportViewColumnPinnedSide'];
  priority: Scalars['Int'];
};

export type ReportViewSortColumn = {
  __typename?: 'ReportViewSortColumn';
  sortDirection: Scalars['ReportViewColumnSortDirection'];
  sortKey: Scalars['String'];
  sortPriority: Scalars['Int'];
};

export type ReportViewSortColumnInput = {
  sortDirection: Scalars['ReportViewColumnSortDirection'];
  sortKey: Scalars['String'];
  sortPriority: Scalars['Int'];
};

export enum ReportViewType {
  BuiltIn = 'BUILT_IN',
  SavedView = 'SAVED_VIEW'
}

export type RepositoryBlockImportReferenceV2 = {
  __typename?: 'RepositoryBlockImportReferenceV2';
  id: Scalars['ID'];
  name: Scalars['String'];
};

export type RepositoryTemplate = Node & {
  __typename?: 'RepositoryTemplate';
  bucket: Scalars['String'];
  categories: Array<Scalars['String']>;
  createdTimestamp: Scalars['DateTime'];
  description: Scalars['String'];
  filePath?: Maybe<Scalars['String']>;
  fileType?: Maybe<Scalars['String']>;
  fileVersionId?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  importedBlocks: Array<Scalars['String']>;
  isActive: Scalars['Boolean'];
  isDeleted: Scalars['Boolean'];
  name: Scalars['String'];
  states: Array<Scalars['String']>;
  templateType: Scalars['String'];
  underwriters: Array<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type RepositoryTemplateConnection = Connection & {
  __typename?: 'RepositoryTemplateConnection';
  edges: Array<RepositoryTemplateEdge>;
  pageInfo: PageInfo;
};

export type RepositoryTemplateEdge = Edge & {
  __typename?: 'RepositoryTemplateEdge';
  node: RepositoryTemplate;
};

export type RequestFedexMfaPinCreateRequestInput = {
  fedexAccountNumber: Scalars['String'];
  method: FedexMfaPinMethod;
};

export type RequestFedexMfaPinCreateResponse = {
  __typename?: 'RequestFedexMfaPinCreateResponse';
  success: Scalars['Boolean'];
};

export type RequestFedexMfaPinRequestInput = {
  id: Scalars['ID'];
  method: FedexMfaPinMethod;
};

export type RequestFedexMfaPinResponse = {
  __typename?: 'RequestFedexMfaPinResponse';
  success: Scalars['Boolean'];
};

export type RequestShippingRatesRequestInput = {
  buyerAddress?: InputMaybe<ShipmentAddressInput>;
  /** @minItems 1 */
  carrierAccounts: Array<Scalars['String']>;
  customLabelField?: InputMaybe<Scalars['String']>;
  deliveryConfirmation?: InputMaybe<Scalars['String']>;
  dropoffType?: InputMaybe<Scalars['String']>;
  fromAddress: ShipmentAddressInput;
  insurance?: InputMaybe<Scalars['String']>;
  labelDate?: InputMaybe<Scalars['String']>;
  labelSize?: InputMaybe<RequestShippingRatesRequestInputLabelSize>;
  orderId: Scalars['ID'];
  parcel: ShipmentParcelInput;
  paymentOption?: InputMaybe<ShipmentPaymentOptionInput>;
  returnAddress?: InputMaybe<ShipmentAddressInput>;
  saturdayDelivery?: InputMaybe<Scalars['Boolean']>;
  toAddress: ShipmentAddressInput;
};

export enum RequestShippingRatesRequestInputLabelSize {
  Size_4X6 = 'SIZE_4X6',
  Size_4X7 = 'SIZE_4X7',
  Size_8_5X11 = 'SIZE_8_5X11'
}

export type Requirement = {
  __typename?: 'Requirement';
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  clauseDisplayType: Scalars['String'];
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['String'];
  libraryId?: Maybe<Scalars['String']>;
  mergeFields?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  requirementFamilyMergeable?: Maybe<Scalars['String']>;
  requirementMergeable?: Maybe<Scalars['String']>;
  requirements?: Maybe<Array<Maybe<Requirement>>>;
  title: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};


export type RequirementRequirementFamilyMergeableArgs = {
  showSyntax?: InputMaybe<Scalars['Boolean']>;
};

export type RequirementItemV2 = {
  __typename?: 'RequirementItemV2';
  description: Scalars['String'];
  pageNumbers?: Maybe<Array<Scalars['Float']>>;
  priority?: Maybe<Scalars['String']>;
  sourceDocuments?: Maybe<Array<Scalars['String']>>;
};

export type RequirementReference = {
  requirementId: Scalars['String'];
  requirements?: InputMaybe<Array<InputMaybe<RequirementReference>>>;
};

export type ResetContactValidationRequestInput = {
  orderId: Scalars['ID'];
  /** Party identifier - corresponds to buyerSellerId from orders service */
  partyId: Scalars['ID'];
  /** Provider extracted from URL path parameter - not sent in request body by frontend */
  provider: ResetContactValidationRequestInputProvider;
};

/** Provider extracted from URL path parameter - not sent in request body by frontend */
export enum ResetContactValidationRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type ResetContactValidationResponse = {
  __typename?: 'ResetContactValidationResponse';
  /** Human-readable message describing the result */
  message: Scalars['String'];
  /** The verification status after reset (always NotRun) */
  newStatus: ResetContactValidationResponseNewStatus;
  /** The verification status before reset */
  previousStatus?: Maybe<Scalars['String']>;
  /** Whether the reset operation was successful */
  success: Scalars['Boolean'];
};

/** The verification status after reset (always NotRun) */
export enum ResetContactValidationResponseNewStatus {
  NotRun = 'NotRun'
}

export type ResetUserMultiFactorAuthenticationInput = {
  emailAddress: Scalars['String'];
};

export type Restriction = {
  __typename?: 'Restriction';
  domain: Scalars['String'];
  reasonCode: Scalars['String'];
  resourceId: Scalars['String'];
  restrictionType: Scalars['String'];
};

export type RestrictiveCovenant = {
  __typename?: 'RestrictiveCovenant';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  restrictiveCovenant?: Maybe<RestrictiveCovenantItem>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type RestrictiveCovenantItem = {
  __typename?: 'RestrictiveCovenantItem';
  applyToPolicy?: Maybe<Scalars['String']>;
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  clauseDisplayType: Scalars['String'];
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  libraryId?: Maybe<Scalars['String']>;
  mergeFields?: Maybe<Scalars['String']>;
  restrictiveCovenantsMergeable?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type RetryAttachIdentityVerificationReportRequestInput = {
  /** Order identifier */
  orderId: Scalars['ID'];
  /** Party identifier */
  partyId: Scalars['ID'];
  /** Provider extracted from URL path parameter */
  provider: RetryAttachIdentityVerificationReportRequestInputProvider;
};

/** Provider extracted from URL path parameter */
export enum RetryAttachIdentityVerificationReportRequestInputProvider {
  IntelliCheck = 'IntelliCheck',
  SafeIdentity = 'SAFEIdentity'
}

export type RetryAttachIdentityVerificationReportResponse = {
  __typename?: 'RetryAttachIdentityVerificationReportResponse';
  /** Additional context on the result */
  message?: Maybe<Scalars['String']>;
  /** Whether the report was successfully attached */
  success: Scalars['Boolean'];
};

export type RetryRejectedPackageRequestInput = {
  orderId: Scalars['ID'];
  packageId: Scalars['ID'];
};

export type RevertEntityDocumentVersionRequestV2Input = {
  documentId: Scalars['ID'];
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  scopeId?: InputMaybe<Scalars['ID']>;
  updatedTimestamp: Scalars['String'];
  versionId: Scalars['ID'];
};

export type RevertTemplateDocVersionRequestV2Input = {
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  updatedTimestamp: Scalars['String'];
  versionId: Scalars['ID'];
};

export type SaveSnapshotRequestInput = {
  collectedDisclosureAmounts?: InputMaybe<Array<PackageResponseCollectedDisclosureAmountsInput>>;
  /** @minItems 1 */
  documents: Array<PackageDocumentInput>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  packageData?: InputMaybe<Array<DataFieldInput>>;
  packageId: Scalars['ID'];
  packageName: Scalars['String'];
  stateRequirements?: InputMaybe<StateRequirementsInput>;
  submitImmediately?: InputMaybe<Scalars['Boolean']>;
};

export type ScAffidavitTaxForm = {
  __typename?: 'ScAffidavitTaxForm';
  address?: Maybe<Scalars['String']>;
  buyersAllNamesWithMaritalAndVesting?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  propertyParcelNumbers?: Maybe<Scalars['String']>;
  saleAmount?: Maybe<Scalars['Float']>;
  sellersAllNamesWithMaritalAndVesting?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
  transferTaxFee?: Maybe<Scalars['Float']>;
};

export type ScheduleBv2 = {
  __typename?: 'ScheduleBV2';
  exceptions?: Maybe<Array<ExceptionItemV2>>;
  requirements?: Maybe<Array<RequirementItemV2>>;
};

export enum SdnRecordType {
  Buyer = 'buyer',
  BuyerEntity = 'buyerEntity',
  BuyerRepresentative = 'buyerRepresentative',
  BuyerSpouse = 'buyerSpouse',
  Seller = 'seller',
  SellerEntity = 'sellerEntity',
  SellerRepresentative = 'sellerRepresentative',
  SellerSpouse = 'sellerSpouse'
}

export type SdnStatusDetails = {
  __typename?: 'SdnStatusDetails';
  additionalDetails?: Maybe<Scalars['String']>;
  dateSearched: Scalars['DateTime'];
  nameSearched: Scalars['String'];
  sdnSearchResult: Scalars['String'];
};

export type SearchLegacyAddress = {
  __typename?: 'SearchLegacyAddress';
  city?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
};

export type SecondaryParty = {
  __typename?: 'SecondaryParty';
  address: Scalars['String'];
  city: Scalars['String'];
  county: Scalars['String'];
  secondaryId: Scalars['String'];
  secondaryName: Scalars['String'];
  secondaryRoleType: Scalars['String'];
  secondaryState?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  underwriterId: Scalars['ID'];
  zip: Scalars['String'];
};

export type SectionMapping = {
  __typename?: 'SectionMapping';
  altaSection?: Maybe<Scalars['String']>;
  cdSection?: Maybe<Scalars['String']>;
  hud1986Section?: Maybe<Scalars['String']>;
  hud2010Section?: Maybe<Scalars['String']>;
};

export type SectionMappingInput = {
  altaSection?: InputMaybe<Scalars['String']>;
  cdSection?: InputMaybe<Scalars['String']>;
  hud1986Section?: InputMaybe<Scalars['String']>;
  hud2010Section?: InputMaybe<Scalars['String']>;
};

export type SectionSummariesTotals = AltaSectionSummaryTotals | SectionSummariesTotalsWithSeller | SectionSummariesTotalsWithoutSeller;

export type SectionSummariesTotalsWithSeller = {
  __typename?: 'SectionSummariesTotalsWithSeller';
  borrowerCalcTotal: Scalars['Float'];
  sellerCalcTotal: Scalars['Float'];
  totalDueFromBorrower: Scalars['Float'];
  totalDueFromSeller: Scalars['Float'];
  totalDueToSeller: Scalars['Float'];
  totalPaidByBorrower: Scalars['Float'];
};

export type SectionSummariesTotalsWithoutSeller = {
  __typename?: 'SectionSummariesTotalsWithoutSeller';
  borrowerCalcTotal: Scalars['Float'];
  totalDueFromBorrower: Scalars['Float'];
  totalPaidByBorrower: Scalars['Float'];
};

export type SectionSummaryDebitsAndCredits = {
  __typename?: 'SectionSummaryDebitsAndCredits';
  section?: Maybe<Scalars['String']>;
  totalAmount?: Maybe<Scalars['Float']>;
};

export type SectionSummaryDebitsAndCreditsInput = {
  orderId: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']>>;
  statementType: Scalars['String'];
};

export type SectionSummaryTotals = {
  __typename?: 'SectionSummaryTotals';
  borrowerPaidAt?: Maybe<Scalars['Float']>;
  borrowerPaidBefore?: Maybe<Scalars['Float']>;
  pboBorrowerAmount?: Maybe<Scalars['Float']>;
  pboSellerAmount?: Maybe<Scalars['Float']>;
  pboTotal?: Maybe<Scalars['Float']>;
  sellerPaidAt?: Maybe<Scalars['Float']>;
  sellerPaidBefore?: Maybe<Scalars['Float']>;
};

export type SecurePortalIntegrationConfigGetResponse = {
  __typename?: 'SecurePortalIntegrationConfigGetResponse';
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  enabled: Scalars['Boolean'];
  updatedBy: UserDisplayName;
  updatedTimestamp: Scalars['String'];
};

export type SecurePortalIntegrationConfigUpdateRequestInput = {
  enabled: Scalars['Boolean'];
};

export type SecurePortalIntegrationConfigUpdateResponse = {
  __typename?: 'SecurePortalIntegrationConfigUpdateResponse';
  enabled: Scalars['Boolean'];
};

export type SecurePortalIntegrationConfigUpdateResponseInput = {
  enabled: Scalars['Boolean'];
};

export type SecurityGroup = {
  __typename?: 'SecurityGroup';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  isDeleteRestricted: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  permissions?: Maybe<Scalars['JSONObject']>;
  schemaVersion?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type SecurityGroupAssignment = {
  __typename?: 'SecurityGroupAssignment';
  orgIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  securityGroupIds?: Maybe<Array<Maybe<Scalars['ID']>>>;
  securityGroups?: Maybe<Array<Maybe<SecurityGroup>>>;
};

export type SecurityGroupAssignments = {
  __typename?: 'SecurityGroupAssignments';
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  securityAssignments?: Maybe<Array<Maybe<SecurityGroupAssignment>>>;
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type SecurityGroupV2Assignment = {
  __typename?: 'SecurityGroupV2Assignment';
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  permissions?: Maybe<Scalars['String']>;
  securityGroupIds?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type SecurityGroupV2Assignments = {
  __typename?: 'SecurityGroupV2Assignments';
  adminPermissions?: Maybe<Array<Maybe<Scalars['String']>>>;
  applicationPermissions?: Maybe<Scalars['JSONObject']>;
};

export type SecurityGroupV2AssignmentsInput = {
  adminPermissions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  applicationPermissions?: InputMaybe<Scalars['JSONObject']>;
};

export enum SecurityInstrumentRecitalType {
  DeedOfTrust = 'DEED_OF_TRUST',
  Mortgage = 'MORTGAGE'
}

export type Seller = OrderBuyerSeller & {
  __typename?: 'Seller';
  address?: Maybe<Address>;
  alias?: Maybe<Scalars['String']>;
  allFullNames?: Maybe<Scalars['String']>;
  buyerSellerId?: Maybe<Scalars['ID']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateOfBirth?: Maybe<Scalars['String']>;
  displayName?: Maybe<Scalars['String']>;
  displayNameMetadata?: Maybe<OverrideMetadataString>;
  emailAddresses?: Maybe<Array<Maybe<BuyerSellerEmailAddress>>>;
  entityDateOfAgreement?: Maybe<Scalars['String']>;
  entityName?: Maybe<Scalars['String']>;
  entityStateOfAgreement?: Maybe<Scalars['String']>;
  excludeFromLoan?: Maybe<Scalars['Boolean']>;
  firstName?: Maybe<Scalars['String']>;
  forwardingAddress?: Maybe<Address>;
  forwardingAddressSameAsCurrentAddress?: Maybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: Maybe<Scalars['Boolean']>;
  forwardingRegion?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  gender?: Maybe<Scalars['String']>;
  hasPowerOfAttorney?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  isForeignAddress?: Maybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  maritalStatus?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  ownershipPercentage?: Maybe<Scalars['Float']>;
  ownershipPercentageMetadata?: Maybe<OverrideMetadataNumber>;
  phoneNumbers?: Maybe<Array<Maybe<BuyerSellerPhoneNumber>>>;
  powerOfAttorney?: Maybe<PowerOfAttorney>;
  recordName?: Maybe<BuyerSellerRecordName>;
  representatives?: Maybe<Array<OrderBuyerSellerSoRep>>;
  representativesAllNames?: Maybe<Scalars['String']>;
  representativesAllNamesWithCapacity?: Maybe<Scalars['String']>;
  sdnStatus?: Maybe<Scalars['String']>;
  sdnStatusDetails?: Maybe<SdnStatusDetails>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  signingName?: Maybe<Scalars['String']>;
  signingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  spouse?: Maybe<OrderBuyerSellerSoRep>;
  suffix?: Maybe<Scalars['String']>;
  taxIdFormatted?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  ten99?: Maybe<Ten99SellerRecord>;
  title?: Maybe<Scalars['String']>;
  typeOfBuyerSeller?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  vesting?: Maybe<Scalars['String']>;
};

export type SendContactFormInput = {
  company: Scalars['String'];
  email: Scalars['String'];
  message: Scalars['String'];
  name: Scalars['String'];
  phone: Scalars['String'];
  reason: Scalars['String'];
  retURL: Scalars['String'];
};

export type SendEmailRequestInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  bcc?: InputMaybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  cc?: InputMaybe<Array<Scalars['String']>>;
  subject: Scalars['String'];
  to: Array<Scalars['String']>;
};

export type SendEmailResponse = {
  __typename?: 'SendEmailResponse';
  sentEmails?: Maybe<Array<IndividualSendEmailResponse>>;
};

export type SendOrderEmailRequestInput = {
  attachments?: InputMaybe<Array<EmailAttachmentInput>>;
  bcc?: InputMaybe<Array<Scalars['String']>>;
  body: Scalars['String'];
  cc?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  orderNumber: Scalars['String'];
  subject: Scalars['String'];
  to: Array<Scalars['String']>;
};

export type Sequence = {
  __typename?: 'Sequence';
  alphaSuffix?: Maybe<Scalars['String']>;
  availableIn?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  currentSequenceNumber?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  numberOfDigitsInSequence?: Maybe<Scalars['Int']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  sequenceName?: Maybe<Scalars['String']>;
  template?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type SetOrderRecordingJurisdictionInput = {
  countyName: Scalars['String'];
  orderId: Scalars['ID'];
};

export type SetOrderRecordingJurisdictionResponse = {
  __typename?: 'SetOrderRecordingJurisdictionResponse';
  countyFips?: Maybe<Scalars['String']>;
  countyName: Scalars['String'];
};

export type SetUserDepartmentsInput = {
  departmentIds: Array<Scalars['ID']>;
  userId: Scalars['ID'];
};

export type Settlement = {
  __typename?: 'Settlement';
  id: Scalars['ID'];
  prorations?: Maybe<Array<Maybe<Proration>>>;
};

export type ShipmentAddress = {
  __typename?: 'ShipmentAddress';
  carrierFacility?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  company?: Maybe<Scalars['String']>;
  country: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  federalTaxId?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  residential?: Maybe<Scalars['Boolean']>;
  state: Scalars['String'];
  stateTaxId?: Maybe<Scalars['ID']>;
  street1: Scalars['String'];
  street2?: Maybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type ShipmentAddressInput = {
  carrierFacility?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  company?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  federalTaxId?: InputMaybe<Scalars['ID']>;
  name?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  residential?: InputMaybe<Scalars['Boolean']>;
  state: Scalars['String'];
  stateTaxId?: InputMaybe<Scalars['ID']>;
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type ShipmentObject = {
  __typename?: 'ShipmentObject';
  buyerAddress?: Maybe<ShipmentAddress>;
  createdBy: UserDisplayName;
  createdTimestamp: Scalars['String'];
  customLabelField?: Maybe<Scalars['String']>;
  deliveryConfirmation?: Maybe<Scalars['String']>;
  dropoffType?: Maybe<Scalars['String']>;
  fromAddress: ShipmentAddress;
  id: Scalars['ID'];
  insurance?: Maybe<Scalars['String']>;
  labelDate?: Maybe<Scalars['String']>;
  labelSize?: Maybe<ShipmentObjectLabelSize>;
  orderId: Scalars['ID'];
  parcel: ShipmentParcel;
  postageLabel?: Maybe<LabelObject>;
  rates?: Maybe<Array<RateObject>>;
  returnAddress?: Maybe<ShipmentAddress>;
  saturdayDelivery?: Maybe<Scalars['Boolean']>;
  selectedRate?: Maybe<RateObject>;
  tenantId: Scalars['ID'];
  toAddress: ShipmentAddress;
  updatedBy: UserDisplayName;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export enum ShipmentObjectLabelSize {
  Size_4X6 = 'SIZE_4X6',
  Size_4X7 = 'SIZE_4X7',
  Size_8_5X11 = 'SIZE_8_5X11'
}

export type ShipmentParcel = {
  __typename?: 'ShipmentParcel';
  height: Scalars['String'];
  length: Scalars['String'];
  predefinedPackage?: Maybe<Scalars['String']>;
  weight: Scalars['String'];
  width: Scalars['String'];
};

export type ShipmentParcelInput = {
  height: Scalars['String'];
  length: Scalars['String'];
  predefinedPackage?: InputMaybe<Scalars['String']>;
  weight: Scalars['String'];
  width: Scalars['String'];
};

export type ShipmentPaymentOptionInput = {
  account?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  postal_code?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<PaymentOption>;
};

export enum ShippingServiceTypes {
  Fedex_2Day = 'FEDEX_2_DAY',
  Fedex_2DayAm = 'FEDEX_2_DAY_AM',
  FedexExpressSaver = 'FEDEX_EXPRESS_SAVER',
  FedexGround = 'FEDEX_GROUND',
  FirstOvernight = 'FIRST_OVERNIGHT',
  GroundHomeDelivery = 'GROUND_HOME_DELIVERY',
  Ground = 'Ground',
  NextDayAir = 'NextDayAir',
  NextDayAirEarlyAm = 'NextDayAirEarlyAM',
  NextDayAirSaver = 'NextDayAirSaver',
  PriorityOvernight = 'PRIORITY_OVERNIGHT',
  SmartPost = 'SMART_POST',
  StandardOvernight = 'STANDARD_OVERNIGHT',
  SecondDayAir = 'SecondDayAir',
  SecondDayAirAm = 'SecondDayAirAM'
}

export type SignatoriesResponse = {
  __typename?: 'SignatoriesResponse';
  errors: Array<ErrorStatus>;
  signatories: Array<Signatory>;
  warnings: Array<WarningStatus>;
};

export type Signatory = {
  __typename?: 'Signatory';
  firmId: Scalars['Int'];
  firmSignatoryId: Scalars['Int'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  signatoryId: Scalars['String'];
};

export type SmartyStreetConfiguration = {
  __typename?: 'SmartyStreetConfiguration';
  apiKey?: Maybe<Scalars['String']>;
};

export type SmtpSettings = {
  __typename?: 'SmtpSettings';
  derivedFromTenant?: Maybe<Scalars['Boolean']>;
  encryptionMethod?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Int']>;
  smtpServerAddress?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type SmtpSettingsInput = {
  encryptionMethod?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  port?: InputMaybe<Scalars['Int']>;
  smtpServerAddress: Scalars['String'];
  username?: InputMaybe<Scalars['String']>;
};

export type SplitConfiguration = {
  __typename?: 'SplitConfiguration';
  cpl: BuyerSellerSplitConfiguration;
  lenderPolicy: BuyerSellerSplitConfiguration;
  ownerPolicy: BuyerSellerSplitConfiguration;
  sellerCpl?: Maybe<BuyerSellerSplitConfiguration>;
};

export type SplitConfigurationSchema = {
  cpl: BuyerSellerSplitValueInput;
  lenderPolicy: BuyerSellerSplitValueInput;
  ownerPolicy: BuyerSellerSplitValueInput;
  sellerCpl?: InputMaybe<BuyerSellerSplitValueInput>;
};

export type SplitTransactionDetailsResponse = {
  __typename?: 'SplitTransactionDetailsResponse';
  escrowAccountId?: Maybe<Scalars['String']>;
  originLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  originTransaction?: Maybe<Transaction>;
  targetLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  targetTransaction?: Maybe<Transaction>;
};

export type SplitTransactionInput = {
  escrowAccountId: Scalars['String'];
  originLineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  originTransaction?: InputMaybe<UpdateTransactionTransferInput>;
  targetLineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
};

export type StaffRole = {
  __typename?: 'StaffRole';
  active: Scalars['Boolean'];
  canToggleActive: Scalars['Boolean'];
  id: Scalars['ID'];
  prioritySorted: Scalars['Boolean'];
  role: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type StaffRolePatchInput = {
  active: Scalars['Boolean'];
  updatedTimestamp: Scalars['String'];
};

export type StandardEscrowFeeAdditionalData = {
  __typename?: 'StandardEscrowFeeAdditionalData';
  amountPerMonth?: Maybe<Scalars['Float']>;
  numberOfMonths?: Maybe<Scalars['Float']>;
};

export type StartFedexMfaCreateRequestInput = {
  companyAccess: CompanyAccessInput;
  companyInfo: StartFedexMfaCreateRequestInput_CompanyInfo;
  description?: InputMaybe<Scalars['String']>;
  fedexAccountNumber: Scalars['String'];
  name: Scalars['String'];
  shippingAddress: StartFedexMfaCreateRequestInput_ShippingAddress;
};

export type StartFedexMfaCreateRequestInput_CompanyInfo = {
  address: StartFedexMfaCreateRequestInput_CompanyInfo_Address;
  contact: StartFedexMfaCreateRequestInput_CompanyInfo_Contact;
  name: Scalars['String'];
};

export type StartFedexMfaCreateRequestInput_CompanyInfo_Address = {
  city: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type StartFedexMfaCreateRequestInput_CompanyInfo_Contact = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type StartFedexMfaCreateRequestInput_ShippingAddress = {
  city: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type StartFedexMfaCreateResponse = {
  __typename?: 'StartFedexMfaCreateResponse';
  account?: Maybe<CarrierAccountObject>;
  alreadyAuthorized: Scalars['Boolean'];
  emailAddress?: Maybe<Scalars['String']>;
  options?: Maybe<Array<FedexMfaPinMethod>>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type StartFedexMfaRequestInput = {
  id: Scalars['ID'];
};

export type StartFedexMfaResponse = {
  __typename?: 'StartFedexMfaResponse';
  alreadyAuthorized: Scalars['Boolean'];
  emailAddress?: Maybe<Scalars['String']>;
  options?: Maybe<Array<FedexMfaPinMethod>>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type StateAttorneyMap = {
  __typename?: 'StateAttorneyMap';
  approvedAttorneyTypeMap: Array<AttorneyTypeMap>;
  state: Scalars['String'];
};

export type StateDetail = {
  __typename?: 'StateDetail';
  abbreviation?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type StateObjectV2 = {
  __typename?: 'StateObjectV2';
  abbreviation: Scalars['String'];
  name: Scalars['String'];
};

export type StateObjectV2Input = {
  abbreviation: Scalars['String'];
  name: Scalars['String'];
};

export type StateRequirements = {
  __typename?: 'StateRequirements';
  caRequirements?: Maybe<CaRequirements>;
  hiRequirements?: Maybe<HiRequirements>;
};

export type StateRequirementsInput = {
  caRequirements?: InputMaybe<CaRequirementsInput>;
  hiRequirements?: InputMaybe<HiRequirementsInput>;
};

export type StateSplitConfiguration = {
  __typename?: 'StateSplitConfiguration';
  AK: SplitConfiguration;
  AL: SplitConfiguration;
  AR: SplitConfiguration;
  AZ: SplitConfiguration;
  CA: SplitConfiguration;
  CO: SplitConfiguration;
  CT: SplitConfiguration;
  DC: SplitConfiguration;
  DE: SplitConfiguration;
  FL: SplitConfiguration;
  GA: SplitConfiguration;
  HI: SplitConfiguration;
  IA: SplitConfiguration;
  ID: SplitConfiguration;
  IL: SplitConfiguration;
  IN: SplitConfiguration;
  KS: SplitConfiguration;
  KY: SplitConfiguration;
  LA: SplitConfiguration;
  MA: SplitConfiguration;
  MD: SplitConfiguration;
  ME: SplitConfiguration;
  MI: SplitConfiguration;
  MN: SplitConfiguration;
  MO: SplitConfiguration;
  MS: SplitConfiguration;
  MT: SplitConfiguration;
  NC: SplitConfiguration;
  ND: SplitConfiguration;
  NE: SplitConfiguration;
  NH: SplitConfiguration;
  NJ: SplitConfiguration;
  NM: SplitConfiguration;
  NV: SplitConfiguration;
  NY: SplitConfiguration;
  OH: SplitConfiguration;
  OK: SplitConfiguration;
  OR: SplitConfiguration;
  PA: SplitConfiguration;
  RI: SplitConfiguration;
  SC: SplitConfiguration;
  SD: SplitConfiguration;
  TN: SplitConfiguration;
  TX: SplitConfiguration;
  UT: SplitConfiguration;
  VA: SplitConfiguration;
  VT: SplitConfiguration;
  WA: SplitConfiguration;
  WI: SplitConfiguration;
  WV: SplitConfiguration;
  WY: SplitConfiguration;
};

export type StateSplitInput = {
  AK: SplitConfigurationSchema;
  AL: SplitConfigurationSchema;
  AR: SplitConfigurationSchema;
  AZ: SplitConfigurationSchema;
  CA: SplitConfigurationSchema;
  CO: SplitConfigurationSchema;
  CT: SplitConfigurationSchema;
  DC: SplitConfigurationSchema;
  DE: SplitConfigurationSchema;
  FL: SplitConfigurationSchema;
  GA: SplitConfigurationSchema;
  HI: SplitConfigurationSchema;
  IA: SplitConfigurationSchema;
  ID: SplitConfigurationSchema;
  IL: SplitConfigurationSchema;
  IN: SplitConfigurationSchema;
  KS: SplitConfigurationSchema;
  KY: SplitConfigurationSchema;
  LA: SplitConfigurationSchema;
  MA: SplitConfigurationSchema;
  MD: SplitConfigurationSchema;
  ME: SplitConfigurationSchema;
  MI: SplitConfigurationSchema;
  MN: SplitConfigurationSchema;
  MO: SplitConfigurationSchema;
  MS: SplitConfigurationSchema;
  MT: SplitConfigurationSchema;
  NC: SplitConfigurationSchema;
  ND: SplitConfigurationSchema;
  NE: SplitConfigurationSchema;
  NH: SplitConfigurationSchema;
  NJ: SplitConfigurationSchema;
  NM: SplitConfigurationSchema;
  NV: SplitConfigurationSchema;
  NY: SplitConfigurationSchema;
  OH: SplitConfigurationSchema;
  OK: SplitConfigurationSchema;
  OR: SplitConfigurationSchema;
  PA: SplitConfigurationSchema;
  RI: SplitConfigurationSchema;
  SC: SplitConfigurationSchema;
  SD: SplitConfigurationSchema;
  TN: SplitConfigurationSchema;
  TX: SplitConfigurationSchema;
  UT: SplitConfigurationSchema;
  VA: SplitConfigurationSchema;
  VT: SplitConfigurationSchema;
  WA: SplitConfigurationSchema;
  WI: SplitConfigurationSchema;
  WV: SplitConfigurationSchema;
  WY: SplitConfigurationSchema;
};

export type StateWithholding = {
  __typename?: 'StateWithholding';
  closingCostsAmount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['ID']>;
  oTotalWithholdingBasis?: Maybe<Scalars['Float']>;
  payoffsAmount?: Maybe<Scalars['Float']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  personalPropertyAmount?: Maybe<Scalars['Float']>;
  salesPriceAmount?: Maybe<Scalars['Float']>;
  sellers?: Maybe<Array<Maybe<StateWithholdingSellerValues>>>;
  totalWithholdingBasis?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type StateWithholdingSellerValues = {
  __typename?: 'StateWithholdingSellerValues';
  amountDue?: Maybe<Scalars['Float']>;
  displayName?: Maybe<Scalars['String']>;
  entityType?: Maybe<Scalars['String']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  rate?: Maybe<Scalars['Float']>;
  sellerRefId: Scalars['String'];
  withholdingBasis?: Maybe<Scalars['Float']>;
};

export type StateWithholdingSellerValuesInput = {
  sellerRefId: Scalars['String'];
};

export type StatementClosingInformation = {
  __typename?: 'StatementClosingInformation';
  closingDate?: Maybe<Scalars['String']>;
  dateIssued?: Maybe<Scalars['String']>;
  disbursementDate?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  salePrice?: Maybe<Scalars['Float']>;
  salePriceLabel?: Maybe<Scalars['String']>;
  settlementAgentCompanyName?: Maybe<Scalars['String']>;
};

export type StatementLineItemAdjustmentRow = {
  __typename?: 'StatementLineItemAdjustmentRow';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  rowNumber?: Maybe<Scalars['String']>;
  subheader?: Maybe<Scalars['String']>;
};

export type StatementLineItemAdjustmentSection = {
  __typename?: 'StatementLineItemAdjustmentSection';
  items?: Maybe<Array<Maybe<StatementLineItemAdjustmentRow>>>;
  total?: Maybe<Scalars['Float']>;
};

export type StatementLineItemAmountFee = {
  __typename?: 'StatementLineItemAmountFee';
  bpa?: Maybe<Scalars['Float']>;
  bpb?: Maybe<Scalars['Float']>;
  pbo?: Maybe<Scalars['Float']>;
  spa?: Maybe<Scalars['Float']>;
  spb?: Maybe<Scalars['Float']>;
};

export type StatementLineItemFee = {
  __typename?: 'StatementLineItemFee';
  bpa?: Maybe<Scalars['Float']>;
  bpb?: Maybe<Scalars['Float']>;
  descriptionAndPayee?: Maybe<Scalars['String']>;
  pbKey?: Maybe<Scalars['String']>;
  pbo?: Maybe<Scalars['Float']>;
  rowNumber?: Maybe<Scalars['String']>;
  spa?: Maybe<Scalars['Float']>;
  spb?: Maybe<Scalars['Float']>;
};

export type StatementLineItemSection = {
  __typename?: 'StatementLineItemSection';
  items?: Maybe<Array<Maybe<StatementLineItemFee>>>;
  total?: Maybe<Scalars['Float']>;
};

export type StatementLoanInformation = {
  __typename?: 'StatementLoanInformation';
  loanNumber?: Maybe<Scalars['String']>;
  loanTerm?: Maybe<Scalars['String']>;
  loanType?: Maybe<Scalars['String']>;
  loanTypeIsOther?: Maybe<Scalars['Boolean']>;
  micNumber?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
};

export type StatementLoanTerms = {
  __typename?: 'StatementLoanTerms';
  balloonPayment?: Maybe<StatementLoanTermsBalloonPayment>;
  interestRate?: Maybe<StatementLoanTermsInterestRate>;
  loanAmount?: Maybe<StatementLoanTermsLoanAmount>;
  monthlyPrincipalAndInterest?: Maybe<StatementLoanTermsMonthlyPrincipalAndInterest>;
  prepaymentPenalty?: Maybe<StatementLoanTermsPrepaymentPenalty>;
};

export type StatementLoanTermsBalloonPayment = {
  __typename?: 'StatementLoanTermsBalloonPayment';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StatementLoanTermsInterestRate = {
  __typename?: 'StatementLoanTermsInterestRate';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['Float']>;
};

export type StatementLoanTermsLoanAmount = {
  __typename?: 'StatementLoanTermsLoanAmount';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['Float']>;
};

export type StatementLoanTermsMonthlyPrincipalAndInterest = {
  __typename?: 'StatementLoanTermsMonthlyPrincipalAndInterest';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
  value?: Maybe<Scalars['Float']>;
};

export type StatementLoanTermsPrepaymentPenalty = {
  __typename?: 'StatementLoanTermsPrepaymentPenalty';
  response?: Maybe<Scalars['Boolean']>;
  sentences?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StatementSections = {
  __typename?: 'StatementSections';
  sections?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type StatementTransactionInformation = {
  __typename?: 'StatementTransactionInformation';
  borrowerAddress?: Maybe<Scalars['String']>;
  borrowerCityStateZip?: Maybe<Scalars['String']>;
  borrowerNames?: Maybe<Scalars['String']>;
  lenderCompanyName?: Maybe<Scalars['String']>;
  sellerAddress?: Maybe<Scalars['String']>;
  sellerCityStateZip?: Maybe<Scalars['String']>;
  sellerNames?: Maybe<Scalars['String']>;
};

export type StatisticalCode = {
  __typename?: 'StatisticalCode';
  code: Scalars['String'];
  description?: Maybe<Scalars['String']>;
};

export type StatusChange = {
  __typename?: 'StatusChange';
  documentChanges: Array<DocumentChangeGroup>;
  packageChanges: Array<FieldChange>;
  previousStatus?: Maybe<PackageStatus>;
  status: PackageStatus;
  statusMessage?: Maybe<Scalars['String']>;
  timestamp: Scalars['String'];
  updatedBy: UserDisplayName;
};

export type StringOverrideMetadata = {
  __typename?: 'StringOverrideMetadata';
  effectiveValue?: Maybe<Scalars['String']>;
  fallbackValue?: Maybe<Scalars['String']>;
  overridden?: Maybe<Scalars['Boolean']>;
  overrideValue?: Maybe<Scalars['String']>;
};

/** Structured postal address for wire beneficiary output. */
export type StructuredAddress = {
  __typename?: 'StructuredAddress';
  addressLine?: Maybe<Array<Maybe<Scalars['String']>>>;
  buildingName?: Maybe<Scalars['String']>;
  buildingNumber?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countrySubDivision?: Maybe<Scalars['String']>;
  department?: Maybe<Scalars['String']>;
  districtName?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  postBox?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  streetName?: Maybe<Scalars['String']>;
  townLocationName?: Maybe<Scalars['String']>;
  townName?: Maybe<Scalars['String']>;
};

/** Structured postal address input for wire initiation. */
export type StructuredAddressInput = {
  addressLine?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  buildingName?: InputMaybe<Scalars['String']>;
  buildingNumber?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  countrySubDivision?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  districtName?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  postBox?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  room?: InputMaybe<Scalars['String']>;
  streetName?: InputMaybe<Scalars['String']>;
  townLocationName?: InputMaybe<Scalars['String']>;
  townName: Scalars['String'];
};

export type SubmitInsightFeedbackInputV2Input = {
  /** @maxItems 10 */
  categories?: InputMaybe<Array<Scalars['String']>>;
  comment?: InputMaybe<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  insightId: Scalars['ID'];
  insightType: Scalars['String'];
  rating: FeedbackRatingV2;
  scopeId?: InputMaybe<Scalars['ID']>;
};

export type SubmitInsightFeedbackResponseV2 = {
  __typename?: 'SubmitInsightFeedbackResponseV2';
  feedbackId: Scalars['ID'];
  success: Scalars['Boolean'];
};

export type SubmitPackageAsyncInput = {
  collectedDisclosureAmounts?: InputMaybe<Array<PackageResponseCollectedDisclosureAmountsInput>>;
  /** @minItems 1 */
  documents: Array<PackageDocumentInput>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  packageData?: InputMaybe<Array<DataFieldInput>>;
  packageId?: InputMaybe<Scalars['ID']>;
  packageName: Scalars['String'];
  stateRequirements?: InputMaybe<StateRequirementsInput>;
  submitImmediately?: InputMaybe<Scalars['Boolean']>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
};

export type SubmitPackageInput = {
  collectedDisclosureAmounts?: InputMaybe<Array<PackageResponseCollectedDisclosureAmountsInput>>;
  /** @minItems 1 */
  documents: Array<PackageDocumentInput>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  packageData?: InputMaybe<Array<DataFieldInput>>;
  packageId?: InputMaybe<Scalars['ID']>;
  packageName: Scalars['String'];
  stateRequirements?: InputMaybe<StateRequirementsInput>;
  submitImmediately?: InputMaybe<Scalars['Boolean']>;
};

export type SubmitPackageResponseDocumentStatus = {
  __typename?: 'SubmitPackageResponseDocumentStatus';
  documentId?: Maybe<Scalars['ID']>;
  documentOrder?: Maybe<Scalars['Float']>;
  documentSequenceIdentifier?: Maybe<Scalars['String']>;
  documentType?: Maybe<Scalars['String']>;
  errorMessages?: Maybe<Array<Scalars['String']>>;
  externalDocumentDesc?: Maybe<Scalars['String']>;
  externalDocumentId?: Maybe<Scalars['ID']>;
  externalDocumentName?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusMessage?: Maybe<Scalars['String']>;
  warningMessages?: Maybe<Array<Scalars['String']>>;
};

export type SubmitPackageResponseLink = {
  __typename?: 'SubmitPackageResponseLink';
  href?: Maybe<Scalars['String']>;
  target?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type SubmitPackageResponsePackageLink = {
  __typename?: 'SubmitPackageResponsePackageLink';
  a?: Maybe<SubmitPackageResponseLink>;
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean'];
};

export type SupportingEvidenceV2 = {
  __typename?: 'SupportingEvidenceV2';
  documentType: Scalars['String'];
  factSummary: Scalars['String'];
  pageNumbers?: Maybe<Array<Scalars['Float']>>;
};

export type SwitchRecordingFeeTransferTaxCalculatorInput = {
  orderId: Scalars['String'];
  providerType: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type System = {
  __typename?: 'System';
  user?: Maybe<User>;
};

export type TagDataItemAttributesV2 = {
  __typename?: 'TagDataItemAttributesV2';
  orgIds?: Maybe<Array<Scalars['String']>>;
};

export type TagDataItemAttributesV2Input = {
  orgIds?: InputMaybe<Array<Scalars['String']>>;
};

export type TagV2 = {
  __typename?: 'TagV2';
  attributes: TagDataItemAttributesV2;
  createdBy: UserDisplayNameV2;
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  name: Scalars['String'];
  sortPriority?: Maybe<Scalars['Int']>;
  updatedBy: UserDisplayNameV2;
  updatedTimestamp: Scalars['String'];
};

export type Task = {
  __typename?: 'Task';
  active?: Maybe<Scalars['Boolean']>;
  assignedTo?: Maybe<Scalars['String']>;
  assignedToMetadata?: Maybe<TaskMetadata>;
  assignment?: Maybe<TaskAssignment>;
  completedBy?: Maybe<User>;
  completedById?: Maybe<Scalars['ID']>;
  completedTimestamp?: Maybe<Scalars['DateTime']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['ID']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  due?: Maybe<TaskDue>;
  dueDate?: Maybe<Scalars['String']>;
  dueDateMetadata?: Maybe<TaskMetadata>;
  id?: Maybe<Scalars['String']>;
  milestoneId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  recordType?: Maybe<Scalars['String']>;
  sortIndex: Scalars['Int'];
  start?: Maybe<TaskStart>;
  startDate?: Maybe<Scalars['String']>;
  startDateMetadata?: Maybe<TaskMetadata>;
  status?: Maybe<Scalars['String']>;
  timeTracking?: Maybe<TaskTimeTracking>;
  type?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  workflowId?: Maybe<Scalars['String']>;
};

export type TaskAssignment = {
  __typename?: 'TaskAssignment';
  personReference?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  typeReference: Scalars['String'];
};

export type TaskAssignmentInput = {
  personReference?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
  typeReference: Scalars['String'];
};

export type TaskDue = {
  __typename?: 'TaskDue';
  basis: Scalars['String'];
  days: Scalars['Int'];
  type: Scalars['String'];
};

export type TaskDueInput = {
  basis: Scalars['String'];
  days: Scalars['Int'];
  type: Scalars['String'];
};

export type TaskMetadata = {
  __typename?: 'TaskMetadata';
  effectiveValue?: Maybe<Scalars['String']>;
  fallbackValue?: Maybe<Scalars['String']>;
  overridden?: Maybe<Scalars['Boolean']>;
  overrideValue?: Maybe<Scalars['String']>;
};

export type TaskStart = {
  __typename?: 'TaskStart';
  reference?: Maybe<Scalars['String']>;
  when: Scalars['String'];
};

export type TaskStartInput = {
  reference?: InputMaybe<Scalars['String']>;
  when: Scalars['String'];
};

export type TaskTimeTracking = {
  __typename?: 'TaskTimeTracking';
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

export type TaskTimeTrackingInput = {
  hours: Scalars['Int'];
  minutes: Scalars['Int'];
};

/** Response from municipal tax rate lookup (ANP-4864) */
export type TaxRateResponse = {
  __typename?: 'TaxRateResponse';
  /** The effective date used for the lookup */
  effectiveDate: Scalars['String'];
  /** The tax rate as a decimal (e.g., 0.09 for 9%) */
  taxRate?: Maybe<Scalars['Float']>;
};

export type TemplateAttributesV2 = {
  __typename?: 'TemplateAttributesV2';
  categories?: Maybe<Array<Scalars['String']>>;
  orgIds?: Maybe<Array<Scalars['String']>>;
  states?: Maybe<Array<StateObjectV2>>;
  underwriters?: Maybe<Array<Scalars['String']>>;
};

export type TemplateAttributesV2Input = {
  categories?: InputMaybe<Array<Scalars['String']>>;
  orgIds?: InputMaybe<Array<Scalars['String']>>;
  states?: InputMaybe<Array<StateObjectV2Input>>;
  underwriters?: InputMaybe<Array<Scalars['String']>>;
};

export type TemplateDocFileVersionV2 = {
  __typename?: 'TemplateDocFileVersionV2';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  versionId: Scalars['ID'];
};

export type TemplateDocTypeAndIdV2Input = {
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
};

export enum TemplateDocTypeV2 {
  Block = 'Block',
  Template = 'Template'
}

export type TemplateDocV2 = {
  __typename?: 'TemplateDocV2';
  attributes: TemplateAttributesV2;
  createdBy: UserDisplayNameV2;
  createdTimestamp: Scalars['String'];
  description: Scalars['String'];
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  fileType: Scalars['String'];
  id: Scalars['ID'];
  isReadOnly: Scalars['Boolean'];
  isVisible: Scalars['Boolean'];
  name: Scalars['String'];
  query?: Maybe<Scalars['String']>;
  tags?: Maybe<Array<Scalars['String']>>;
  updatedBy: UserDisplayNameV2;
  updatedTimestamp: Scalars['String'];
  uploadStatus: UploadStatusV2;
};

export type TemplateSetIdV2Input = {
  setId: Scalars['ID'];
};

export type TemplateSetV2 = {
  __typename?: 'TemplateSetV2';
  attributes: TemplateAttributesV2;
  createdBy: UserDisplayNameV2;
  createdTimestamp: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  name: Scalars['String'];
  /** @maxItems 100 */
  templateIds: Array<Scalars['String']>;
  updatedBy: UserDisplayNameV2;
  updatedTimestamp: Scalars['String'];
};

export enum TemplateTypeV2 {
  Template = 'Template'
}

export type Ten99 = {
  __typename?: 'Ten99';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  orderEligible?: Maybe<Scalars['Boolean']>;
  ten99SellerRecords?: Maybe<Array<Maybe<Ten99SellerRecord>>>;
  totalBuyersTaxAmount?: Maybe<Scalars['Float']>;
  totalProceeds?: Maybe<Scalars['Float']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Ten99Form = {
  __typename?: 'Ten99Form';
  accountNumber?: Maybe<Scalars['String']>;
  propertyAddress?: Maybe<Scalars['String']>;
  propertyCityStateZip?: Maybe<Scalars['String']>;
  sellers?: Maybe<Array<Maybe<Ten99FormSellers>>>;
  settlementAgentAddress?: Maybe<Scalars['String']>;
  settlementAgentCityStateZip?: Maybe<Scalars['String']>;
  settlementAgentName?: Maybe<Scalars['String']>;
  settlementAgentPhone?: Maybe<Scalars['String']>;
  settlementAgentTaxIdNumber?: Maybe<Scalars['String']>;
  settlementDate?: Maybe<Scalars['String']>;
};

export type Ten99FormSellers = {
  __typename?: 'Ten99FormSellers';
  address?: Maybe<Scalars['String']>;
  addressCityStateZip?: Maybe<Scalars['String']>;
  buyerTaxAmount?: Maybe<Scalars['Float']>;
  foreignPersonEntity?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  propertyOrServicesIndicator?: Maybe<Scalars['Boolean']>;
  sellerType?: Maybe<Scalars['String']>;
  sellersAllocatedProceeds?: Maybe<Scalars['Float']>;
  spouseName?: Maybe<Scalars['String']>;
  spouseTaxIdNumber?: Maybe<Scalars['String']>;
  taxIdNumber?: Maybe<Scalars['String']>;
};

export type Ten99Input = {
  id: Scalars['ID'];
  ten99SellerRecords?: InputMaybe<Array<InputMaybe<Ten99SellerRecordInput>>>;
};

export type Ten99Response = {
  ten99: Ten99;
};

export type Ten99SellerRecord = {
  __typename?: 'Ten99SellerRecord';
  buyerTaxAmount?: Maybe<Scalars['Float']>;
  buyerTaxAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  doNotReport?: Maybe<Scalars['Boolean']>;
  foreignPersonEntity?: Maybe<Scalars['Boolean']>;
  ownershipPercentage?: Maybe<Scalars['Float']>;
  propertyOrServicesIndicator?: Maybe<Scalars['Boolean']>;
  sellerId: Scalars['ID'];
  sellersAllocatedProceeds?: Maybe<Scalars['Float']>;
  sellersAllocatedProceedsOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  sequenceNumber?: Maybe<Scalars['Float']>;
  spouseTaxReportingName?: Maybe<Scalars['String']>;
  spouseTaxReportingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  taxReportingName?: Maybe<Scalars['String']>;
  taxReportingNameOverrideMetadata?: Maybe<OverrideMetadataString>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Ten99SellerRecordInput = {
  buyerTaxAmount?: InputMaybe<Scalars['Float']>;
  doNotReport?: InputMaybe<Scalars['Boolean']>;
  foreignPersonEntity?: InputMaybe<Scalars['Boolean']>;
  ownershipPercentage?: InputMaybe<Scalars['Float']>;
  propertyOrServicesIndicator?: InputMaybe<Scalars['Boolean']>;
  sellerId: Scalars['String'];
  sellersAllocatedProceeds?: InputMaybe<Scalars['Float']>;
  spouseTaxReportingName?: InputMaybe<Scalars['String']>;
  taxReportingName?: InputMaybe<Scalars['String']>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type Tenant = {
  __typename?: 'Tenant';
  abbreviation: Scalars['String'];
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['ID']>;
  billingContact: TenantBillingContact;
  /** @deprecated use billingContact object */
  billingContactEmail: Scalars['EmailAddress'];
  /** @deprecated use billingContact object */
  billingContactFirstName: Scalars['String'];
  /** @deprecated use billingContact object */
  billingContactLastName: Scalars['String'];
  /** @deprecated use billingContact object */
  billingContactMiddleName?: Maybe<Scalars['String']>;
  /** @deprecated use billingContact object */
  billingContactPhone: Scalars['String'];
  /** @deprecated use billingContact object */
  billingContactPhoneExtension?: Maybe<Scalars['String']>;
  /** @deprecated use billingContact object */
  billingContactPhoneType?: Maybe<Scalars['String']>;
  businessContact: TenantContact;
  /** @deprecated use businessContact object */
  businessContactEmail?: Maybe<Scalars['EmailAddress']>;
  /** @deprecated use businessContact object */
  businessContactFirstName?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactLastName?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactMiddleName?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactPhone?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactPhoneExtension?: Maybe<Scalars['String']>;
  /** @deprecated use businessContact object */
  businessContactPhoneType?: Maybe<Scalars['String']>;
  childNodes?: Maybe<Array<Maybe<TenantChildNode>>>;
  /** @deprecated use address object */
  city?: Maybe<Scalars['String']>;
  /** @deprecated use address object */
  county?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  integrations?: Maybe<TenantIntegrations>;
  itemId: Scalars['String'];
  labelL1?: Maybe<Scalars['String']>;
  labelL2?: Maybe<Scalars['String']>;
  labelL3?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  profileImage?: Maybe<TenantProfileImage>;
  smtpSettings?: Maybe<TenantSmtpSettings>;
  /** @deprecated use address object */
  state?: Maybe<Scalars['String']>;
  /** @deprecated use address object */
  streetAddress?: Maybe<Scalars['String']>;
  /** @deprecated use address object */
  streetAddress2?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['ID']>;
  taxIdType?: Maybe<Scalars['String']>;
  technicalContact: TenantContact;
  /** @deprecated use technicalContact object */
  technicalContactEmail?: Maybe<Scalars['EmailAddress']>;
  /** @deprecated use technicalContact object */
  technicalContactFirstName?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactLastName?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactMiddleName?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactPhone?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactPhoneExtension?: Maybe<Scalars['String']>;
  /** @deprecated use technicalContact object */
  technicalContactPhoneType?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  /** @deprecated use address object */
  zip?: Maybe<Scalars['String']>;
};

export type TenantBillingContact = {
  __typename?: 'TenantBillingContact';
  email: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  fullName: Scalars['String'];
  lastName: Scalars['String'];
  middleName?: Maybe<Scalars['String']>;
  phone: Scalars['String'];
  phoneExtension?: Maybe<Scalars['String']>;
  phoneType?: Maybe<Scalars['String']>;
};

export type TenantChildImage = {
  __typename?: 'TenantChildImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp: Scalars['String'];
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type TenantChildNode = {
  __typename?: 'TenantChildNode';
  abbreviation: Scalars['String'];
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  childNodes?: Maybe<Array<Maybe<TenantChildNode>>>;
  city?: Maybe<Scalars['String']>;
  contactEmail?: Maybe<Scalars['String']>;
  contactFirstName?: Maybe<Scalars['String']>;
  contactLastName?: Maybe<Scalars['String']>;
  contactMiddleName?: Maybe<Scalars['String']>;
  contactPhone?: Maybe<Scalars['String']>;
  contactPhoneExtension?: Maybe<Scalars['String']>;
  contactPhoneType?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  emailAddresses?: Maybe<Array<Maybe<EmailAddressSchema>>>;
  id: Scalars['ID'];
  itemId: Scalars['String'];
  licenses?: Maybe<Array<Maybe<License>>>;
  name: Scalars['String'];
  nmlsId?: Maybe<Scalars['String']>;
  orgIds?: Maybe<Array<Maybe<Scalars['String']>>>;
  parentItemId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<PhoneNumberType>>>;
  profileImage?: Maybe<TenantChildProfileImage>;
  state?: Maybe<Scalars['String']>;
  streetAddress?: Maybe<Scalars['String']>;
  streetAddress2?: Maybe<Scalars['String']>;
  taxId?: Maybe<Scalars['String']>;
  taxIdType?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  website?: Maybe<Scalars['String']>;
  wireInstructions?: Maybe<WireSchema>;
  zip?: Maybe<Scalars['String']>;
};

export type TenantChildProfileImage = {
  __typename?: 'TenantChildProfileImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type TenantContact = {
  __typename?: 'TenantContact';
  email?: Maybe<Scalars['EmailAddress']>;
  firstName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  middleName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  phoneExtension?: Maybe<Scalars['String']>;
  phoneType?: Maybe<Scalars['String']>;
};

export type TenantIntegrations = {
  __typename?: 'TenantIntegrations';
  agentNetFinance?: Maybe<AgentNetFinance>;
};

export type TenantProfileImage = {
  __typename?: 'TenantProfileImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type TenantSmtpSettings = {
  __typename?: 'TenantSmtpSettings';
  encryptionMethod: Scalars['String'];
  port: Scalars['Int'];
  smtpServerAddress: Scalars['String'];
};

export type TenantSmtpSettingsInput = {
  encryptionMethod: Scalars['String'];
  port: Scalars['Int'];
  smtpServerAddress: Scalars['String'];
};

export type TenantUnderwriter = {
  __typename?: 'TenantUnderwriter';
  active: Scalars['Boolean'];
  companyIds: Array<Scalars['String']>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  displayName: Scalars['String'];
  id: Scalars['ID'];
  splitConfiguration: TenantUnderwriterSplitConfiguration;
  underwriter?: Maybe<Underwriter>;
  underwriterId: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

/**
 * Agent retained and underwriter remitted percentages for a single split.
 * Float supports fractional percentages of up to two decimal places, for example 12.5 or 9.25.
 */
export type TenantUnderwriterAgentUnderwriterSplit = {
  __typename?: 'TenantUnderwriterAgentUnderwriterSplit';
  agent: Scalars['Float'];
  underwriter: Scalars['Float'];
};

/**
 * Agent retained and underwriter remitted percentages for a single split.
 * Float supports fractional percentages of up to two decimal places, for example 12.5 or 9.25.
 * Precision beyond two decimal places is rejected by the underwriters service.
 */
export type TenantUnderwriterAgentUnderwriterSplitInput = {
  agent: Scalars['Float'];
  underwriter: Scalars['Float'];
};

export type TenantUnderwriterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  displayName: Scalars['String'];
  splitConfiguration: TenantUnderwriterSplitConfigurationInput;
  underwriterId: Scalars['String'];
};

export type TenantUnderwriterResponse = {
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type TenantUnderwriterResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type TenantUnderwriterSplitConfiguration = {
  __typename?: 'TenantUnderwriterSplitConfiguration';
  global: TenantUnderwriterSplitInfo;
  state?: Maybe<Scalars['JSONObject']>;
};

export type TenantUnderwriterSplitConfigurationInput = {
  global: TenantUnderwriterSplitInfoInput;
  state?: InputMaybe<Scalars['JSONObject']>;
};

export type TenantUnderwriterSplitInfo = {
  __typename?: 'TenantUnderwriterSplitInfo';
  endorsementFlat: TenantUnderwriterAgentUnderwriterSplit;
  endorsementPercent: TenantUnderwriterAgentUnderwriterSplit;
  policy: TenantUnderwriterAgentUnderwriterSplit;
};

export type TenantUnderwriterSplitInfoInput = {
  endorsementFlat: TenantUnderwriterAgentUnderwriterSplitInput;
  endorsementPercent: TenantUnderwriterAgentUnderwriterSplitInput;
  policy: TenantUnderwriterAgentUnderwriterSplitInput;
};

export type TitleAllocationInput = {
  allocations?: InputMaybe<Array<InputMaybe<AllocationItemInput>>>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type TitleAllocations = {
  __typename?: 'TitleAllocations';
  agentRetainedRemaining?: Maybe<Scalars['Float']>;
  agentRetainedTotal?: Maybe<Scalars['Float']>;
  allocations?: Maybe<Array<Maybe<AllocationItem>>>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type TitleConfiguration = {
  __typename?: 'TitleConfiguration';
  /** State specific buyer/seller split */
  buyerSellerSplits?: Maybe<SplitConfiguration>;
  /** Default state policy fee for a given state */
  defaultStatePolicyFeeItems: Array<DefaultPolicyFeeAndTaxItem>;
  /** Default state policy fees */
  defaultStatePolicyFees: Array<DefaultStatePolicyFeesMap>;
  /** Underwriter configuration values */
  underwriter?: Maybe<UnderwriterConfiguration>;
};


export type TitleConfigurationBuyerSellerSplitsArgs = {
  state: Scalars['String'];
};


export type TitleConfigurationDefaultStatePolicyFeeItemsArgs = {
  state: Scalars['String'];
};


export type TitleConfigurationUnderwriterArgs = {
  underwriterId: Scalars['String'];
};

export type TitleCpl = {
  __typename?: 'TitleCpl';
  additionalFields?: Maybe<Scalars['JSONObject']>;
  address?: Maybe<Address>;
  /** @deprecated Use agentRetainedV2 instead for dollar/percentage values */
  agentRetained?: Maybe<Scalars['Float']>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  agentRetainedV2Override?: Maybe<DollarsPercent>;
  amount?: Maybe<Scalars['Float']>;
  amountOverride?: Maybe<Scalars['Float']>;
  approvedAttorney?: Maybe<Scalars['String']>;
  buyerPays?: Maybe<Scalars['Float']>;
  closingAttorney?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  coveredParty?: Maybe<Scalars['String']>;
  cplNumber?: Maybe<Scalars['String']>;
  displayOnSettlement?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  effectiveDateOverride?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lender?: Maybe<OrderParty>;
  lenderId?: Maybe<Scalars['String']>;
  letterType?: Maybe<Scalars['String']>;
  loanNumber?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  priceStatus?: Maybe<Scalars['String']>;
  product?: Maybe<CplProduct>;
  proposedLoanInsured?: Maybe<Scalars['String']>;
  remittanceDate?: Maybe<Scalars['String']>;
  secondaryPartyId?: Maybe<Scalars['String']>;
  secondaryPartyRoleType?: Maybe<Scalars['String']>;
  sellerPays?: Maybe<Scalars['Float']>;
  status?: Maybe<Scalars['String']>;
  /** @deprecated Use underwriterRemittedV2 instead for dollar/percentage values */
  underwriterRemitted?: Maybe<Scalars['Float']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
  underwriterRemittedV2Override?: Maybe<DollarsPercent>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  useLenderAddress?: Maybe<Scalars['Boolean']>;
};

export type TitleCplItem = {
  additionalFields?: InputMaybe<Scalars['JSONObject']>;
  address?: InputMaybe<AddressInput>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  agentRetainedV2?: InputMaybe<DollarsPercentInput>;
  agentRetainedV2Override?: InputMaybe<DollarsPercentInput>;
  amount?: InputMaybe<Scalars['Float']>;
  amountOverride?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  closingAttorney?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  coveredParty?: InputMaybe<Scalars['String']>;
  cplNumber?: InputMaybe<Scalars['String']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  effectiveDateOverride?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lenderAddress?: InputMaybe<AddressInput>;
  lenderId?: InputMaybe<Scalars['String']>;
  letterType?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  priceStatus?: InputMaybe<Scalars['String']>;
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  underwriterRemittedV2?: InputMaybe<DollarsPercentInput>;
  underwriterRemittedV2Override?: InputMaybe<DollarsPercentInput>;
  useLenderAddress?: InputMaybe<Scalars['Boolean']>;
};

export type TitleCpls = {
  __typename?: 'TitleCpls';
  approvedAttorneys: Array<ApprovedAttorney>;
  attorneySelectionType?: Maybe<Scalars['String']>;
  closingAttorneys: Array<ClosingAttorney>;
  cpls: Array<TitleCpl>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  id: Scalars['ID'];
  policyDetails: Array<PolicyDetails>;
  proposedLoanInsured?: Maybe<Scalars['String']>;
  recentAttorneySelections?: Maybe<Array<RecentAttorneySelection>>;
  secondaryParties: Array<SecondaryParty>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
  validation?: Maybe<ParameterValidation>;
};

export type TitleDomain = {
  __typename?: 'TitleDomain';
  branchId: Scalars['ID'];
  /** TODO: Detach from Order hierarchy */
  configuration?: Maybe<TitleConfiguration>;
  cpl?: Maybe<TitleCpls>;
  exceptions?: Maybe<Array<Maybe<TitleException>>>;
  general?: Maybe<TitleGeneral>;
  getRemittanceTotals?: Maybe<RemittanceTotals>;
  orderId: Scalars['ID'];
  policies?: Maybe<TitlePolicies>;
  policyMetadata?: Maybe<PolicyMetadata>;
  premium?: Maybe<TitlePremium>;
  requirements?: Maybe<Array<Maybe<Requirement>>>;
  titleAllocations?: Maybe<TitleAllocations>;
  titleExceptions?: Maybe<TitleExceptions>;
  titleFeeAllocations?: Maybe<FeeAllocations>;
  titleFees?: Maybe<TitleFees>;
  titleRequirements?: Maybe<TitleRequirements>;
};


export type TitleDomainCplArgs = {
  state: Scalars['String'];
  underwriterId: Scalars['String'];
};


export type TitleDomainPremiumArgs = {
  premiumType: Scalars['String'];
};

export type TitleException = {
  __typename?: 'TitleException';
  applyToPolicy?: Maybe<Scalars['String']>;
  bodyContent?: Maybe<Scalars['String']>;
  bodyTemplate: Scalars['String'];
  clauseDisplayType: Scalars['String'];
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  exceptionFamilyMergeable?: Maybe<Scalars['String']>;
  exceptionMergeable?: Maybe<Scalars['String']>;
  exceptions?: Maybe<Array<Maybe<TitleException>>>;
  id: Scalars['ID'];
  isAffirmativeCoverage?: Maybe<Scalars['Boolean']>;
  isSubordinateMatter?: Maybe<Scalars['Boolean']>;
  libraryId?: Maybe<Scalars['String']>;
  mergeFields?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  title: Scalars['String'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};


export type TitleExceptionExceptionFamilyMergeableArgs = {
  showSyntax?: InputMaybe<Scalars['Boolean']>;
};

export type TitleExceptions = {
  __typename?: 'TitleExceptions';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  exceptions: Array<Maybe<TitleException>>;
  /** id format is {orderId}#EXCEPTIONS */
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type TitleFeeAdditionalData = {
  __typename?: 'TitleFeeAdditionalData';
  externalCalculatorId?: Maybe<Scalars['String']>;
  sourceBorrowerPaidAt?: Maybe<Scalars['Float']>;
  sourceSellerPaidAt?: Maybe<Scalars['Float']>;
};

export type TitleFees = {
  __typename?: 'TitleFees';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  defaultPayeeId?: Maybe<Scalars['String']>;
  fees?: Maybe<Array<Maybe<FeeItem>>>;
  id: Scalars['ID'];
  orderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type TitleFields = {
  __typename?: 'TitleFields';
  orderId?: Maybe<Scalars['ID']>;
  policyMetadata?: Maybe<PolicyMetadata>;
  totalFeesAmount?: Maybe<Scalars['Float']>;
  totalPremiumsAmount?: Maybe<Scalars['Float']>;
};

export type TitleGeneral = {
  __typename?: 'TitleGeneral';
  amountMortgageInsured?: Maybe<Scalars['Float']>;
  amountMortgageInsuredMetadata?: Maybe<OverrideMetadataNumber>;
  amountOwnerInsured?: Maybe<Scalars['Float']>;
  amountOwnerInsuredMetadata?: Maybe<OverrideMetadataNumber>;
  authorizedSignatory?: Maybe<Scalars['String']>;
  authorizedSignatoryUser?: Maybe<User>;
  commitmentExpiration?: Maybe<Scalars['String']>;
  commitmentExpirationDuration?: Maybe<Scalars['Float']>;
  commitmentExpirationMetadata?: Maybe<OverrideMetadataNumber>;
  commitmentExpirationTerm?: Maybe<Scalars['String']>;
  commitmentNumber?: Maybe<Scalars['String']>;
  commitmentNumberMetadata?: Maybe<OverrideMetadataString>;
  commitmentNumberOverride?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  /** @deprecated Use currentTitleHolderMetadata.currentTitleHolder */
  currentTitleHolder?: Maybe<Scalars['String']>;
  currentTitleHolderMergeable?: Maybe<Scalars['String']>;
  currentTitleHolderMetadata?: Maybe<CurrentTitleHolderMetadata>;
  dateEffective?: Maybe<Scalars['DateTime']>;
  /** ID Format: orderId#GENERAL */
  id: Scalars['ID'];
  includeMaritalStatus?: Maybe<Scalars['Boolean']>;
  insuredLanguageType?: Maybe<Scalars['String']>;
  interestInLand?: Maybe<Scalars['String']>;
  /** @deprecated Use OverrideMetadata */
  isCommitmentNumberOverridden?: Maybe<Scalars['Boolean']>;
  /** @deprecated Use order */
  legalDescriptionBrief?: Maybe<Scalars['String']>;
  legalDescriptionBriefMergeable?: Maybe<Scalars['String']>;
  /** @deprecated Use order */
  legalDescriptionFull?: Maybe<Scalars['String']>;
  order?: Maybe<Order>;
  orderId: Scalars['String'];
  /** @deprecated Use order */
  piqUpdatedTimestamp?: Maybe<Scalars['String']>;
  proposedLoanInsured?: Maybe<Scalars['String']>;
  proposedLoanInsuredMetadata?: Maybe<OverrideMetadataString>;
  seeExhibitA?: Maybe<Scalars['Boolean']>;
  shouldDisplayMaritalStatus?: Maybe<Scalars['Boolean']>;
  timeEffective?: Maybe<Scalars['String']>;
  /** @deprecated Use currentTitleHolderMetadata.titleHolderType */
  titleHolderType?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
  vestingClause?: Maybe<Scalars['String']>;
  vestingClauseMetadata?: Maybe<OverrideMetadataString>;
};


export type TitleGeneralCurrentTitleHolderMergeableArgs = {
  showSyntax?: InputMaybe<Scalars['Boolean']>;
};

export type TitlePolicies = {
  __typename?: 'TitlePolicies';
  lender?: Maybe<TitlePremium>;
  owner?: Maybe<TitlePremium>;
};

export type TitlePremium = {
  __typename?: 'TitlePremium';
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  agentRetainedV2Override?: Maybe<DollarsPercent>;
  buyerPays?: Maybe<Scalars['Float']>;
  cdSection?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  disclosedAmount?: Maybe<Scalars['Float']>;
  disclosedAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  displayOnSettlement?: Maybe<Scalars['String']>;
  displayPropertyType?: Maybe<Scalars['String']>;
  effectiveDate?: Maybe<Scalars['String']>;
  /** @deprecated use effectiveDateOverrideMetadata */
  effectiveDateMetadata?: Maybe<OverrideMetadataString>;
  effectiveDateOverrideMetadata?: Maybe<OverrideMetadataString>;
  endorsements?: Maybe<Array<Maybe<TitlePremiumEndorsement>>>;
  endorsementsAgentRetainedTotal?: Maybe<Scalars['Float']>;
  endorsementsTotalAmount?: Maybe<Scalars['Float']>;
  endorsementsUnderwriterRemittedTotal?: Maybe<Scalars['Float']>;
  /** ID Format: {orderId}#{premiumType} */
  id: Scalars['ID'];
  isExtendedCoverage?: Maybe<Scalars['Boolean']>;
  /**
   * ANP-4864: Static list of KY municipal tax codes for dropdown selection
   * Embedded in TitlePremium response like policyTypes - empty array for non-KY orders
   * Resolved via entity resolver that checks property state
   */
  kyMunicipalTaxCodes: Array<KyMunicipalTaxCode>;
  liabilityAmount?: Maybe<Scalars['Float']>;
  /**
   * ANP-3103: KY Municipal Tax information
   * Returns nested object with comprehensive tax metadata
   * Null for non-KY properties, populated object for KY orders
   */
  municipalTaxInfo?: Maybe<MunicipalTaxInfo>;
  orderId: Scalars['ID'];
  payee?: Maybe<OrderParty>;
  payeeId?: Maybe<Scalars['String']>;
  payeeIdOverrideMetadata?: Maybe<OverrideMetadataString>;
  /** @deprecated use payeeIdOverrideMetadata */
  payeeMetadata?: Maybe<OverrideMetadataString>;
  policyAmount?: Maybe<Scalars['Float']>;
  policyAmountOverrideMetadata?: Maybe<OverrideMetadataNumber>;
  policyFees: Array<PolicyFeeAndTaxItem>;
  policyType?: Maybe<Scalars['String']>;
  policyTypes?: Maybe<Array<Maybe<PolicyType>>>;
  premiumType?: Maybe<Scalars['String']>;
  priorPolicy?: Maybe<Scalars['Boolean']>;
  priorPolicyAmount?: Maybe<Scalars['Float']>;
  priorPolicyCoverageType?: Maybe<Scalars['String']>;
  priorPolicyDate?: Maybe<Scalars['String']>;
  priorPolicyDiscountApplied?: Maybe<Scalars['Float']>;
  priorPolicyNumber?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  rate?: Maybe<TitleRate>;
  /** @deprecated use rate */
  rateDetails?: Maybe<TitleRateDetails>;
  rateId?: Maybe<Scalars['String']>;
  rateType?: Maybe<Scalars['String']>;
  /**
   * ANP-6975: Tracks the state of automatic premium recalculation.
   * Frontend polls this field to drive visual indicators (toasts, banners, nav icons).
   */
  recalculationStatus?: Maybe<RecalculationStatus>;
  remittanceAmount?: Maybe<Scalars['Float']>;
  remittanceAmountOverride?: Maybe<Scalars['Float']>;
  riskRateId?: Maybe<Scalars['String']>;
  sellerPays?: Maybe<Scalars['Float']>;
  simultaneousIssue?: Maybe<Scalars['Boolean']>;
  state?: Maybe<Scalars['String']>;
  statementType?: Maybe<Scalars['String']>;
  /**
   * Selected tax code (auto-fetched or user-selected from dropdown)
   * ANP-3103: Add KY Premium Tax Field to OP/LP
   * Stored as flat field for direct access
   */
  taxCode?: Maybe<Scalars['String']>;
  /**
   * Current tax rate (decimal, e.g., 0.09 for 9%)
   * ANP-1282: Tax rate lookup from FA Municipal Tax Service
   * Stored as flat field for direct access
   */
  taxRate?: Maybe<Scalars['Float']>;
  /**
   * User override for tax rate (decimal, e.g., 0.09 for 9%)
   * ANP-1707: Allows KY agents to override system-fetched municipal tax rate
   * When set, this value is used instead of taxRate for calculations
   */
  taxRateOverride?: Maybe<Scalars['Float']>;
  transactionType?: Maybe<Scalars['String']>;
  /** @deprecated use underwriterObject */
  underwriter?: Maybe<Scalars['String']>;
  underwriterObject?: Maybe<Underwriter>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
  underwriterRemittedV2Override?: Maybe<DollarsPercent>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type TitlePremiumEndorsement = {
  __typename?: 'TitlePremiumEndorsement';
  additionalQuestions?: Maybe<Array<AdditionalQuestion>>;
  agentRetainedV2?: Maybe<DollarsPercent>;
  agentRetainedV2Override?: Maybe<DollarsPercent>;
  amount?: Maybe<Scalars['Float']>;
  amountOverride?: Maybe<Scalars['Float']>;
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isDefaultEndorsement?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  underwriterRemittedV2?: Maybe<DollarsPercent>;
  underwriterRemittedV2Override?: Maybe<DollarsPercent>;
};

export type TitlePremiumEndorsementInput = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionInput>>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  agentRetainedOverride?: InputMaybe<Scalars['Float']>;
  amount?: InputMaybe<Scalars['Float']>;
  amountOverride?: InputMaybe<Scalars['Float']>;
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefaultEndorsement?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  underwriterRemittedOverride?: InputMaybe<Scalars['Float']>;
};

export type TitlePremiums = {
  __typename?: 'TitlePremiums';
  endorsementsTotalAmount?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  lender?: Maybe<TitlePremium>;
  owner?: Maybe<TitlePremium>;
};

export type TitleRate = {
  __typename?: 'TitleRate';
  actual?: Maybe<Scalars['Float']>;
  disclosed?: Maybe<Scalars['Float']>;
  discountApplied?: Maybe<Scalars['Float']>;
};

export type TitleRateCalculation = {
  __typename?: 'TitleRateCalculation';
  actual?: Maybe<OverrideMetadataNumber>;
  disclosed?: Maybe<OverrideMetadataNumber>;
};

export type TitleRateDetails = {
  __typename?: 'TitleRateDetails';
  lender?: Maybe<TitleRateCalculation>;
  owner?: Maybe<TitleRateCalculation>;
};

export type TitleRateInput = {
  actual?: InputMaybe<Scalars['Float']>;
  disclosed?: InputMaybe<Scalars['Float']>;
  discountApplied?: InputMaybe<Scalars['Float']>;
};

export type TitleRemittableProduct = {
  __typename?: 'TitleRemittableProduct';
  agentPremium?: Maybe<Scalars['Float']>;
  branch: Scalars['String'];
  branchId: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  company: Scalars['String'];
  companyId: Scalars['String'];
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Float']>;
  dateSettlement?: Maybe<Scalars['String']>;
  grossPremium?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  liabilityAmount?: Maybe<Scalars['Float']>;
  orderId: Scalars['String'];
  orderNumber: Scalars['String'];
  policyEffectiveDate?: Maybe<Scalars['String']>;
  priorPolicyAmount?: Maybe<Scalars['Float']>;
  priorPolicyType?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  productId: Scalars['String'];
  productIndex: Scalars['Int'];
  productNumber?: Maybe<Scalars['String']>;
  productStatus?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  rateType?: Maybe<Scalars['String']>;
  remittanceAmount?: Maybe<Scalars['Float']>;
  remittanceDate?: Maybe<Scalars['String']>;
  simultaneousIssue?: Maybe<Scalars['Boolean']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  underwriterId: Scalars['String'];
  uwPremium?: Maybe<Scalars['Float']>;
};

export type TitleRemittanceReportEntry = {
  __typename?: 'TitleRemittanceReportEntry';
  agentPremium?: Maybe<Scalars['Float']>;
  branch?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  companyId?: Maybe<Scalars['String']>;
  countyFips?: Maybe<Scalars['String']>;
  countyName?: Maybe<Scalars['String']>;
  credits?: Maybe<Scalars['Float']>;
  dateSettlement?: Maybe<Scalars['String']>;
  grossPremium?: Maybe<Scalars['Float']>;
  liabilityAmount?: Maybe<Scalars['Float']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  policyEffectiveDate?: Maybe<Scalars['String']>;
  priorPolicyAmount?: Maybe<Scalars['Float']>;
  priorPolicyType?: Maybe<Scalars['String']>;
  product?: Maybe<Scalars['String']>;
  productNumber?: Maybe<Scalars['String']>;
  productType?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  rateType?: Maybe<Scalars['String']>;
  remittanceAmount?: Maybe<Scalars['Float']>;
  remittanceDate?: Maybe<Scalars['String']>;
  simultaneousIssue?: Maybe<Scalars['Boolean']>;
  stateOrProvince?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  underwriterId?: Maybe<Scalars['String']>;
  uwPremium?: Maybe<Scalars['Float']>;
};

export type TitleRequirements = {
  __typename?: 'TitleRequirements';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  /** id format is {orderId}#REQUIREMENTS */
  id: Scalars['ID'];
  orderId: Scalars['ID'];
  requirements: Array<Maybe<Requirement>>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type TitleSearchClear2GoAddOn = {
  __typename?: 'TitleSearchClear2GoAddOn';
  actionableCurativeAddon?: Maybe<Scalars['String']>;
  alertCode?: Maybe<Scalars['String']>;
  alertDescription?: Maybe<Scalars['String']>;
  alertName?: Maybe<Scalars['String']>;
};

export type TitleSearchClear2GoComplexityIndicator = {
  __typename?: 'TitleSearchClear2GoComplexityIndicator';
  level?: Maybe<Scalars['String']>;
  overallOrderResult?: Maybe<Scalars['String']>;
  result?: Maybe<Scalars['String']>;
  resultCategory?: Maybe<Scalars['String']>;
};

export type TitleSearchImportDataSnapshot = {
  __typename?: 'TitleSearchImportDataSnapshot';
  createdAt: Scalars['String'];
  data: TitleSearchOrderImportDataWithSelection;
  isUpdate: Scalars['Boolean'];
  snapshotId: Scalars['String'];
  updateId?: Maybe<Scalars['String']>;
};

export type TitleSearchImportDocumentModel = {
  __typename?: 'TitleSearchImportDocumentModel';
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  modifiedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  providerUri?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
};

export type TitleSearchImportDocumentSelectedInput = {
  description?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  modifiedDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  providerUri?: InputMaybe<Scalars['String']>;
  selected: Scalars['Boolean'];
};

export type TitleSearchImportGeneralDataModel = {
  __typename?: 'TitleSearchImportGeneralDataModel';
  code: Scalars['String'];
  selected?: Maybe<Scalars['Boolean']>;
  value: Scalars['String'];
};

export type TitleSearchImportGeneralDataSelectedInput = {
  code: Scalars['String'];
  selected: Scalars['Boolean'];
  value: Scalars['String'];
};

/**
 * Shared input type for title search import requirements and exceptions.
 * Both have identical structure.
 */
export type TitleSearchImportItemInput = {
  bodyTemplate: Scalars['String'];
  code: Scalars['String'];
  indentLevel: Scalars['Int'];
  parentCode?: InputMaybe<Scalars['String']>;
  showNumber: Scalars['Boolean'];
  showOnDocument: Scalars['Boolean'];
  title: Scalars['String'];
};

export type TitleSearchImportRequirementsExceptionsDataModel = {
  __typename?: 'TitleSearchImportRequirementsExceptionsDataModel';
  bodyTemplate: Scalars['String'];
  code: Scalars['String'];
  indentLevel: Scalars['Int'];
  parentCode?: Maybe<Scalars['String']>;
  selected?: Maybe<Scalars['Boolean']>;
  showNumber: Scalars['Boolean'];
  showOnDocument: Scalars['Boolean'];
  title: Scalars['String'];
};

export type TitleSearchImportRequirementsExceptionsDataSelectedInput = {
  bodyTemplate: Scalars['String'];
  code: Scalars['String'];
  indentLevel: Scalars['Int'];
  parentCode: Scalars['String'];
  selected: Scalars['Boolean'];
  showNumber: Scalars['Boolean'];
  showOnDocument: Scalars['Boolean'];
  title: Scalars['String'];
};

export type TitleSearchOrder = {
  __typename?: 'TitleSearchOrder';
  allowedActions?: Maybe<Array<TitleSearchProductAction>>;
  businessSegment?: Maybe<Scalars['String']>;
  clear2GoAddOns?: Maybe<Array<TitleSearchClear2GoAddOn>>;
  clear2GoComplexityIndicator?: Maybe<TitleSearchClear2GoComplexityIndicator>;
  clear2GoIsCascaded?: Maybe<Scalars['Boolean']>;
  copyType?: Maybe<Scalars['String']>;
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  disclaimerMessage?: Maybe<Scalars['String']>;
  displayPropertyType?: Maybe<Scalars['String']>;
  documents?: Maybe<Array<TitleSearchOrderDocument>>;
  dueDate?: Maybe<Scalars['String']>;
  externalFileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  importData?: Maybe<TitleSearchOrderImportData>;
  importDataSnapshots?: Maybe<Array<TitleSearchImportDataSnapshot>>;
  importDocuments?: Maybe<Array<TitleSearchOrderDocument>>;
  isDisclaimerAccepted?: Maybe<Scalars['Boolean']>;
  municipalSearchType?: Maybe<Scalars['String']>;
  notes?: Maybe<Array<TitleSearchOrderNote>>;
  notificationEmailAddress?: Maybe<Scalars['String']>;
  orderId: Scalars['String'];
  orderNumber?: Maybe<Scalars['String']>;
  productFields?: Maybe<Array<TitleSearchOrderProductField>>;
  productName?: Maybe<Scalars['String']>;
  propertyType?: Maybe<Scalars['String']>;
  providerCreatedDate?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  searchOrderContact?: Maybe<TitleSearchOrderContact>;
  searchType?: Maybe<Scalars['String']>;
  serviceOrderReferenceId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  transactionType?: Maybe<Scalars['String']>;
  updatedBy: Scalars['String'];
  updatedTimestamp: Scalars['String'];
  updates?: Maybe<Array<TitleSearchUpdateModel>>;
  xmlParsingStatus?: Maybe<Scalars['String']>;
};

export type TitleSearchOrderContact = {
  __typename?: 'TitleSearchOrderContact';
  email?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type TitleSearchOrderDocument = {
  __typename?: 'TitleSearchOrderDocument';
  description?: Maybe<Scalars['String']>;
  documentId?: Maybe<Scalars['String']>;
  mimeType?: Maybe<Scalars['String']>;
  modifiedDate?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  providerUri?: Maybe<Scalars['String']>;
};

export type TitleSearchOrderDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  documentId?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  modifiedDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  providerUri?: InputMaybe<Scalars['String']>;
};

export type TitleSearchOrderImportData = {
  __typename?: 'TitleSearchOrderImportData';
  exceptions?: Maybe<Array<TitleSearchImportRequirementsExceptionsDataModel>>;
  general?: Maybe<Array<TitleSearchImportGeneralDataModel>>;
  requirements?: Maybe<Array<TitleSearchImportRequirementsExceptionsDataModel>>;
};

export type TitleSearchOrderImportDataWithSelection = {
  __typename?: 'TitleSearchOrderImportDataWithSelection';
  documents?: Maybe<Array<TitleSearchImportDocumentModel>>;
  exceptions?: Maybe<Array<TitleSearchImportRequirementsExceptionsDataModel>>;
  general?: Maybe<Array<TitleSearchImportGeneralDataModel>>;
  requirements?: Maybe<Array<TitleSearchImportRequirementsExceptionsDataModel>>;
};

export type TitleSearchOrderNote = {
  __typename?: 'TitleSearchOrderNote';
  createdDate?: Maybe<Scalars['String']>;
  text?: Maybe<Scalars['String']>;
};

export type TitleSearchOrderProductField = {
  __typename?: 'TitleSearchOrderProductField';
  name?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export type TitleSearchOrderProductFieldInput = {
  name?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

export type TitleSearchProduct = {
  __typename?: 'TitleSearchProduct';
  disclaimerInfo: TitleSearchProductDisclaimerInfo;
  fields: Array<TitleSearchProductField>;
  notificationEmailAddress: Scalars['String'];
  productName: Scalars['String'];
};

export enum TitleSearchProductAction {
  Cancel = 'CANCEL',
  Edit = 'EDIT',
  RequestUpdate = 'REQUEST_UPDATE'
}

export type TitleSearchProductDisclaimerInfo = {
  __typename?: 'TitleSearchProductDisclaimerInfo';
  isDisclaimerAcceptanceRequired: Scalars['Boolean'];
  text: Scalars['String'];
};

export type TitleSearchProductField = {
  __typename?: 'TitleSearchProductField';
  isRequired: Scalars['Boolean'];
  label: Scalars['String'];
  name: Scalars['String'];
  options: Array<TitleSearchProductOption>;
};

export type TitleSearchProductOption = {
  __typename?: 'TitleSearchProductOption';
  helpText?: Maybe<Scalars['String']>;
  mappedText?: Maybe<Scalars['String']>;
  text: Scalars['String'];
};

export type TitleSearchProductsResponse = {
  __typename?: 'TitleSearchProductsResponse';
  errors: Array<ErrorStatus>;
  products: Array<TitleSearchProduct>;
  warnings: Array<WarningStatus>;
};

export type TitleSearchProvider = {
  __typename?: 'TitleSearchProvider';
  id: Scalars['ID'];
  isActive: Scalars['Boolean'];
  maxFileSize: Scalars['Float'];
  name: Scalars['String'];
};

export type TitleSearchUpdateModel = {
  __typename?: 'TitleSearchUpdateModel';
  id?: Maybe<Scalars['String']>;
  isUpdateDelivered?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Scalars['String']>;
  updateType?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedDate?: Maybe<Scalars['String']>;
};

export type ToggleTen99Input = {
  orderEligible: Scalars['Boolean'];
  orderId: Scalars['ID'];
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type ToggleTen99Response = OrderResponse & Ten99Response & {
  __typename?: 'ToggleTen99Response';
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  ten99: Ten99;
};

export enum ToolType {
  ContactValidation = 'ContactValidation',
  IdentityVerification = 'IdentityVerification',
  Sdn = 'SDN'
}

export type TotalCommissionAmountValue = {
  __typename?: 'TotalCommissionAmountValue';
  calculatedValue?: Maybe<Scalars['Float']>;
  calculationMethod: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  finalizedPayorPayeeData?: Maybe<FinalizedPayorPayeeData>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCleared?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lastActivityDate?: Maybe<Scalars['String']>;
  lineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  matchedIncomingWireId?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  oPayeeAddress?: Maybe<Address>;
  oPayorPayeeId?: Maybe<Scalars['String']>;
  oTaxId?: Maybe<FundingTaxId>;
  oWireTransfer?: Maybe<WireSchema>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  parentConsolidatedPaymentId?: Maybe<Scalars['String']>;
  payee?: Maybe<OrderParty>;
  payorPayeeDisplayName?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeName?: Maybe<Scalars['String']>;
  payorPayeeString_sk?: Maybe<Scalars['String']>;
  payorPayeeType?: Maybe<Scalars['String']>;
  positivePayDate?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  reconciliationMethod?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  searchData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  transferredOrderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedByName?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  wireExpectedDate?: Maybe<Scalars['String']>;
};

export type TransactionCategoryStatus = {
  __typename?: 'TransactionCategoryStatus';
  cleared: TransactionCategoryStatusTotal;
  unmatched: TransactionCategoryStatusTotal;
};

export type TransactionCategoryStatusTotal = {
  __typename?: 'TransactionCategoryStatusTotal';
  amount: Scalars['Float'];
  items: Scalars['Int'];
};

export type TransactionDataAggregationInput = {
  aggregation: Scalars['String'];
  column: Scalars['String'];
};

export type TransactionDataFilterInput = {
  column: Scalars['String'];
  dateFromValue?: InputMaybe<Scalars['String']>;
  dateToValue?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['Float']>;
  minValue?: InputMaybe<Scalars['Float']>;
  operator: Scalars['String'];
  type: Scalars['String'];
  value?: InputMaybe<Scalars['JSONObject']>;
};

export type TransactionLineDetailTransferTarget = {
  __typename?: 'TransactionLineDetailTransferTarget';
  escrowAccountId?: Maybe<Scalars['String']>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

export type TransactionTableDataInput = {
  aggregations?: InputMaybe<Array<TransactionDataAggregationInput>>;
  escrowAccountId: Scalars['String'];
  filters?: InputMaybe<Array<TransactionDataFilterInput>>;
  groupings?: InputMaybe<Array<TransactionViewGroupingFieldInput>>;
  limit: Scalars['Int'];
  offset: Scalars['Int'];
  search?: InputMaybe<Scalars['String']>;
  sorting?: InputMaybe<Array<TransactionViewSortColumnInput>>;
};

export type TransactionTableDataResponse = {
  __typename?: 'TransactionTableDataResponse';
  data: Array<Transaction>;
};

export type TransactionType = {
  __typename?: 'TransactionType';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  enableDrawFields?: Maybe<Scalars['Boolean']>;
  enableLoanFields?: Maybe<Scalars['Boolean']>;
  enableSaleFields?: Maybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  isCustom?: Maybe<Scalars['Boolean']>;
  name?: Maybe<Scalars['String']>;
  purpose?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type TransactionViewGroupingFieldInput = {
  groupKey: Scalars['String'];
  groupPriority: Scalars['Int'];
  groupValue?: InputMaybe<Scalars['JSONObject']>;
};

export type TransactionViewSortColumnInput = {
  sortDirection: Scalars['String'];
  sortKey: Scalars['String'];
  sortPriority: Scalars['Int'];
};

export type TransferTaxCalculatorLineItem = {
  __typename?: 'TransferTaxCalculatorLineItem';
  amount?: Maybe<Scalars['Float']>;
  amountFallback?: Maybe<Scalars['Float']>;
  buyerAmount?: Maybe<Scalars['Float']>;
  buyerAmountFallback?: Maybe<Scalars['Float']>;
  buyerPercentage?: Maybe<Scalars['Float']>;
  default?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['ID']>;
  name?: Maybe<Scalars['String']>;
  nameFallback?: Maybe<Scalars['String']>;
  orderId: Scalars['ID'];
  payee?: Maybe<RecordingFeeTransferTaxPayee>;
  payeeId?: Maybe<Scalars['String']>;
  payeeSuggested?: Maybe<Scalars['String']>;
  sellerAmount?: Maybe<Scalars['Float']>;
  sellerPercentage?: Maybe<Scalars['Float']>;
  type?: Maybe<Scalars['String']>;
};

export type TransferTaxCalculatorLineItemInput = {
  amount?: InputMaybe<Scalars['Float']>;
  buyerPercentage?: InputMaybe<Scalars['Float']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  type: Scalars['String'];
};

export type TransferTaxFeeAdditionalData = {
  __typename?: 'TransferTaxFeeAdditionalData';
  externalCalculatorLineItemId?: Maybe<Scalars['String']>;
  providerType?: Maybe<Scalars['String']>;
  rfttFeeLineType?: Maybe<Scalars['String']>;
};

export type TransferTaxes = {
  __typename?: 'TransferTaxes';
  lineItems: Array<TransferTaxCalculatorLineItem>;
};

export type TransferTaxesInput = {
  lineItems?: InputMaybe<Array<InputMaybe<TransferTaxCalculatorLineItemInput>>>;
};

export type TransferTransactionDetailsInput = {
  escrowAccountId: Scalars['String'];
  originLineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  originTransaction?: InputMaybe<UpdateTransactionTransferInput>;
  targetOrder: Scalars['String'];
  /**
   * @deprecated Sets payorPayeeId on target transaction but does NOT create an order party.
   * Order party is now derived from origin order partial automatically.
   */
  targetOrderParty?: InputMaybe<Scalars['String']>;
};

export type TransferTransactionDetailsResponse = {
  __typename?: 'TransferTransactionDetailsResponse';
  escrowAccountId?: Maybe<Scalars['String']>;
  originLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  originTransaction?: Maybe<Transaction>;
  targetLineDetails?: Maybe<Array<Maybe<LineDetail>>>;
  targetTransaction?: Maybe<Transaction>;
};

export type TriggerTitleSearchImportDataInput = {
  documents: Array<TriggerTitleSearchImportDocumentInput>;
  exceptions: Array<TitleSearchImportItemInput>;
  general: Array<TriggerTitleSearchImportGeneralInput>;
  requirements: Array<TitleSearchImportItemInput>;
};

export type TriggerTitleSearchImportDocumentInput = {
  description?: InputMaybe<Scalars['String']>;
  mimeType?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  providerUri: Scalars['String'];
};

export type TriggerTitleSearchImportGeneralInput = {
  code: Scalars['String'];
  value: Scalars['String'];
};

export type TriggerTitleSearchImportInput = {
  branchId?: InputMaybe<Scalars['String']>;
  companyId: Scalars['String'];
  externalFileId: Scalars['String'];
  importData: TriggerTitleSearchImportDataInput;
  orderId: Scalars['String'];
  providerId: Scalars['String'];
  serviceOrderReferenceId: Scalars['String'];
  titleSearchId: Scalars['String'];
  updateId?: InputMaybe<Scalars['String']>;
};

export type TriggerTitleSearchImportPendingDocument = {
  __typename?: 'TriggerTitleSearchImportPendingDocument';
  providerUri: Scalars['String'];
};

export type TriggerTitleSearchImportPendingException = {
  __typename?: 'TriggerTitleSearchImportPendingException';
  clauseId: Scalars['String'];
  uuid: Scalars['String'];
};

export type TriggerTitleSearchImportPendingItems = {
  __typename?: 'TriggerTitleSearchImportPendingItems';
  documents: Array<TriggerTitleSearchImportPendingDocument>;
  exceptions: Array<TriggerTitleSearchImportPendingException>;
  requirements: Array<TriggerTitleSearchImportPendingRequirement>;
};

export type TriggerTitleSearchImportPendingRequirement = {
  __typename?: 'TriggerTitleSearchImportPendingRequirement';
  clauseId: Scalars['String'];
  uuid: Scalars['String'];
};

export type TriggerTitleSearchImportResponse = {
  __typename?: 'TriggerTitleSearchImportResponse';
  executionArn?: Maybe<Scalars['String']>;
  isRetry: Scalars['Boolean'];
  manifest: ImportManifest;
  pendingItems: TriggerTitleSearchImportPendingItems;
};

export type TxDisclosureT64Form = {
  __typename?: 'TxDisclosureT64Form';
  buyer?: Maybe<TxDisclosureT64FormAddress>;
  buyersAllNames?: Maybe<Scalars['String']>;
  endorsements?: Maybe<Scalars['Float']>;
  isPurchaseTransaction?: Maybe<Scalars['Boolean']>;
  lenderCompany?: Maybe<TxDisclosureT64FormCompany>;
  lenderEndorsements?: Maybe<Scalars['String']>;
  lenderPolicyAmount?: Maybe<Scalars['Float']>;
  loanAmount?: Maybe<Scalars['Float']>;
  orderNumber?: Maybe<Scalars['String']>;
  ownerEndorsements?: Maybe<Scalars['String']>;
  ownerPolicyAmount?: Maybe<Scalars['Float']>;
  property?: Maybe<TxDisclosureT64FormAddress>;
  recordingFees?: Maybe<Array<Maybe<TxDisclosureT64FormFeeItem>>>;
  saleAmount?: Maybe<Scalars['Float']>;
  seller?: Maybe<TxDisclosureT64FormAddress>;
  sellersAllNames?: Maybe<Scalars['String']>;
  settlementAgent?: Maybe<TxDisclosureT64FormCompany>;
  settlementDate?: Maybe<Scalars['String']>;
  settlementFees?: Maybe<Array<Maybe<TxDisclosureT64FormFeeItem>>>;
  signatures?: Maybe<TxDisclosureT64FormSignatures>;
  titleAgent?: Maybe<Scalars['String']>;
  titleAgentAllocatedAmount?: Maybe<Scalars['Float']>;
  titleAllocations?: Maybe<Array<Maybe<TxDisclosureT64FormAllocation>>>;
  totalAmount?: Maybe<Scalars['Float']>;
  underwriter?: Maybe<Scalars['String']>;
  underwriterRemitted?: Maybe<Scalars['Float']>;
};

export type TxDisclosureT64FormAddress = {
  __typename?: 'TxDisclosureT64FormAddress';
  cityStateZip?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type TxDisclosureT64FormAllocation = {
  __typename?: 'TxDisclosureT64FormAllocation';
  allocationMethod?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
  payeeName?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['Float']>;
};

export type TxDisclosureT64FormCompany = {
  __typename?: 'TxDisclosureT64FormCompany';
  address?: Maybe<TxDisclosureT64FormAddress>;
  name?: Maybe<Scalars['String']>;
};

export type TxDisclosureT64FormFeeItem = {
  __typename?: 'TxDisclosureT64FormFeeItem';
  amount?: Maybe<Scalars['Float']>;
  description?: Maybe<Scalars['String']>;
};

export type TxDisclosureT64FormSignature = {
  __typename?: 'TxDisclosureT64FormSignature';
  entityName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  powerofAttorneySigningName?: Maybe<Scalars['String']>;
};

export type TxDisclosureT64FormSignatures = {
  __typename?: 'TxDisclosureT64FormSignatures';
  buyers?: Maybe<Array<Maybe<TxDisclosureT64FormSignature>>>;
  sellers?: Maybe<Array<Maybe<TxDisclosureT64FormSignature>>>;
};

export type TxStatementBuyer = {
  __typename?: 'TxStatementBuyer';
  buyerAddress?: Maybe<TxStatementBuyerAddress>;
  sellerAddress?: Maybe<TxStatementBuyerAddress>;
};

export type TxStatementBuyerAddress = {
  __typename?: 'TxStatementBuyerAddress';
  cityStateZip?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type TxStatementCombined = {
  __typename?: 'TxStatementCombined';
  buyerAddress?: Maybe<TxStatementCombinedAddress>;
  lenderAddress?: Maybe<Scalars['String']>;
  loanNumber?: Maybe<Scalars['String']>;
  sellerAddress?: Maybe<TxStatementCombinedAddress>;
};

export type TxStatementCombinedAddress = {
  __typename?: 'TxStatementCombinedAddress';
  cityStateZip?: Maybe<Scalars['String']>;
  street?: Maybe<Scalars['String']>;
};

export type UnPlattedLand = {
  __typename?: 'UnPlattedLand';
  description?: Maybe<Scalars['String']>;
  quarterSection?: Maybe<QuarterSection>;
  range?: Maybe<Scalars['String']>;
  section?: Maybe<Scalars['String']>;
  township?: Maybe<Scalars['String']>;
};

export type UnPlattedLandInput = {
  description?: InputMaybe<Scalars['String']>;
  quarterSection?: InputMaybe<QuarterSectionInput>;
  range?: InputMaybe<Scalars['String']>;
  section?: InputMaybe<Scalars['String']>;
  township?: InputMaybe<Scalars['String']>;
};

export type Underwriter = {
  __typename?: 'Underwriter';
  abbreviation: Scalars['String'];
  activeDate?: Maybe<Scalars['String']>;
  address: UnderwriterAddress;
  deactivatedDate?: Maybe<Scalars['String']>;
  friendlyName: Scalars['String'];
  id: Scalars['ID'];
  image: Scalars['String'];
  integration?: Maybe<Integration>;
  integrationType?: Maybe<Scalars['JSONObject']>;
  itemId: Scalars['ID'];
  name: Scalars['String'];
  phone: Phone;
  replacementUnderwriterId?: Maybe<Scalars['ID']>;
  state: Scalars['String'];
  website: Scalars['String'];
};

export type UnderwriterAddress = {
  __typename?: 'UnderwriterAddress';
  mailing?: Maybe<Address>;
  overnight?: Maybe<Address>;
  primary: Address;
};

export type UnderwriterConfiguration = {
  __typename?: 'UnderwriterConfiguration';
  /** Map of allowed approved attorney types for each state */
  approvedAttorneyMap: Array<StateAttorneyMap>;
  /** Underwriter id */
  underwriterId: Scalars['String'];
};

export type UnderwriterDisclosureFeeAdditionalData = {
  __typename?: 'UnderwriterDisclosureFeeAdditionalData';
  externalLenderPremiumId?: Maybe<Scalars['String']>;
  externalOwnerPremiumId?: Maybe<Scalars['String']>;
  overallUnderwriterRemittedAmount?: Maybe<Scalars['Float']>;
};

export type UnderwriterValidationResult = {
  __typename?: 'UnderwriterValidationResult';
  action: Scalars['String'];
  reason: Scalars['String'];
  replacementUsed?: Maybe<Scalars['ID']>;
  validatedUnderwriterId?: Maybe<Scalars['ID']>;
};

export type UpdateAdjustmentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminMilestoneInput = {
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminMilestoneResponse = {
  __typename?: 'UpdateAdminMilestoneResponse';
  existingMilestoneName?: Maybe<Scalars['String']>;
  milestone?: Maybe<AdminMilestone>;
};

export type UpdateAdminTaskInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignment?: InputMaybe<TaskAssignmentInput>;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<TaskDueInput>;
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<TaskStartInput>;
  type?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminTaskResponse = {
  __typename?: 'UpdateAdminTaskResponse';
  existingTaskName?: Maybe<Scalars['String']>;
  task?: Maybe<AdminTask>;
};

export type UpdateAdminWorkflowInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companies?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  name?: InputMaybe<Scalars['String']>;
  states?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  transactionPurpose?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateAdminWorkflowResponse = {
  __typename?: 'UpdateAdminWorkflowResponse';
  existingWorkflowName?: Maybe<Scalars['String']>;
  workflow?: Maybe<AdminWorkflow>;
};

export type UpdateCarrierAccountRequestInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  carrierType?: InputMaybe<CarrierType>;
  companyAccess?: InputMaybe<CompanyAccessInput>;
  companyInfo?: InputMaybe<UpdateCarrierAccountRequestInput_CompanyInfo>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  shippingAddress?: InputMaybe<UpdateCarrierAccountRequestInput_ShippingAddress>;
};

export type UpdateCarrierAccountRequestInput_CompanyInfo = {
  address?: InputMaybe<UpdateCarrierAccountRequestInput_CompanyInfo_Address>;
  contact?: InputMaybe<UpdateCarrierAccountRequestInput_CompanyInfo_Contact>;
  name?: InputMaybe<Scalars['String']>;
};

export type UpdateCarrierAccountRequestInput_CompanyInfo_Address = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateCarrierAccountRequestInput_CompanyInfo_Contact = {
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type UpdateCarrierAccountRequestInput_ShippingAddress = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<CountryCodes>;
  state?: InputMaybe<Scalars['String']>;
  street1?: InputMaybe<Scalars['String']>;
  street2?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateDcAdjustmentInput = {
  amount?: InputMaybe<Scalars['Float']>;
  dcAddendumLineNumber?: InputMaybe<Scalars['Int']>;
  dcLineNumber?: InputMaybe<Scalars['Int']>;
  description?: InputMaybe<Scalars['String']>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  id: Scalars['String'];
  isDebitCredit?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  payeePayorId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateDepartmentInput = {
  name: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
  users?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateDirectoryCompanyInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  addresses?: InputMaybe<Array<InputMaybe<AddressInput>>>;
  altaId?: InputMaybe<Scalars['String']>;
  alternateSearchName?: InputMaybe<Scalars['String']>;
  companyName?: InputMaybe<Scalars['String']>;
  companyTypes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  id: Scalars['ID'];
  lenderLanguage?: InputMaybe<Scalars['String']>;
  lenderLanguageDefaultType?: InputMaybe<Scalars['String']>;
  lenderLanguageOptions?: InputMaybe<LenderLanguageOptionsInput>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  tenantOrgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedTimestamp: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
};

export type UpdateDirectoryContactInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  firstName?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  middleName?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
  notaryCommissions?: InputMaybe<Array<InputMaybe<NotaryCommissionsInput>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  suffix?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  useCompanyAddress?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEntityDocumentTagsV2Input = {
  addTags?: InputMaybe<Array<Scalars['String']>>;
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  removeTags?: InputMaybe<Array<Scalars['String']>>;
  setTags?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateEntityDocumentV2Input = {
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: OrderDocumentTypeV2;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  listMergeChoices?: InputMaybe<Scalars['String']>;
  mergeFieldData?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  rawMergeDataUri?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  scopeId?: InputMaybe<Scalars['ID']>;
  skipClone?: InputMaybe<Scalars['Boolean']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateEpnAccountInput = {
  accountName?: InputMaybe<Scalars['String']>;
  apiKey?: InputMaybe<Scalars['String']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  id: Scalars['ID'];
  isAutoSubmitEnabled?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateEpnIntegrationStatusInput = {
  isEnabled: Scalars['Boolean'];
};

export type UpdateEscrowAccountInput = {
  accountNumber?: InputMaybe<Scalars['String']>;
  accountNumberAlternate?: InputMaybe<Scalars['String']>;
  addresses?: InputMaybe<Array<InputMaybe<EscrowAccountAddressInput>>>;
  bankName?: InputMaybe<Scalars['String']>;
  checkPrinting?: InputMaybe<CheckPrintingInput>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  escrowAccountName?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  integrations?: InputMaybe<EscrowAccountIntegrationsInput>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  isDeleted?: InputMaybe<Scalars['Boolean']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  positivePay?: InputMaybe<PositivePayInput>;
  quickbooksConfig?: InputMaybe<QuickBooksConfigInput>;
  routingNumber?: InputMaybe<Scalars['String']>;
  routingNumberDeposit?: InputMaybe<Scalars['String']>;
  routingNumberFractional?: InputMaybe<Scalars['String']>;
  routingNumberWire?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type UpdateExceptionInput = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  clauseDisplayType: Scalars['String'];
  exceptionId: Scalars['String'];
  isAffirmativeCoverage?: InputMaybe<Scalars['Boolean']>;
  isSubordinateMatter?: InputMaybe<Scalars['Boolean']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateExceptionItemInput = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  clauseDisplayType: Scalars['String'];
  exceptionId: Scalars['String'];
  isAffirmativeCoverage?: InputMaybe<Scalars['Boolean']>;
  isSubordinateMatter?: InputMaybe<Scalars['Boolean']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateExceptionsHeaderInput = {
  exceptions?: InputMaybe<Array<InputMaybe<ExceptionReference>>>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateExceptionsInput = {
  exceptions: Array<InputMaybe<UpdateExceptionItemInput>>;
  orderId: Scalars['String'];
};

export type UpdateFeeInput = {
  borrowerPaidAt?: InputMaybe<Scalars['Float']>;
  borrowerPaidBefore?: InputMaybe<Scalars['Float']>;
  description: Scalars['String'];
  feeLineType: Scalars['String'];
  feeTypeAdditionalData?: InputMaybe<FeeTypeAdditionalDataInput>;
  fromStatementSection: Scalars['String'];
  fromStatementType: Scalars['String'];
  funding: Scalars['String'];
  gfeLineNumber?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  orderId: Scalars['String'];
  payeeId?: InputMaybe<Scalars['String']>;
  pboBorrowerAmount?: InputMaybe<Scalars['Float']>;
  pboBorrowerPaidById?: InputMaybe<Scalars['String']>;
  pboSellerAmount?: InputMaybe<Scalars['Float']>;
  pboSellerPaidById?: InputMaybe<Scalars['String']>;
  sectionMapping?: InputMaybe<SectionMappingInput>;
  sellerPaidAt?: InputMaybe<Scalars['Float']>;
  sellerPaidBefore?: InputMaybe<Scalars['Float']>;
  statementPayeeDisplayName?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateFundInput = {
  escrowAccountId?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateFundingForFeesInput = {
  feesToUpdate: Array<FeeToUpdateInput>;
  orderId: Scalars['String'];
  statementSection: Scalars['String'];
  statementType: Scalars['String'];
  updatedFunding: Scalars['String'];
};

export type UpdateGfeChargeInput = {
  gfeCharge: UpdateGfeChargeItemInput;
  orderId: Scalars['String'];
};

export type UpdateGfeChargeItemInput = {
  comparisonCategory?: InputMaybe<Scalars['String']>;
  gfeAmount?: InputMaybe<Scalars['Float']>;
  id: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateGfeChargesInput = {
  gfeCharges: Array<UpdateGfeChargeItemInput>;
  orderId: Scalars['String'];
};

export type UpdateIsSetAsCdLastLineInput = {
  fromStatementSection: Scalars['String'];
  id: Scalars['String'];
  isSetAsCDLastLine: Scalars['Boolean'];
  orderId: Scalars['String'];
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateLineDetailInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isLocked?: InputMaybe<Scalars['Boolean']>;
  lineNumber?: InputMaybe<Scalars['String']>;
  oAmount?: InputMaybe<Scalars['Float']>;
  oDescription?: InputMaybe<Scalars['String']>;
  oLineNumber?: InputMaybe<Scalars['String']>;
  refMetadata?: InputMaybe<RefMetaDataInput>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type UpdateLineDetailsInput = {
  escrowAccountId: Scalars['String'];
  lineDetails?: InputMaybe<Array<InputMaybe<UpdateLineDetailInput>>>;
  transactionId: Scalars['String'];
};

export type UpdateLoanDisclosuresInput = {
  adjustableInterestRateTable?: InputMaybe<AdjustableInterestRateTableInput>;
  adjustablePaymentsTable?: InputMaybe<AdjustablePaymentsTableInput>;
  escrowAccount?: InputMaybe<Scalars['String']>;
  escrowWaiverFee?: InputMaybe<Scalars['Float']>;
  escrowWaiverFeeDescription?: InputMaybe<Scalars['String']>;
  escrowedCostsFirstYear?: InputMaybe<Scalars['Float']>;
  escrowedCostsListing?: InputMaybe<Scalars['String']>;
  estimatedCostsOverFirstYear?: InputMaybe<Scalars['Float']>;
  initialEscrowPayment?: InputMaybe<Scalars['Float']>;
  latePaymentDays?: InputMaybe<Scalars['Int']>;
  latePaymentFeeDescription?: InputMaybe<Scalars['String']>;
  loanAssumptionPermitted?: InputMaybe<Scalars['String']>;
  loanHasDemandFeature?: InputMaybe<Scalars['String']>;
  monthlyEscrowAmount?: InputMaybe<Scalars['Float']>;
  negativeAmortization?: InputMaybe<Scalars['String']>;
  nonEscrowedCostFirstYear?: InputMaybe<Scalars['Float']>;
  nonEscrowedCostsListing?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  partialPayments?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateMergeTemplateData = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateMortgageRecitalInput = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  recitalType?: InputMaybe<SecurityInstrumentRecitalType>;
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateNoteInput = {
  appliesTo?: InputMaybe<AppliesTo>;
  appliesToId?: InputMaybe<Scalars['String']>;
  attributions?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  body: Scalars['String'];
  entityId: Scalars['String'];
  entityType: NoteEntityType;
  noteId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateNotificationsInput = {
  notifications?: InputMaybe<Array<InputMaybe<NotificationInput>>>;
};

export type UpdateOrderBuyerSellerInput = {
  address?: InputMaybe<AddressInput>;
  alias?: InputMaybe<Scalars['String']>;
  buyerSellerId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  entityDateOfAgreement?: InputMaybe<Scalars['String']>;
  entityName?: InputMaybe<Scalars['String']>;
  entityStateOfAgreement?: InputMaybe<Scalars['String']>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  forwardingAddress?: InputMaybe<AddressInput>;
  forwardingAddressSameAsCurrentAddress?: InputMaybe<Scalars['Boolean']>;
  forwardingAddressSameAsPropertyAddress?: InputMaybe<Scalars['Boolean']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  isForeignAddress?: InputMaybe<Scalars['Boolean']>;
  isForeignForwardingAddress?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  typeOfBuyerSeller?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  vesting?: InputMaybe<Scalars['String']>;
};

export type UpdateOrderBuyerSellerSoRepInput = {
  alias?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<BuyerSellerEmailAddressInput>>>;
  excludeFromLoan?: InputMaybe<Scalars['Boolean']>;
  firstName?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<Scalars['String']>;
  hasPowerOfAttorney?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  maritalStatus?: InputMaybe<Scalars['String']>;
  middleName?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<BuyerSellerPhoneNumberInput>>>;
  powerOfAttorney?: InputMaybe<PowerOfAttorneyInput>;
  refBuyerSellerId?: InputMaybe<Scalars['String']>;
  referencedAs?: InputMaybe<Scalars['String']>;
  representativeCapacity?: InputMaybe<Scalars['String']>;
  sdnStatus?: InputMaybe<Scalars['String']>;
  signingName?: InputMaybe<Scalars['String']>;
  soRepId?: InputMaybe<Scalars['String']>;
  suffix?: InputMaybe<Scalars['String']>;
  taxIdNumber?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderHeaderInput = {
  branch?: InputMaybe<Scalars['String']>;
  businessSource?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  dateCancelled?: InputMaybe<Scalars['String']>;
  dateClosed?: InputMaybe<Scalars['String']>;
  dateOnHold?: InputMaybe<Scalars['String']>;
  isFeeAccount?: InputMaybe<Scalars['Boolean']>;
  isMasterOrder?: InputMaybe<Scalars['Boolean']>;
  orderNumber?: InputMaybe<Scalars['String']>;
  propertyState?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  statementType?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  transactionTypeId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderInput = {
  buyer?: InputMaybe<UpdateOrderBuyerSellerInput>;
  buyerReps?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
  buyerSpouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
  commissions?: InputMaybe<OrderCommissionsInput>;
  header?: InputMaybe<UpdateOrderHeaderInput>;
  loan?: InputMaybe<OrderLoanInput>;
  main?: InputMaybe<UpdateOrderMainInput>;
  orderId: Scalars['ID'];
  party?: InputMaybe<OrderPartyInput>;
  piq?: InputMaybe<OrderPiqInput>;
  seller?: InputMaybe<UpdateOrderBuyerSellerInput>;
  sellerReps?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
  sellerSpouse?: InputMaybe<UpdateOrderBuyerSellerSoRepInput>;
};

export type UpdateOrderMainInput = {
  amountInitialDraw?: InputMaybe<Scalars['Float']>;
  amountLoan?: InputMaybe<Scalars['Float']>;
  amountSale?: InputMaybe<Scalars['Float']>;
  closingLocation?: InputMaybe<AddressInput>;
  dateDisbursement?: InputMaybe<Scalars['String']>;
  dateFunding?: InputMaybe<Scalars['String']>;
  dateRecission?: InputMaybe<Scalars['String']>;
  dateSettlement?: InputMaybe<Scalars['String']>;
  otherReferenceNumber?: InputMaybe<Scalars['String']>;
  staff?: InputMaybe<Array<InputMaybe<OrderStaffInput>>>;
  timeSettlement?: InputMaybe<Scalars['String']>;
  underwriterId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderMilestoneInput = {
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  updatedTimestamp: Scalars['DateTime'];
};

/** This is an input structure for updating an OrderParty with either Directory IDs or complete PartyCompany/PartyContact data */
export type UpdateOrderPartyInput = {
  /** When directoryCompanyId is specified, then the company field is ignored */
  company?: InputMaybe<PartyCompanyInput>;
  /** When directoryContactId is specified, then the contact field is ignored */
  contact?: InputMaybe<PartyContactInput>;
  /** Specify the ID of a DirectoryCompany to be copied into the PartyCompany. */
  directoryCompanyReferenceId?: InputMaybe<Scalars['String']>;
  /** Specify the ID of a DirectoryContact to be copied into the PartyContact. */
  directoryContactReferenceId?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  isSettlementUseOnly?: InputMaybe<Scalars['Boolean']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateOrderTaskInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  assignment?: InputMaybe<TaskAssignmentInput>;
  completedBy?: InputMaybe<Scalars['String']>;
  completedTimestamp?: InputMaybe<Scalars['String']>;
  departmentDependency?: InputMaybe<Scalars['String']>;
  due?: InputMaybe<TaskDueInput>;
  dueDate?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  sortIndex?: InputMaybe<Scalars['Int']>;
  start?: InputMaybe<TaskStartInput>;
  startDate?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  timeTracking?: InputMaybe<TaskTimeTrackingInput>;
  type?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateOrderTaskResponse = {
  __typename?: 'UpdateOrderTaskResponse';
  existingTaskName?: Maybe<Scalars['String']>;
  task?: Maybe<Task>;
};

export type UpdatePackageInput = {
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  orderId: Scalars['ID'];
  packageId: Scalars['ID'];
  packageName?: InputMaybe<Scalars['String']>;
};

export type UpdatePayoffAdditionalFee = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
};

export type UpdatePayoffInput = {
  additionalDaysAfterDisbursement?: InputMaybe<Scalars['Int']>;
  additionalFees?: InputMaybe<Array<InputMaybe<UpdatePayoffAdditionalFee>>>;
  appendedDescription?: InputMaybe<Scalars['String']>;
  asOfDate?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  lenderPartyId?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  paidBy?: InputMaybe<Scalars['String']>;
  perDiemInterestAmount?: InputMaybe<Scalars['Float']>;
  principalBalance?: InputMaybe<Scalars['Float']>;
  totalAdditionalInterest?: InputMaybe<Scalars['Float']>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type UpdatePolicyMetadataInput = {
  createRecital?: InputMaybe<Scalars['Boolean']>;
  insuredVesting?: InputMaybe<UpdateMergeTemplateData>;
  loanPolicy?: InputMaybe<PolicyDataInput>;
  mortgageRecital?: InputMaybe<UpdateMortgageRecitalInput>;
  orderId: Scalars['ID'];
  ownerPolicy?: InputMaybe<PolicyDataInput>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
};

export type UpdatePropertyTaxProrationConfigurationInput = {
  calendarYearStarts?: InputMaybe<Scalars['String']>;
  daysInYear?: InputMaybe<Scalars['String']>;
  dueDates?: InputMaybe<Array<DueDateInput>>;
  id: Scalars['ID'];
  includeProrationDate?: InputMaybe<Scalars['Boolean']>;
  paymentFrequency?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  taxType?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateProrationCharge = {
  frequency?: InputMaybe<Scalars['String']>;
  lineItem?: InputMaybe<ProrationChargeLineItemInput>;
  payeePartyId?: InputMaybe<Scalars['String']>;
  prorationChargeSubtype?: InputMaybe<Scalars['String']>;
  prorationChargeType?: InputMaybe<Scalars['String']>;
  prorationDetails?: InputMaybe<ProrationDetailsInput>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateProrationInput = {
  frequency?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isPropertyTax?: InputMaybe<Scalars['Boolean']>;
  lineItems?: InputMaybe<Array<InputMaybe<ProrationLineItemInput>>>;
  payeePartyId?: InputMaybe<Scalars['String']>;
  prorationDetails?: InputMaybe<ProrationDetailsInput_V2>;
  prorationSubtype?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateReconciliationInput = {
  beginningBalance?: InputMaybe<Scalars['Float']>;
  clearedBalance?: InputMaybe<Scalars['Float']>;
  endingDate?: InputMaybe<Scalars['String']>;
  escrowAccountId: Scalars['String'];
  reconciliationId: Scalars['String'];
  statementEndingBalance?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<ReconciliationStatus>;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateRecordingDocumentInput = {
  actualFees?: InputMaybe<Scalars['Float']>;
  associatedDocumentId?: InputMaybe<Scalars['ID']>;
  associatedDocumentType?: InputMaybe<Scalars['String']>;
  book?: InputMaybe<Scalars['String']>;
  collectedFees?: InputMaybe<Scalars['Float']>;
  considerationAmount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  documentDate?: InputMaybe<Scalars['String']>;
  documentTime?: InputMaybe<Scalars['String']>;
  documentType?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  instrumentNumber?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  page?: InputMaybe<Scalars['String']>;
  pageCount?: InputMaybe<Scalars['String']>;
  recordedDate?: InputMaybe<Scalars['String']>;
  recordedTime?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateReportInput = {
  description?: InputMaybe<Scalars['String']>;
  view?: InputMaybe<ReportViewInput>;
  viewName?: InputMaybe<Scalars['String']>;
  visibility?: InputMaybe<Scalars['ReportViewVisibility']>;
};

export type UpdateRequirementInput = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  clauseDisplayType: Scalars['String'];
  mergeFields?: InputMaybe<Scalars['String']>;
  orderId: Scalars['String'];
  requirementId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateRequirementItemInput = {
  bodyTemplate?: InputMaybe<Scalars['String']>;
  clauseDisplayType: Scalars['String'];
  mergeFields?: InputMaybe<Scalars['String']>;
  requirementId: Scalars['String'];
  title?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateRequirementsHeaderInput = {
  orderId: Scalars['String'];
  requirements?: InputMaybe<Array<InputMaybe<RequirementReference>>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateRequirementsInput = {
  orderId: Scalars['String'];
  requirements: Array<InputMaybe<UpdateRequirementItemInput>>;
};

export type UpdateRestrictiveCovenantInput = {
  applyToPolicy?: InputMaybe<Scalars['String']>;
  bodyTemplate?: InputMaybe<Scalars['String']>;
  clauseDisplayType?: InputMaybe<Scalars['String']>;
  mergeFields?: InputMaybe<Scalars['String']>;
  orderId: Scalars['ID'];
  title?: InputMaybe<Scalars['String']>;
};

export type UpdateSecurityGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  id: Scalars['ID'];
  name?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['JSONObject']>;
  schemaVersion?: InputMaybe<Scalars['Int']>;
  type?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateSequenceInput = {
  alphaSuffix?: InputMaybe<Scalars['String']>;
  currentSequenceNumber?: InputMaybe<Scalars['Int']>;
  numberOfDigitsInSequence?: InputMaybe<Scalars['Int']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  sequenceId: Scalars['ID'];
  sequenceName?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateStateWithholdingInput = {
  description?: InputMaybe<Scalars['String']>;
  oTotalWithholdingBasis?: InputMaybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  payorPayeeId: Scalars['String'];
  sellers?: InputMaybe<Array<InputMaybe<StateWithholdingSellerValuesInput>>>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateTagV2Input = {
  attributes: TagDataItemAttributesV2Input;
  sortPriority?: InputMaybe<Scalars['Int']>;
  tagId: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateTemplateDocTagsV2Input = {
  addTags?: InputMaybe<Array<Scalars['String']>>;
  /** @minItems 1 */
  documentIds: Array<Scalars['String']>;
  documentType: TemplateDocTypeV2;
  removeTags?: InputMaybe<Array<Scalars['String']>>;
  setTags?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateTemplateDocV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  documentId: Scalars['ID'];
  documentType: TemplateDocTypeV2;
  isVisible?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['ID']>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  updatedTimestamp?: InputMaybe<Scalars['String']>;
};

export type UpdateTemplateSetV2Input = {
  attributes?: InputMaybe<TemplateAttributesV2Input>;
  description?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  setId: Scalars['ID'];
  templateIds?: InputMaybe<Array<Scalars['String']>>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateTen99Response = OrderResponse & Ten99Response & {
  __typename?: 'UpdateTen99Response';
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  ten99: Ten99;
};

export type UpdateTenantChildInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  contactEmail?: InputMaybe<Scalars['String']>;
  contactFirstName?: InputMaybe<Scalars['String']>;
  contactLastName?: InputMaybe<Scalars['String']>;
  contactMiddleName?: InputMaybe<Scalars['String']>;
  contactPhone?: InputMaybe<Scalars['String']>;
  contactPhoneExtension?: InputMaybe<Scalars['String']>;
  contactPhoneType?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  emailAddresses?: InputMaybe<Array<InputMaybe<EmailAddressInput>>>;
  id: Scalars['ID'];
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  name: Scalars['String'];
  nmlsId?: InputMaybe<Scalars['String']>;
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<PhoneNumberInput>>>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
  wireInstructions?: InputMaybe<WireInput>;
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateTenantInput = {
  abbreviation: Scalars['String'];
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  billingContactEmail?: InputMaybe<Scalars['String']>;
  billingContactFirstName?: InputMaybe<Scalars['String']>;
  billingContactLastName?: InputMaybe<Scalars['String']>;
  billingContactMiddleName?: InputMaybe<Scalars['String']>;
  billingContactPhone?: InputMaybe<Scalars['String']>;
  billingContactPhoneExtension?: InputMaybe<Scalars['String']>;
  billingContactPhoneType?: InputMaybe<Scalars['String']>;
  businessContactEmail?: InputMaybe<Scalars['String']>;
  businessContactFirstName?: InputMaybe<Scalars['String']>;
  businessContactLastName?: InputMaybe<Scalars['String']>;
  businessContactMiddleName?: InputMaybe<Scalars['String']>;
  businessContactPhone?: InputMaybe<Scalars['String']>;
  businessContactPhoneExtension?: InputMaybe<Scalars['String']>;
  businessContactPhoneType?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['ID']>;
  itemId?: InputMaybe<Scalars['ID']>;
  labelL1?: InputMaybe<Scalars['String']>;
  labelL2?: InputMaybe<Scalars['String']>;
  labelL3?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  smtpSettings?: InputMaybe<TenantSmtpSettingsInput>;
  state?: InputMaybe<Scalars['String']>;
  streetAddress?: InputMaybe<Scalars['String']>;
  streetAddress2?: InputMaybe<Scalars['String']>;
  taxId?: InputMaybe<Scalars['String']>;
  taxIdType?: InputMaybe<Scalars['String']>;
  technicalContactEmail?: InputMaybe<Scalars['String']>;
  technicalContactFirstName?: InputMaybe<Scalars['String']>;
  technicalContactLastName?: InputMaybe<Scalars['String']>;
  technicalContactMiddleName?: InputMaybe<Scalars['String']>;
  technicalContactPhone?: InputMaybe<Scalars['String']>;
  technicalContactPhoneExtension?: InputMaybe<Scalars['String']>;
  technicalContactPhoneType?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  zip?: InputMaybe<Scalars['String']>;
};

export type UpdateTenantProfileImageInput = {
  id: Scalars['ID'];
  profileImage?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateTenantUnderwriterInput = {
  active?: InputMaybe<Scalars['Boolean']>;
  companyIds?: InputMaybe<Array<Scalars['String']>>;
  displayName?: InputMaybe<Scalars['String']>;
  splitConfiguration: TenantUnderwriterSplitConfigurationInput;
  underwriterId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateTenantUnderwriterResponse = TenantUnderwriterResponse & {
  __typename?: 'UpdateTenantUnderwriterResponse';
  tenantUnderwriter: TenantUnderwriter;
  tenantUnderwriters: Array<TenantUnderwriter>;
};


export type UpdateTenantUnderwriterResponseTenantUnderwritersArgs = {
  companyId?: InputMaybe<Scalars['String']>;
  filterByActive?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTitleCplInput = {
  address?: InputMaybe<AddressInput>;
  agentRetained?: InputMaybe<Scalars['Float']>;
  agentRetainedV2?: InputMaybe<DollarsPercentInput>;
  agentRetainedV2Override?: InputMaybe<DollarsPercentInput>;
  amount?: InputMaybe<Scalars['Float']>;
  approvedAttorney?: InputMaybe<Scalars['String']>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  closingAttorney?: InputMaybe<Scalars['String']>;
  coveredParty?: InputMaybe<Scalars['String']>;
  cplNumber?: InputMaybe<Scalars['String']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  effectiveDateOverride?: InputMaybe<Scalars['String']>;
  lenderAddress?: InputMaybe<AddressInput>;
  lenderId?: InputMaybe<Scalars['String']>;
  letterType?: InputMaybe<Scalars['String']>;
  loanNumber?: InputMaybe<Scalars['String']>;
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  remittanceDate?: InputMaybe<Scalars['String']>;
  secondaryPartyId?: InputMaybe<Scalars['String']>;
  secondaryPartyRoleType?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  status?: InputMaybe<Scalars['String']>;
  underwriterRemitted?: InputMaybe<Scalars['Float']>;
  underwriterRemittedV2?: InputMaybe<DollarsPercentInput>;
  underwriterRemittedV2Override?: InputMaybe<DollarsPercentInput>;
  updatedTimestamp: Scalars['String'];
  useLenderAddress?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateTitleCplsInput = {
  cpls: Array<TitleCplItem>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateTitleGeneralInput = {
  amountMortgageInsured?: InputMaybe<Scalars['Float']>;
  amountOwnerInsured?: InputMaybe<Scalars['Float']>;
  authorizedSignatory?: InputMaybe<Scalars['String']>;
  commitmentExpirationDuration?: InputMaybe<Scalars['Float']>;
  commitmentExpirationTerm?: InputMaybe<Scalars['String']>;
  commitmentNumberOverride?: InputMaybe<Scalars['String']>;
  currentTitleHolder?: InputMaybe<Scalars['String']>;
  currentTitleHolderMergeFields?: InputMaybe<Scalars['String']>;
  dateEffective?: InputMaybe<Scalars['DateTime']>;
  includeMaritalStatus?: InputMaybe<Scalars['Boolean']>;
  insuredLanguageType?: InputMaybe<Scalars['String']>;
  interestInLand?: InputMaybe<Scalars['String']>;
  isCommitmentNumberOverridden?: InputMaybe<Scalars['Boolean']>;
  orderId: Scalars['String'];
  proposedLoanInsured?: InputMaybe<Scalars['String']>;
  seeExhibitA?: InputMaybe<Scalars['Boolean']>;
  timeEffective?: InputMaybe<Scalars['String']>;
  titleHolderType?: InputMaybe<Scalars['String']>;
  updatedTimestamp?: InputMaybe<Scalars['DateTime']>;
  vestingClause?: InputMaybe<Scalars['String']>;
};

export type UpdateTitlePremiumInput = {
  additionalQuestions?: InputMaybe<Array<AdditionalQuestionInput>>;
  agentRetainedV2?: InputMaybe<DollarsPercentInput>;
  agentRetainedV2Override?: InputMaybe<DollarsPercentInput>;
  buyerPays?: InputMaybe<Scalars['Float']>;
  cdSection?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  disclosedAmount?: InputMaybe<Scalars['Float']>;
  displayOnSettlement?: InputMaybe<Scalars['String']>;
  effectiveDate?: InputMaybe<Scalars['String']>;
  endorsements?: InputMaybe<Array<TitlePremiumEndorsementInput>>;
  isExtendedCoverage?: InputMaybe<Scalars['Boolean']>;
  payeeId?: InputMaybe<Scalars['String']>;
  policyAmount?: InputMaybe<Scalars['Float']>;
  policyFees?: InputMaybe<Array<PolicyFeeAndTaxItemInput>>;
  policyName?: InputMaybe<Scalars['String']>;
  policyType?: InputMaybe<Scalars['String']>;
  priorPolicy?: InputMaybe<Scalars['Boolean']>;
  priorPolicyAmount?: InputMaybe<Scalars['Float']>;
  priorPolicyCoverageType?: InputMaybe<Scalars['String']>;
  priorPolicyDate?: InputMaybe<Scalars['String']>;
  priorPolicyDiscountApplied?: InputMaybe<Scalars['Float']>;
  priorPolicyNumber?: InputMaybe<Scalars['String']>;
  rate?: InputMaybe<TitleRateInput>;
  rateId?: InputMaybe<Scalars['String']>;
  rateType?: InputMaybe<Scalars['String']>;
  remittanceAmount?: InputMaybe<Scalars['Float']>;
  remittanceAmountOverride?: InputMaybe<Scalars['Float']>;
  riskRateId?: InputMaybe<Scalars['String']>;
  sellerPays?: InputMaybe<Scalars['Float']>;
  simultaneousIssue?: InputMaybe<Scalars['Boolean']>;
  taxCode?: InputMaybe<Scalars['String']>;
  taxRate?: InputMaybe<Scalars['Float']>;
  taxRateOverride?: InputMaybe<Scalars['Float']>;
  underwriterRemittedV2?: InputMaybe<DollarsPercentInput>;
  underwriterRemittedV2Override?: InputMaybe<DollarsPercentInput>;
  updatedTimestamp: Scalars['String'];
};

export type UpdateTitleProductsRemittanceDateInput = {
  products: Array<RemittanceProductInput>;
  remittanceDate: Scalars['String'];
};

export type UpdateTitleProductsRemittanceDateResponse = {
  __typename?: 'UpdateTitleProductsRemittanceDateResponse';
  failure: Array<RemittanceProduct>;
  success: Array<RemittanceProduct>;
};

export type UpdateTitleSearchOrderInput = {
  id: Scalars['String'];
  orderId: Scalars['String'];
  payload: UpdateTitleSearchOrderPayload;
  updateType?: InputMaybe<Scalars['String']>;
};

export type UpdateTitleSearchOrderPayload = {
  documents?: InputMaybe<Array<TitleSearchOrderDocumentInput>>;
  notes?: InputMaybe<Scalars['String']>;
  notificationEmailAddress?: InputMaybe<Scalars['String']>;
};

export type UpdateTransactionInput = {
  escrowAccountId: Scalars['String'];
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  isCleared?: InputMaybe<Scalars['Boolean']>;
  lastActivityDate?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  oTaxId?: InputMaybe<FundingTaxIdInput>;
  oWireTransfer?: InputMaybe<WireInput>;
  orderNumber?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId?: InputMaybe<Scalars['String']>;
  positivePayDate?: InputMaybe<Scalars['String']>;
  reconcileDate?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  searchData?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionCategory: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
  transactionId: Scalars['String'];
  transferredOrderId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  wireExpectedDate?: InputMaybe<Scalars['String']>;
  wireTransfer?: InputMaybe<Scalars['String']>;
};

export type UpdateTransactionTransferInput = {
  fundingTransactionType?: InputMaybe<Scalars['String']>;
  id: Scalars['String'];
  isCleared?: InputMaybe<Scalars['Boolean']>;
  lastActivityDate?: InputMaybe<Scalars['String']>;
  memo?: InputMaybe<Scalars['String']>;
  oPayeeAddress?: InputMaybe<AddressInput>;
  oPayorPayeeId?: InputMaybe<Scalars['String']>;
  oTaxId?: InputMaybe<FundingTaxIdInput>;
  oWireTransfer?: InputMaybe<WireInput>;
  orderNumber?: InputMaybe<Scalars['String']>;
  payeeAddress?: InputMaybe<AddressInput>;
  payorPayeeId?: InputMaybe<Scalars['String']>;
  positivePayDate?: InputMaybe<Scalars['String']>;
  reconcileDate?: InputMaybe<Scalars['String']>;
  refNumber?: InputMaybe<Scalars['String']>;
  searchData?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
  statusReason?: InputMaybe<Scalars['String']>;
  transactionCategory: Scalars['String'];
  transactionDate?: InputMaybe<Scalars['String']>;
  transferredOrderId?: InputMaybe<Scalars['String']>;
  updatedTimestamp: Scalars['String'];
  wireExpectedDate?: InputMaybe<Scalars['String']>;
  wireTransfer?: InputMaybe<Scalars['String']>;
};

export type UpdateUserInput = {
  address?: InputMaybe<AddressInput>;
  altaId?: InputMaybe<Scalars['String']>;
  department?: InputMaybe<Scalars['String']>;
  displayName?: InputMaybe<Scalars['String']>;
  emailAddress?: InputMaybe<Scalars['EmailAddress']>;
  firstName?: InputMaybe<Scalars['String']>;
  homeL2Id?: InputMaybe<Scalars['ID']>;
  homeL3Id?: InputMaybe<Scalars['ID']>;
  id: Scalars['ID'];
  initials?: InputMaybe<Scalars['String']>;
  isCheckAuthorizedSignatory?: InputMaybe<Scalars['Boolean']>;
  isDisclosureSettlementAgent?: InputMaybe<Scalars['Boolean']>;
  isUnderwriterAuthorizedSignatory?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  licenses?: InputMaybe<Array<InputMaybe<LicenseInput>>>;
  middleName?: InputMaybe<Scalars['String']>;
  nameSuffix?: InputMaybe<Scalars['String']>;
  nmlsId?: InputMaybe<Scalars['String']>;
  phoneNumbers?: InputMaybe<Array<InputMaybe<UserPhoneNumberInput>>>;
  profileImage?: InputMaybe<Scalars['String']>;
  security?: InputMaybe<UserSecurityInput>;
  securityV2?: InputMaybe<SecurityGroupV2AssignmentsInput>;
  securityVersion?: InputMaybe<Scalars['String']>;
  sendEmailMethod?: InputMaybe<Scalars['String']>;
  smtpSettings?: InputMaybe<SmtpSettingsInput>;
  updatedTimestamp: Scalars['DateTime'];
};

export type UpdateUserSignatureImageInput = {
  id: Scalars['ID'];
  signatureImage: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type UpdateUserStatusInput = {
  id: Scalars['ID'];
  updatedTimestamp: Scalars['String'];
  userStatus: Scalars['String'];
};

export type UploadNewEntityDocumentV2Input = {
  compression?: InputMaybe<UploadNewEntityDocumentV2InputCompression>;
  cryptoKey: FileCryptoKeyV2Input;
  entityId: Scalars['ID'];
  entityType: DocumentEntityTypeV2;
  fileSize: Scalars['Float'];
  fileType: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
};

export enum UploadNewEntityDocumentV2InputCompression {
  Gzip = 'gzip'
}

export type UploadNewTemplateV2Input = {
  compression?: InputMaybe<UploadNewTemplateV2InputCompression>;
  cryptoKey?: InputMaybe<FileCryptoKeyV2Input>;
  documentType: TemplateDocTypeV2;
  fileSize: Scalars['Float'];
  fileType: Scalars['String'];
  mimeType: Scalars['String'];
  name: Scalars['String'];
};

export enum UploadNewTemplateV2InputCompression {
  Gzip = 'gzip'
}

export type UploadRecordingFeesDocumentInput = {
  orderId: Scalars['String'];
  rfttFees: GetRfttFeesInput;
};

export type UploadRecordingFeesDocumentResponse = {
  __typename?: 'UploadRecordingFeesDocumentResponse';
  status: Scalars['String'];
};

export enum UploadStatusV2 {
  Complete = 'Complete',
  Error = 'Error',
  Generating = 'Generating',
  Pending = 'Pending'
}

export type UploadTitleSearchImportDocumentsInput = {
  documents: Array<UploadTitleSearchImportDocumentsPayload>;
  id: Scalars['String'];
  importDataSnapshot?: InputMaybe<ImportDataSnapshotInput>;
  orderId: Scalars['String'];
  updateId?: InputMaybe<Scalars['ID']>;
};

export type UploadTitleSearchImportDocumentsPayload = {
  providerUri: Scalars['String'];
};

export type UpsertDocTypeMappingByCountyNameInput = {
  countyName: Scalars['String'];
  documentType: Scalars['String'];
  dynamicDocumentName: Scalars['String'];
  dynamicDocumentType: Scalars['String'];
  epnAccountId: Scalars['ID'];
};

export type User = {
  __typename?: 'User';
  address?: Maybe<Address>;
  altaId?: Maybe<Scalars['String']>;
  createdBy?: Maybe<User>;
  createdById?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  department?: Maybe<Scalars['String']>;
  displayName: Scalars['String'];
  emailAddress: Scalars['EmailAddress'];
  firstName: Scalars['String'];
  fullName?: Maybe<Scalars['String']>;
  hasMultipleTenants?: Maybe<Scalars['Boolean']>;
  homeL2Id?: Maybe<Scalars['ID']>;
  homeL3Id?: Maybe<Scalars['ID']>;
  id: Scalars['ID'];
  initials?: Maybe<Scalars['String']>;
  isCheckAuthorizedSignatory?: Maybe<Scalars['Boolean']>;
  isDisclosureSettlementAgent?: Maybe<Scalars['Boolean']>;
  isUnderwriterAuthorizedSignatory?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  licenses?: Maybe<Array<Maybe<License>>>;
  loginInfo?: Maybe<LoginInfoItem>;
  middleName?: Maybe<Scalars['String']>;
  nameSuffix?: Maybe<Scalars['String']>;
  nmlsId?: Maybe<Scalars['String']>;
  phoneNumbers?: Maybe<Array<Maybe<UserPhoneNumberType>>>;
  profileImage?: Maybe<Scalars['String']>;
  recentOrders?: Maybe<Array<Maybe<Order>>>;
  security?: Maybe<SecurityGroupAssignments>;
  securityV2?: Maybe<SecurityGroupV2Assignments>;
  securityVersion?: Maybe<Scalars['String']>;
  sendEmailMethod?: Maybe<Scalars['String']>;
  signatureImageMergeable?: Maybe<Image>;
  smtpSettings?: Maybe<SmtpSettings>;
  tenantId: Scalars['ID'];
  updatedBy?: Maybe<User>;
  updatedById?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type UserCredentialAgentNetStatus = {
  __typename?: 'UserCredentialAgentNetStatus';
  active: Scalars['Boolean'];
  error: Scalars['Boolean'];
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type UserDefaults = {
  __typename?: 'UserDefaults';
  branch?: Maybe<Scalars['String']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  propertyState?: Maybe<Scalars['String']>;
  sequenceId?: Maybe<Scalars['String']>;
  statementType?: Maybe<Scalars['String']>;
  transactionTypeId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type UserDisplayName = {
  __typename?: 'UserDisplayName';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type UserDisplayNameV2 = {
  __typename?: 'UserDisplayNameV2';
  displayName: Scalars['String'];
  id: Scalars['ID'];
};

export type UserEnteredCommissions = {
  __typename?: 'UserEnteredCommissions';
  commissionBasisOverride?: Maybe<CommissionBasisOverride>;
  distributionMethod: Scalars['String'];
  id: Scalars['ID'];
  lineItems: Array<UserEnteredCommissionsLineItem>;
  sellerPaidPercentage?: Maybe<Scalars['Float']>;
  totalCommissionAmount: TotalCommissionAmountValue;
};

export type UserEnteredCommissionsLineItem = BaseOrderCommissionsLineItem & {
  __typename?: 'UserEnteredCommissionsLineItem';
  agentType: Scalars['String'];
  calculatedValue?: Maybe<Scalars['Float']>;
  id: Scalars['ID'];
  party?: Maybe<OrderParty>;
  partyId: Scalars['String'];
  value?: Maybe<Scalars['Float']>;
};

export type UserLockStatus = {
  __typename?: 'UserLockStatus';
  isLocked: Scalars['Boolean'];
};

export type UserPhoneNumberInput = {
  ext?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  type?: InputMaybe<Scalars['String']>;
};

export type UserPhoneNumberType = {
  __typename?: 'UserPhoneNumberType';
  ext?: Maybe<Scalars['String']>;
  isPrimary?: Maybe<Scalars['Boolean']>;
  phoneNumber: Scalars['PhoneNumber'];
  phoneNumberFull?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type UserProfileImage = {
  __typename?: 'UserProfileImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  profileImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type UserSecurityAssignmentsInput = {
  orgIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  securityGroupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
};

export type UserSecurityInput = {
  securityAssignments?: InputMaybe<Array<InputMaybe<UserSecurityAssignmentsInput>>>;
};

export type UserSetCredentialAgentNet = {
  personalAccessToken?: InputMaybe<Scalars['String']>;
};

export type UserSignatureImage = {
  __typename?: 'UserSignatureImage';
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  signatureImage?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
};

export type Va2012R5PForm = {
  __typename?: 'Va2012R5PForm';
  buyers?: Maybe<Array<Maybe<Va2012R5PFormBuyers>>>;
  sellers?: Maybe<Array<Maybe<Va2012R5PFormSellers>>>;
};

export type Va2012R5PFormBuyers = {
  __typename?: 'Va2012R5PFormBuyers';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  representatives?: Maybe<Va2012R5PFormRepresentatives>;
};

export type Va2012R5PFormRepresentatives = {
  __typename?: 'Va2012R5PFormRepresentatives';
  fifth?: Maybe<Scalars['String']>;
  first?: Maybe<Scalars['String']>;
  fourth?: Maybe<Scalars['String']>;
  second?: Maybe<Scalars['String']>;
  sixth?: Maybe<Scalars['String']>;
  third?: Maybe<Scalars['String']>;
};

export type Va2012R5PFormSellers = {
  __typename?: 'Va2012R5PFormSellers';
  address?: Maybe<Scalars['String']>;
  cityStateZip?: Maybe<Scalars['String']>;
  representatives?: Maybe<Va2012R5PFormRepresentatives>;
};

export type ValidateFedexMfaPinCreateRequestInput = {
  companyAccess: CompanyAccessInput;
  companyInfo: ValidateFedexMfaPinCreateRequestInput_CompanyInfo;
  description?: InputMaybe<Scalars['String']>;
  fedexAccountNumber: Scalars['String'];
  name: Scalars['String'];
  pinCode: Scalars['String'];
  shippingAddress: ValidateFedexMfaPinCreateRequestInput_ShippingAddress;
};

export type ValidateFedexMfaPinCreateRequestInput_CompanyInfo = {
  address: ValidateFedexMfaPinCreateRequestInput_CompanyInfo_Address;
  contact: ValidateFedexMfaPinCreateRequestInput_CompanyInfo_Contact;
  name: Scalars['String'];
};

export type ValidateFedexMfaPinCreateRequestInput_CompanyInfo_Address = {
  city: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type ValidateFedexMfaPinCreateRequestInput_CompanyInfo_Contact = {
  emailAddress: Scalars['String'];
  firstName: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type ValidateFedexMfaPinCreateRequestInput_ShippingAddress = {
  city: Scalars['String'];
  country?: InputMaybe<CountryCodes>;
  state: Scalars['String'];
  street1: Scalars['String'];
  street2?: InputMaybe<Scalars['String']>;
  zip: Scalars['String'];
};

export type ValidateFedexMfaPinCreateResponse = {
  __typename?: 'ValidateFedexMfaPinCreateResponse';
  account: CarrierAccountObject;
  success: Scalars['Boolean'];
};

export type ValidateFedexMfaPinRequestInput = {
  id: Scalars['ID'];
  pinCode: Scalars['String'];
};

export type ValidateFedexMfaPinResponse = {
  __typename?: 'ValidateFedexMfaPinResponse';
  success: Scalars['Boolean'];
};

export type ValidatePackageAsyncInput = {
  collectedDisclosureAmounts?: InputMaybe<Array<PackageResponseCollectedDisclosureAmountsInput>>;
  /** @minItems 1 */
  documents: Array<PackageDocumentInput>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  packageData?: InputMaybe<Array<DataFieldInput>>;
  packageId?: InputMaybe<Scalars['ID']>;
  packageName: Scalars['String'];
  stateRequirements?: InputMaybe<StateRequirementsInput>;
  subscriptionId?: InputMaybe<Scalars['ID']>;
};

export type ValidatePackageInput = {
  collectedDisclosureAmounts?: InputMaybe<Array<PackageResponseCollectedDisclosureAmountsInput>>;
  /** @minItems 1 */
  documents: Array<PackageDocumentInput>;
  featureFlags?: InputMaybe<Array<Scalars['String']>>;
  orderId: Scalars['ID'];
  packageData?: InputMaybe<Array<DataFieldInput>>;
  packageId?: InputMaybe<Scalars['ID']>;
  packageName: Scalars['String'];
  stateRequirements?: InputMaybe<StateRequirementsInput>;
};

export type ValidatePackageResponse = {
  __typename?: 'ValidatePackageResponse';
  createdBy: Scalars['String'];
  createdTimestamp: Scalars['String'];
  epnEventId?: Maybe<Scalars['ID']>;
  eventTimestamp?: Maybe<Scalars['Float']>;
  orderId: Scalars['ID'];
  packageData: PackageStatusSnapshotData;
  packageId: Scalars['ID'];
  snapshotType?: Maybe<PackageStatusSnapshotType>;
  status: ValidatePackageStatus;
  statusMessage?: Maybe<Scalars['String']>;
  tenantId: Scalars['ID'];
};

export enum ValidatePackageStatus {
  Error = 'Error',
  Ok = 'Ok'
}

export type ValidateRate = RateValidation & {
  __typename?: 'ValidateRate';
  missingFields: Array<Scalars['String']>;
  orderId: Scalars['String'];
  valid: Scalars['Boolean'];
};

export type ValidateSdnInput = {
  childId?: InputMaybe<Scalars['ID']>;
  orderId: Scalars['ID'];
  parentId: Scalars['ID'];
  recordType: SdnRecordType;
};

export type ValidateSdnResponse = OrderResponse & {
  __typename?: 'ValidateSdnResponse';
  childId?: Maybe<Scalars['ID']>;
  order?: Maybe<Order>;
  orderId: Scalars['ID'];
  parentId: Scalars['ID'];
  sdnStatusDetails: SdnStatusDetails;
};

/**
 * Input for wire validation mutation.
 * Backend gathers wire data from database using these identifiers.
 */
export type ValidateWireInput = {
  /** Escrow account identifier (path parameter in svc-funding) */
  escrowAccountId: Scalars['String'];
  /**
   * Optional snapshot of wire data for validation.
   * When provided, backend merges snapshot values with stored data.
   */
  snapshot?: InputMaybe<WireValidationSnapshot>;
  /** Transaction identifier (path parameter in svc-funding) */
  transactionId: Scalars['String'];
};

/**
 * Response from wire validation.
 * Contains SES validation result with success/failure status and recommended actions.
 */
export type ValidateWireResponse = {
  __typename?: 'ValidateWireResponse';
  /** Whether the validation can be retried */
  isRetryable?: Maybe<Scalars['Boolean']>;
  /** Whether the validation succeeded */
  isSuccess?: Maybe<Scalars['Boolean']>;
  /** Human-readable result message */
  message?: Maybe<Scalars['String']>;
  /** Recommended action based on result */
  recommendedAction?: Maybe<Scalars['String']>;
  /** Whether manual validation is required */
  requiresManualValidation?: Maybe<Scalars['Boolean']>;
  /** Result category: Success, Failure, Error, or Caution */
  resultCategory?: Maybe<WireValidationResultCategory>;
  /** SES result code (e.g., AS07, AF01) */
  resultCode?: Maybe<Scalars['String']>;
  /** Unique SES transaction identifier */
  uniqueTransactionId?: Maybe<Scalars['String']>;
  /** Phone number for validation follow-up */
  validationPhoneNumber?: Maybe<Scalars['String']>;
};

/**
 * Historical wire validation attempt record.
 * Represents a single validation event with masked account details.
 */
export type ValidationHistoryItem = {
  __typename?: 'ValidationHistoryItem';
  /** Bank account number (masked, shows last 4 digits only) */
  accountNumber: Scalars['String'];
  /** User who initiated the validation */
  createdBy: Scalars['String'];
  /** When the validation attempt was created */
  createdTimestamp: Scalars['DateTime'];
  /** Unique event identifier */
  eventId: Scalars['ID'];
  /** Error message if validation failed */
  failureMessage?: Maybe<Scalars['String']>;
  /** Payee/recipient name */
  payeeName?: Maybe<Scalars['String']>;
  /** SES result code from validation service */
  resultCode: Scalars['String'];
  /** Validation result type (success/failure/pending/timeout) */
  resultType: WireValidationResultType;
  /** Bank routing number */
  routingNumber: Scalars['String'];
  /** Wire type classification */
  validationType: Scalars['String'];
};

export type VerifiedAddress = {
  __typename?: 'VerifiedAddress';
  uspsData?: Maybe<VerifiedAddressUspsData>;
};

export type VerifiedAddressUspsData = {
  __typename?: 'VerifiedAddressUSPSData';
  abbreviatedCity?: Maybe<Scalars['String']>;
  addressRecordType?: Maybe<Scalars['String']>;
  carrierRoute?: Maybe<Scalars['String']>;
  carrierRouteIndicator?: Maybe<Scalars['String']>;
  cassProcessed?: Maybe<Scalars['Boolean']>;
  county?: Maybe<Scalars['String']>;
  defaultAddress?: Maybe<Scalars['Boolean']>;
  deliveryPointCheckDigit?: Maybe<Scalars['String']>;
  deliveryPointCode?: Maybe<Scalars['String']>;
  dpvCmra?: Maybe<Scalars['String']>;
  dpvConfirmation?: Maybe<Scalars['String']>;
  dpvDoorNotAccessible?: Maybe<Scalars['String']>;
  dpvDrop?: Maybe<Scalars['String']>;
  dpvEnhancedDeliveryCode?: Maybe<Scalars['String']>;
  dpvFootnote?: Maybe<Scalars['String']>;
  dpvNoSecureLocation?: Maybe<Scalars['String']>;
  dpvNoStat?: Maybe<Scalars['String']>;
  dpvNoStatReasonCode?: Maybe<Scalars['Int']>;
  dpvNonDeliveryDays?: Maybe<Scalars['String']>;
  dpvNonDeliveryDaysValues?: Maybe<Scalars['Int']>;
  dpvPbsa?: Maybe<Scalars['String']>;
  dpvThrowback?: Maybe<Scalars['String']>;
  dpvVacant?: Maybe<Scalars['String']>;
  elotFlag?: Maybe<Scalars['String']>;
  elotNumber?: Maybe<Scalars['String']>;
  errorMessage?: Maybe<Scalars['String']>;
  ewsNoMatch?: Maybe<Scalars['Boolean']>;
  fipsCountyCode?: Maybe<Scalars['String']>;
  lacsLinkIndicator?: Maybe<Scalars['String']>;
  lacsLinkReturnCode?: Maybe<Scalars['String']>;
  pmbDesignator?: Maybe<Scalars['String']>;
  pmbNumber?: Maybe<Scalars['String']>;
  poBoxOnlyPostalCode?: Maybe<Scalars['Boolean']>;
  postOfficeCity?: Maybe<Scalars['String']>;
  postOfficeState?: Maybe<Scalars['String']>;
  standardizedAddress?: Maybe<VerifiedAddressUspsDataStandardizedAddress>;
  suitelinkFootnote?: Maybe<Scalars['String']>;
};

export type VerifiedAddressUspsDataStandardizedAddress = {
  __typename?: 'VerifiedAddressUSPSDataStandardizedAddress';
  city?: Maybe<Scalars['String']>;
  cityStateZipAddressLine?: Maybe<Scalars['String']>;
  firstAddressLine?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  zipCode?: Maybe<Scalars['String']>;
  zipCodeExtension?: Maybe<Scalars['String']>;
};

export type VestingEntryV2 = {
  __typename?: 'VestingEntryV2';
  date?: Maybe<Scalars['String']>;
  grantee?: Maybe<Array<Scalars['String']>>;
  grantor?: Maybe<Array<Scalars['String']>>;
  parties?: Maybe<Array<Scalars['String']>>;
  recordingInfo?: Maybe<Scalars['String']>;
  sourceDocument?: Maybe<Scalars['String']>;
  vestingType?: Maybe<Scalars['String']>;
};

export type VoidConsolidatedPaymentInput = {
  consolidatedPaymentId: Scalars['String'];
  escrowAccountId: Scalars['String'];
  statusReason: Scalars['String'];
};

export type VoidConsolidatedPaymentResult = {
  __typename?: 'VoidConsolidatedPaymentResult';
  consolidatedPaymentId?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  voidDate?: Maybe<Scalars['String']>;
};

export type VoidTitleCplInput = {
  cplId: Scalars['String'];
  updatedTimestamp: Scalars['String'];
};

export type Warning = {
  __typename?: 'Warning';
  code: Scalars['String'];
  message: Scalars['String'];
};

export type WarningStatus = {
  __typename?: 'WarningStatus';
  code: Scalars['String'];
  message: Scalars['String'];
};

/** Which account number on a wire an authorized reveal targets (ANP-8370 Show/Hide control). */
export enum WireAccountField {
  Beneficiary = 'BENEFICIARY',
  Originator = 'ORIGINATOR'
}

export type WireAccountNumberUnmasked = {
  __typename?: 'WireAccountNumberUnmasked';
  accountNumber: Scalars['String'];
  reference: Scalars['String'];
};

/** Beneficiary details as returned on an outgoing wire. The full account number is protected PII and is never exposed — only the display mask is returned. */
export type WireBeneficiary = {
  __typename?: 'WireBeneficiary';
  accountNumberMasked?: Maybe<Scalars['String']>;
  address?: Maybe<StructuredAddress>;
  bankName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  routingNumber: Scalars['String'];
};

/** AG-Grid filter descriptor for one wire-grid column (value/values/min-max/date-range operands, all strings). */
export type WireDataFilterInput = {
  column: Scalars['String'];
  dateFromValue?: InputMaybe<Scalars['String']>;
  dateToValue?: InputMaybe<Scalars['String']>;
  maxValue?: InputMaybe<Scalars['String']>;
  minValue?: InputMaybe<Scalars['String']>;
  operator: Scalars['String'];
  type: Scalars['String'];
  value?: InputMaybe<Scalars['String']>;
  values?: InputMaybe<Array<Scalars['String']>>;
};

/**
 * AG-Grid row-grouping descriptor for one level. groupKey is the column id being grouped on;
 * groupPriority is the level index (outer→inner). groupValue is absent when this is the level the
 * UI is asking the backend to expand (emit group-header rows) and present when the level is part
 * of the drill path.
 */
export type WireGroupingInput = {
  groupKey: Scalars['String'];
  groupPriority: Scalars['Int'];
  groupValue?: InputMaybe<Scalars['JSONObject']>;
};

/** One entry in an incoming wire's MATCH/UNMATCH history; user is the acting user (null when unrecorded). */
export type WireHistoryEntry = {
  __typename?: 'WireHistoryEntry';
  eventType: WireHistoryEventType;
  timestamp: Scalars['String'];
  user?: Maybe<User>;
};

export enum WireHistoryEventType {
  Match = 'MATCH',
  Unmatch = 'UNMATCH'
}

export type WireInput = {
  beneficiaryBank?: InputMaybe<BeneficiaryBankInput>;
  payeePhone?: InputMaybe<Scalars['String']>;
  receivingBank?: InputMaybe<ReceivingBankInput>;
  recipientAccountNum?: InputMaybe<Scalars['String']>;
  recipientAddress?: InputMaybe<AddressInput>;
  recipientName?: InputMaybe<Scalars['String']>;
  wireType?: InputMaybe<WireTypeEnum>;
};

export type WireManagement = {
  __typename?: 'WireManagement';
  amount?: Maybe<Scalars['Float']>;
  createdBy?: Maybe<Scalars['String']>;
  createdTimestamp?: Maybe<Scalars['String']>;
  dateFunding?: Maybe<Scalars['String']>;
  escrowAccountId?: Maybe<Scalars['String']>;
  escrowAccountName?: Maybe<Scalars['String']>;
  escrowAcctName?: Maybe<Scalars['String']>;
  finalizedPayorPayeeData?: Maybe<FinalizedPayorPayeeData>;
  fundingTransactionType?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isCleared?: Maybe<Scalars['Boolean']>;
  isUserCreated?: Maybe<Scalars['Boolean']>;
  lastActivityDate?: Maybe<Scalars['String']>;
  memo?: Maybe<Scalars['String']>;
  oPayeeAddress?: Maybe<Address>;
  oPayorPayeeId?: Maybe<Scalars['String']>;
  oTaxId?: Maybe<FundingTaxId>;
  oWireTransfer?: Maybe<WireSchema>;
  orderId?: Maybe<Scalars['String']>;
  orderNumber?: Maybe<Scalars['String']>;
  payorPayeeDisplayName?: Maybe<Scalars['String']>;
  payorPayeeId?: Maybe<Scalars['String']>;
  payorPayeeString_sk?: Maybe<Scalars['String']>;
  payorPayeeType?: Maybe<Scalars['String']>;
  positivePayDate?: Maybe<Scalars['String']>;
  /** Property (PIQ) address for the transaction's order — resolved on demand; used by the Match drawer receipts grid (display + search). */
  propertyAddress?: Maybe<Scalars['String']>;
  reconcileDate?: Maybe<Scalars['String']>;
  refNumber?: Maybe<Scalars['String']>;
  searchData?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  statusReason?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionCategory?: Maybe<Scalars['String']>;
  transactionDate?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  transferredOrderId?: Maybe<Scalars['String']>;
  updatedBy?: Maybe<Scalars['String']>;
  updatedTimestamp?: Maybe<Scalars['String']>;
  wireExpectedDate?: Maybe<Scalars['String']>;
};

/**
 * Originator (source/escrow account) details snapshotted onto an outgoing wire at initiation, for
 * display on the Outgoing Wires screen. Display-safe only — accountNumberMasked never exposes the
 * full source account number. All fields nullable: absent on wires created before the snapshot
 * existed.
 */
export type WireOriginator = {
  __typename?: 'WireOriginator';
  accountNumberMasked?: Maybe<Scalars['String']>;
  address?: Maybe<WireOriginatorAddress>;
  bankName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  routingNumber?: Maybe<Scalars['String']>;
};

/**
 * Originator (source/escrow account) postal address for display. Flat shape mirroring the escrow
 * account's stored address (and the Wire Details drawer's originator-address prop) so it maps 1:1
 * without the structured-address field translation the beneficiary path uses.
 */
export type WireOriginatorAddress = {
  __typename?: 'WireOriginatorAddress';
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  line1?: Maybe<Scalars['String']>;
  line2?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  stateOrProvince?: Maybe<Scalars['String']>;
};

export type WireSchema = {
  __typename?: 'WireSchema';
  beneficiaryBank?: Maybe<BeneficiaryBankSchema>;
  payeePhone?: Maybe<Scalars['String']>;
  receivingBank?: Maybe<ReceivingBankSchema>;
  recipientAccountNum?: Maybe<Scalars['String']>;
  recipientAddress?: Maybe<Address>;
  recipientName?: Maybe<Scalars['String']>;
  unmaskedRecipientAccountNum?: Maybe<Scalars['String']>;
  wireType?: Maybe<WireTypeEnum>;
};

/** AG-Grid sort descriptor for one wire-grid column. */
export type WireSortColumnInput = {
  sortDirection: Scalars['String'];
  sortKey: Scalars['String'];
  sortPriority: Scalars['Int'];
};

export enum WireStatus {
  Cancelled = 'Cancelled',
  Completed = 'Completed',
  Failed = 'Failed',
  PendingTransmittal = 'Pending_Transmittal',
  Rejected = 'Rejected',
  Sent = 'Sent',
  Transmitting = 'Transmitting'
}

export enum WireTypeEnum {
  Business = 'BUSINESS',
  Payoff = 'PAYOFF',
  Personal = 'PERSONAL'
}

export type WireValidationEula = {
  __typename?: 'WireValidationEula';
  approvedAt?: Maybe<Scalars['String']>;
  approvedByUserId?: Maybe<Scalars['String']>;
  approvedVersion?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
};

/**
 * Input for wire validation hash lookup query.
 * Checks if wire details have been previously validated.
 */
export type WireValidationHashInput = {
  /** Bank account number (optional - server always looks up from transaction) */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Escrow account identifier */
  escrowAccountId: Scalars['String'];
  /** Order identifier */
  orderId: Scalars['String'];
  /** Optional payee name (affects hash calculation) */
  payeeName?: InputMaybe<Scalars['String']>;
  /** Bank routing number */
  routingNumber: Scalars['String'];
  /** Transaction identifier */
  transactionId: Scalars['String'];
  /** Type of wire: PERSONAL, BUSINESS, or PAYOFF (affects hash calculation) */
  wireType?: InputMaybe<WireTypeEnum>;
};

/**
 * Response from wire validation hash lookup.
 * Indicates whether the wire details have been previously validated.
 */
export type WireValidationHashResponse = {
  __typename?: 'WireValidationHashResponse';
  /** Whether a matching validated hash record exists */
  isValid: Scalars['Boolean'];
  /** Result code from original validation (if found) */
  resultCode?: Maybe<Scalars['String']>;
  /** Result type from original validation (if found) */
  resultType?: Maybe<Scalars['String']>;
  /** Timestamp when the wire was validated (ISO 8601) */
  validatedAt?: Maybe<Scalars['String']>;
};

/** Input for fetching wire validation history. */
export type WireValidationHistoryInput = {
  /** Escrow account identifier */
  escrowAccountId: Scalars['String'];
  /** Transaction identifier */
  transactionId: Scalars['String'];
};

/**
 * Result category for wire validation.
 * Four-state model provides nuanced feedback on validation results.
 */
export enum WireValidationResultCategory {
  /** Partial success, needs attention */
  Caution = 'Caution',
  /** System error during validation */
  Error = 'Error',
  /** Wire validation failed */
  Failure = 'Failure',
  /** Wire validated successfully */
  Success = 'Success'
}

/**
 * Wire validation result type.
 * Maps to backend validation attempt result status.
 */
export enum WireValidationResultType {
  /** Validation failed */
  Failure = 'failure',
  /** Validation pending or in progress */
  Pending = 'pending',
  /** Validation succeeded */
  Success = 'success',
  /** Validation request timed out */
  Timeout = 'timeout'
}

/**
 * Optional snapshot of wire data for validation without persisting.
 * All fields are optional - backend merges with stored data.
 * Matches the svc-funding implementation (7 fields).
 */
export type WireValidationSnapshot = {
  /** Bank account number */
  accountNumber?: InputMaybe<Scalars['String']>;
  /** Name of the bank */
  bankName?: InputMaybe<Scalars['String']>;
  /** Payee full name */
  payeeName?: InputMaybe<Scalars['String']>;
  /** Payee phone number (preferred for the SES contact phone) */
  payeePhone?: InputMaybe<Scalars['String']>;
  /**
   * Overridden payee party id for an unsaved payee change; lets the backend
   * resolve beneficiary bank data for a payee not yet persisted.
   */
  payorPayeeId?: InputMaybe<Scalars['String']>;
  /** Bank routing number (9 digits) */
  routingNumber?: InputMaybe<Scalars['String']>;
  /** Type of wire: PERSONAL, BUSINESS, or PAYOFF */
  wireType?: InputMaybe<WireTypeEnum>;
};

export type Workflow = {
  __typename?: 'Workflow';
  active?: Maybe<Scalars['Boolean']>;
  companies?: Maybe<Array<Maybe<Scalars['String']>>>;
  createdBy?: Maybe<User>;
  createdById: Scalars['ID'];
  createdTimestamp?: Maybe<Scalars['DateTime']>;
  id: Scalars['ID'];
  milestones?: Maybe<Array<Maybe<Milestone>>>;
  name: Scalars['String'];
  states?: Maybe<Array<Maybe<Scalars['String']>>>;
  transactionPurpose?: Maybe<Array<Maybe<Scalars['String']>>>;
  updatedBy?: Maybe<User>;
  updatedById: Scalars['ID'];
  updatedTimestamp?: Maybe<Scalars['DateTime']>;
};

export type WrappedClausePackageResponse = {
  __typename?: 'WrappedClausePackageResponse';
  clausePackages: Array<Maybe<ClausePackage>>;
};

export type WrappedClauseTemplateResponse = {
  __typename?: 'WrappedClauseTemplateResponse';
  clauseTemplates: Array<Maybe<ClauseTemplate>>;
};

export type WrappedPayoff = {
  __typename?: 'WrappedPayoff';
  order?: Maybe<Order>;
  payoffs?: Maybe<Array<Maybe<Payoff>>>;
};

export type AdjustmentFieldsFragment = { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } };

export type GetDcAdjustmentsQueryVariables = Exact<{
  orderId: Scalars['String'];
  statementType: Scalars['String'];
  statementSections?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetDcAdjustmentsQuery = { __typename?: 'Query', getDcAdjustments: { __typename?: 'GetAdjustmentsResponse', adjustments: Array<{ __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }> } };

export type GetAdjustmentStatementSectionTotalsQueryVariables = Exact<{
  orderId: Scalars['String'];
  statementType: Scalars['String'];
  statementSections: Array<Scalars['String']> | Scalars['String'];
}>;


export type GetAdjustmentStatementSectionTotalsQuery = { __typename?: 'Query', getAdjustmentStatementSectionTotals?: { __typename?: 'AltaSectionSummaryTotals', debitBorrower: number, creditBorrower: number, debitSeller?: number | null | undefined, creditSeller?: number | null | undefined, toFromBorrower: number, toFromSeller?: number | null | undefined, totalBorrowerDebit: number, totalBorrowerCredit: number, totalSellerDebit?: number | null | undefined, totalSellerCredit?: number | null | undefined } | { __typename?: 'SectionSummariesTotalsWithSeller', totalDueFromBorrower: number, totalPaidByBorrower: number, totalDueToSeller: number, totalDueFromSeller: number, borrowerCalcTotal: number, sellerCalcTotal: number } | { __typename?: 'SectionSummariesTotalsWithoutSeller', totalDueFromBorrower: number, totalPaidByBorrower: number, borrowerCalcTotal: number } | null | undefined };

export type CreateDcAdjustmentMutationVariables = Exact<{
  input: CreateDcAdjustmentInput;
}>;


export type CreateDcAdjustmentMutation = { __typename?: 'Mutation', createDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type UpdateDcAdjustmentMutationVariables = Exact<{
  input: UpdateDcAdjustmentInput;
}>;


export type UpdateDcAdjustmentMutation = { __typename?: 'Mutation', updateDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type DeleteDcAdjustmentMutationVariables = Exact<{
  input: DeleteDcAdjustmentInput;
}>;


export type DeleteDcAdjustmentMutation = { __typename?: 'Mutation', deleteDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type ClearDcAdjustmentMutationVariables = Exact<{
  input: ClearDcAdjustmentInput;
}>;


export type ClearDcAdjustmentMutation = { __typename?: 'Mutation', clearDcAdjustment: { __typename?: 'AdjustmentResponseWithMirror', adjustment: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } }, mirrorAdjustment?: { __typename?: 'Adjustment', id: string, tenantId: string, orderId: string, lineType: string, description: string, isDebitCredit: boolean, payeePayorId?: string | null | undefined, amount?: number | null | undefined, externalItemId?: string | null | undefined, createdTimestamp?: any | null | undefined, updatedTimestamp?: any | null | undefined, createdBy?: string | null | undefined, updatedBy?: string | null | undefined, lineMapping: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined }, sectionMapping: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined }, dcLineMapping?: { __typename?: 'AdjustmentLineMappings', cd?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, alta?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud2010?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined, hud1986?: { __typename?: 'AdjustmentLineMapping', lineNumber: number, addendumLineNumber?: number | null | undefined } | null | undefined } | null | undefined, dcSectionMapping?: { __typename?: 'AdjustmentSectionMapping', cd?: string | null | undefined, alta?: string | null | undefined, hud2010?: string | null | undefined, hud1986?: string | null | undefined } | null | undefined, defaultLineMapping: { __typename?: 'DefaultLineMapping', cdAlta?: boolean | null | undefined, hud2010?: boolean | null | undefined, hud1986?: boolean | null | undefined } } | null | undefined } };

export type OverrideMetadataNumberFieldsFragment = { __typename?: 'OverrideMetadataNumber', effectiveValue?: number | null | undefined, overrideValue?: number | null | undefined, fallbackValue?: number | null | undefined, overridden: boolean };

export type OverrideMetadataStringFieldsFragment = { __typename?: 'OverrideMetadataString', effectiveValue?: string | null | undefined, overrideValue?: string | null | undefined, fallbackValue?: string | null | undefined, overridden: boolean };

export const AdjustmentFieldsFragmentDoc = gql`
    fragment AdjustmentFields on Adjustment {
  id
  tenantId
  orderId
  lineType
  description
  isDebitCredit
  lineMapping {
    cd {
      lineNumber
      addendumLineNumber
    }
    alta {
      lineNumber
      addendumLineNumber
    }
    hud2010 {
      lineNumber
      addendumLineNumber
    }
    hud1986 {
      lineNumber
      addendumLineNumber
    }
  }
  sectionMapping {
    cd
    alta
    hud2010
    hud1986
  }
  dcLineMapping {
    cd {
      lineNumber
      addendumLineNumber
    }
    alta {
      lineNumber
      addendumLineNumber
    }
    hud2010 {
      lineNumber
      addendumLineNumber
    }
    hud1986 {
      lineNumber
      addendumLineNumber
    }
  }
  dcSectionMapping {
    cd
    alta
    hud2010
    hud1986
  }
  defaultLineMapping {
    cdAlta
    hud2010
    hud1986
  }
  payeePayorId
  amount
  externalItemId
  createdTimestamp
  updatedTimestamp
  createdBy
  updatedBy
}
    `;
export const OverrideMetadataNumberFieldsFragmentDoc = gql`
    fragment OverrideMetadataNumberFields on OverrideMetadataNumber {
  effectiveValue
  overrideValue
  fallbackValue
  overridden
}
    `;
export const OverrideMetadataStringFieldsFragmentDoc = gql`
    fragment OverrideMetadataStringFields on OverrideMetadataString {
  effectiveValue
  overrideValue
  fallbackValue
  overridden
}
    `;
export const GetDcAdjustmentsDocument = gql`
    query GetDcAdjustments($orderId: String!, $statementType: String!, $statementSections: [String!]) {
  getDcAdjustments(
    orderId: $orderId
    statementType: $statementType
    statementSections: $statementSections
  ) {
    adjustments {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;

/**
 * __useGetDcAdjustmentsQuery__
 *
 * To run a query within a React component, call `useGetDcAdjustmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDcAdjustmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDcAdjustmentsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      statementType: // value for 'statementType'
 *      statementSections: // value for 'statementSections'
 *   },
 * });
 */
export function useGetDcAdjustmentsQuery(baseOptions: Apollo.QueryHookOptions<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>(GetDcAdjustmentsDocument, options);
      }
export function useGetDcAdjustmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>(GetDcAdjustmentsDocument, options);
        }
export type GetDcAdjustmentsQueryHookResult = ReturnType<typeof useGetDcAdjustmentsQuery>;
export type GetDcAdjustmentsLazyQueryHookResult = ReturnType<typeof useGetDcAdjustmentsLazyQuery>;
export type GetDcAdjustmentsQueryResult = Apollo.QueryResult<GetDcAdjustmentsQuery, GetDcAdjustmentsQueryVariables>;
export const GetAdjustmentStatementSectionTotalsDocument = gql`
    query GetAdjustmentStatementSectionTotals($orderId: String!, $statementType: String!, $statementSections: [String!]!) {
  getAdjustmentStatementSectionTotals(
    orderId: $orderId
    statementType: $statementType
    statementSections: $statementSections
  ) {
    ... on SectionSummariesTotalsWithSeller {
      totalDueFromBorrower
      totalPaidByBorrower
      totalDueToSeller
      totalDueFromSeller
      borrowerCalcTotal
      sellerCalcTotal
    }
    ... on SectionSummariesTotalsWithoutSeller {
      totalDueFromBorrower
      totalPaidByBorrower
      borrowerCalcTotal
    }
    ... on AltaSectionSummaryTotals {
      debitBorrower
      creditBorrower
      debitSeller
      creditSeller
      toFromBorrower
      toFromSeller
      totalBorrowerDebit
      totalBorrowerCredit
      totalSellerDebit
      totalSellerCredit
    }
  }
}
    `;

/**
 * __useGetAdjustmentStatementSectionTotalsQuery__
 *
 * To run a query within a React component, call `useGetAdjustmentStatementSectionTotalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdjustmentStatementSectionTotalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdjustmentStatementSectionTotalsQuery({
 *   variables: {
 *      orderId: // value for 'orderId'
 *      statementType: // value for 'statementType'
 *      statementSections: // value for 'statementSections'
 *   },
 * });
 */
export function useGetAdjustmentStatementSectionTotalsQuery(baseOptions: Apollo.QueryHookOptions<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>(GetAdjustmentStatementSectionTotalsDocument, options);
      }
export function useGetAdjustmentStatementSectionTotalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>(GetAdjustmentStatementSectionTotalsDocument, options);
        }
export type GetAdjustmentStatementSectionTotalsQueryHookResult = ReturnType<typeof useGetAdjustmentStatementSectionTotalsQuery>;
export type GetAdjustmentStatementSectionTotalsLazyQueryHookResult = ReturnType<typeof useGetAdjustmentStatementSectionTotalsLazyQuery>;
export type GetAdjustmentStatementSectionTotalsQueryResult = Apollo.QueryResult<GetAdjustmentStatementSectionTotalsQuery, GetAdjustmentStatementSectionTotalsQueryVariables>;
export const CreateDcAdjustmentDocument = gql`
    mutation CreateDcAdjustment($input: CreateDcAdjustmentInput!) {
  createDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type CreateDcAdjustmentMutationFn = Apollo.MutationFunction<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>;

/**
 * __useCreateDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useCreateDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createDcAdjustmentMutation, { data, loading, error }] = useCreateDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>(CreateDcAdjustmentDocument, options);
      }
export type CreateDcAdjustmentMutationHookResult = ReturnType<typeof useCreateDcAdjustmentMutation>;
export type CreateDcAdjustmentMutationResult = Apollo.MutationResult<CreateDcAdjustmentMutation>;
export type CreateDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<CreateDcAdjustmentMutation, CreateDcAdjustmentMutationVariables>;
export const UpdateDcAdjustmentDocument = gql`
    mutation UpdateDcAdjustment($input: UpdateDcAdjustmentInput!) {
  updateDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type UpdateDcAdjustmentMutationFn = Apollo.MutationFunction<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>;

/**
 * __useUpdateDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useUpdateDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateDcAdjustmentMutation, { data, loading, error }] = useUpdateDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>(UpdateDcAdjustmentDocument, options);
      }
export type UpdateDcAdjustmentMutationHookResult = ReturnType<typeof useUpdateDcAdjustmentMutation>;
export type UpdateDcAdjustmentMutationResult = Apollo.MutationResult<UpdateDcAdjustmentMutation>;
export type UpdateDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<UpdateDcAdjustmentMutation, UpdateDcAdjustmentMutationVariables>;
export const DeleteDcAdjustmentDocument = gql`
    mutation DeleteDcAdjustment($input: DeleteDcAdjustmentInput!) {
  deleteDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type DeleteDcAdjustmentMutationFn = Apollo.MutationFunction<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>;

/**
 * __useDeleteDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useDeleteDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteDcAdjustmentMutation, { data, loading, error }] = useDeleteDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>(DeleteDcAdjustmentDocument, options);
      }
export type DeleteDcAdjustmentMutationHookResult = ReturnType<typeof useDeleteDcAdjustmentMutation>;
export type DeleteDcAdjustmentMutationResult = Apollo.MutationResult<DeleteDcAdjustmentMutation>;
export type DeleteDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<DeleteDcAdjustmentMutation, DeleteDcAdjustmentMutationVariables>;
export const ClearDcAdjustmentDocument = gql`
    mutation ClearDcAdjustment($input: ClearDcAdjustmentInput!) {
  clearDcAdjustment(input: $input) {
    adjustment {
      ...AdjustmentFields
    }
    mirrorAdjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`;
export type ClearDcAdjustmentMutationFn = Apollo.MutationFunction<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>;

/**
 * __useClearDcAdjustmentMutation__
 *
 * To run a mutation, you first call `useClearDcAdjustmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearDcAdjustmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearDcAdjustmentMutation, { data, loading, error }] = useClearDcAdjustmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useClearDcAdjustmentMutation(baseOptions?: Apollo.MutationHookOptions<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>(ClearDcAdjustmentDocument, options);
      }
export type ClearDcAdjustmentMutationHookResult = ReturnType<typeof useClearDcAdjustmentMutation>;
export type ClearDcAdjustmentMutationResult = Apollo.MutationResult<ClearDcAdjustmentMutation>;
export type ClearDcAdjustmentMutationOptions = Apollo.BaseMutationOptions<ClearDcAdjustmentMutation, ClearDcAdjustmentMutationVariables>;
